/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  jsonb: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
  xml: any;
};

export type AiToolsConcept = {
  __typename?: 'AIToolsConcept';
  description: Scalars['String'];
  type: Scalars['String'];
};

export type AiToolsGenerateCaptionInput = {
  category: Scalars['String'];
  client_organization_id: Scalars['String'];
  language: Scalars['String'];
  request: Scalars['String'];
};

export type AiToolsGenerateCaptionOutput = {
  __typename?: 'AIToolsGenerateCaptionOutput';
  caption: Scalars['String'];
};

export type AiToolsGenerateConceptInput = {
  brand_type: Scalars['String'];
  client_organization_id: Scalars['String'];
  period: Scalars['String'];
};

export type AiToolsGetRelatedEventInput = {
  client_organization_id: Scalars['String'];
  day?: InputMaybe<Scalars['Int']>;
  desc: Scalars['String'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type AiToolsGetUsageInput = {
  client_organization_id: Scalars['String'];
  service: Scalars['String'];
};

export enum AiToolsImageCategory {
  Action = 'action',
  Food = 'food',
  Icon = 'icon',
  Illustration = 'illustration',
  Object = 'object',
  Portrait = 'portrait',
  Render = 'render',
  Scene = 'scene'
}

export type AiToolsImages = {
  __typename?: 'AIToolsImages';
  urls: Array<Scalars['String']>;
};

export type AiToolsImagesInput = {
  category: AiToolsImageCategory;
  client_organization_id: Scalars['String'];
  description: Scalars['String'];
  number_of_images: Scalars['Int'];
};

export type AddAndInviteMember = {
  __typename?: 'AddAndInviteMember';
  outcome?: Maybe<Scalars['String']>;
};

export type AddAndInviteMemberInput = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  role: Scalars['String'];
  title: Scalars['String'];
};

export type AddClientInput = {
  brandName: Scalars['String'];
  contactName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type AddclientOutput = {
  __typename?: 'AddclientOutput';
  organization: ClientOrganization;
  organizationMember: ClientOrganizationMember;
  user: ClientUser;
};

export type AuthRefreshInput = {
  refresh_token: Scalars['String'];
};

export type AuthRefreshOutput = {
  __typename?: 'AuthRefreshOutput';
  access_token?: Maybe<Scalars['String']>;
};

export type Boolean_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _cast?: InputMaybe<Boolean_Cast_Exp>;
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type ClientFacebookConnection = {
  __typename?: 'ClientFacebookConnection';
  business_id: Scalars['String'];
  client_organization_id: Scalars['String'];
  fb_user_id: Scalars['String'];
};

export type ClientFacebookConnectionInput = {
  access_token: Scalars['String'];
  business_id: Scalars['String'];
  client_organization_id: Scalars['String'];
  facebook_user_id: Scalars['String'];
};

export type ClientFacebookResources = {
  __typename?: 'ClientFacebookResources';
  client_organization_id: Scalars['String'];
  connection_date?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fb_id: Scalars['String'];
  fb_name?: Maybe<Scalars['String']>;
  resource_type: Scalars['String'];
  status: Scalars['String'];
};

export type ClientInvitation = {
  __typename?: 'ClientInvitation';
  agency_id?: Maybe<Scalars['String']>;
  client_email?: Maybe<Scalars['String']>;
  client_organization_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type ClientInvitationInput = {
  email: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
};

export type ClientOrganization = {
  __typename?: 'ClientOrganization';
  agency_id: Scalars['String'];
  created_at: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type ClientOrganizationMember = {
  __typename?: 'ClientOrganizationMember';
  created_at: Scalars['String'];
  id: Scalars['String'];
  organization_id: Scalars['String'];
  role_id: Scalars['String'];
  status: Scalars['String'];
  user_id: Scalars['String'];
};

export type ClientReportAggregatedDataType = {
  __typename?: 'ClientReportAggregatedDataType';
  description?: Maybe<Scalars['String']>;
  metric?: Maybe<Scalars['String']>;
  previous_period?: Maybe<ClientReportPeriodDataType>;
  selected_period?: Maybe<ClientReportPeriodDataType>;
  title?: Maybe<Scalars['String']>;
};

export type ClientReportItemType = {
  __typename?: 'ClientReportItemType';
  aggregated_data?: Maybe<ClientReportAggregatedDataType>;
  metric?: Maybe<Scalars['String']>;
  social_media?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ClientReportPeriodDataType = {
  __typename?: 'ClientReportPeriodDataType';
  since?: Maybe<Scalars['String']>;
  until?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type ClientUser = {
  __typename?: 'ClientUser';
  agency_id: Scalars['String'];
  created_at: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['String'];
  image_url: Scalars['String'];
  phone: Scalars['String'];
};

export type FacebookClientCode = {
  __typename?: 'FacebookClientCode';
  code: Scalars['String'];
};

export type FacebookConnection = {
  __typename?: 'FacebookConnection';
  business_id: Scalars['String'];
  business_manager_id: Scalars['String'];
  fb_user_id: Scalars['String'];
  id: Scalars['String'];
  organization_id: Scalars['String'];
};

export type FacebookConnectionInput = {
  access_token: Scalars['String'];
  business_id: Scalars['String'];
  business_manager_id: Scalars['String'];
  facebook_user_id: Scalars['String'];
};

export type FacebookGroupedScopes = {
  __typename?: 'FacebookGroupedScopes';
  ad?: Maybe<Array<Maybe<Scalars['String']>>>;
  default?: Maybe<Array<Maybe<Scalars['String']>>>;
  domain?: Maybe<Array<Maybe<Scalars['String']>>>;
  instagram?: Maybe<Array<Maybe<Scalars['String']>>>;
  lead?: Maybe<Array<Maybe<Scalars['String']>>>;
  page?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GenericResult = {
  __typename?: 'GenericResult';
  ok?: Maybe<Scalars['Boolean']>;
};

export type GetClientReportInput = {
  client_organization_id: Scalars['String'];
  metrics?: InputMaybe<Scalars['String']>;
  report_type?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['String']>;
};

export type GetClientSharedReportInput = {
  client_organization_id: Scalars['String'];
  expires_at?: InputMaybe<Scalars['String']>;
  facebook_page_metrics?: InputMaybe<Scalars['String']>;
  instagram_page_metrics?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['String']>;
};

export type GetClientSharedReportOutput = {
  __typename?: 'GetClientSharedReportOutput';
  expires_at?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type Int_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _cast?: InputMaybe<Int_Cast_Exp>;
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  agency_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  member_email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type OrganizationInvitationAcceptInput = {
  email: Scalars['String'];
  user_id: Scalars['String'];
};

export type OrganizationInvitationInput = {
  email: Scalars['String'];
  message: Scalars['String'];
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  organization_id?: Maybe<Scalars['String']>;
  role_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type OrganizationMemberInput = {
  organization_id: Scalars['String'];
  role: Scalars['String'];
  user_id: Scalars['String'];
};

export type OrganizationMemberRemoveInput = {
  organization_id: Scalars['String'];
  user_id: Scalars['String'];
};

export type RelatedEvent = {
  __typename?: 'RelatedEvent';
  date: Scalars['String'];
  excerpt: Scalars['String'];
  name: Scalars['String'];
  score: Scalars['Int'];
  url: Scalars['String'];
};

export type ServiceUsage = {
  __typename?: 'ServiceUsage';
  available_credits?: Maybe<Scalars['Int']>;
  client_limit?: Maybe<Scalars['Int']>;
  current?: Maybe<Scalars['Int']>;
};

export type SetUrlMetadataInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client_organization_id: Scalars['String'];
};

export type SignInInput = {
  email: Scalars['String'];
  organization_id?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type SignInOutput = {
  __typename?: 'SignInOutput';
  access_token?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
};

export type SignOutInput = {
  email: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
};

export type SignUpInput = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  freelancer_status?: InputMaybe<Scalars['String']>;
  invitation_id?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
  organization_id?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone_number?: InputMaybe<Scalars['String']>;
};

export type SignUpOutput = {
  __typename?: 'SignUpOutput';
  access_token: Scalars['String'];
  address_id?: Maybe<Scalars['String']>;
  agency_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  refresh_token: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type UpdatePasswordInput = {
  new_password: Scalars['String'];
  previous_password: Scalars['String'];
};

export type UrlMetadataInput = {
  client_organization_id: Scalars['String'];
};

export type UrlMetadataOutput = {
  __typename?: 'UrlMetadataOutput';
  agency_id?: Maybe<Scalars['String']>;
  aggregated: Scalars['String'];
  business_id?: Maybe<Scalars['String']>;
  business_name?: Maybe<Scalars['String']>;
  done?: Maybe<Scalars['Boolean']>;
  scopes: FacebookGroupedScopes;
};

export type VerifyFacebookResourceInput = {
  client_organization_id: Scalars['String'];
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: 'address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: 'address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
};


/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  line1?: InputMaybe<String_Comparison_Exp>;
  line2?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** a connection between addresses and their owners */
export type Address_Links = {
  __typename?: 'address_links';
  address_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_default?: Maybe<Scalars['Boolean']>;
  owner_id: Scalars['uuid'];
};

/** aggregated selection of "address_links" */
export type Address_Links_Aggregate = {
  __typename?: 'address_links_aggregate';
  aggregate?: Maybe<Address_Links_Aggregate_Fields>;
  nodes: Array<Address_Links>;
};

/** aggregate fields of "address_links" */
export type Address_Links_Aggregate_Fields = {
  __typename?: 'address_links_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Address_Links_Max_Fields>;
  min?: Maybe<Address_Links_Min_Fields>;
};


/** aggregate fields of "address_links" */
export type Address_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "address_links" */
export type Address_Links_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Address_Links_Max_Order_By>;
  min?: InputMaybe<Address_Links_Min_Order_By>;
};

/** input type for inserting array relation for remote table "address_links" */
export type Address_Links_Arr_Rel_Insert_Input = {
  data: Array<Address_Links_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_Links_On_Conflict>;
};

/** Boolean expression to filter rows from the table "address_links". All fields are combined with a logical 'AND'. */
export type Address_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Links_Bool_Exp>>;
  _not?: InputMaybe<Address_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Links_Bool_Exp>>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "address_links" */
export enum Address_Links_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressLinksPkey = 'address_links_pkey'
}

/** input type for inserting data into table "address_links" */
export type Address_Links_Insert_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Address_Links_Max_Fields = {
  __typename?: 'address_links_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  owner_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "address_links" */
export type Address_Links_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Address_Links_Min_Fields = {
  __typename?: 'address_links_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  owner_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "address_links" */
export type Address_Links_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "address_links" */
export type Address_Links_Mutation_Response = {
  __typename?: 'address_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address_Links>;
};

/** on_conflict condition type for table "address_links" */
export type Address_Links_On_Conflict = {
  constraint: Address_Links_Constraint;
  update_columns?: Array<Address_Links_Update_Column>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};

/** Ordering options when selecting data from "address_links". */
export type Address_Links_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address_links */
export type Address_Links_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "address_links" */
export enum Address_Links_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  OwnerId = 'owner_id'
}

/** input type for updating data in table "address_links" */
export type Address_Links_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "address_links" */
export enum Address_Links_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  OwnerId = 'owner_id'
}

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'address_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'address_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line1?: InputMaybe<Order_By>;
  line2?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  Line1 = 'line1',
  /** column name */
  Line2 = 'line2',
  /** column name */
  State = 'state',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  Line1 = 'line1',
  /** column name */
  Line2 = 'line2',
  /** column name */
  State = 'state',
  /** column name */
  Zipcode = 'zipcode'
}

/** columns and relationships of "ai_tools_credits" */
export type Ai_Tools_Credits = {
  __typename?: 'ai_tools_credits';
  added_by?: Maybe<Scalars['uuid']>;
  amount?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  organization_id: Scalars['uuid'];
  service: Ai_Tools_Services_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "ai_tools_credits" */
export type Ai_Tools_Credits_Aggregate = {
  __typename?: 'ai_tools_credits_aggregate';
  aggregate?: Maybe<Ai_Tools_Credits_Aggregate_Fields>;
  nodes: Array<Ai_Tools_Credits>;
};

/** aggregate fields of "ai_tools_credits" */
export type Ai_Tools_Credits_Aggregate_Fields = {
  __typename?: 'ai_tools_credits_aggregate_fields';
  avg?: Maybe<Ai_Tools_Credits_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ai_Tools_Credits_Max_Fields>;
  min?: Maybe<Ai_Tools_Credits_Min_Fields>;
  stddev?: Maybe<Ai_Tools_Credits_Stddev_Fields>;
  stddev_pop?: Maybe<Ai_Tools_Credits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ai_Tools_Credits_Stddev_Samp_Fields>;
  sum?: Maybe<Ai_Tools_Credits_Sum_Fields>;
  var_pop?: Maybe<Ai_Tools_Credits_Var_Pop_Fields>;
  var_samp?: Maybe<Ai_Tools_Credits_Var_Samp_Fields>;
  variance?: Maybe<Ai_Tools_Credits_Variance_Fields>;
};


/** aggregate fields of "ai_tools_credits" */
export type Ai_Tools_Credits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ai_Tools_Credits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ai_Tools_Credits_Avg_Fields = {
  __typename?: 'ai_tools_credits_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ai_tools_credits". All fields are combined with a logical 'AND'. */
export type Ai_Tools_Credits_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Tools_Credits_Bool_Exp>>;
  _not?: InputMaybe<Ai_Tools_Credits_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Tools_Credits_Bool_Exp>>;
  added_by?: InputMaybe<Uuid_Comparison_Exp>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  service?: InputMaybe<Ai_Tools_Services_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ai_tools_credits" */
export enum Ai_Tools_Credits_Constraint {
  /** unique or primary key constraint on columns "id" */
  AiToolsCreditsPkey = 'ai_tools_credits_pkey'
}

/** input type for incrementing numeric columns in table "ai_tools_credits" */
export type Ai_Tools_Credits_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ai_tools_credits" */
export type Ai_Tools_Credits_Insert_Input = {
  added_by?: InputMaybe<Scalars['uuid']>;
  amount?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  service?: InputMaybe<Ai_Tools_Services_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ai_Tools_Credits_Max_Fields = {
  __typename?: 'ai_tools_credits_max_fields';
  added_by?: Maybe<Scalars['uuid']>;
  amount?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ai_Tools_Credits_Min_Fields = {
  __typename?: 'ai_tools_credits_min_fields';
  added_by?: Maybe<Scalars['uuid']>;
  amount?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ai_tools_credits" */
export type Ai_Tools_Credits_Mutation_Response = {
  __typename?: 'ai_tools_credits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ai_Tools_Credits>;
};

/** on_conflict condition type for table "ai_tools_credits" */
export type Ai_Tools_Credits_On_Conflict = {
  constraint: Ai_Tools_Credits_Constraint;
  update_columns?: Array<Ai_Tools_Credits_Update_Column>;
  where?: InputMaybe<Ai_Tools_Credits_Bool_Exp>;
};

/** Ordering options when selecting data from "ai_tools_credits". */
export type Ai_Tools_Credits_Order_By = {
  added_by?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ai_tools_credits */
export type Ai_Tools_Credits_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ai_tools_credits" */
export enum Ai_Tools_Credits_Select_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Service = 'service',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ai_tools_credits" */
export type Ai_Tools_Credits_Set_Input = {
  added_by?: InputMaybe<Scalars['uuid']>;
  amount?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  service?: InputMaybe<Ai_Tools_Services_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ai_Tools_Credits_Stddev_Fields = {
  __typename?: 'ai_tools_credits_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ai_Tools_Credits_Stddev_Pop_Fields = {
  __typename?: 'ai_tools_credits_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ai_Tools_Credits_Stddev_Samp_Fields = {
  __typename?: 'ai_tools_credits_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Ai_Tools_Credits_Sum_Fields = {
  __typename?: 'ai_tools_credits_sum_fields';
  amount?: Maybe<Scalars['Int']>;
};

/** update columns of table "ai_tools_credits" */
export enum Ai_Tools_Credits_Update_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Service = 'service',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Ai_Tools_Credits_Var_Pop_Fields = {
  __typename?: 'ai_tools_credits_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ai_Tools_Credits_Var_Samp_Fields = {
  __typename?: 'ai_tools_credits_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ai_Tools_Credits_Variance_Fields = {
  __typename?: 'ai_tools_credits_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ai_tools_history" */
export type Ai_Tools_History = {
  __typename?: 'ai_tools_history';
  /** An object relationship */
  ai_service: Ai_Tools_Services;
  client_organization_id?: Maybe<Scalars['uuid']>;
  credit_used?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  input: Scalars['jsonb'];
  organization_id: Scalars['uuid'];
  output: Scalars['jsonb'];
  service: Ai_Tools_Services_Enum;
  timestamp?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "ai_tools_history" */
export type Ai_Tools_HistoryInputArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ai_tools_history" */
export type Ai_Tools_HistoryOutputArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ai_tools_history" */
export type Ai_Tools_History_Aggregate = {
  __typename?: 'ai_tools_history_aggregate';
  aggregate?: Maybe<Ai_Tools_History_Aggregate_Fields>;
  nodes: Array<Ai_Tools_History>;
};

/** aggregate fields of "ai_tools_history" */
export type Ai_Tools_History_Aggregate_Fields = {
  __typename?: 'ai_tools_history_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ai_Tools_History_Max_Fields>;
  min?: Maybe<Ai_Tools_History_Min_Fields>;
};


/** aggregate fields of "ai_tools_history" */
export type Ai_Tools_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ai_Tools_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ai_Tools_History_Append_Input = {
  input?: InputMaybe<Scalars['jsonb']>;
  output?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "ai_tools_history". All fields are combined with a logical 'AND'. */
export type Ai_Tools_History_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Tools_History_Bool_Exp>>;
  _not?: InputMaybe<Ai_Tools_History_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Tools_History_Bool_Exp>>;
  ai_service?: InputMaybe<Ai_Tools_Services_Bool_Exp>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  credit_used?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  input?: InputMaybe<Jsonb_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  output?: InputMaybe<Jsonb_Comparison_Exp>;
  service?: InputMaybe<Ai_Tools_Services_Enum_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ai_tools_history" */
export enum Ai_Tools_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  AiToolsHistoryPkey = 'ai_tools_history_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ai_Tools_History_Delete_At_Path_Input = {
  input?: InputMaybe<Array<Scalars['String']>>;
  output?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ai_Tools_History_Delete_Elem_Input = {
  input?: InputMaybe<Scalars['Int']>;
  output?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ai_Tools_History_Delete_Key_Input = {
  input?: InputMaybe<Scalars['String']>;
  output?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ai_tools_history" */
export type Ai_Tools_History_Insert_Input = {
  ai_service?: InputMaybe<Ai_Tools_Services_Obj_Rel_Insert_Input>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  credit_used?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  input?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  output?: InputMaybe<Scalars['jsonb']>;
  service?: InputMaybe<Ai_Tools_Services_Enum>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ai_Tools_History_Max_Fields = {
  __typename?: 'ai_tools_history_max_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ai_Tools_History_Min_Fields = {
  __typename?: 'ai_tools_history_min_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ai_tools_history" */
export type Ai_Tools_History_Mutation_Response = {
  __typename?: 'ai_tools_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ai_Tools_History>;
};

/** on_conflict condition type for table "ai_tools_history" */
export type Ai_Tools_History_On_Conflict = {
  constraint: Ai_Tools_History_Constraint;
  update_columns?: Array<Ai_Tools_History_Update_Column>;
  where?: InputMaybe<Ai_Tools_History_Bool_Exp>;
};

/** Ordering options when selecting data from "ai_tools_history". */
export type Ai_Tools_History_Order_By = {
  ai_service?: InputMaybe<Ai_Tools_Services_Order_By>;
  client_organization_id?: InputMaybe<Order_By>;
  credit_used?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  output?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ai_tools_history */
export type Ai_Tools_History_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ai_Tools_History_Prepend_Input = {
  input?: InputMaybe<Scalars['jsonb']>;
  output?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ai_tools_history" */
export enum Ai_Tools_History_Select_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreditUsed = 'credit_used',
  /** column name */
  Id = 'id',
  /** column name */
  Input = 'input',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Output = 'output',
  /** column name */
  Service = 'service',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "ai_tools_history" */
export type Ai_Tools_History_Set_Input = {
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  credit_used?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  input?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  output?: InputMaybe<Scalars['jsonb']>;
  service?: InputMaybe<Ai_Tools_Services_Enum>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ai_tools_history" */
export enum Ai_Tools_History_Update_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreditUsed = 'credit_used',
  /** column name */
  Id = 'id',
  /** column name */
  Input = 'input',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Output = 'output',
  /** column name */
  Service = 'service',
  /** column name */
  Timestamp = 'timestamp'
}

/** columns and relationships of "ai_tools_services" */
export type Ai_Tools_Services = {
  __typename?: 'ai_tools_services';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "ai_tools_services" */
export type Ai_Tools_Services_Aggregate = {
  __typename?: 'ai_tools_services_aggregate';
  aggregate?: Maybe<Ai_Tools_Services_Aggregate_Fields>;
  nodes: Array<Ai_Tools_Services>;
};

/** aggregate fields of "ai_tools_services" */
export type Ai_Tools_Services_Aggregate_Fields = {
  __typename?: 'ai_tools_services_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ai_Tools_Services_Max_Fields>;
  min?: Maybe<Ai_Tools_Services_Min_Fields>;
};


/** aggregate fields of "ai_tools_services" */
export type Ai_Tools_Services_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ai_Tools_Services_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ai_tools_services". All fields are combined with a logical 'AND'. */
export type Ai_Tools_Services_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Tools_Services_Bool_Exp>>;
  _not?: InputMaybe<Ai_Tools_Services_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Tools_Services_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ai_tools_services" */
export enum Ai_Tools_Services_Constraint {
  /** unique or primary key constraint on columns "id" */
  AiToolsServicesPkey = 'ai_tools_services_pkey'
}

export enum Ai_Tools_Services_Enum {
  /** CAPTION */
  Caption = 'CAPTION',
  /** CONCEPT */
  Concept = 'CONCEPT',
  /** EVENT */
  Event = 'EVENT',
  /** IMAGE */
  Image = 'IMAGE'
}

/** Boolean expression to compare columns of type "ai_tools_services_enum". All fields are combined with logical 'AND'. */
export type Ai_Tools_Services_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ai_Tools_Services_Enum>;
  _in?: InputMaybe<Array<Ai_Tools_Services_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ai_Tools_Services_Enum>;
  _nin?: InputMaybe<Array<Ai_Tools_Services_Enum>>;
};

/** input type for inserting data into table "ai_tools_services" */
export type Ai_Tools_Services_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ai_Tools_Services_Max_Fields = {
  __typename?: 'ai_tools_services_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ai_Tools_Services_Min_Fields = {
  __typename?: 'ai_tools_services_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ai_tools_services" */
export type Ai_Tools_Services_Mutation_Response = {
  __typename?: 'ai_tools_services_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ai_Tools_Services>;
};

/** input type for inserting object relation for remote table "ai_tools_services" */
export type Ai_Tools_Services_Obj_Rel_Insert_Input = {
  data: Ai_Tools_Services_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ai_Tools_Services_On_Conflict>;
};

/** on_conflict condition type for table "ai_tools_services" */
export type Ai_Tools_Services_On_Conflict = {
  constraint: Ai_Tools_Services_Constraint;
  update_columns?: Array<Ai_Tools_Services_Update_Column>;
  where?: InputMaybe<Ai_Tools_Services_Bool_Exp>;
};

/** Ordering options when selecting data from "ai_tools_services". */
export type Ai_Tools_Services_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ai_tools_services */
export type Ai_Tools_Services_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "ai_tools_services" */
export enum Ai_Tools_Services_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "ai_tools_services" */
export type Ai_Tools_Services_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ai_tools_services" */
export enum Ai_Tools_Services_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Bigint_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _cast?: InputMaybe<Bigint_Cast_Exp>;
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** default categories for caption examples. client_organization_caption_examples */
export type Caption_Example_Categories = {
  __typename?: 'caption_example_categories';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "caption_example_categories" */
export type Caption_Example_Categories_Aggregate = {
  __typename?: 'caption_example_categories_aggregate';
  aggregate?: Maybe<Caption_Example_Categories_Aggregate_Fields>;
  nodes: Array<Caption_Example_Categories>;
};

/** aggregate fields of "caption_example_categories" */
export type Caption_Example_Categories_Aggregate_Fields = {
  __typename?: 'caption_example_categories_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Caption_Example_Categories_Max_Fields>;
  min?: Maybe<Caption_Example_Categories_Min_Fields>;
};


/** aggregate fields of "caption_example_categories" */
export type Caption_Example_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Caption_Example_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "caption_example_categories". All fields are combined with a logical 'AND'. */
export type Caption_Example_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Caption_Example_Categories_Bool_Exp>>;
  _not?: InputMaybe<Caption_Example_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Caption_Example_Categories_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "caption_example_categories" */
export enum Caption_Example_Categories_Constraint {
  /** unique or primary key constraint on columns "name" */
  CaptionExampleCategoriesNameKey = 'caption_example_categories_name_key',
  /** unique or primary key constraint on columns "id" */
  CaptionExampleCategoriesPkey = 'caption_example_categories_pkey'
}

export enum Caption_Example_Categories_Enum {
  /** Information */
  Information = 'INFORMATION',
  /** Inspiration */
  Inspiration = 'INSPIRATION',
  /** Meme */
  Meme = 'MEME',
  /** News */
  News = 'NEWS',
  /** Portrait */
  Portrait = 'PORTRAIT',
  /** Promotion */
  Promotion = 'PROMOTION',
  /** Quote */
  Quote = 'QUOTE'
}

/** Boolean expression to compare columns of type "caption_example_categories_enum". All fields are combined with logical 'AND'. */
export type Caption_Example_Categories_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Caption_Example_Categories_Enum>;
  _in?: InputMaybe<Array<Caption_Example_Categories_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Caption_Example_Categories_Enum>;
  _nin?: InputMaybe<Array<Caption_Example_Categories_Enum>>;
};

/** input type for inserting data into table "caption_example_categories" */
export type Caption_Example_Categories_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Caption_Example_Categories_Max_Fields = {
  __typename?: 'caption_example_categories_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Caption_Example_Categories_Min_Fields = {
  __typename?: 'caption_example_categories_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "caption_example_categories" */
export type Caption_Example_Categories_Mutation_Response = {
  __typename?: 'caption_example_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Caption_Example_Categories>;
};

/** on_conflict condition type for table "caption_example_categories" */
export type Caption_Example_Categories_On_Conflict = {
  constraint: Caption_Example_Categories_Constraint;
  update_columns?: Array<Caption_Example_Categories_Update_Column>;
  where?: InputMaybe<Caption_Example_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "caption_example_categories". */
export type Caption_Example_Categories_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: caption_example_categories */
export type Caption_Example_Categories_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "caption_example_categories" */
export enum Caption_Example_Categories_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "caption_example_categories" */
export type Caption_Example_Categories_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "caption_example_categories" */
export enum Caption_Example_Categories_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "caption_example_subcategories" */
export type Caption_Example_Subcategories = {
  __typename?: 'caption_example_subcategories';
  category_id: Caption_Example_Categories_Enum;
  name: Scalars['String'];
};

/** aggregated selection of "caption_example_subcategories" */
export type Caption_Example_Subcategories_Aggregate = {
  __typename?: 'caption_example_subcategories_aggregate';
  aggregate?: Maybe<Caption_Example_Subcategories_Aggregate_Fields>;
  nodes: Array<Caption_Example_Subcategories>;
};

/** aggregate fields of "caption_example_subcategories" */
export type Caption_Example_Subcategories_Aggregate_Fields = {
  __typename?: 'caption_example_subcategories_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Caption_Example_Subcategories_Max_Fields>;
  min?: Maybe<Caption_Example_Subcategories_Min_Fields>;
};


/** aggregate fields of "caption_example_subcategories" */
export type Caption_Example_Subcategories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Caption_Example_Subcategories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "caption_example_subcategories". All fields are combined with a logical 'AND'. */
export type Caption_Example_Subcategories_Bool_Exp = {
  _and?: InputMaybe<Array<Caption_Example_Subcategories_Bool_Exp>>;
  _not?: InputMaybe<Caption_Example_Subcategories_Bool_Exp>;
  _or?: InputMaybe<Array<Caption_Example_Subcategories_Bool_Exp>>;
  category_id?: InputMaybe<Caption_Example_Categories_Enum_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "caption_example_subcategories" */
export enum Caption_Example_Subcategories_Constraint {
  /** unique or primary key constraint on columns "name" */
  CaptionExampleSubcategoriesPkey = 'caption_example_subcategories_pkey'
}

/** input type for inserting data into table "caption_example_subcategories" */
export type Caption_Example_Subcategories_Insert_Input = {
  category_id?: InputMaybe<Caption_Example_Categories_Enum>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Caption_Example_Subcategories_Max_Fields = {
  __typename?: 'caption_example_subcategories_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Caption_Example_Subcategories_Min_Fields = {
  __typename?: 'caption_example_subcategories_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "caption_example_subcategories" */
export type Caption_Example_Subcategories_Mutation_Response = {
  __typename?: 'caption_example_subcategories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Caption_Example_Subcategories>;
};

/** input type for inserting object relation for remote table "caption_example_subcategories" */
export type Caption_Example_Subcategories_Obj_Rel_Insert_Input = {
  data: Caption_Example_Subcategories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Caption_Example_Subcategories_On_Conflict>;
};

/** on_conflict condition type for table "caption_example_subcategories" */
export type Caption_Example_Subcategories_On_Conflict = {
  constraint: Caption_Example_Subcategories_Constraint;
  update_columns?: Array<Caption_Example_Subcategories_Update_Column>;
  where?: InputMaybe<Caption_Example_Subcategories_Bool_Exp>;
};

/** Ordering options when selecting data from "caption_example_subcategories". */
export type Caption_Example_Subcategories_Order_By = {
  category_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: caption_example_subcategories */
export type Caption_Example_Subcategories_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "caption_example_subcategories" */
export enum Caption_Example_Subcategories_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "caption_example_subcategories" */
export type Caption_Example_Subcategories_Set_Input = {
  category_id?: InputMaybe<Caption_Example_Categories_Enum>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "caption_example_subcategories" */
export enum Caption_Example_Subcategories_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "chat_bridgings" */
export type Chat_Bridgings = {
  __typename?: 'chat_bridgings';
  id: Scalars['uuid'];
  in_id: Scalars['uuid'];
  in_type: Scalars['String'];
  out_id?: Maybe<Scalars['uuid']>;
  out_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "chat_bridgings" */
export type Chat_Bridgings_Aggregate = {
  __typename?: 'chat_bridgings_aggregate';
  aggregate?: Maybe<Chat_Bridgings_Aggregate_Fields>;
  nodes: Array<Chat_Bridgings>;
};

/** aggregate fields of "chat_bridgings" */
export type Chat_Bridgings_Aggregate_Fields = {
  __typename?: 'chat_bridgings_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chat_Bridgings_Max_Fields>;
  min?: Maybe<Chat_Bridgings_Min_Fields>;
};


/** aggregate fields of "chat_bridgings" */
export type Chat_Bridgings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Bridgings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "chat_bridgings". All fields are combined with a logical 'AND'. */
export type Chat_Bridgings_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Bridgings_Bool_Exp>>;
  _not?: InputMaybe<Chat_Bridgings_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Bridgings_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_id?: InputMaybe<Uuid_Comparison_Exp>;
  in_type?: InputMaybe<String_Comparison_Exp>;
  out_id?: InputMaybe<Uuid_Comparison_Exp>;
  out_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_bridgings" */
export enum Chat_Bridgings_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatBridgingsPkey = 'chat_bridgings_pkey'
}

/** input type for inserting data into table "chat_bridgings" */
export type Chat_Bridgings_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  in_id?: InputMaybe<Scalars['uuid']>;
  in_type?: InputMaybe<Scalars['String']>;
  out_id?: InputMaybe<Scalars['uuid']>;
  out_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Chat_Bridgings_Max_Fields = {
  __typename?: 'chat_bridgings_max_fields';
  id?: Maybe<Scalars['uuid']>;
  in_id?: Maybe<Scalars['uuid']>;
  in_type?: Maybe<Scalars['String']>;
  out_id?: Maybe<Scalars['uuid']>;
  out_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Chat_Bridgings_Min_Fields = {
  __typename?: 'chat_bridgings_min_fields';
  id?: Maybe<Scalars['uuid']>;
  in_id?: Maybe<Scalars['uuid']>;
  in_type?: Maybe<Scalars['String']>;
  out_id?: Maybe<Scalars['uuid']>;
  out_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chat_bridgings" */
export type Chat_Bridgings_Mutation_Response = {
  __typename?: 'chat_bridgings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Bridgings>;
};

/** on_conflict condition type for table "chat_bridgings" */
export type Chat_Bridgings_On_Conflict = {
  constraint: Chat_Bridgings_Constraint;
  update_columns?: Array<Chat_Bridgings_Update_Column>;
  where?: InputMaybe<Chat_Bridgings_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_bridgings". */
export type Chat_Bridgings_Order_By = {
  id?: InputMaybe<Order_By>;
  in_id?: InputMaybe<Order_By>;
  in_type?: InputMaybe<Order_By>;
  out_id?: InputMaybe<Order_By>;
  out_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_bridgings */
export type Chat_Bridgings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "chat_bridgings" */
export enum Chat_Bridgings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InId = 'in_id',
  /** column name */
  InType = 'in_type',
  /** column name */
  OutId = 'out_id',
  /** column name */
  OutType = 'out_type'
}

/** input type for updating data in table "chat_bridgings" */
export type Chat_Bridgings_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  in_id?: InputMaybe<Scalars['uuid']>;
  in_type?: InputMaybe<Scalars['String']>;
  out_id?: InputMaybe<Scalars['uuid']>;
  out_type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chat_bridgings" */
export enum Chat_Bridgings_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InId = 'in_id',
  /** column name */
  InType = 'in_type',
  /** column name */
  OutId = 'out_id',
  /** column name */
  OutType = 'out_type'
}

/** columns and relationships of "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_Message = {
  __typename?: 'chat_stream_action_send_message';
  attachments?: Maybe<Scalars['jsonb']>;
  channel_id: Scalars['String'];
  id: Scalars['uuid'];
  message_id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
};


/** columns and relationships of "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_MessageAttachmentsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_Message_Aggregate = {
  __typename?: 'chat_stream_action_send_message_aggregate';
  aggregate?: Maybe<Chat_Stream_Action_Send_Message_Aggregate_Fields>;
  nodes: Array<Chat_Stream_Action_Send_Message>;
};

/** aggregate fields of "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_Message_Aggregate_Fields = {
  __typename?: 'chat_stream_action_send_message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chat_Stream_Action_Send_Message_Max_Fields>;
  min?: Maybe<Chat_Stream_Action_Send_Message_Min_Fields>;
};


/** aggregate fields of "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Chat_Stream_Action_Send_Message_Append_Input = {
  attachments?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "chat_stream_action_send_message". All fields are combined with a logical 'AND'. */
export type Chat_Stream_Action_Send_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Bool_Exp>>;
  _not?: InputMaybe<Chat_Stream_Action_Send_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Bool_Exp>>;
  attachments?: InputMaybe<Jsonb_Comparison_Exp>;
  channel_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_stream_action_send_message" */
export enum Chat_Stream_Action_Send_Message_Constraint {
  /** unique or primary key constraint on columns "message_id" */
  ChatStreamActionSendMessageMessageIdKey = 'chat_stream_action_send_message_message_id_key',
  /** unique or primary key constraint on columns "id" */
  ChatStreamActionSendMessagePkey = 'chat_stream_action_send_message_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Chat_Stream_Action_Send_Message_Delete_At_Path_Input = {
  attachments?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Chat_Stream_Action_Send_Message_Delete_Elem_Input = {
  attachments?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Chat_Stream_Action_Send_Message_Delete_Key_Input = {
  attachments?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_Message_Insert_Input = {
  attachments?: InputMaybe<Scalars['jsonb']>;
  channel_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Chat_Stream_Action_Send_Message_Max_Fields = {
  __typename?: 'chat_stream_action_send_message_max_fields';
  channel_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Chat_Stream_Action_Send_Message_Min_Fields = {
  __typename?: 'chat_stream_action_send_message_min_fields';
  channel_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_Message_Mutation_Response = {
  __typename?: 'chat_stream_action_send_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Stream_Action_Send_Message>;
};

/** on_conflict condition type for table "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_Message_On_Conflict = {
  constraint: Chat_Stream_Action_Send_Message_Constraint;
  update_columns?: Array<Chat_Stream_Action_Send_Message_Update_Column>;
  where?: InputMaybe<Chat_Stream_Action_Send_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_stream_action_send_message". */
export type Chat_Stream_Action_Send_Message_Order_By = {
  attachments?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_stream_action_send_message */
export type Chat_Stream_Action_Send_Message_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Chat_Stream_Action_Send_Message_Prepend_Input = {
  attachments?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "chat_stream_action_send_message" */
export enum Chat_Stream_Action_Send_Message_Select_Column {
  /** column name */
  Attachments = 'attachments',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Text = 'text',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "chat_stream_action_send_message" */
export type Chat_Stream_Action_Send_Message_Set_Input = {
  attachments?: InputMaybe<Scalars['jsonb']>;
  channel_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chat_stream_action_send_message" */
export enum Chat_Stream_Action_Send_Message_Update_Column {
  /** column name */
  Attachments = 'attachments',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Text = 'text',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "chat_stream_post_webhooks" */
export type Chat_Stream_Post_Webhooks = {
  __typename?: 'chat_stream_post_webhooks';
  body: Scalars['jsonb'];
  id: Scalars['uuid'];
};


/** columns and relationships of "chat_stream_post_webhooks" */
export type Chat_Stream_Post_WebhooksBodyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "chat_stream_post_webhooks" */
export type Chat_Stream_Post_Webhooks_Aggregate = {
  __typename?: 'chat_stream_post_webhooks_aggregate';
  aggregate?: Maybe<Chat_Stream_Post_Webhooks_Aggregate_Fields>;
  nodes: Array<Chat_Stream_Post_Webhooks>;
};

/** aggregate fields of "chat_stream_post_webhooks" */
export type Chat_Stream_Post_Webhooks_Aggregate_Fields = {
  __typename?: 'chat_stream_post_webhooks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chat_Stream_Post_Webhooks_Max_Fields>;
  min?: Maybe<Chat_Stream_Post_Webhooks_Min_Fields>;
};


/** aggregate fields of "chat_stream_post_webhooks" */
export type Chat_Stream_Post_Webhooks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Chat_Stream_Post_Webhooks_Append_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "chat_stream_post_webhooks". All fields are combined with a logical 'AND'. */
export type Chat_Stream_Post_Webhooks_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Bool_Exp>>;
  _not?: InputMaybe<Chat_Stream_Post_Webhooks_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Bool_Exp>>;
  body?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_stream_post_webhooks" */
export enum Chat_Stream_Post_Webhooks_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatStreamPostWebhooksPkey = 'chat_stream_post_webhooks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Chat_Stream_Post_Webhooks_Delete_At_Path_Input = {
  body?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Chat_Stream_Post_Webhooks_Delete_Elem_Input = {
  body?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Chat_Stream_Post_Webhooks_Delete_Key_Input = {
  body?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "chat_stream_post_webhooks" */
export type Chat_Stream_Post_Webhooks_Insert_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Chat_Stream_Post_Webhooks_Max_Fields = {
  __typename?: 'chat_stream_post_webhooks_max_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Chat_Stream_Post_Webhooks_Min_Fields = {
  __typename?: 'chat_stream_post_webhooks_min_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "chat_stream_post_webhooks" */
export type Chat_Stream_Post_Webhooks_Mutation_Response = {
  __typename?: 'chat_stream_post_webhooks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Stream_Post_Webhooks>;
};

/** on_conflict condition type for table "chat_stream_post_webhooks" */
export type Chat_Stream_Post_Webhooks_On_Conflict = {
  constraint: Chat_Stream_Post_Webhooks_Constraint;
  update_columns?: Array<Chat_Stream_Post_Webhooks_Update_Column>;
  where?: InputMaybe<Chat_Stream_Post_Webhooks_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_stream_post_webhooks". */
export type Chat_Stream_Post_Webhooks_Order_By = {
  body?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_stream_post_webhooks */
export type Chat_Stream_Post_Webhooks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Chat_Stream_Post_Webhooks_Prepend_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "chat_stream_post_webhooks" */
export enum Chat_Stream_Post_Webhooks_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "chat_stream_post_webhooks" */
export type Chat_Stream_Post_Webhooks_Set_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "chat_stream_post_webhooks" */
export enum Chat_Stream_Post_Webhooks_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Id = 'id'
}

/** columns and relationships of "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_Webhooks = {
  __typename?: 'chat_stream_pre_webhooks';
  body: Scalars['jsonb'];
  id: Scalars['uuid'];
  stream_channel?: Maybe<Scalars['jsonb']>;
  stream_channel_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_WebhooksBodyArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_WebhooksStream_ChannelArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_Webhooks_Aggregate = {
  __typename?: 'chat_stream_pre_webhooks_aggregate';
  aggregate?: Maybe<Chat_Stream_Pre_Webhooks_Aggregate_Fields>;
  nodes: Array<Chat_Stream_Pre_Webhooks>;
};

/** aggregate fields of "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_Webhooks_Aggregate_Fields = {
  __typename?: 'chat_stream_pre_webhooks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chat_Stream_Pre_Webhooks_Max_Fields>;
  min?: Maybe<Chat_Stream_Pre_Webhooks_Min_Fields>;
};


/** aggregate fields of "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_Webhooks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Chat_Stream_Pre_Webhooks_Append_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  stream_channel?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "chat_stream_pre_webhooks". All fields are combined with a logical 'AND'. */
export type Chat_Stream_Pre_Webhooks_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Bool_Exp>>;
  _not?: InputMaybe<Chat_Stream_Pre_Webhooks_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Bool_Exp>>;
  body?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  stream_channel?: InputMaybe<Jsonb_Comparison_Exp>;
  stream_channel_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_stream_pre_webhooks" */
export enum Chat_Stream_Pre_Webhooks_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatStreamPreWebhooksPkey = 'chat_stream_pre_webhooks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Chat_Stream_Pre_Webhooks_Delete_At_Path_Input = {
  body?: InputMaybe<Array<Scalars['String']>>;
  stream_channel?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Chat_Stream_Pre_Webhooks_Delete_Elem_Input = {
  body?: InputMaybe<Scalars['Int']>;
  stream_channel?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Chat_Stream_Pre_Webhooks_Delete_Key_Input = {
  body?: InputMaybe<Scalars['String']>;
  stream_channel?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_Webhooks_Insert_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  stream_channel?: InputMaybe<Scalars['jsonb']>;
  stream_channel_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Chat_Stream_Pre_Webhooks_Max_Fields = {
  __typename?: 'chat_stream_pre_webhooks_max_fields';
  id?: Maybe<Scalars['uuid']>;
  stream_channel_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Chat_Stream_Pre_Webhooks_Min_Fields = {
  __typename?: 'chat_stream_pre_webhooks_min_fields';
  id?: Maybe<Scalars['uuid']>;
  stream_channel_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_Webhooks_Mutation_Response = {
  __typename?: 'chat_stream_pre_webhooks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Stream_Pre_Webhooks>;
};

/** on_conflict condition type for table "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_Webhooks_On_Conflict = {
  constraint: Chat_Stream_Pre_Webhooks_Constraint;
  update_columns?: Array<Chat_Stream_Pre_Webhooks_Update_Column>;
  where?: InputMaybe<Chat_Stream_Pre_Webhooks_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_stream_pre_webhooks". */
export type Chat_Stream_Pre_Webhooks_Order_By = {
  body?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stream_channel?: InputMaybe<Order_By>;
  stream_channel_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_stream_pre_webhooks */
export type Chat_Stream_Pre_Webhooks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Chat_Stream_Pre_Webhooks_Prepend_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  stream_channel?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "chat_stream_pre_webhooks" */
export enum Chat_Stream_Pre_Webhooks_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Id = 'id',
  /** column name */
  StreamChannel = 'stream_channel',
  /** column name */
  StreamChannelId = 'stream_channel_id'
}

/** input type for updating data in table "chat_stream_pre_webhooks" */
export type Chat_Stream_Pre_Webhooks_Set_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  stream_channel?: InputMaybe<Scalars['jsonb']>;
  stream_channel_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chat_stream_pre_webhooks" */
export enum Chat_Stream_Pre_Webhooks_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Id = 'id',
  /** column name */
  StreamChannel = 'stream_channel',
  /** column name */
  StreamChannelId = 'stream_channel_id'
}

/** columns and relationships of "chat_twilio_conv_action_send_message" */
export type Chat_Twilio_Conv_Action_Send_Message = {
  __typename?: 'chat_twilio_conv_action_send_message';
  attachment_url?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channel_sid: Scalars['String'];
  id: Scalars['uuid'];
  media_sid?: Maybe<Scalars['String']>;
  message_sid?: Maybe<Scalars['String']>;
};

/** aggregated selection of "chat_twilio_conv_action_send_message" */
export type Chat_Twilio_Conv_Action_Send_Message_Aggregate = {
  __typename?: 'chat_twilio_conv_action_send_message_aggregate';
  aggregate?: Maybe<Chat_Twilio_Conv_Action_Send_Message_Aggregate_Fields>;
  nodes: Array<Chat_Twilio_Conv_Action_Send_Message>;
};

/** aggregate fields of "chat_twilio_conv_action_send_message" */
export type Chat_Twilio_Conv_Action_Send_Message_Aggregate_Fields = {
  __typename?: 'chat_twilio_conv_action_send_message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chat_Twilio_Conv_Action_Send_Message_Max_Fields>;
  min?: Maybe<Chat_Twilio_Conv_Action_Send_Message_Min_Fields>;
};


/** aggregate fields of "chat_twilio_conv_action_send_message" */
export type Chat_Twilio_Conv_Action_Send_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "chat_twilio_conv_action_send_message". All fields are combined with a logical 'AND'. */
export type Chat_Twilio_Conv_Action_Send_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Bool_Exp>>;
  _not?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Bool_Exp>>;
  attachment_url?: InputMaybe<String_Comparison_Exp>;
  author?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  channel_sid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  media_sid?: InputMaybe<String_Comparison_Exp>;
  message_sid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_twilio_conv_action_send_message" */
export enum Chat_Twilio_Conv_Action_Send_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatTwilioConvActionSendMessagePkey = 'chat_twilio_conv_action_send_message_pkey'
}

/** input type for inserting data into table "chat_twilio_conv_action_send_message" */
export type Chat_Twilio_Conv_Action_Send_Message_Insert_Input = {
  attachment_url?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  channel_sid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  media_sid?: InputMaybe<Scalars['String']>;
  message_sid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Chat_Twilio_Conv_Action_Send_Message_Max_Fields = {
  __typename?: 'chat_twilio_conv_action_send_message_max_fields';
  attachment_url?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channel_sid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  media_sid?: Maybe<Scalars['String']>;
  message_sid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Chat_Twilio_Conv_Action_Send_Message_Min_Fields = {
  __typename?: 'chat_twilio_conv_action_send_message_min_fields';
  attachment_url?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  channel_sid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  media_sid?: Maybe<Scalars['String']>;
  message_sid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chat_twilio_conv_action_send_message" */
export type Chat_Twilio_Conv_Action_Send_Message_Mutation_Response = {
  __typename?: 'chat_twilio_conv_action_send_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Twilio_Conv_Action_Send_Message>;
};

/** on_conflict condition type for table "chat_twilio_conv_action_send_message" */
export type Chat_Twilio_Conv_Action_Send_Message_On_Conflict = {
  constraint: Chat_Twilio_Conv_Action_Send_Message_Constraint;
  update_columns?: Array<Chat_Twilio_Conv_Action_Send_Message_Update_Column>;
  where?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_twilio_conv_action_send_message". */
export type Chat_Twilio_Conv_Action_Send_Message_Order_By = {
  attachment_url?: InputMaybe<Order_By>;
  author?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  channel_sid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_sid?: InputMaybe<Order_By>;
  message_sid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_twilio_conv_action_send_message */
export type Chat_Twilio_Conv_Action_Send_Message_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "chat_twilio_conv_action_send_message" */
export enum Chat_Twilio_Conv_Action_Send_Message_Select_Column {
  /** column name */
  AttachmentUrl = 'attachment_url',
  /** column name */
  Author = 'author',
  /** column name */
  Body = 'body',
  /** column name */
  ChannelSid = 'channel_sid',
  /** column name */
  Id = 'id',
  /** column name */
  MediaSid = 'media_sid',
  /** column name */
  MessageSid = 'message_sid'
}

/** input type for updating data in table "chat_twilio_conv_action_send_message" */
export type Chat_Twilio_Conv_Action_Send_Message_Set_Input = {
  attachment_url?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  channel_sid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  media_sid?: InputMaybe<Scalars['String']>;
  message_sid?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chat_twilio_conv_action_send_message" */
export enum Chat_Twilio_Conv_Action_Send_Message_Update_Column {
  /** column name */
  AttachmentUrl = 'attachment_url',
  /** column name */
  Author = 'author',
  /** column name */
  Body = 'body',
  /** column name */
  ChannelSid = 'channel_sid',
  /** column name */
  Id = 'id',
  /** column name */
  MediaSid = 'media_sid',
  /** column name */
  MessageSid = 'message_sid'
}

/** columns and relationships of "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_Webhooks = {
  __typename?: 'chat_twilio_conv_post_webhooks';
  body: Scalars['jsonb'];
  id: Scalars['uuid'];
};


/** columns and relationships of "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_WebhooksBodyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_Webhooks_Aggregate = {
  __typename?: 'chat_twilio_conv_post_webhooks_aggregate';
  aggregate?: Maybe<Chat_Twilio_Conv_Post_Webhooks_Aggregate_Fields>;
  nodes: Array<Chat_Twilio_Conv_Post_Webhooks>;
};

/** aggregate fields of "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_Webhooks_Aggregate_Fields = {
  __typename?: 'chat_twilio_conv_post_webhooks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chat_Twilio_Conv_Post_Webhooks_Max_Fields>;
  min?: Maybe<Chat_Twilio_Conv_Post_Webhooks_Min_Fields>;
};


/** aggregate fields of "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_Webhooks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Chat_Twilio_Conv_Post_Webhooks_Append_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "chat_twilio_conv_post_webhooks". All fields are combined with a logical 'AND'. */
export type Chat_Twilio_Conv_Post_Webhooks_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Bool_Exp>>;
  _not?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Bool_Exp>>;
  body?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_twilio_conv_post_webhooks" */
export enum Chat_Twilio_Conv_Post_Webhooks_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatTwilioConvPostWebhooksPkey = 'chat_twilio_conv_post_webhooks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Chat_Twilio_Conv_Post_Webhooks_Delete_At_Path_Input = {
  body?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Chat_Twilio_Conv_Post_Webhooks_Delete_Elem_Input = {
  body?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Chat_Twilio_Conv_Post_Webhooks_Delete_Key_Input = {
  body?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_Webhooks_Insert_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Chat_Twilio_Conv_Post_Webhooks_Max_Fields = {
  __typename?: 'chat_twilio_conv_post_webhooks_max_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Chat_Twilio_Conv_Post_Webhooks_Min_Fields = {
  __typename?: 'chat_twilio_conv_post_webhooks_min_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_Webhooks_Mutation_Response = {
  __typename?: 'chat_twilio_conv_post_webhooks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Twilio_Conv_Post_Webhooks>;
};

/** on_conflict condition type for table "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_Webhooks_On_Conflict = {
  constraint: Chat_Twilio_Conv_Post_Webhooks_Constraint;
  update_columns?: Array<Chat_Twilio_Conv_Post_Webhooks_Update_Column>;
  where?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_twilio_conv_post_webhooks". */
export type Chat_Twilio_Conv_Post_Webhooks_Order_By = {
  body?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_twilio_conv_post_webhooks */
export type Chat_Twilio_Conv_Post_Webhooks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Chat_Twilio_Conv_Post_Webhooks_Prepend_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "chat_twilio_conv_post_webhooks" */
export enum Chat_Twilio_Conv_Post_Webhooks_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "chat_twilio_conv_post_webhooks" */
export type Chat_Twilio_Conv_Post_Webhooks_Set_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "chat_twilio_conv_post_webhooks" */
export enum Chat_Twilio_Conv_Post_Webhooks_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Id = 'id'
}

/** Table to get a GetStream user/channel associated Alias */
export type Chat_User_Channel_Alias = {
  __typename?: 'chat_user_channel_alias';
  alias?: Maybe<Scalars['String']>;
  channel_id: Scalars['String'];
  id: Scalars['uuid'];
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "chat_user_channel_alias" */
export type Chat_User_Channel_Alias_Aggregate = {
  __typename?: 'chat_user_channel_alias_aggregate';
  aggregate?: Maybe<Chat_User_Channel_Alias_Aggregate_Fields>;
  nodes: Array<Chat_User_Channel_Alias>;
};

/** aggregate fields of "chat_user_channel_alias" */
export type Chat_User_Channel_Alias_Aggregate_Fields = {
  __typename?: 'chat_user_channel_alias_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chat_User_Channel_Alias_Max_Fields>;
  min?: Maybe<Chat_User_Channel_Alias_Min_Fields>;
};


/** aggregate fields of "chat_user_channel_alias" */
export type Chat_User_Channel_Alias_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_User_Channel_Alias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "chat_user_channel_alias". All fields are combined with a logical 'AND'. */
export type Chat_User_Channel_Alias_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_User_Channel_Alias_Bool_Exp>>;
  _not?: InputMaybe<Chat_User_Channel_Alias_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_User_Channel_Alias_Bool_Exp>>;
  alias?: InputMaybe<String_Comparison_Exp>;
  channel_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_user_channel_alias" */
export enum Chat_User_Channel_Alias_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatUserChannelAliasPkey = 'chat_user_channel_alias_pkey',
  /** unique or primary key constraint on columns "alias" */
  ChatUserChannelPalias = 'chat_user_channel_palias'
}

/** input type for inserting data into table "chat_user_channel_alias" */
export type Chat_User_Channel_Alias_Insert_Input = {
  alias?: InputMaybe<Scalars['String']>;
  channel_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Chat_User_Channel_Alias_Max_Fields = {
  __typename?: 'chat_user_channel_alias_max_fields';
  alias?: Maybe<Scalars['String']>;
  channel_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Chat_User_Channel_Alias_Min_Fields = {
  __typename?: 'chat_user_channel_alias_min_fields';
  alias?: Maybe<Scalars['String']>;
  channel_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chat_user_channel_alias" */
export type Chat_User_Channel_Alias_Mutation_Response = {
  __typename?: 'chat_user_channel_alias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_User_Channel_Alias>;
};

/** on_conflict condition type for table "chat_user_channel_alias" */
export type Chat_User_Channel_Alias_On_Conflict = {
  constraint: Chat_User_Channel_Alias_Constraint;
  update_columns?: Array<Chat_User_Channel_Alias_Update_Column>;
  where?: InputMaybe<Chat_User_Channel_Alias_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_user_channel_alias". */
export type Chat_User_Channel_Alias_Order_By = {
  alias?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_user_channel_alias */
export type Chat_User_Channel_Alias_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "chat_user_channel_alias" */
export enum Chat_User_Channel_Alias_Select_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "chat_user_channel_alias" */
export type Chat_User_Channel_Alias_Set_Input = {
  alias?: InputMaybe<Scalars['String']>;
  channel_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chat_user_channel_alias" */
export enum Chat_User_Channel_Alias_Update_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "client_fb_request_meta" */
export type Client_Fb_Request_Meta = {
  __typename?: 'client_fb_request_meta';
  client_organization_id: Scalars['uuid'];
  done?: Maybe<Scalars['Boolean']>;
  scopes: Scalars['jsonb'];
};


/** columns and relationships of "client_fb_request_meta" */
export type Client_Fb_Request_MetaScopesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "client_fb_request_meta" */
export type Client_Fb_Request_Meta_Aggregate = {
  __typename?: 'client_fb_request_meta_aggregate';
  aggregate?: Maybe<Client_Fb_Request_Meta_Aggregate_Fields>;
  nodes: Array<Client_Fb_Request_Meta>;
};

/** aggregate fields of "client_fb_request_meta" */
export type Client_Fb_Request_Meta_Aggregate_Fields = {
  __typename?: 'client_fb_request_meta_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Fb_Request_Meta_Max_Fields>;
  min?: Maybe<Client_Fb_Request_Meta_Min_Fields>;
};


/** aggregate fields of "client_fb_request_meta" */
export type Client_Fb_Request_Meta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Fb_Request_Meta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Client_Fb_Request_Meta_Append_Input = {
  scopes?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "client_fb_request_meta". All fields are combined with a logical 'AND'. */
export type Client_Fb_Request_Meta_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Fb_Request_Meta_Bool_Exp>>;
  _not?: InputMaybe<Client_Fb_Request_Meta_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Fb_Request_Meta_Bool_Exp>>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  done?: InputMaybe<Boolean_Comparison_Exp>;
  scopes?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_fb_request_meta" */
export enum Client_Fb_Request_Meta_Constraint {
  /** unique or primary key constraint on columns "client_organization_id" */
  ClientFbRequestMetaPkey = 'client_fb_request_meta_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Client_Fb_Request_Meta_Delete_At_Path_Input = {
  scopes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Client_Fb_Request_Meta_Delete_Elem_Input = {
  scopes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Client_Fb_Request_Meta_Delete_Key_Input = {
  scopes?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "client_fb_request_meta" */
export type Client_Fb_Request_Meta_Insert_Input = {
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  done?: InputMaybe<Scalars['Boolean']>;
  scopes?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Client_Fb_Request_Meta_Max_Fields = {
  __typename?: 'client_fb_request_meta_max_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Client_Fb_Request_Meta_Min_Fields = {
  __typename?: 'client_fb_request_meta_min_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "client_fb_request_meta" */
export type Client_Fb_Request_Meta_Mutation_Response = {
  __typename?: 'client_fb_request_meta_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Fb_Request_Meta>;
};

/** on_conflict condition type for table "client_fb_request_meta" */
export type Client_Fb_Request_Meta_On_Conflict = {
  constraint: Client_Fb_Request_Meta_Constraint;
  update_columns?: Array<Client_Fb_Request_Meta_Update_Column>;
  where?: InputMaybe<Client_Fb_Request_Meta_Bool_Exp>;
};

/** Ordering options when selecting data from "client_fb_request_meta". */
export type Client_Fb_Request_Meta_Order_By = {
  client_organization_id?: InputMaybe<Order_By>;
  done?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_fb_request_meta */
export type Client_Fb_Request_Meta_Pk_Columns_Input = {
  client_organization_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Client_Fb_Request_Meta_Prepend_Input = {
  scopes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "client_fb_request_meta" */
export enum Client_Fb_Request_Meta_Select_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  Done = 'done',
  /** column name */
  Scopes = 'scopes'
}

/** input type for updating data in table "client_fb_request_meta" */
export type Client_Fb_Request_Meta_Set_Input = {
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  done?: InputMaybe<Scalars['Boolean']>;
  scopes?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "client_fb_request_meta" */
export enum Client_Fb_Request_Meta_Update_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  Done = 'done',
  /** column name */
  Scopes = 'scopes'
}

/** columns and relationships of "client_fb_resource_status" */
export type Client_Fb_Resource_Status = {
  __typename?: 'client_fb_resource_status';
  name: Scalars['String'];
};

/** aggregated selection of "client_fb_resource_status" */
export type Client_Fb_Resource_Status_Aggregate = {
  __typename?: 'client_fb_resource_status_aggregate';
  aggregate?: Maybe<Client_Fb_Resource_Status_Aggregate_Fields>;
  nodes: Array<Client_Fb_Resource_Status>;
};

/** aggregate fields of "client_fb_resource_status" */
export type Client_Fb_Resource_Status_Aggregate_Fields = {
  __typename?: 'client_fb_resource_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Fb_Resource_Status_Max_Fields>;
  min?: Maybe<Client_Fb_Resource_Status_Min_Fields>;
};


/** aggregate fields of "client_fb_resource_status" */
export type Client_Fb_Resource_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Fb_Resource_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "client_fb_resource_status". All fields are combined with a logical 'AND'. */
export type Client_Fb_Resource_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Fb_Resource_Status_Bool_Exp>>;
  _not?: InputMaybe<Client_Fb_Resource_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Fb_Resource_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_fb_resource_status" */
export enum Client_Fb_Resource_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  ClientFbResourceStatusPkey = 'client_fb_resource_status_pkey'
}

export enum Client_Fb_Resource_Status_Enum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "client_fb_resource_status_enum". All fields are combined with logical 'AND'. */
export type Client_Fb_Resource_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Client_Fb_Resource_Status_Enum>;
  _in?: InputMaybe<Array<Client_Fb_Resource_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Client_Fb_Resource_Status_Enum>;
  _nin?: InputMaybe<Array<Client_Fb_Resource_Status_Enum>>;
};

/** input type for inserting data into table "client_fb_resource_status" */
export type Client_Fb_Resource_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Client_Fb_Resource_Status_Max_Fields = {
  __typename?: 'client_fb_resource_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Client_Fb_Resource_Status_Min_Fields = {
  __typename?: 'client_fb_resource_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "client_fb_resource_status" */
export type Client_Fb_Resource_Status_Mutation_Response = {
  __typename?: 'client_fb_resource_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Fb_Resource_Status>;
};

/** on_conflict condition type for table "client_fb_resource_status" */
export type Client_Fb_Resource_Status_On_Conflict = {
  constraint: Client_Fb_Resource_Status_Constraint;
  update_columns?: Array<Client_Fb_Resource_Status_Update_Column>;
  where?: InputMaybe<Client_Fb_Resource_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "client_fb_resource_status". */
export type Client_Fb_Resource_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_fb_resource_status */
export type Client_Fb_Resource_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "client_fb_resource_status" */
export enum Client_Fb_Resource_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "client_fb_resource_status" */
export type Client_Fb_Resource_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "client_fb_resource_status" */
export enum Client_Fb_Resource_Status_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "client_fb_resource_type" */
export type Client_Fb_Resource_Type = {
  __typename?: 'client_fb_resource_type';
  name: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "client_fb_resource_type" */
export type Client_Fb_Resource_Type_Aggregate = {
  __typename?: 'client_fb_resource_type_aggregate';
  aggregate?: Maybe<Client_Fb_Resource_Type_Aggregate_Fields>;
  nodes: Array<Client_Fb_Resource_Type>;
};

/** aggregate fields of "client_fb_resource_type" */
export type Client_Fb_Resource_Type_Aggregate_Fields = {
  __typename?: 'client_fb_resource_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Fb_Resource_Type_Max_Fields>;
  min?: Maybe<Client_Fb_Resource_Type_Min_Fields>;
};


/** aggregate fields of "client_fb_resource_type" */
export type Client_Fb_Resource_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Fb_Resource_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "client_fb_resource_type". All fields are combined with a logical 'AND'. */
export type Client_Fb_Resource_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Fb_Resource_Type_Bool_Exp>>;
  _not?: InputMaybe<Client_Fb_Resource_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Fb_Resource_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_fb_resource_type" */
export enum Client_Fb_Resource_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  ClientFbResourceTypePkey = 'client_fb_resource_type_pkey'
}

export enum Client_Fb_Resource_Type_Enum {
  /** ad */
  Ad = 'ad',
  /** catalog */
  Catalog = 'catalog',
  /** domain */
  Domain = 'domain',
  /** instagram */
  Instagram = 'instagram',
  /** leads */
  Leads = 'leads',
  /** page */
  Page = 'page',
  /** pixel */
  Pixel = 'pixel'
}

/** Boolean expression to compare columns of type "client_fb_resource_type_enum". All fields are combined with logical 'AND'. */
export type Client_Fb_Resource_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Client_Fb_Resource_Type_Enum>;
  _in?: InputMaybe<Array<Client_Fb_Resource_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Client_Fb_Resource_Type_Enum>;
  _nin?: InputMaybe<Array<Client_Fb_Resource_Type_Enum>>;
};

/** input type for inserting data into table "client_fb_resource_type" */
export type Client_Fb_Resource_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Client_Fb_Resource_Type_Max_Fields = {
  __typename?: 'client_fb_resource_type_max_fields';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Client_Fb_Resource_Type_Min_Fields = {
  __typename?: 'client_fb_resource_type_min_fields';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "client_fb_resource_type" */
export type Client_Fb_Resource_Type_Mutation_Response = {
  __typename?: 'client_fb_resource_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Fb_Resource_Type>;
};

/** on_conflict condition type for table "client_fb_resource_type" */
export type Client_Fb_Resource_Type_On_Conflict = {
  constraint: Client_Fb_Resource_Type_Constraint;
  update_columns?: Array<Client_Fb_Resource_Type_Update_Column>;
  where?: InputMaybe<Client_Fb_Resource_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "client_fb_resource_type". */
export type Client_Fb_Resource_Type_Order_By = {
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_fb_resource_type */
export type Client_Fb_Resource_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "client_fb_resource_type" */
export enum Client_Fb_Resource_Type_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "client_fb_resource_type" */
export type Client_Fb_Resource_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "client_fb_resource_type" */
export enum Client_Fb_Resource_Type_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "client_fb_resources" */
export type Client_Fb_Resources = {
  __typename?: 'client_fb_resources';
  client_organization_id: Scalars['uuid'];
  connection_date?: Maybe<Scalars['date']>;
  created_at: Scalars['timestamptz'];
  fb_id: Scalars['String'];
  fb_name: Scalars['String'];
  resource_type: Client_Fb_Resource_Type_Enum;
  status: Client_Fb_Resource_Status_Enum;
};

/** aggregated selection of "client_fb_resources" */
export type Client_Fb_Resources_Aggregate = {
  __typename?: 'client_fb_resources_aggregate';
  aggregate?: Maybe<Client_Fb_Resources_Aggregate_Fields>;
  nodes: Array<Client_Fb_Resources>;
};

/** aggregate fields of "client_fb_resources" */
export type Client_Fb_Resources_Aggregate_Fields = {
  __typename?: 'client_fb_resources_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Fb_Resources_Max_Fields>;
  min?: Maybe<Client_Fb_Resources_Min_Fields>;
};


/** aggregate fields of "client_fb_resources" */
export type Client_Fb_Resources_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Fb_Resources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "client_fb_resources" */
export type Client_Fb_Resources_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Fb_Resources_Max_Order_By>;
  min?: InputMaybe<Client_Fb_Resources_Min_Order_By>;
};

/** input type for inserting array relation for remote table "client_fb_resources" */
export type Client_Fb_Resources_Arr_Rel_Insert_Input = {
  data: Array<Client_Fb_Resources_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Fb_Resources_On_Conflict>;
};

/** Boolean expression to filter rows from the table "client_fb_resources". All fields are combined with a logical 'AND'. */
export type Client_Fb_Resources_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Fb_Resources_Bool_Exp>>;
  _not?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Fb_Resources_Bool_Exp>>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  connection_date?: InputMaybe<Date_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fb_id?: InputMaybe<String_Comparison_Exp>;
  fb_name?: InputMaybe<String_Comparison_Exp>;
  resource_type?: InputMaybe<Client_Fb_Resource_Type_Enum_Comparison_Exp>;
  status?: InputMaybe<Client_Fb_Resource_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_fb_resources" */
export enum Client_Fb_Resources_Constraint {
  /** unique or primary key constraint on columns "client_organization_id", "resource_type" */
  ClientFbResourcesPkey = 'client_fb_resources_pkey'
}

/** input type for inserting data into table "client_fb_resources" */
export type Client_Fb_Resources_Insert_Input = {
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  connection_date?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fb_id?: InputMaybe<Scalars['String']>;
  fb_name?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Client_Fb_Resource_Type_Enum>;
  status?: InputMaybe<Client_Fb_Resource_Status_Enum>;
};

/** aggregate max on columns */
export type Client_Fb_Resources_Max_Fields = {
  __typename?: 'client_fb_resources_max_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
  connection_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fb_id?: Maybe<Scalars['String']>;
  fb_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "client_fb_resources" */
export type Client_Fb_Resources_Max_Order_By = {
  client_organization_id?: InputMaybe<Order_By>;
  connection_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fb_id?: InputMaybe<Order_By>;
  fb_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Client_Fb_Resources_Min_Fields = {
  __typename?: 'client_fb_resources_min_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
  connection_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fb_id?: Maybe<Scalars['String']>;
  fb_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "client_fb_resources" */
export type Client_Fb_Resources_Min_Order_By = {
  client_organization_id?: InputMaybe<Order_By>;
  connection_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fb_id?: InputMaybe<Order_By>;
  fb_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_fb_resources" */
export type Client_Fb_Resources_Mutation_Response = {
  __typename?: 'client_fb_resources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Fb_Resources>;
};

/** on_conflict condition type for table "client_fb_resources" */
export type Client_Fb_Resources_On_Conflict = {
  constraint: Client_Fb_Resources_Constraint;
  update_columns?: Array<Client_Fb_Resources_Update_Column>;
  where?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
};

/** Ordering options when selecting data from "client_fb_resources". */
export type Client_Fb_Resources_Order_By = {
  client_organization_id?: InputMaybe<Order_By>;
  connection_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fb_id?: InputMaybe<Order_By>;
  fb_name?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_fb_resources */
export type Client_Fb_Resources_Pk_Columns_Input = {
  client_organization_id: Scalars['uuid'];
  resource_type: Client_Fb_Resource_Type_Enum;
};

/** select columns of table "client_fb_resources" */
export enum Client_Fb_Resources_Select_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  ConnectionDate = 'connection_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FbId = 'fb_id',
  /** column name */
  FbName = 'fb_name',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "client_fb_resources" */
export type Client_Fb_Resources_Set_Input = {
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  connection_date?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fb_id?: InputMaybe<Scalars['String']>;
  fb_name?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Client_Fb_Resource_Type_Enum>;
  status?: InputMaybe<Client_Fb_Resource_Status_Enum>;
};

/** update columns of table "client_fb_resources" */
export enum Client_Fb_Resources_Update_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  ConnectionDate = 'connection_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FbId = 'fb_id',
  /** column name */
  FbName = 'fb_name',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Status = 'status'
}

/** columns and relationships of "client_invites" */
export type Client_Invites = {
  __typename?: 'client_invites';
  /** An object relationship */
  agency: Organizations;
  agency_id: Scalars['uuid'];
  client_email: Scalars['String'];
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  message: Scalars['String'];
  status?: Maybe<Invites_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "client_invites" */
export type Client_Invites_Aggregate = {
  __typename?: 'client_invites_aggregate';
  aggregate?: Maybe<Client_Invites_Aggregate_Fields>;
  nodes: Array<Client_Invites>;
};

/** aggregate fields of "client_invites" */
export type Client_Invites_Aggregate_Fields = {
  __typename?: 'client_invites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Invites_Max_Fields>;
  min?: Maybe<Client_Invites_Min_Fields>;
};


/** aggregate fields of "client_invites" */
export type Client_Invites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "client_invites". All fields are combined with a logical 'AND'. */
export type Client_Invites_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Invites_Bool_Exp>>;
  _not?: InputMaybe<Client_Invites_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Invites_Bool_Exp>>;
  agency?: InputMaybe<Organizations_Bool_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_email?: InputMaybe<String_Comparison_Exp>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Invites_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_invites" */
export enum Client_Invites_Constraint {
  /** unique or primary key constraint on columns "client_email" */
  ClientInvitesClientEmailKey = 'client_invites_client_email_key',
  /** unique or primary key constraint on columns "agency_id", "client_email" */
  ClientInvitesPkey = 'client_invites_pkey'
}

/** input type for inserting data into table "client_invites" */
export type Client_Invites_Insert_Input = {
  agency?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  agency_id?: InputMaybe<Scalars['uuid']>;
  client_email?: InputMaybe<Scalars['String']>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Invites_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Client_Invites_Max_Fields = {
  __typename?: 'client_invites_max_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  client_email?: Maybe<Scalars['String']>;
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Client_Invites_Min_Fields = {
  __typename?: 'client_invites_min_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  client_email?: Maybe<Scalars['String']>;
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "client_invites" */
export type Client_Invites_Mutation_Response = {
  __typename?: 'client_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Invites>;
};

/** on_conflict condition type for table "client_invites" */
export type Client_Invites_On_Conflict = {
  constraint: Client_Invites_Constraint;
  update_columns?: Array<Client_Invites_Update_Column>;
  where?: InputMaybe<Client_Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "client_invites". */
export type Client_Invites_Order_By = {
  agency?: InputMaybe<Organizations_Order_By>;
  agency_id?: InputMaybe<Order_By>;
  client_email?: InputMaybe<Order_By>;
  client_organization_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_invites */
export type Client_Invites_Pk_Columns_Input = {
  agency_id: Scalars['uuid'];
  client_email: Scalars['String'];
};

/** select columns of table "client_invites" */
export enum Client_Invites_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ClientEmail = 'client_email',
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Message = 'message',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "client_invites" */
export type Client_Invites_Set_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  client_email?: InputMaybe<Scalars['String']>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Invites_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "client_invites" */
export enum Client_Invites_Update_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ClientEmail = 'client_email',
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Message = 'message',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "client_organization_caption_examples" */
export type Client_Organization_Caption_Examples = {
  __typename?: 'client_organization_caption_examples';
  caption: Scalars['String'];
  /** An object relationship */
  client_organization: Client_Organizations;
  client_organization_id: Scalars['uuid'];
  concept: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  subcategory?: Maybe<Caption_Example_Subcategories>;
  subcategory_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "client_organization_caption_examples" */
export type Client_Organization_Caption_Examples_Aggregate = {
  __typename?: 'client_organization_caption_examples_aggregate';
  aggregate?: Maybe<Client_Organization_Caption_Examples_Aggregate_Fields>;
  nodes: Array<Client_Organization_Caption_Examples>;
};

/** aggregate fields of "client_organization_caption_examples" */
export type Client_Organization_Caption_Examples_Aggregate_Fields = {
  __typename?: 'client_organization_caption_examples_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Organization_Caption_Examples_Max_Fields>;
  min?: Maybe<Client_Organization_Caption_Examples_Min_Fields>;
};


/** aggregate fields of "client_organization_caption_examples" */
export type Client_Organization_Caption_Examples_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Organization_Caption_Examples_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "client_organization_caption_examples". All fields are combined with a logical 'AND'. */
export type Client_Organization_Caption_Examples_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Organization_Caption_Examples_Bool_Exp>>;
  _not?: InputMaybe<Client_Organization_Caption_Examples_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Organization_Caption_Examples_Bool_Exp>>;
  caption?: InputMaybe<String_Comparison_Exp>;
  client_organization?: InputMaybe<Client_Organizations_Bool_Exp>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  concept?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  subcategory?: InputMaybe<Caption_Example_Subcategories_Bool_Exp>;
  subcategory_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_organization_caption_examples" */
export enum Client_Organization_Caption_Examples_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationCaptionExamplesPkey = 'organization_caption_examples_pkey'
}

/** input type for inserting data into table "client_organization_caption_examples" */
export type Client_Organization_Caption_Examples_Insert_Input = {
  caption?: InputMaybe<Scalars['String']>;
  client_organization?: InputMaybe<Client_Organizations_Obj_Rel_Insert_Input>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  concept?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  subcategory?: InputMaybe<Caption_Example_Subcategories_Obj_Rel_Insert_Input>;
  subcategory_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Client_Organization_Caption_Examples_Max_Fields = {
  __typename?: 'client_organization_caption_examples_max_fields';
  caption?: Maybe<Scalars['String']>;
  client_organization_id?: Maybe<Scalars['uuid']>;
  concept?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  subcategory_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Client_Organization_Caption_Examples_Min_Fields = {
  __typename?: 'client_organization_caption_examples_min_fields';
  caption?: Maybe<Scalars['String']>;
  client_organization_id?: Maybe<Scalars['uuid']>;
  concept?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  subcategory_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "client_organization_caption_examples" */
export type Client_Organization_Caption_Examples_Mutation_Response = {
  __typename?: 'client_organization_caption_examples_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Organization_Caption_Examples>;
};

/** on_conflict condition type for table "client_organization_caption_examples" */
export type Client_Organization_Caption_Examples_On_Conflict = {
  constraint: Client_Organization_Caption_Examples_Constraint;
  update_columns?: Array<Client_Organization_Caption_Examples_Update_Column>;
  where?: InputMaybe<Client_Organization_Caption_Examples_Bool_Exp>;
};

/** Ordering options when selecting data from "client_organization_caption_examples". */
export type Client_Organization_Caption_Examples_Order_By = {
  caption?: InputMaybe<Order_By>;
  client_organization?: InputMaybe<Client_Organizations_Order_By>;
  client_organization_id?: InputMaybe<Order_By>;
  concept?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subcategory?: InputMaybe<Caption_Example_Subcategories_Order_By>;
  subcategory_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_organization_caption_examples */
export type Client_Organization_Caption_Examples_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "client_organization_caption_examples" */
export enum Client_Organization_Caption_Examples_Select_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  Concept = 'concept',
  /** column name */
  Id = 'id',
  /** column name */
  SubcategoryId = 'subcategory_id'
}

/** input type for updating data in table "client_organization_caption_examples" */
export type Client_Organization_Caption_Examples_Set_Input = {
  caption?: InputMaybe<Scalars['String']>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  concept?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  subcategory_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "client_organization_caption_examples" */
export enum Client_Organization_Caption_Examples_Update_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  Concept = 'concept',
  /** column name */
  Id = 'id',
  /** column name */
  SubcategoryId = 'subcategory_id'
}

/** columns and relationships of "client_organization_fb_connection" */
export type Client_Organization_Fb_Connection = {
  __typename?: 'client_organization_fb_connection';
  /** An array relationship */
  access: Array<Client_Fb_Resources>;
  /** An aggregate relationship */
  access_aggregate: Client_Fb_Resources_Aggregate;
  access_token: Scalars['String'];
  access_token_expiration: Scalars['timestamp'];
  business_id: Scalars['String'];
  client_organization_id: Scalars['uuid'];
  fb_user_id: Scalars['String'];
};


/** columns and relationships of "client_organization_fb_connection" */
export type Client_Organization_Fb_ConnectionAccessArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resources_Order_By>>;
  where?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
};


/** columns and relationships of "client_organization_fb_connection" */
export type Client_Organization_Fb_ConnectionAccess_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resources_Order_By>>;
  where?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
};

/** aggregated selection of "client_organization_fb_connection" */
export type Client_Organization_Fb_Connection_Aggregate = {
  __typename?: 'client_organization_fb_connection_aggregate';
  aggregate?: Maybe<Client_Organization_Fb_Connection_Aggregate_Fields>;
  nodes: Array<Client_Organization_Fb_Connection>;
};

/** aggregate fields of "client_organization_fb_connection" */
export type Client_Organization_Fb_Connection_Aggregate_Fields = {
  __typename?: 'client_organization_fb_connection_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Organization_Fb_Connection_Max_Fields>;
  min?: Maybe<Client_Organization_Fb_Connection_Min_Fields>;
};


/** aggregate fields of "client_organization_fb_connection" */
export type Client_Organization_Fb_Connection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Organization_Fb_Connection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "client_organization_fb_connection". All fields are combined with a logical 'AND'. */
export type Client_Organization_Fb_Connection_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Organization_Fb_Connection_Bool_Exp>>;
  _not?: InputMaybe<Client_Organization_Fb_Connection_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Organization_Fb_Connection_Bool_Exp>>;
  access?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
  access_token?: InputMaybe<String_Comparison_Exp>;
  access_token_expiration?: InputMaybe<Timestamp_Comparison_Exp>;
  business_id?: InputMaybe<String_Comparison_Exp>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  fb_user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_organization_fb_connection" */
export enum Client_Organization_Fb_Connection_Constraint {
  /** unique or primary key constraint on columns "client_organization_id" */
  ClientOrganizationFbConnectionPkey = 'client_organization_fb_connection_pkey'
}

/** input type for inserting data into table "client_organization_fb_connection" */
export type Client_Organization_Fb_Connection_Insert_Input = {
  access?: InputMaybe<Client_Fb_Resources_Arr_Rel_Insert_Input>;
  access_token?: InputMaybe<Scalars['String']>;
  access_token_expiration?: InputMaybe<Scalars['timestamp']>;
  business_id?: InputMaybe<Scalars['String']>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  fb_user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Client_Organization_Fb_Connection_Max_Fields = {
  __typename?: 'client_organization_fb_connection_max_fields';
  access_token?: Maybe<Scalars['String']>;
  access_token_expiration?: Maybe<Scalars['timestamp']>;
  business_id?: Maybe<Scalars['String']>;
  client_organization_id?: Maybe<Scalars['uuid']>;
  fb_user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Client_Organization_Fb_Connection_Min_Fields = {
  __typename?: 'client_organization_fb_connection_min_fields';
  access_token?: Maybe<Scalars['String']>;
  access_token_expiration?: Maybe<Scalars['timestamp']>;
  business_id?: Maybe<Scalars['String']>;
  client_organization_id?: Maybe<Scalars['uuid']>;
  fb_user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "client_organization_fb_connection" */
export type Client_Organization_Fb_Connection_Mutation_Response = {
  __typename?: 'client_organization_fb_connection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Organization_Fb_Connection>;
};

/** on_conflict condition type for table "client_organization_fb_connection" */
export type Client_Organization_Fb_Connection_On_Conflict = {
  constraint: Client_Organization_Fb_Connection_Constraint;
  update_columns?: Array<Client_Organization_Fb_Connection_Update_Column>;
  where?: InputMaybe<Client_Organization_Fb_Connection_Bool_Exp>;
};

/** Ordering options when selecting data from "client_organization_fb_connection". */
export type Client_Organization_Fb_Connection_Order_By = {
  access_aggregate?: InputMaybe<Client_Fb_Resources_Aggregate_Order_By>;
  access_token?: InputMaybe<Order_By>;
  access_token_expiration?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  client_organization_id?: InputMaybe<Order_By>;
  fb_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_organization_fb_connection */
export type Client_Organization_Fb_Connection_Pk_Columns_Input = {
  client_organization_id: Scalars['uuid'];
};

/** select columns of table "client_organization_fb_connection" */
export enum Client_Organization_Fb_Connection_Select_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  AccessTokenExpiration = 'access_token_expiration',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  FbUserId = 'fb_user_id'
}

/** input type for updating data in table "client_organization_fb_connection" */
export type Client_Organization_Fb_Connection_Set_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  access_token_expiration?: InputMaybe<Scalars['timestamp']>;
  business_id?: InputMaybe<Scalars['String']>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  fb_user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "client_organization_fb_connection" */
export enum Client_Organization_Fb_Connection_Update_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  AccessTokenExpiration = 'access_token_expiration',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  FbUserId = 'fb_user_id'
}

/** columns and relationships of "client_organizations" */
export type Client_Organizations = {
  __typename?: 'client_organizations';
  address_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  address_links: Array<Address_Links>;
  /** An aggregate relationship */
  address_links_aggregate: Address_Links_Aggregate;
  /** An object relationship */
  agency: Organizations;
  agency_id: Scalars['uuid'];
  ai_brand_description?: Maybe<Scalars['String']>;
  /** An array relationship */
  client_relevant_links: Array<Client_Relevant_Links>;
  /** An aggregate relationship */
  client_relevant_links_aggregate: Client_Relevant_Links_Aggregate;
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  logo_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  members: Array<Organization_Members>;
  /** An aggregate relationship */
  members_aggregate: Organization_Members_Aggregate;
  name?: Maybe<Scalars['String']>;
  status: Organizations_Status_Enum;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "client_organizations" */
export type Client_OrganizationsAddress_LinksArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


/** columns and relationships of "client_organizations" */
export type Client_OrganizationsAddress_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


/** columns and relationships of "client_organizations" */
export type Client_OrganizationsClient_Relevant_LinksArgs = {
  distinct_on?: InputMaybe<Array<Client_Relevant_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Relevant_Links_Order_By>>;
  where?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
};


/** columns and relationships of "client_organizations" */
export type Client_OrganizationsClient_Relevant_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Relevant_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Relevant_Links_Order_By>>;
  where?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
};


/** columns and relationships of "client_organizations" */
export type Client_OrganizationsMembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "client_organizations" */
export type Client_OrganizationsMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};

/** aggregated selection of "client_organizations" */
export type Client_Organizations_Aggregate = {
  __typename?: 'client_organizations_aggregate';
  aggregate?: Maybe<Client_Organizations_Aggregate_Fields>;
  nodes: Array<Client_Organizations>;
};

/** aggregate fields of "client_organizations" */
export type Client_Organizations_Aggregate_Fields = {
  __typename?: 'client_organizations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Organizations_Max_Fields>;
  min?: Maybe<Client_Organizations_Min_Fields>;
};


/** aggregate fields of "client_organizations" */
export type Client_Organizations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "client_organizations" */
export type Client_Organizations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Organizations_Max_Order_By>;
  min?: InputMaybe<Client_Organizations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "client_organizations" */
export type Client_Organizations_Arr_Rel_Insert_Input = {
  data: Array<Client_Organizations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Organizations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "client_organizations". All fields are combined with a logical 'AND'. */
export type Client_Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Organizations_Bool_Exp>>;
  _not?: InputMaybe<Client_Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Organizations_Bool_Exp>>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  address_links?: InputMaybe<Address_Links_Bool_Exp>;
  agency?: InputMaybe<Organizations_Bool_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  ai_brand_description?: InputMaybe<String_Comparison_Exp>;
  client_relevant_links?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logo_url?: InputMaybe<String_Comparison_Exp>;
  members?: InputMaybe<Organization_Members_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Organizations_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_organizations" */
export enum Client_Organizations_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientOrganizationsPkey = 'client_organizations_pkey'
}

/** input type for inserting data into table "client_organizations" */
export type Client_Organizations_Insert_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  address_links?: InputMaybe<Address_Links_Arr_Rel_Insert_Input>;
  agency?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  agency_id?: InputMaybe<Scalars['uuid']>;
  ai_brand_description?: InputMaybe<Scalars['String']>;
  client_relevant_links?: InputMaybe<Client_Relevant_Links_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  logo_url?: InputMaybe<Scalars['String']>;
  members?: InputMaybe<Organization_Members_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Organizations_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Client_Organizations_Max_Fields = {
  __typename?: 'client_organizations_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  agency_id?: Maybe<Scalars['uuid']>;
  ai_brand_description?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logo_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "client_organizations" */
export type Client_Organizations_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  agency_id?: InputMaybe<Order_By>;
  ai_brand_description?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Client_Organizations_Min_Fields = {
  __typename?: 'client_organizations_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  agency_id?: Maybe<Scalars['uuid']>;
  ai_brand_description?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logo_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "client_organizations" */
export type Client_Organizations_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  agency_id?: InputMaybe<Order_By>;
  ai_brand_description?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_organizations" */
export type Client_Organizations_Mutation_Response = {
  __typename?: 'client_organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Organizations>;
};

/** input type for inserting object relation for remote table "client_organizations" */
export type Client_Organizations_Obj_Rel_Insert_Input = {
  data: Client_Organizations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Organizations_On_Conflict>;
};

/** on_conflict condition type for table "client_organizations" */
export type Client_Organizations_On_Conflict = {
  constraint: Client_Organizations_Constraint;
  update_columns?: Array<Client_Organizations_Update_Column>;
  where?: InputMaybe<Client_Organizations_Bool_Exp>;
};

/** Ordering options when selecting data from "client_organizations". */
export type Client_Organizations_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_links_aggregate?: InputMaybe<Address_Links_Aggregate_Order_By>;
  agency?: InputMaybe<Organizations_Order_By>;
  agency_id?: InputMaybe<Order_By>;
  ai_brand_description?: InputMaybe<Order_By>;
  client_relevant_links_aggregate?: InputMaybe<Client_Relevant_Links_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  members_aggregate?: InputMaybe<Organization_Members_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_organizations */
export type Client_Organizations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "client_organizations" */
export enum Client_Organizations_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  AiBrandDescription = 'ai_brand_description',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "client_organizations" */
export type Client_Organizations_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  agency_id?: InputMaybe<Scalars['uuid']>;
  ai_brand_description?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  logo_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Organizations_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "client_organizations" */
export enum Client_Organizations_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  AiBrandDescription = 'ai_brand_description',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Relevant links added by the Agency for each of their clients */
export type Client_Relevant_Links = {
  __typename?: 'client_relevant_links';
  agency_id: Scalars['uuid'];
  client_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
};

/** aggregated selection of "client_relevant_links" */
export type Client_Relevant_Links_Aggregate = {
  __typename?: 'client_relevant_links_aggregate';
  aggregate?: Maybe<Client_Relevant_Links_Aggregate_Fields>;
  nodes: Array<Client_Relevant_Links>;
};

/** aggregate fields of "client_relevant_links" */
export type Client_Relevant_Links_Aggregate_Fields = {
  __typename?: 'client_relevant_links_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Relevant_Links_Max_Fields>;
  min?: Maybe<Client_Relevant_Links_Min_Fields>;
};


/** aggregate fields of "client_relevant_links" */
export type Client_Relevant_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Relevant_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "client_relevant_links" */
export type Client_Relevant_Links_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Relevant_Links_Max_Order_By>;
  min?: InputMaybe<Client_Relevant_Links_Min_Order_By>;
};

/** input type for inserting array relation for remote table "client_relevant_links" */
export type Client_Relevant_Links_Arr_Rel_Insert_Input = {
  data: Array<Client_Relevant_Links_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Relevant_Links_On_Conflict>;
};

/** Boolean expression to filter rows from the table "client_relevant_links". All fields are combined with a logical 'AND'. */
export type Client_Relevant_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Relevant_Links_Bool_Exp>>;
  _not?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Relevant_Links_Bool_Exp>>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_relevant_links" */
export enum Client_Relevant_Links_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientRelevantLinksPkey = 'client_relevant_links_pkey'
}

/** input type for inserting data into table "client_relevant_links" */
export type Client_Relevant_Links_Insert_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Client_Relevant_Links_Max_Fields = {
  __typename?: 'client_relevant_links_max_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  client_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "client_relevant_links" */
export type Client_Relevant_Links_Max_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Client_Relevant_Links_Min_Fields = {
  __typename?: 'client_relevant_links_min_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  client_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "client_relevant_links" */
export type Client_Relevant_Links_Min_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_relevant_links" */
export type Client_Relevant_Links_Mutation_Response = {
  __typename?: 'client_relevant_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Relevant_Links>;
};

/** on_conflict condition type for table "client_relevant_links" */
export type Client_Relevant_Links_On_Conflict = {
  constraint: Client_Relevant_Links_Constraint;
  update_columns?: Array<Client_Relevant_Links_Update_Column>;
  where?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
};

/** Ordering options when selecting data from "client_relevant_links". */
export type Client_Relevant_Links_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_relevant_links */
export type Client_Relevant_Links_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "client_relevant_links" */
export enum Client_Relevant_Links_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "client_relevant_links" */
export type Client_Relevant_Links_Set_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "client_relevant_links" */
export enum Client_Relevant_Links_Update_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** columns and relationships of "client_report_document" */
export type Client_Report_Document = {
  __typename?: 'client_report_document';
  aggregated_data?: Maybe<Scalars['jsonb']>;
  client_report_set_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  metric?: Maybe<Scalars['String']>;
  period_end: Scalars['timestamptz'];
  period_start: Scalars['timestamptz'];
  raw_data?: Maybe<Scalars['jsonb']>;
  social_media: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "client_report_document" */
export type Client_Report_DocumentAggregated_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "client_report_document" */
export type Client_Report_DocumentRaw_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "client_report_document" */
export type Client_Report_Document_Aggregate = {
  __typename?: 'client_report_document_aggregate';
  aggregate?: Maybe<Client_Report_Document_Aggregate_Fields>;
  nodes: Array<Client_Report_Document>;
};

/** aggregate fields of "client_report_document" */
export type Client_Report_Document_Aggregate_Fields = {
  __typename?: 'client_report_document_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Report_Document_Max_Fields>;
  min?: Maybe<Client_Report_Document_Min_Fields>;
};


/** aggregate fields of "client_report_document" */
export type Client_Report_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Report_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "client_report_document" */
export type Client_Report_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Report_Document_Max_Order_By>;
  min?: InputMaybe<Client_Report_Document_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Client_Report_Document_Append_Input = {
  aggregated_data?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "client_report_document" */
export type Client_Report_Document_Arr_Rel_Insert_Input = {
  data: Array<Client_Report_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Report_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "client_report_document". All fields are combined with a logical 'AND'. */
export type Client_Report_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Report_Document_Bool_Exp>>;
  _not?: InputMaybe<Client_Report_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Report_Document_Bool_Exp>>;
  aggregated_data?: InputMaybe<Jsonb_Comparison_Exp>;
  client_report_set_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metric?: InputMaybe<String_Comparison_Exp>;
  period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  raw_data?: InputMaybe<Jsonb_Comparison_Exp>;
  social_media?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_report_document" */
export enum Client_Report_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientReportDocumentPkey = 'client_report_document_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Client_Report_Document_Delete_At_Path_Input = {
  aggregated_data?: InputMaybe<Array<Scalars['String']>>;
  raw_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Client_Report_Document_Delete_Elem_Input = {
  aggregated_data?: InputMaybe<Scalars['Int']>;
  raw_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Client_Report_Document_Delete_Key_Input = {
  aggregated_data?: InputMaybe<Scalars['String']>;
  raw_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "client_report_document" */
export type Client_Report_Document_Insert_Input = {
  aggregated_data?: InputMaybe<Scalars['jsonb']>;
  client_report_set_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metric?: InputMaybe<Scalars['String']>;
  period_end?: InputMaybe<Scalars['timestamptz']>;
  period_start?: InputMaybe<Scalars['timestamptz']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  social_media?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Client_Report_Document_Max_Fields = {
  __typename?: 'client_report_document_max_fields';
  client_report_set_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  metric?: Maybe<Scalars['String']>;
  period_end?: Maybe<Scalars['timestamptz']>;
  period_start?: Maybe<Scalars['timestamptz']>;
  social_media?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "client_report_document" */
export type Client_Report_Document_Max_Order_By = {
  client_report_set_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  social_media?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Client_Report_Document_Min_Fields = {
  __typename?: 'client_report_document_min_fields';
  client_report_set_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  metric?: Maybe<Scalars['String']>;
  period_end?: Maybe<Scalars['timestamptz']>;
  period_start?: Maybe<Scalars['timestamptz']>;
  social_media?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "client_report_document" */
export type Client_Report_Document_Min_Order_By = {
  client_report_set_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  social_media?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_report_document" */
export type Client_Report_Document_Mutation_Response = {
  __typename?: 'client_report_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Report_Document>;
};

/** on_conflict condition type for table "client_report_document" */
export type Client_Report_Document_On_Conflict = {
  constraint: Client_Report_Document_Constraint;
  update_columns?: Array<Client_Report_Document_Update_Column>;
  where?: InputMaybe<Client_Report_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "client_report_document". */
export type Client_Report_Document_Order_By = {
  aggregated_data?: InputMaybe<Order_By>;
  client_report_set_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  raw_data?: InputMaybe<Order_By>;
  social_media?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_report_document */
export type Client_Report_Document_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Client_Report_Document_Prepend_Input = {
  aggregated_data?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "client_report_document" */
export enum Client_Report_Document_Select_Column {
  /** column name */
  AggregatedData = 'aggregated_data',
  /** column name */
  ClientReportSetId = 'client_report_set_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metric = 'metric',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  SocialMedia = 'social_media',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "client_report_document" */
export type Client_Report_Document_Set_Input = {
  aggregated_data?: InputMaybe<Scalars['jsonb']>;
  client_report_set_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metric?: InputMaybe<Scalars['String']>;
  period_end?: InputMaybe<Scalars['timestamptz']>;
  period_start?: InputMaybe<Scalars['timestamptz']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  social_media?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "client_report_document" */
export enum Client_Report_Document_Update_Column {
  /** column name */
  AggregatedData = 'aggregated_data',
  /** column name */
  ClientReportSetId = 'client_report_set_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metric = 'metric',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  SocialMedia = 'social_media',
  /** column name */
  Type = 'type'
}

/** This table contains all the set of reports related to the marketing performance of clients social media. */
export type Client_Report_Set = {
  __typename?: 'client_report_set';
  /** An object relationship */
  client_organization: Client_Organizations;
  client_organization_id: Scalars['uuid'];
  /** An array relationship */
  client_report_documents: Array<Client_Report_Document>;
  /** An aggregate relationship */
  client_report_documents_aggregate: Client_Report_Document_Aggregate;
  created_at: Scalars['timestamptz'];
  email_recipients?: Maybe<Scalars['jsonb']>;
  expires_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
};


/** This table contains all the set of reports related to the marketing performance of clients social media. */
export type Client_Report_SetClient_Report_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Document_Order_By>>;
  where?: InputMaybe<Client_Report_Document_Bool_Exp>;
};


/** This table contains all the set of reports related to the marketing performance of clients social media. */
export type Client_Report_SetClient_Report_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Document_Order_By>>;
  where?: InputMaybe<Client_Report_Document_Bool_Exp>;
};


/** This table contains all the set of reports related to the marketing performance of clients social media. */
export type Client_Report_SetEmail_RecipientsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "client_report_set" */
export type Client_Report_Set_Aggregate = {
  __typename?: 'client_report_set_aggregate';
  aggregate?: Maybe<Client_Report_Set_Aggregate_Fields>;
  nodes: Array<Client_Report_Set>;
};

/** aggregate fields of "client_report_set" */
export type Client_Report_Set_Aggregate_Fields = {
  __typename?: 'client_report_set_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Report_Set_Max_Fields>;
  min?: Maybe<Client_Report_Set_Min_Fields>;
};


/** aggregate fields of "client_report_set" */
export type Client_Report_Set_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Report_Set_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Client_Report_Set_Append_Input = {
  email_recipients?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "client_report_set". All fields are combined with a logical 'AND'. */
export type Client_Report_Set_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Report_Set_Bool_Exp>>;
  _not?: InputMaybe<Client_Report_Set_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Report_Set_Bool_Exp>>;
  client_organization?: InputMaybe<Client_Organizations_Bool_Exp>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_report_documents?: InputMaybe<Client_Report_Document_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_recipients?: InputMaybe<Jsonb_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_report_set" */
export enum Client_Report_Set_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientReportSetPkey = 'client_report_set_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Client_Report_Set_Delete_At_Path_Input = {
  email_recipients?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Client_Report_Set_Delete_Elem_Input = {
  email_recipients?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Client_Report_Set_Delete_Key_Input = {
  email_recipients?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "client_report_set" */
export type Client_Report_Set_Insert_Input = {
  client_organization?: InputMaybe<Client_Organizations_Obj_Rel_Insert_Input>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  client_report_documents?: InputMaybe<Client_Report_Document_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_recipients?: InputMaybe<Scalars['jsonb']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Client_Report_Set_Max_Fields = {
  __typename?: 'client_report_set_max_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Client_Report_Set_Min_Fields = {
  __typename?: 'client_report_set_min_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "client_report_set" */
export type Client_Report_Set_Mutation_Response = {
  __typename?: 'client_report_set_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Report_Set>;
};

/** on_conflict condition type for table "client_report_set" */
export type Client_Report_Set_On_Conflict = {
  constraint: Client_Report_Set_Constraint;
  update_columns?: Array<Client_Report_Set_Update_Column>;
  where?: InputMaybe<Client_Report_Set_Bool_Exp>;
};

/** Ordering options when selecting data from "client_report_set". */
export type Client_Report_Set_Order_By = {
  client_organization?: InputMaybe<Client_Organizations_Order_By>;
  client_organization_id?: InputMaybe<Order_By>;
  client_report_documents_aggregate?: InputMaybe<Client_Report_Document_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_recipients?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_report_set */
export type Client_Report_Set_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Client_Report_Set_Prepend_Input = {
  email_recipients?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "client_report_set" */
export enum Client_Report_Set_Select_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailRecipients = 'email_recipients',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "client_report_set" */
export type Client_Report_Set_Set_Input = {
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_recipients?: InputMaybe<Scalars['jsonb']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "client_report_set" */
export enum Client_Report_Set_Update_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailRecipients = 'email_recipients',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id'
}

export type Date_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _cast?: InputMaybe<Date_Cast_Exp>;
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

export type Generate_Upload_Url_Input = {
  path: Scalars['String'];
};

export type Generate_Upload_Url_Output = {
  __typename?: 'generate_upload_url_output';
  url: Scalars['String'];
};

/** columns and relationships of "invites_status" */
export type Invites_Status = {
  __typename?: 'invites_status';
  name?: Maybe<Scalars['String']>;
  /** vals: pending, accepted, rejected, timed_out, canceled, bounced */
  status: Scalars['String'];
};

/** aggregated selection of "invites_status" */
export type Invites_Status_Aggregate = {
  __typename?: 'invites_status_aggregate';
  aggregate?: Maybe<Invites_Status_Aggregate_Fields>;
  nodes: Array<Invites_Status>;
};

/** aggregate fields of "invites_status" */
export type Invites_Status_Aggregate_Fields = {
  __typename?: 'invites_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invites_Status_Max_Fields>;
  min?: Maybe<Invites_Status_Min_Fields>;
};


/** aggregate fields of "invites_status" */
export type Invites_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invites_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invites_status". All fields are combined with a logical 'AND'. */
export type Invites_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Invites_Status_Bool_Exp>>;
  _not?: InputMaybe<Invites_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Invites_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "invites_status" */
export enum Invites_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  InvitesStatusPkey = 'invites_status_pkey'
}

export enum Invites_Status_Enum {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Bounced */
  Bounced = 'BOUNCED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Timed Out */
  TimedOut = 'TIMED_OUT'
}

/** Boolean expression to compare columns of type "invites_status_enum". All fields are combined with logical 'AND'. */
export type Invites_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Invites_Status_Enum>;
  _in?: InputMaybe<Array<Invites_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Invites_Status_Enum>;
  _nin?: InputMaybe<Array<Invites_Status_Enum>>;
};

/** input type for inserting data into table "invites_status" */
export type Invites_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
  /** vals: pending, accepted, rejected, timed_out, canceled, bounced */
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Invites_Status_Max_Fields = {
  __typename?: 'invites_status_max_fields';
  name?: Maybe<Scalars['String']>;
  /** vals: pending, accepted, rejected, timed_out, canceled, bounced */
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Invites_Status_Min_Fields = {
  __typename?: 'invites_status_min_fields';
  name?: Maybe<Scalars['String']>;
  /** vals: pending, accepted, rejected, timed_out, canceled, bounced */
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "invites_status" */
export type Invites_Status_Mutation_Response = {
  __typename?: 'invites_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invites_Status>;
};

/** on_conflict condition type for table "invites_status" */
export type Invites_Status_On_Conflict = {
  constraint: Invites_Status_Constraint;
  update_columns?: Array<Invites_Status_Update_Column>;
  where?: InputMaybe<Invites_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "invites_status". */
export type Invites_Status_Order_By = {
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invites_status */
export type Invites_Status_Pk_Columns_Input = {
  /** vals: pending, accepted, rejected, timed_out, canceled, bounced */
  status: Scalars['String'];
};

/** select columns of table "invites_status" */
export enum Invites_Status_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "invites_status" */
export type Invites_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
  /** vals: pending, accepted, rejected, timed_out, canceled, bounced */
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "invites_status" */
export enum Invites_Status_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status'
}

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "member_invites" */
export type Member_Invites = {
  __typename?: 'member_invites';
  agency_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamp']>;
  member_email: Scalars['String'];
  message: Scalars['String'];
  status?: Maybe<Invites_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "member_invites" */
export type Member_Invites_Aggregate = {
  __typename?: 'member_invites_aggregate';
  aggregate?: Maybe<Member_Invites_Aggregate_Fields>;
  nodes: Array<Member_Invites>;
};

/** aggregate fields of "member_invites" */
export type Member_Invites_Aggregate_Fields = {
  __typename?: 'member_invites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Member_Invites_Max_Fields>;
  min?: Maybe<Member_Invites_Min_Fields>;
};


/** aggregate fields of "member_invites" */
export type Member_Invites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Member_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "member_invites" */
export type Member_Invites_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Member_Invites_Max_Order_By>;
  min?: InputMaybe<Member_Invites_Min_Order_By>;
};

/** input type for inserting array relation for remote table "member_invites" */
export type Member_Invites_Arr_Rel_Insert_Input = {
  data: Array<Member_Invites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Member_Invites_On_Conflict>;
};

/** Boolean expression to filter rows from the table "member_invites". All fields are combined with a logical 'AND'. */
export type Member_Invites_Bool_Exp = {
  _and?: InputMaybe<Array<Member_Invites_Bool_Exp>>;
  _not?: InputMaybe<Member_Invites_Bool_Exp>;
  _or?: InputMaybe<Array<Member_Invites_Bool_Exp>>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  member_email?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Invites_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "member_invites" */
export enum Member_Invites_Constraint {
  /** unique or primary key constraint on columns "agency_id", "member_email" */
  MemberInvitesPkey = 'member_invites_pkey'
}

/** input type for inserting data into table "member_invites" */
export type Member_Invites_Insert_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  member_email?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Invites_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Member_Invites_Max_Fields = {
  __typename?: 'member_invites_max_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  member_email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "member_invites" */
export type Member_Invites_Max_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  member_email?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Member_Invites_Min_Fields = {
  __typename?: 'member_invites_min_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  member_email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "member_invites" */
export type Member_Invites_Min_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  member_email?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "member_invites" */
export type Member_Invites_Mutation_Response = {
  __typename?: 'member_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Member_Invites>;
};

/** on_conflict condition type for table "member_invites" */
export type Member_Invites_On_Conflict = {
  constraint: Member_Invites_Constraint;
  update_columns?: Array<Member_Invites_Update_Column>;
  where?: InputMaybe<Member_Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "member_invites". */
export type Member_Invites_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  member_email?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: member_invites */
export type Member_Invites_Pk_Columns_Input = {
  agency_id: Scalars['uuid'];
  member_email: Scalars['String'];
};

/** select columns of table "member_invites" */
export enum Member_Invites_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  MemberEmail = 'member_email',
  /** column name */
  Message = 'message',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "member_invites" */
export type Member_Invites_Set_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  member_email?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Invites_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "member_invites" */
export enum Member_Invites_Update_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  MemberEmail = 'member_email',
  /** column name */
  Message = 'message',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  add_client?: Maybe<AddclientOutput>;
  add_client_facebook_connection?: Maybe<ClientFacebookConnection>;
  add_facebook_connection?: Maybe<FacebookConnection>;
  /** This action handles creating a user on the request of the Agency manager on behalf of the user and adding them to agency members */
  add_organization_user?: Maybe<AddAndInviteMember>;
  ai_tools_generate_caption: AiToolsGenerateCaptionOutput;
  ai_tools_generate_concept?: Maybe<Array<Maybe<AiToolsConcept>>>;
  /** AI Image generation endpoint */
  ai_tools_generate_images?: Maybe<AiToolsImages>;
  ai_tools_get_related_event?: Maybe<Array<Maybe<RelatedEvent>>>;
  auth_refresh?: Maybe<AuthRefreshOutput>;
  auth_sign_in?: Maybe<SignInOutput>;
  auth_sign_out?: Maybe<GenericResult>;
  auth_sign_up?: Maybe<SignUpOutput>;
  /** auth_update_password */
  auth_update_password?: Maybe<GenericResult>;
  client_invitation_cancel?: Maybe<ClientInvitation>;
  client_invitation_create?: Maybe<ClientInvitation>;
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>;
  /** delete data from the table: "address_links" */
  delete_address_links?: Maybe<Address_Links_Mutation_Response>;
  /** delete single row from the table: "address_links" */
  delete_address_links_by_pk?: Maybe<Address_Links>;
  /** delete data from the table: "ai_tools_credits" */
  delete_ai_tools_credits?: Maybe<Ai_Tools_Credits_Mutation_Response>;
  /** delete single row from the table: "ai_tools_credits" */
  delete_ai_tools_credits_by_pk?: Maybe<Ai_Tools_Credits>;
  /** delete data from the table: "ai_tools_history" */
  delete_ai_tools_history?: Maybe<Ai_Tools_History_Mutation_Response>;
  /** delete single row from the table: "ai_tools_history" */
  delete_ai_tools_history_by_pk?: Maybe<Ai_Tools_History>;
  /** delete data from the table: "ai_tools_services" */
  delete_ai_tools_services?: Maybe<Ai_Tools_Services_Mutation_Response>;
  /** delete single row from the table: "ai_tools_services" */
  delete_ai_tools_services_by_pk?: Maybe<Ai_Tools_Services>;
  /** delete data from the table: "caption_example_categories" */
  delete_caption_example_categories?: Maybe<Caption_Example_Categories_Mutation_Response>;
  /** delete single row from the table: "caption_example_categories" */
  delete_caption_example_categories_by_pk?: Maybe<Caption_Example_Categories>;
  /** delete data from the table: "caption_example_subcategories" */
  delete_caption_example_subcategories?: Maybe<Caption_Example_Subcategories_Mutation_Response>;
  /** delete single row from the table: "caption_example_subcategories" */
  delete_caption_example_subcategories_by_pk?: Maybe<Caption_Example_Subcategories>;
  /** delete data from the table: "chat_bridgings" */
  delete_chat_bridgings?: Maybe<Chat_Bridgings_Mutation_Response>;
  /** delete single row from the table: "chat_bridgings" */
  delete_chat_bridgings_by_pk?: Maybe<Chat_Bridgings>;
  /** delete data from the table: "chat_stream_action_send_message" */
  delete_chat_stream_action_send_message?: Maybe<Chat_Stream_Action_Send_Message_Mutation_Response>;
  /** delete single row from the table: "chat_stream_action_send_message" */
  delete_chat_stream_action_send_message_by_pk?: Maybe<Chat_Stream_Action_Send_Message>;
  /** delete data from the table: "chat_stream_post_webhooks" */
  delete_chat_stream_post_webhooks?: Maybe<Chat_Stream_Post_Webhooks_Mutation_Response>;
  /** delete single row from the table: "chat_stream_post_webhooks" */
  delete_chat_stream_post_webhooks_by_pk?: Maybe<Chat_Stream_Post_Webhooks>;
  /** delete data from the table: "chat_stream_pre_webhooks" */
  delete_chat_stream_pre_webhooks?: Maybe<Chat_Stream_Pre_Webhooks_Mutation_Response>;
  /** delete single row from the table: "chat_stream_pre_webhooks" */
  delete_chat_stream_pre_webhooks_by_pk?: Maybe<Chat_Stream_Pre_Webhooks>;
  /** delete data from the table: "chat_twilio_conv_action_send_message" */
  delete_chat_twilio_conv_action_send_message?: Maybe<Chat_Twilio_Conv_Action_Send_Message_Mutation_Response>;
  /** delete single row from the table: "chat_twilio_conv_action_send_message" */
  delete_chat_twilio_conv_action_send_message_by_pk?: Maybe<Chat_Twilio_Conv_Action_Send_Message>;
  /** delete data from the table: "chat_twilio_conv_post_webhooks" */
  delete_chat_twilio_conv_post_webhooks?: Maybe<Chat_Twilio_Conv_Post_Webhooks_Mutation_Response>;
  /** delete single row from the table: "chat_twilio_conv_post_webhooks" */
  delete_chat_twilio_conv_post_webhooks_by_pk?: Maybe<Chat_Twilio_Conv_Post_Webhooks>;
  /** delete data from the table: "chat_user_channel_alias" */
  delete_chat_user_channel_alias?: Maybe<Chat_User_Channel_Alias_Mutation_Response>;
  /** delete single row from the table: "chat_user_channel_alias" */
  delete_chat_user_channel_alias_by_pk?: Maybe<Chat_User_Channel_Alias>;
  /** delete data from the table: "client_fb_request_meta" */
  delete_client_fb_request_meta?: Maybe<Client_Fb_Request_Meta_Mutation_Response>;
  /** delete single row from the table: "client_fb_request_meta" */
  delete_client_fb_request_meta_by_pk?: Maybe<Client_Fb_Request_Meta>;
  /** delete data from the table: "client_fb_resource_status" */
  delete_client_fb_resource_status?: Maybe<Client_Fb_Resource_Status_Mutation_Response>;
  /** delete single row from the table: "client_fb_resource_status" */
  delete_client_fb_resource_status_by_pk?: Maybe<Client_Fb_Resource_Status>;
  /** delete data from the table: "client_fb_resource_type" */
  delete_client_fb_resource_type?: Maybe<Client_Fb_Resource_Type_Mutation_Response>;
  /** delete single row from the table: "client_fb_resource_type" */
  delete_client_fb_resource_type_by_pk?: Maybe<Client_Fb_Resource_Type>;
  /** delete data from the table: "client_fb_resources" */
  delete_client_fb_resources?: Maybe<Client_Fb_Resources_Mutation_Response>;
  /** delete single row from the table: "client_fb_resources" */
  delete_client_fb_resources_by_pk?: Maybe<Client_Fb_Resources>;
  /** delete data from the table: "client_invites" */
  delete_client_invites?: Maybe<Client_Invites_Mutation_Response>;
  /** delete single row from the table: "client_invites" */
  delete_client_invites_by_pk?: Maybe<Client_Invites>;
  /** delete data from the table: "client_organization_caption_examples" */
  delete_client_organization_caption_examples?: Maybe<Client_Organization_Caption_Examples_Mutation_Response>;
  /** delete single row from the table: "client_organization_caption_examples" */
  delete_client_organization_caption_examples_by_pk?: Maybe<Client_Organization_Caption_Examples>;
  /** delete data from the table: "client_organization_fb_connection" */
  delete_client_organization_fb_connection?: Maybe<Client_Organization_Fb_Connection_Mutation_Response>;
  /** delete single row from the table: "client_organization_fb_connection" */
  delete_client_organization_fb_connection_by_pk?: Maybe<Client_Organization_Fb_Connection>;
  /** delete data from the table: "client_organizations" */
  delete_client_organizations?: Maybe<Client_Organizations_Mutation_Response>;
  /** delete single row from the table: "client_organizations" */
  delete_client_organizations_by_pk?: Maybe<Client_Organizations>;
  /** delete data from the table: "client_relevant_links" */
  delete_client_relevant_links?: Maybe<Client_Relevant_Links_Mutation_Response>;
  /** delete single row from the table: "client_relevant_links" */
  delete_client_relevant_links_by_pk?: Maybe<Client_Relevant_Links>;
  /** delete data from the table: "client_report_document" */
  delete_client_report_document?: Maybe<Client_Report_Document_Mutation_Response>;
  /** delete single row from the table: "client_report_document" */
  delete_client_report_document_by_pk?: Maybe<Client_Report_Document>;
  /** delete data from the table: "client_report_set" */
  delete_client_report_set?: Maybe<Client_Report_Set_Mutation_Response>;
  /** delete single row from the table: "client_report_set" */
  delete_client_report_set_by_pk?: Maybe<Client_Report_Set>;
  /** delete data from the table: "invites_status" */
  delete_invites_status?: Maybe<Invites_Status_Mutation_Response>;
  /** delete single row from the table: "invites_status" */
  delete_invites_status_by_pk?: Maybe<Invites_Status>;
  /** delete data from the table: "member_invites" */
  delete_member_invites?: Maybe<Member_Invites_Mutation_Response>;
  /** delete single row from the table: "member_invites" */
  delete_member_invites_by_pk?: Maybe<Member_Invites>;
  /** delete data from the table: "offers" */
  delete_offers?: Maybe<Offers_Mutation_Response>;
  /** delete single row from the table: "offers" */
  delete_offers_by_pk?: Maybe<Offers>;
  /** delete data from the table: "offers_status" */
  delete_offers_status?: Maybe<Offers_Status_Mutation_Response>;
  /** delete single row from the table: "offers_status" */
  delete_offers_status_by_pk?: Maybe<Offers_Status>;
  /** delete data from the table: "organization_fb_connection" */
  delete_organization_fb_connection?: Maybe<Organization_Fb_Connection_Mutation_Response>;
  /** delete single row from the table: "organization_fb_connection" */
  delete_organization_fb_connection_by_pk?: Maybe<Organization_Fb_Connection>;
  /** delete data from the table: "organization_members" */
  delete_organization_members?: Maybe<Organization_Members_Mutation_Response>;
  /** delete single row from the table: "organization_members" */
  delete_organization_members_by_pk?: Maybe<Organization_Members>;
  /** delete data from the table: "organization_members_status" */
  delete_organization_members_status?: Maybe<Organization_Members_Status_Mutation_Response>;
  /** delete single row from the table: "organization_members_status" */
  delete_organization_members_status_by_pk?: Maybe<Organization_Members_Status>;
  /** delete data from the table: "organization_members_type" */
  delete_organization_members_type?: Maybe<Organization_Members_Type_Mutation_Response>;
  /** delete single row from the table: "organization_members_type" */
  delete_organization_members_type_by_pk?: Maybe<Organization_Members_Type>;
  /** delete data from the table: "organizations" */
  delete_organizations?: Maybe<Organizations_Mutation_Response>;
  /** delete single row from the table: "organizations" */
  delete_organizations_by_pk?: Maybe<Organizations>;
  /** delete data from the table: "organizations_status" */
  delete_organizations_status?: Maybe<Organizations_Status_Mutation_Response>;
  /** delete single row from the table: "organizations_status" */
  delete_organizations_status_by_pk?: Maybe<Organizations_Status>;
  /** delete data from the table: "organizations_type" */
  delete_organizations_type?: Maybe<Organizations_Type_Mutation_Response>;
  /** delete single row from the table: "organizations_type" */
  delete_organizations_type_by_pk?: Maybe<Organizations_Type>;
  /** delete data from the table: "project_users" */
  delete_project_users?: Maybe<Project_Users_Mutation_Response>;
  /** delete single row from the table: "project_users" */
  delete_project_users_by_pk?: Maybe<Project_Users>;
  /** delete data from the table: "projects" */
  delete_projects?: Maybe<Projects_Mutation_Response>;
  /** delete single row from the table: "projects" */
  delete_projects_by_pk?: Maybe<Projects>;
  /** delete data from the table: "projects_status" */
  delete_projects_status?: Maybe<Projects_Status_Mutation_Response>;
  /** delete single row from the table: "projects_status" */
  delete_projects_status_by_pk?: Maybe<Projects_Status>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "theme_type" */
  delete_theme_type?: Maybe<Theme_Type_Mutation_Response>;
  /** delete single row from the table: "theme_type" */
  delete_theme_type_by_pk?: Maybe<Theme_Type>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "users_freelancer_status" */
  delete_users_freelancer_status?: Maybe<Users_Freelancer_Status_Mutation_Response>;
  /** delete single row from the table: "users_freelancer_status" */
  delete_users_freelancer_status_by_pk?: Maybe<Users_Freelancer_Status>;
  /** delete data from the table: "white_labeling" */
  delete_white_labeling?: Maybe<White_Labeling_Mutation_Response>;
  /** delete single row from the table: "white_labeling" */
  delete_white_labeling_by_pk?: Maybe<White_Labeling>;
  /** delete data from the table: "white_labeling_colors" */
  delete_white_labeling_colors?: Maybe<White_Labeling_Colors_Mutation_Response>;
  /** delete single row from the table: "white_labeling_colors" */
  delete_white_labeling_colors_by_pk?: Maybe<White_Labeling_Colors>;
  /** delete data from the table: "white_labeling_fonts" */
  delete_white_labeling_fonts?: Maybe<White_Labeling_Fonts_Mutation_Response>;
  /** delete single row from the table: "white_labeling_fonts" */
  delete_white_labeling_fonts_by_pk?: Maybe<White_Labeling_Fonts>;
  /** delete data from the table: "workflow.document_versions" */
  delete_workflow_document_versions?: Maybe<Workflow_Document_Versions_Mutation_Response>;
  /** delete single row from the table: "workflow.document_versions" */
  delete_workflow_document_versions_by_pk?: Maybe<Workflow_Document_Versions>;
  /** delete data from the table: "workflow.documents" */
  delete_workflow_documents?: Maybe<Workflow_Documents_Mutation_Response>;
  /** delete single row from the table: "workflow.documents" */
  delete_workflow_documents_by_pk?: Maybe<Workflow_Documents>;
  /** delete data from the table: "workflow.field_contents" */
  delete_workflow_field_contents?: Maybe<Workflow_Field_Contents_Mutation_Response>;
  /** delete single row from the table: "workflow.field_contents" */
  delete_workflow_field_contents_by_pk?: Maybe<Workflow_Field_Contents>;
  /** delete data from the table: "workflow.field_permission_types" */
  delete_workflow_field_permission_types?: Maybe<Workflow_Field_Permission_Types_Mutation_Response>;
  /** delete single row from the table: "workflow.field_permission_types" */
  delete_workflow_field_permission_types_by_pk?: Maybe<Workflow_Field_Permission_Types>;
  /** delete data from the table: "workflow.field_permissions" */
  delete_workflow_field_permissions?: Maybe<Workflow_Field_Permissions_Mutation_Response>;
  /** delete single row from the table: "workflow.field_permissions" */
  delete_workflow_field_permissions_by_pk?: Maybe<Workflow_Field_Permissions>;
  /** delete data from the table: "workflow.field_types" */
  delete_workflow_field_types?: Maybe<Workflow_Field_Types_Mutation_Response>;
  /** delete single row from the table: "workflow.field_types" */
  delete_workflow_field_types_by_pk?: Maybe<Workflow_Field_Types>;
  /** delete data from the table: "workflow.fields" */
  delete_workflow_fields?: Maybe<Workflow_Fields_Mutation_Response>;
  /** delete single row from the table: "workflow.fields" */
  delete_workflow_fields_by_pk?: Maybe<Workflow_Fields>;
  /** delete data from the table: "workflow.pages" */
  delete_workflow_pages?: Maybe<Workflow_Pages_Mutation_Response>;
  /** delete single row from the table: "workflow.pages" */
  delete_workflow_pages_by_pk?: Maybe<Workflow_Pages>;
  /** delete data from the table: "workflow.processmaker_users" */
  delete_workflow_processmaker_users?: Maybe<Workflow_Processmaker_Users_Mutation_Response>;
  /** delete single row from the table: "workflow.processmaker_users" */
  delete_workflow_processmaker_users_by_pk?: Maybe<Workflow_Processmaker_Users>;
  /** delete data from the table: "workflow.saved_document_part_types" */
  delete_workflow_saved_document_part_types?: Maybe<Workflow_Saved_Document_Part_Types_Mutation_Response>;
  /** delete single row from the table: "workflow.saved_document_part_types" */
  delete_workflow_saved_document_part_types_by_pk?: Maybe<Workflow_Saved_Document_Part_Types>;
  /** delete data from the table: "workflow.saved_document_parts" */
  delete_workflow_saved_document_parts?: Maybe<Workflow_Saved_Document_Parts_Mutation_Response>;
  /** delete single row from the table: "workflow.saved_document_parts" */
  delete_workflow_saved_document_parts_by_pk?: Maybe<Workflow_Saved_Document_Parts>;
  /** delete data from the table: "workflow.section_comment_status" */
  delete_workflow_section_comment_status?: Maybe<Workflow_Section_Comment_Status_Mutation_Response>;
  /** delete single row from the table: "workflow.section_comment_status" */
  delete_workflow_section_comment_status_by_pk?: Maybe<Workflow_Section_Comment_Status>;
  /** delete data from the table: "workflow.section_comments" */
  delete_workflow_section_comments?: Maybe<Workflow_Section_Comments_Mutation_Response>;
  /** delete single row from the table: "workflow.section_comments" */
  delete_workflow_section_comments_by_pk?: Maybe<Workflow_Section_Comments>;
  /** delete data from the table: "workflow.sections" */
  delete_workflow_sections?: Maybe<Workflow_Sections_Mutation_Response>;
  /** delete single row from the table: "workflow.sections" */
  delete_workflow_sections_by_pk?: Maybe<Workflow_Sections>;
  /** delete data from the table: "workflow.task_notifications" */
  delete_workflow_task_notifications?: Maybe<Workflow_Task_Notifications_Mutation_Response>;
  /** delete single row from the table: "workflow.task_notifications" */
  delete_workflow_task_notifications_by_pk?: Maybe<Workflow_Task_Notifications>;
  /** delete data from the table: "workflow.task_types" */
  delete_workflow_task_types?: Maybe<Workflow_Task_Types_Mutation_Response>;
  /** delete single row from the table: "workflow.task_types" */
  delete_workflow_task_types_by_pk?: Maybe<Workflow_Task_Types>;
  /** delete data from the table: "workflow.tasks" */
  delete_workflow_tasks?: Maybe<Workflow_Tasks_Mutation_Response>;
  /** delete single row from the table: "workflow.tasks" */
  delete_workflow_tasks_by_pk?: Maybe<Workflow_Tasks>;
  /** delete data from the table: "workflow.workflow_creation_status" */
  delete_workflow_workflow_creation_status?: Maybe<Workflow_Workflow_Creation_Status_Mutation_Response>;
  /** delete single row from the table: "workflow.workflow_creation_status" */
  delete_workflow_workflow_creation_status_by_pk?: Maybe<Workflow_Workflow_Creation_Status>;
  /** delete data from the table: "workflow.workflow_reactflow_status" */
  delete_workflow_workflow_reactflow_status?: Maybe<Workflow_Workflow_Reactflow_Status_Mutation_Response>;
  /** delete single row from the table: "workflow.workflow_reactflow_status" */
  delete_workflow_workflow_reactflow_status_by_pk?: Maybe<Workflow_Workflow_Reactflow_Status>;
  /** delete data from the table: "workflow.workflow_status" */
  delete_workflow_workflow_status?: Maybe<Workflow_Workflow_Status_Mutation_Response>;
  /** delete single row from the table: "workflow.workflow_status" */
  delete_workflow_workflow_status_by_pk?: Maybe<Workflow_Workflow_Status>;
  /** delete data from the table: "workflow.workflow_templates" */
  delete_workflow_workflow_templates?: Maybe<Workflow_Workflow_Templates_Mutation_Response>;
  /** delete single row from the table: "workflow.workflow_templates" */
  delete_workflow_workflow_templates_by_pk?: Maybe<Workflow_Workflow_Templates>;
  /** delete data from the table: "workflow.workflow_versions" */
  delete_workflow_workflow_versions?: Maybe<Workflow_Workflow_Versions_Mutation_Response>;
  /** delete single row from the table: "workflow.workflow_versions" */
  delete_workflow_workflow_versions_by_pk?: Maybe<Workflow_Workflow_Versions>;
  /** delete data from the table: "workflow.workflows" */
  delete_workflow_workflows?: Maybe<Workflow_Workflows_Mutation_Response>;
  /** delete single row from the table: "workflow.workflows" */
  delete_workflow_workflows_by_pk?: Maybe<Workflow_Workflows>;
  generate_upload_url?: Maybe<Generate_Upload_Url_Output>;
  /** get_client_report */
  get_client_report?: Maybe<ClientReportItemType>;
  /** get_client_shared_report */
  get_client_shared_report?: Maybe<GetClientSharedReportOutput>;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert data into the table: "address_links" */
  insert_address_links?: Maybe<Address_Links_Mutation_Response>;
  /** insert a single row into the table: "address_links" */
  insert_address_links_one?: Maybe<Address_Links>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "ai_tools_credits" */
  insert_ai_tools_credits?: Maybe<Ai_Tools_Credits_Mutation_Response>;
  /** insert a single row into the table: "ai_tools_credits" */
  insert_ai_tools_credits_one?: Maybe<Ai_Tools_Credits>;
  /** insert data into the table: "ai_tools_history" */
  insert_ai_tools_history?: Maybe<Ai_Tools_History_Mutation_Response>;
  /** insert a single row into the table: "ai_tools_history" */
  insert_ai_tools_history_one?: Maybe<Ai_Tools_History>;
  /** insert data into the table: "ai_tools_services" */
  insert_ai_tools_services?: Maybe<Ai_Tools_Services_Mutation_Response>;
  /** insert a single row into the table: "ai_tools_services" */
  insert_ai_tools_services_one?: Maybe<Ai_Tools_Services>;
  /** insert data into the table: "caption_example_categories" */
  insert_caption_example_categories?: Maybe<Caption_Example_Categories_Mutation_Response>;
  /** insert a single row into the table: "caption_example_categories" */
  insert_caption_example_categories_one?: Maybe<Caption_Example_Categories>;
  /** insert data into the table: "caption_example_subcategories" */
  insert_caption_example_subcategories?: Maybe<Caption_Example_Subcategories_Mutation_Response>;
  /** insert a single row into the table: "caption_example_subcategories" */
  insert_caption_example_subcategories_one?: Maybe<Caption_Example_Subcategories>;
  /** insert data into the table: "chat_bridgings" */
  insert_chat_bridgings?: Maybe<Chat_Bridgings_Mutation_Response>;
  /** insert a single row into the table: "chat_bridgings" */
  insert_chat_bridgings_one?: Maybe<Chat_Bridgings>;
  /** insert data into the table: "chat_stream_action_send_message" */
  insert_chat_stream_action_send_message?: Maybe<Chat_Stream_Action_Send_Message_Mutation_Response>;
  /** insert a single row into the table: "chat_stream_action_send_message" */
  insert_chat_stream_action_send_message_one?: Maybe<Chat_Stream_Action_Send_Message>;
  /** insert data into the table: "chat_stream_post_webhooks" */
  insert_chat_stream_post_webhooks?: Maybe<Chat_Stream_Post_Webhooks_Mutation_Response>;
  /** insert a single row into the table: "chat_stream_post_webhooks" */
  insert_chat_stream_post_webhooks_one?: Maybe<Chat_Stream_Post_Webhooks>;
  /** insert data into the table: "chat_stream_pre_webhooks" */
  insert_chat_stream_pre_webhooks?: Maybe<Chat_Stream_Pre_Webhooks_Mutation_Response>;
  /** insert a single row into the table: "chat_stream_pre_webhooks" */
  insert_chat_stream_pre_webhooks_one?: Maybe<Chat_Stream_Pre_Webhooks>;
  /** insert data into the table: "chat_twilio_conv_action_send_message" */
  insert_chat_twilio_conv_action_send_message?: Maybe<Chat_Twilio_Conv_Action_Send_Message_Mutation_Response>;
  /** insert a single row into the table: "chat_twilio_conv_action_send_message" */
  insert_chat_twilio_conv_action_send_message_one?: Maybe<Chat_Twilio_Conv_Action_Send_Message>;
  /** insert data into the table: "chat_twilio_conv_post_webhooks" */
  insert_chat_twilio_conv_post_webhooks?: Maybe<Chat_Twilio_Conv_Post_Webhooks_Mutation_Response>;
  /** insert a single row into the table: "chat_twilio_conv_post_webhooks" */
  insert_chat_twilio_conv_post_webhooks_one?: Maybe<Chat_Twilio_Conv_Post_Webhooks>;
  /** insert data into the table: "chat_user_channel_alias" */
  insert_chat_user_channel_alias?: Maybe<Chat_User_Channel_Alias_Mutation_Response>;
  /** insert a single row into the table: "chat_user_channel_alias" */
  insert_chat_user_channel_alias_one?: Maybe<Chat_User_Channel_Alias>;
  /** insert data into the table: "client_fb_request_meta" */
  insert_client_fb_request_meta?: Maybe<Client_Fb_Request_Meta_Mutation_Response>;
  /** insert a single row into the table: "client_fb_request_meta" */
  insert_client_fb_request_meta_one?: Maybe<Client_Fb_Request_Meta>;
  /** insert data into the table: "client_fb_resource_status" */
  insert_client_fb_resource_status?: Maybe<Client_Fb_Resource_Status_Mutation_Response>;
  /** insert a single row into the table: "client_fb_resource_status" */
  insert_client_fb_resource_status_one?: Maybe<Client_Fb_Resource_Status>;
  /** insert data into the table: "client_fb_resource_type" */
  insert_client_fb_resource_type?: Maybe<Client_Fb_Resource_Type_Mutation_Response>;
  /** insert a single row into the table: "client_fb_resource_type" */
  insert_client_fb_resource_type_one?: Maybe<Client_Fb_Resource_Type>;
  /** insert data into the table: "client_fb_resources" */
  insert_client_fb_resources?: Maybe<Client_Fb_Resources_Mutation_Response>;
  /** insert a single row into the table: "client_fb_resources" */
  insert_client_fb_resources_one?: Maybe<Client_Fb_Resources>;
  /** insert data into the table: "client_invites" */
  insert_client_invites?: Maybe<Client_Invites_Mutation_Response>;
  /** insert a single row into the table: "client_invites" */
  insert_client_invites_one?: Maybe<Client_Invites>;
  /** insert data into the table: "client_organization_caption_examples" */
  insert_client_organization_caption_examples?: Maybe<Client_Organization_Caption_Examples_Mutation_Response>;
  /** insert a single row into the table: "client_organization_caption_examples" */
  insert_client_organization_caption_examples_one?: Maybe<Client_Organization_Caption_Examples>;
  /** insert data into the table: "client_organization_fb_connection" */
  insert_client_organization_fb_connection?: Maybe<Client_Organization_Fb_Connection_Mutation_Response>;
  /** insert a single row into the table: "client_organization_fb_connection" */
  insert_client_organization_fb_connection_one?: Maybe<Client_Organization_Fb_Connection>;
  /** insert data into the table: "client_organizations" */
  insert_client_organizations?: Maybe<Client_Organizations_Mutation_Response>;
  /** insert a single row into the table: "client_organizations" */
  insert_client_organizations_one?: Maybe<Client_Organizations>;
  /** insert data into the table: "client_relevant_links" */
  insert_client_relevant_links?: Maybe<Client_Relevant_Links_Mutation_Response>;
  /** insert a single row into the table: "client_relevant_links" */
  insert_client_relevant_links_one?: Maybe<Client_Relevant_Links>;
  /** insert data into the table: "client_report_document" */
  insert_client_report_document?: Maybe<Client_Report_Document_Mutation_Response>;
  /** insert a single row into the table: "client_report_document" */
  insert_client_report_document_one?: Maybe<Client_Report_Document>;
  /** insert data into the table: "client_report_set" */
  insert_client_report_set?: Maybe<Client_Report_Set_Mutation_Response>;
  /** insert a single row into the table: "client_report_set" */
  insert_client_report_set_one?: Maybe<Client_Report_Set>;
  /** insert data into the table: "invites_status" */
  insert_invites_status?: Maybe<Invites_Status_Mutation_Response>;
  /** insert a single row into the table: "invites_status" */
  insert_invites_status_one?: Maybe<Invites_Status>;
  /** insert data into the table: "member_invites" */
  insert_member_invites?: Maybe<Member_Invites_Mutation_Response>;
  /** insert a single row into the table: "member_invites" */
  insert_member_invites_one?: Maybe<Member_Invites>;
  /** insert data into the table: "offers" */
  insert_offers?: Maybe<Offers_Mutation_Response>;
  /** insert a single row into the table: "offers" */
  insert_offers_one?: Maybe<Offers>;
  /** insert data into the table: "offers_status" */
  insert_offers_status?: Maybe<Offers_Status_Mutation_Response>;
  /** insert a single row into the table: "offers_status" */
  insert_offers_status_one?: Maybe<Offers_Status>;
  /** insert data into the table: "organization_fb_connection" */
  insert_organization_fb_connection?: Maybe<Organization_Fb_Connection_Mutation_Response>;
  /** insert a single row into the table: "organization_fb_connection" */
  insert_organization_fb_connection_one?: Maybe<Organization_Fb_Connection>;
  /** insert data into the table: "organization_members" */
  insert_organization_members?: Maybe<Organization_Members_Mutation_Response>;
  /** insert a single row into the table: "organization_members" */
  insert_organization_members_one?: Maybe<Organization_Members>;
  /** insert data into the table: "organization_members_status" */
  insert_organization_members_status?: Maybe<Organization_Members_Status_Mutation_Response>;
  /** insert a single row into the table: "organization_members_status" */
  insert_organization_members_status_one?: Maybe<Organization_Members_Status>;
  /** insert data into the table: "organization_members_type" */
  insert_organization_members_type?: Maybe<Organization_Members_Type_Mutation_Response>;
  /** insert a single row into the table: "organization_members_type" */
  insert_organization_members_type_one?: Maybe<Organization_Members_Type>;
  /** insert data into the table: "organizations" */
  insert_organizations?: Maybe<Organizations_Mutation_Response>;
  /** insert a single row into the table: "organizations" */
  insert_organizations_one?: Maybe<Organizations>;
  /** insert data into the table: "organizations_status" */
  insert_organizations_status?: Maybe<Organizations_Status_Mutation_Response>;
  /** insert a single row into the table: "organizations_status" */
  insert_organizations_status_one?: Maybe<Organizations_Status>;
  /** insert data into the table: "organizations_type" */
  insert_organizations_type?: Maybe<Organizations_Type_Mutation_Response>;
  /** insert a single row into the table: "organizations_type" */
  insert_organizations_type_one?: Maybe<Organizations_Type>;
  /** insert data into the table: "project_users" */
  insert_project_users?: Maybe<Project_Users_Mutation_Response>;
  /** insert a single row into the table: "project_users" */
  insert_project_users_one?: Maybe<Project_Users>;
  /** insert data into the table: "projects" */
  insert_projects?: Maybe<Projects_Mutation_Response>;
  /** insert a single row into the table: "projects" */
  insert_projects_one?: Maybe<Projects>;
  /** insert data into the table: "projects_status" */
  insert_projects_status?: Maybe<Projects_Status_Mutation_Response>;
  /** insert a single row into the table: "projects_status" */
  insert_projects_status_one?: Maybe<Projects_Status>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "theme_type" */
  insert_theme_type?: Maybe<Theme_Type_Mutation_Response>;
  /** insert a single row into the table: "theme_type" */
  insert_theme_type_one?: Maybe<Theme_Type>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert data into the table: "users_freelancer_status" */
  insert_users_freelancer_status?: Maybe<Users_Freelancer_Status_Mutation_Response>;
  /** insert a single row into the table: "users_freelancer_status" */
  insert_users_freelancer_status_one?: Maybe<Users_Freelancer_Status>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "white_labeling" */
  insert_white_labeling?: Maybe<White_Labeling_Mutation_Response>;
  /** insert data into the table: "white_labeling_colors" */
  insert_white_labeling_colors?: Maybe<White_Labeling_Colors_Mutation_Response>;
  /** insert a single row into the table: "white_labeling_colors" */
  insert_white_labeling_colors_one?: Maybe<White_Labeling_Colors>;
  /** insert data into the table: "white_labeling_fonts" */
  insert_white_labeling_fonts?: Maybe<White_Labeling_Fonts_Mutation_Response>;
  /** insert a single row into the table: "white_labeling_fonts" */
  insert_white_labeling_fonts_one?: Maybe<White_Labeling_Fonts>;
  /** insert a single row into the table: "white_labeling" */
  insert_white_labeling_one?: Maybe<White_Labeling>;
  /** insert data into the table: "workflow.document_versions" */
  insert_workflow_document_versions?: Maybe<Workflow_Document_Versions_Mutation_Response>;
  /** insert a single row into the table: "workflow.document_versions" */
  insert_workflow_document_versions_one?: Maybe<Workflow_Document_Versions>;
  /** insert data into the table: "workflow.documents" */
  insert_workflow_documents?: Maybe<Workflow_Documents_Mutation_Response>;
  /** insert a single row into the table: "workflow.documents" */
  insert_workflow_documents_one?: Maybe<Workflow_Documents>;
  /** insert data into the table: "workflow.field_contents" */
  insert_workflow_field_contents?: Maybe<Workflow_Field_Contents_Mutation_Response>;
  /** insert a single row into the table: "workflow.field_contents" */
  insert_workflow_field_contents_one?: Maybe<Workflow_Field_Contents>;
  /** insert data into the table: "workflow.field_permission_types" */
  insert_workflow_field_permission_types?: Maybe<Workflow_Field_Permission_Types_Mutation_Response>;
  /** insert a single row into the table: "workflow.field_permission_types" */
  insert_workflow_field_permission_types_one?: Maybe<Workflow_Field_Permission_Types>;
  /** insert data into the table: "workflow.field_permissions" */
  insert_workflow_field_permissions?: Maybe<Workflow_Field_Permissions_Mutation_Response>;
  /** insert a single row into the table: "workflow.field_permissions" */
  insert_workflow_field_permissions_one?: Maybe<Workflow_Field_Permissions>;
  /** insert data into the table: "workflow.field_types" */
  insert_workflow_field_types?: Maybe<Workflow_Field_Types_Mutation_Response>;
  /** insert a single row into the table: "workflow.field_types" */
  insert_workflow_field_types_one?: Maybe<Workflow_Field_Types>;
  /** insert data into the table: "workflow.fields" */
  insert_workflow_fields?: Maybe<Workflow_Fields_Mutation_Response>;
  /** insert a single row into the table: "workflow.fields" */
  insert_workflow_fields_one?: Maybe<Workflow_Fields>;
  /** insert data into the table: "workflow.pages" */
  insert_workflow_pages?: Maybe<Workflow_Pages_Mutation_Response>;
  /** insert a single row into the table: "workflow.pages" */
  insert_workflow_pages_one?: Maybe<Workflow_Pages>;
  /** insert data into the table: "workflow.processmaker_users" */
  insert_workflow_processmaker_users?: Maybe<Workflow_Processmaker_Users_Mutation_Response>;
  /** insert a single row into the table: "workflow.processmaker_users" */
  insert_workflow_processmaker_users_one?: Maybe<Workflow_Processmaker_Users>;
  /** insert data into the table: "workflow.saved_document_part_types" */
  insert_workflow_saved_document_part_types?: Maybe<Workflow_Saved_Document_Part_Types_Mutation_Response>;
  /** insert a single row into the table: "workflow.saved_document_part_types" */
  insert_workflow_saved_document_part_types_one?: Maybe<Workflow_Saved_Document_Part_Types>;
  /** insert data into the table: "workflow.saved_document_parts" */
  insert_workflow_saved_document_parts?: Maybe<Workflow_Saved_Document_Parts_Mutation_Response>;
  /** insert a single row into the table: "workflow.saved_document_parts" */
  insert_workflow_saved_document_parts_one?: Maybe<Workflow_Saved_Document_Parts>;
  /** insert data into the table: "workflow.section_comment_status" */
  insert_workflow_section_comment_status?: Maybe<Workflow_Section_Comment_Status_Mutation_Response>;
  /** insert a single row into the table: "workflow.section_comment_status" */
  insert_workflow_section_comment_status_one?: Maybe<Workflow_Section_Comment_Status>;
  /** insert data into the table: "workflow.section_comments" */
  insert_workflow_section_comments?: Maybe<Workflow_Section_Comments_Mutation_Response>;
  /** insert a single row into the table: "workflow.section_comments" */
  insert_workflow_section_comments_one?: Maybe<Workflow_Section_Comments>;
  /** insert data into the table: "workflow.sections" */
  insert_workflow_sections?: Maybe<Workflow_Sections_Mutation_Response>;
  /** insert a single row into the table: "workflow.sections" */
  insert_workflow_sections_one?: Maybe<Workflow_Sections>;
  /** insert data into the table: "workflow.task_notifications" */
  insert_workflow_task_notifications?: Maybe<Workflow_Task_Notifications_Mutation_Response>;
  /** insert a single row into the table: "workflow.task_notifications" */
  insert_workflow_task_notifications_one?: Maybe<Workflow_Task_Notifications>;
  /** insert data into the table: "workflow.task_types" */
  insert_workflow_task_types?: Maybe<Workflow_Task_Types_Mutation_Response>;
  /** insert a single row into the table: "workflow.task_types" */
  insert_workflow_task_types_one?: Maybe<Workflow_Task_Types>;
  /** insert data into the table: "workflow.tasks" */
  insert_workflow_tasks?: Maybe<Workflow_Tasks_Mutation_Response>;
  /** insert a single row into the table: "workflow.tasks" */
  insert_workflow_tasks_one?: Maybe<Workflow_Tasks>;
  /** insert data into the table: "workflow.workflow_creation_status" */
  insert_workflow_workflow_creation_status?: Maybe<Workflow_Workflow_Creation_Status_Mutation_Response>;
  /** insert a single row into the table: "workflow.workflow_creation_status" */
  insert_workflow_workflow_creation_status_one?: Maybe<Workflow_Workflow_Creation_Status>;
  /** insert data into the table: "workflow.workflow_reactflow_status" */
  insert_workflow_workflow_reactflow_status?: Maybe<Workflow_Workflow_Reactflow_Status_Mutation_Response>;
  /** insert a single row into the table: "workflow.workflow_reactflow_status" */
  insert_workflow_workflow_reactflow_status_one?: Maybe<Workflow_Workflow_Reactflow_Status>;
  /** insert data into the table: "workflow.workflow_status" */
  insert_workflow_workflow_status?: Maybe<Workflow_Workflow_Status_Mutation_Response>;
  /** insert a single row into the table: "workflow.workflow_status" */
  insert_workflow_workflow_status_one?: Maybe<Workflow_Workflow_Status>;
  /** insert data into the table: "workflow.workflow_templates" */
  insert_workflow_workflow_templates?: Maybe<Workflow_Workflow_Templates_Mutation_Response>;
  /** insert a single row into the table: "workflow.workflow_templates" */
  insert_workflow_workflow_templates_one?: Maybe<Workflow_Workflow_Templates>;
  /** insert data into the table: "workflow.workflow_versions" */
  insert_workflow_workflow_versions?: Maybe<Workflow_Workflow_Versions_Mutation_Response>;
  /** insert a single row into the table: "workflow.workflow_versions" */
  insert_workflow_workflow_versions_one?: Maybe<Workflow_Workflow_Versions>;
  /** insert data into the table: "workflow.workflows" */
  insert_workflow_workflows?: Maybe<Workflow_Workflows_Mutation_Response>;
  /** insert a single row into the table: "workflow.workflows" */
  insert_workflow_workflows_one?: Maybe<Workflow_Workflows>;
  organization_invitation_accept?: Maybe<OrganizationInvitation>;
  organization_invitation_cancel?: Maybe<OrganizationInvitation>;
  organization_invitation_create?: Maybe<OrganizationInvitation>;
  organization_member_add?: Maybe<OrganizationMember>;
  organization_member_remove?: Maybe<OrganizationMember>;
  reset_client_facebook_connection?: Maybe<GenericResult>;
  set_url_metadata?: Maybe<UrlMetadataOutput>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update data of the table: "address_links" */
  update_address_links?: Maybe<Address_Links_Mutation_Response>;
  /** update single row of the table: "address_links" */
  update_address_links_by_pk?: Maybe<Address_Links>;
  /** update data of the table: "ai_tools_credits" */
  update_ai_tools_credits?: Maybe<Ai_Tools_Credits_Mutation_Response>;
  /** update single row of the table: "ai_tools_credits" */
  update_ai_tools_credits_by_pk?: Maybe<Ai_Tools_Credits>;
  /** update data of the table: "ai_tools_history" */
  update_ai_tools_history?: Maybe<Ai_Tools_History_Mutation_Response>;
  /** update single row of the table: "ai_tools_history" */
  update_ai_tools_history_by_pk?: Maybe<Ai_Tools_History>;
  /** update data of the table: "ai_tools_services" */
  update_ai_tools_services?: Maybe<Ai_Tools_Services_Mutation_Response>;
  /** update single row of the table: "ai_tools_services" */
  update_ai_tools_services_by_pk?: Maybe<Ai_Tools_Services>;
  /** update data of the table: "caption_example_categories" */
  update_caption_example_categories?: Maybe<Caption_Example_Categories_Mutation_Response>;
  /** update single row of the table: "caption_example_categories" */
  update_caption_example_categories_by_pk?: Maybe<Caption_Example_Categories>;
  /** update data of the table: "caption_example_subcategories" */
  update_caption_example_subcategories?: Maybe<Caption_Example_Subcategories_Mutation_Response>;
  /** update single row of the table: "caption_example_subcategories" */
  update_caption_example_subcategories_by_pk?: Maybe<Caption_Example_Subcategories>;
  /** update data of the table: "chat_bridgings" */
  update_chat_bridgings?: Maybe<Chat_Bridgings_Mutation_Response>;
  /** update single row of the table: "chat_bridgings" */
  update_chat_bridgings_by_pk?: Maybe<Chat_Bridgings>;
  /** update data of the table: "chat_stream_action_send_message" */
  update_chat_stream_action_send_message?: Maybe<Chat_Stream_Action_Send_Message_Mutation_Response>;
  /** update single row of the table: "chat_stream_action_send_message" */
  update_chat_stream_action_send_message_by_pk?: Maybe<Chat_Stream_Action_Send_Message>;
  /** update data of the table: "chat_stream_post_webhooks" */
  update_chat_stream_post_webhooks?: Maybe<Chat_Stream_Post_Webhooks_Mutation_Response>;
  /** update single row of the table: "chat_stream_post_webhooks" */
  update_chat_stream_post_webhooks_by_pk?: Maybe<Chat_Stream_Post_Webhooks>;
  /** update data of the table: "chat_stream_pre_webhooks" */
  update_chat_stream_pre_webhooks?: Maybe<Chat_Stream_Pre_Webhooks_Mutation_Response>;
  /** update single row of the table: "chat_stream_pre_webhooks" */
  update_chat_stream_pre_webhooks_by_pk?: Maybe<Chat_Stream_Pre_Webhooks>;
  /** update data of the table: "chat_twilio_conv_action_send_message" */
  update_chat_twilio_conv_action_send_message?: Maybe<Chat_Twilio_Conv_Action_Send_Message_Mutation_Response>;
  /** update single row of the table: "chat_twilio_conv_action_send_message" */
  update_chat_twilio_conv_action_send_message_by_pk?: Maybe<Chat_Twilio_Conv_Action_Send_Message>;
  /** update data of the table: "chat_twilio_conv_post_webhooks" */
  update_chat_twilio_conv_post_webhooks?: Maybe<Chat_Twilio_Conv_Post_Webhooks_Mutation_Response>;
  /** update single row of the table: "chat_twilio_conv_post_webhooks" */
  update_chat_twilio_conv_post_webhooks_by_pk?: Maybe<Chat_Twilio_Conv_Post_Webhooks>;
  /** update data of the table: "chat_user_channel_alias" */
  update_chat_user_channel_alias?: Maybe<Chat_User_Channel_Alias_Mutation_Response>;
  /** update single row of the table: "chat_user_channel_alias" */
  update_chat_user_channel_alias_by_pk?: Maybe<Chat_User_Channel_Alias>;
  /** update data of the table: "client_fb_request_meta" */
  update_client_fb_request_meta?: Maybe<Client_Fb_Request_Meta_Mutation_Response>;
  /** update single row of the table: "client_fb_request_meta" */
  update_client_fb_request_meta_by_pk?: Maybe<Client_Fb_Request_Meta>;
  /** update data of the table: "client_fb_resource_status" */
  update_client_fb_resource_status?: Maybe<Client_Fb_Resource_Status_Mutation_Response>;
  /** update single row of the table: "client_fb_resource_status" */
  update_client_fb_resource_status_by_pk?: Maybe<Client_Fb_Resource_Status>;
  /** update data of the table: "client_fb_resource_type" */
  update_client_fb_resource_type?: Maybe<Client_Fb_Resource_Type_Mutation_Response>;
  /** update single row of the table: "client_fb_resource_type" */
  update_client_fb_resource_type_by_pk?: Maybe<Client_Fb_Resource_Type>;
  /** update data of the table: "client_fb_resources" */
  update_client_fb_resources?: Maybe<Client_Fb_Resources_Mutation_Response>;
  /** update single row of the table: "client_fb_resources" */
  update_client_fb_resources_by_pk?: Maybe<Client_Fb_Resources>;
  /** update data of the table: "client_invites" */
  update_client_invites?: Maybe<Client_Invites_Mutation_Response>;
  /** update single row of the table: "client_invites" */
  update_client_invites_by_pk?: Maybe<Client_Invites>;
  /** update data of the table: "client_organization_caption_examples" */
  update_client_organization_caption_examples?: Maybe<Client_Organization_Caption_Examples_Mutation_Response>;
  /** update single row of the table: "client_organization_caption_examples" */
  update_client_organization_caption_examples_by_pk?: Maybe<Client_Organization_Caption_Examples>;
  /** update data of the table: "client_organization_fb_connection" */
  update_client_organization_fb_connection?: Maybe<Client_Organization_Fb_Connection_Mutation_Response>;
  /** update single row of the table: "client_organization_fb_connection" */
  update_client_organization_fb_connection_by_pk?: Maybe<Client_Organization_Fb_Connection>;
  /** update data of the table: "client_organizations" */
  update_client_organizations?: Maybe<Client_Organizations_Mutation_Response>;
  /** update single row of the table: "client_organizations" */
  update_client_organizations_by_pk?: Maybe<Client_Organizations>;
  /** update data of the table: "client_relevant_links" */
  update_client_relevant_links?: Maybe<Client_Relevant_Links_Mutation_Response>;
  /** update single row of the table: "client_relevant_links" */
  update_client_relevant_links_by_pk?: Maybe<Client_Relevant_Links>;
  /** update data of the table: "client_report_document" */
  update_client_report_document?: Maybe<Client_Report_Document_Mutation_Response>;
  /** update single row of the table: "client_report_document" */
  update_client_report_document_by_pk?: Maybe<Client_Report_Document>;
  /** update data of the table: "client_report_set" */
  update_client_report_set?: Maybe<Client_Report_Set_Mutation_Response>;
  /** update single row of the table: "client_report_set" */
  update_client_report_set_by_pk?: Maybe<Client_Report_Set>;
  /** update data of the table: "invites_status" */
  update_invites_status?: Maybe<Invites_Status_Mutation_Response>;
  /** update single row of the table: "invites_status" */
  update_invites_status_by_pk?: Maybe<Invites_Status>;
  /** update data of the table: "member_invites" */
  update_member_invites?: Maybe<Member_Invites_Mutation_Response>;
  /** update single row of the table: "member_invites" */
  update_member_invites_by_pk?: Maybe<Member_Invites>;
  /** update data of the table: "offers" */
  update_offers?: Maybe<Offers_Mutation_Response>;
  /** update single row of the table: "offers" */
  update_offers_by_pk?: Maybe<Offers>;
  /** update data of the table: "offers_status" */
  update_offers_status?: Maybe<Offers_Status_Mutation_Response>;
  /** update single row of the table: "offers_status" */
  update_offers_status_by_pk?: Maybe<Offers_Status>;
  /** update data of the table: "organization_fb_connection" */
  update_organization_fb_connection?: Maybe<Organization_Fb_Connection_Mutation_Response>;
  /** update single row of the table: "organization_fb_connection" */
  update_organization_fb_connection_by_pk?: Maybe<Organization_Fb_Connection>;
  /** update data of the table: "organization_members" */
  update_organization_members?: Maybe<Organization_Members_Mutation_Response>;
  /** update single row of the table: "organization_members" */
  update_organization_members_by_pk?: Maybe<Organization_Members>;
  /** update data of the table: "organization_members_status" */
  update_organization_members_status?: Maybe<Organization_Members_Status_Mutation_Response>;
  /** update single row of the table: "organization_members_status" */
  update_organization_members_status_by_pk?: Maybe<Organization_Members_Status>;
  /** update data of the table: "organization_members_type" */
  update_organization_members_type?: Maybe<Organization_Members_Type_Mutation_Response>;
  /** update single row of the table: "organization_members_type" */
  update_organization_members_type_by_pk?: Maybe<Organization_Members_Type>;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<Organizations_Mutation_Response>;
  /** update single row of the table: "organizations" */
  update_organizations_by_pk?: Maybe<Organizations>;
  /** update data of the table: "organizations_status" */
  update_organizations_status?: Maybe<Organizations_Status_Mutation_Response>;
  /** update single row of the table: "organizations_status" */
  update_organizations_status_by_pk?: Maybe<Organizations_Status>;
  /** update data of the table: "organizations_type" */
  update_organizations_type?: Maybe<Organizations_Type_Mutation_Response>;
  /** update single row of the table: "organizations_type" */
  update_organizations_type_by_pk?: Maybe<Organizations_Type>;
  /** update data of the table: "project_users" */
  update_project_users?: Maybe<Project_Users_Mutation_Response>;
  /** update single row of the table: "project_users" */
  update_project_users_by_pk?: Maybe<Project_Users>;
  /** update data of the table: "projects" */
  update_projects?: Maybe<Projects_Mutation_Response>;
  /** update single row of the table: "projects" */
  update_projects_by_pk?: Maybe<Projects>;
  /** update data of the table: "projects_status" */
  update_projects_status?: Maybe<Projects_Status_Mutation_Response>;
  /** update single row of the table: "projects_status" */
  update_projects_status_by_pk?: Maybe<Projects_Status>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update data of the table: "theme_type" */
  update_theme_type?: Maybe<Theme_Type_Mutation_Response>;
  /** update single row of the table: "theme_type" */
  update_theme_type_by_pk?: Maybe<Theme_Type>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update data of the table: "users_freelancer_status" */
  update_users_freelancer_status?: Maybe<Users_Freelancer_Status_Mutation_Response>;
  /** update single row of the table: "users_freelancer_status" */
  update_users_freelancer_status_by_pk?: Maybe<Users_Freelancer_Status>;
  /** update data of the table: "white_labeling" */
  update_white_labeling?: Maybe<White_Labeling_Mutation_Response>;
  /** update single row of the table: "white_labeling" */
  update_white_labeling_by_pk?: Maybe<White_Labeling>;
  /** update data of the table: "white_labeling_colors" */
  update_white_labeling_colors?: Maybe<White_Labeling_Colors_Mutation_Response>;
  /** update single row of the table: "white_labeling_colors" */
  update_white_labeling_colors_by_pk?: Maybe<White_Labeling_Colors>;
  /** update data of the table: "white_labeling_fonts" */
  update_white_labeling_fonts?: Maybe<White_Labeling_Fonts_Mutation_Response>;
  /** update single row of the table: "white_labeling_fonts" */
  update_white_labeling_fonts_by_pk?: Maybe<White_Labeling_Fonts>;
  /** update data of the table: "workflow.document_versions" */
  update_workflow_document_versions?: Maybe<Workflow_Document_Versions_Mutation_Response>;
  /** update single row of the table: "workflow.document_versions" */
  update_workflow_document_versions_by_pk?: Maybe<Workflow_Document_Versions>;
  /** update data of the table: "workflow.documents" */
  update_workflow_documents?: Maybe<Workflow_Documents_Mutation_Response>;
  /** update single row of the table: "workflow.documents" */
  update_workflow_documents_by_pk?: Maybe<Workflow_Documents>;
  /** update data of the table: "workflow.field_contents" */
  update_workflow_field_contents?: Maybe<Workflow_Field_Contents_Mutation_Response>;
  /** update single row of the table: "workflow.field_contents" */
  update_workflow_field_contents_by_pk?: Maybe<Workflow_Field_Contents>;
  /** update data of the table: "workflow.field_permission_types" */
  update_workflow_field_permission_types?: Maybe<Workflow_Field_Permission_Types_Mutation_Response>;
  /** update single row of the table: "workflow.field_permission_types" */
  update_workflow_field_permission_types_by_pk?: Maybe<Workflow_Field_Permission_Types>;
  /** update data of the table: "workflow.field_permissions" */
  update_workflow_field_permissions?: Maybe<Workflow_Field_Permissions_Mutation_Response>;
  /** update single row of the table: "workflow.field_permissions" */
  update_workflow_field_permissions_by_pk?: Maybe<Workflow_Field_Permissions>;
  /** update data of the table: "workflow.field_types" */
  update_workflow_field_types?: Maybe<Workflow_Field_Types_Mutation_Response>;
  /** update single row of the table: "workflow.field_types" */
  update_workflow_field_types_by_pk?: Maybe<Workflow_Field_Types>;
  /** update data of the table: "workflow.fields" */
  update_workflow_fields?: Maybe<Workflow_Fields_Mutation_Response>;
  /** update single row of the table: "workflow.fields" */
  update_workflow_fields_by_pk?: Maybe<Workflow_Fields>;
  /** update data of the table: "workflow.pages" */
  update_workflow_pages?: Maybe<Workflow_Pages_Mutation_Response>;
  /** update single row of the table: "workflow.pages" */
  update_workflow_pages_by_pk?: Maybe<Workflow_Pages>;
  /** update data of the table: "workflow.processmaker_users" */
  update_workflow_processmaker_users?: Maybe<Workflow_Processmaker_Users_Mutation_Response>;
  /** update single row of the table: "workflow.processmaker_users" */
  update_workflow_processmaker_users_by_pk?: Maybe<Workflow_Processmaker_Users>;
  /** update data of the table: "workflow.saved_document_part_types" */
  update_workflow_saved_document_part_types?: Maybe<Workflow_Saved_Document_Part_Types_Mutation_Response>;
  /** update single row of the table: "workflow.saved_document_part_types" */
  update_workflow_saved_document_part_types_by_pk?: Maybe<Workflow_Saved_Document_Part_Types>;
  /** update data of the table: "workflow.saved_document_parts" */
  update_workflow_saved_document_parts?: Maybe<Workflow_Saved_Document_Parts_Mutation_Response>;
  /** update single row of the table: "workflow.saved_document_parts" */
  update_workflow_saved_document_parts_by_pk?: Maybe<Workflow_Saved_Document_Parts>;
  /** update data of the table: "workflow.section_comment_status" */
  update_workflow_section_comment_status?: Maybe<Workflow_Section_Comment_Status_Mutation_Response>;
  /** update single row of the table: "workflow.section_comment_status" */
  update_workflow_section_comment_status_by_pk?: Maybe<Workflow_Section_Comment_Status>;
  /** update data of the table: "workflow.section_comments" */
  update_workflow_section_comments?: Maybe<Workflow_Section_Comments_Mutation_Response>;
  /** update single row of the table: "workflow.section_comments" */
  update_workflow_section_comments_by_pk?: Maybe<Workflow_Section_Comments>;
  /** update data of the table: "workflow.sections" */
  update_workflow_sections?: Maybe<Workflow_Sections_Mutation_Response>;
  /** update single row of the table: "workflow.sections" */
  update_workflow_sections_by_pk?: Maybe<Workflow_Sections>;
  /** update data of the table: "workflow.task_notifications" */
  update_workflow_task_notifications?: Maybe<Workflow_Task_Notifications_Mutation_Response>;
  /** update single row of the table: "workflow.task_notifications" */
  update_workflow_task_notifications_by_pk?: Maybe<Workflow_Task_Notifications>;
  /** update data of the table: "workflow.task_types" */
  update_workflow_task_types?: Maybe<Workflow_Task_Types_Mutation_Response>;
  /** update single row of the table: "workflow.task_types" */
  update_workflow_task_types_by_pk?: Maybe<Workflow_Task_Types>;
  /** update data of the table: "workflow.tasks" */
  update_workflow_tasks?: Maybe<Workflow_Tasks_Mutation_Response>;
  /** update single row of the table: "workflow.tasks" */
  update_workflow_tasks_by_pk?: Maybe<Workflow_Tasks>;
  /** update data of the table: "workflow.workflow_creation_status" */
  update_workflow_workflow_creation_status?: Maybe<Workflow_Workflow_Creation_Status_Mutation_Response>;
  /** update single row of the table: "workflow.workflow_creation_status" */
  update_workflow_workflow_creation_status_by_pk?: Maybe<Workflow_Workflow_Creation_Status>;
  /** update data of the table: "workflow.workflow_reactflow_status" */
  update_workflow_workflow_reactflow_status?: Maybe<Workflow_Workflow_Reactflow_Status_Mutation_Response>;
  /** update single row of the table: "workflow.workflow_reactflow_status" */
  update_workflow_workflow_reactflow_status_by_pk?: Maybe<Workflow_Workflow_Reactflow_Status>;
  /** update data of the table: "workflow.workflow_status" */
  update_workflow_workflow_status?: Maybe<Workflow_Workflow_Status_Mutation_Response>;
  /** update single row of the table: "workflow.workflow_status" */
  update_workflow_workflow_status_by_pk?: Maybe<Workflow_Workflow_Status>;
  /** update data of the table: "workflow.workflow_templates" */
  update_workflow_workflow_templates?: Maybe<Workflow_Workflow_Templates_Mutation_Response>;
  /** update single row of the table: "workflow.workflow_templates" */
  update_workflow_workflow_templates_by_pk?: Maybe<Workflow_Workflow_Templates>;
  /** update data of the table: "workflow.workflow_versions" */
  update_workflow_workflow_versions?: Maybe<Workflow_Workflow_Versions_Mutation_Response>;
  /** update single row of the table: "workflow.workflow_versions" */
  update_workflow_workflow_versions_by_pk?: Maybe<Workflow_Workflow_Versions>;
  /** update data of the table: "workflow.workflows" */
  update_workflow_workflows?: Maybe<Workflow_Workflows_Mutation_Response>;
  /** update single row of the table: "workflow.workflows" */
  update_workflow_workflows_by_pk?: Maybe<Workflow_Workflows>;
};


/** mutation root */
export type Mutation_RootAdd_ClientArgs = {
  arg1: AddClientInput;
};


/** mutation root */
export type Mutation_RootAdd_Client_Facebook_ConnectionArgs = {
  arg1: ClientFacebookConnectionInput;
};


/** mutation root */
export type Mutation_RootAdd_Facebook_ConnectionArgs = {
  arg1: FacebookConnectionInput;
};


/** mutation root */
export type Mutation_RootAdd_Organization_UserArgs = {
  arg1: AddAndInviteMemberInput;
};


/** mutation root */
export type Mutation_RootAi_Tools_Generate_CaptionArgs = {
  arg1: AiToolsGenerateCaptionInput;
};


/** mutation root */
export type Mutation_RootAi_Tools_Generate_ConceptArgs = {
  arg1: AiToolsGenerateConceptInput;
};


/** mutation root */
export type Mutation_RootAi_Tools_Generate_ImagesArgs = {
  arg1: AiToolsImagesInput;
};


/** mutation root */
export type Mutation_RootAi_Tools_Get_Related_EventArgs = {
  arg1: AiToolsGetRelatedEventInput;
};


/** mutation root */
export type Mutation_RootAuth_RefreshArgs = {
  arg1: AuthRefreshInput;
};


/** mutation root */
export type Mutation_RootAuth_Sign_InArgs = {
  arg1: SignInInput;
};


/** mutation root */
export type Mutation_RootAuth_Sign_OutArgs = {
  arg1: SignOutInput;
};


/** mutation root */
export type Mutation_RootAuth_Sign_UpArgs = {
  arg1: SignUpInput;
};


/** mutation root */
export type Mutation_RootAuth_Update_PasswordArgs = {
  arg1: UpdatePasswordInput;
};


/** mutation root */
export type Mutation_RootClient_Invitation_CancelArgs = {
  arg1: ClientInvitationInput;
};


/** mutation root */
export type Mutation_RootClient_Invitation_CreateArgs = {
  arg1: ClientInvitationInput;
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Address_LinksArgs = {
  where: Address_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ai_Tools_CreditsArgs = {
  where: Ai_Tools_Credits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ai_Tools_Credits_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ai_Tools_HistoryArgs = {
  where: Ai_Tools_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ai_Tools_History_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ai_Tools_ServicesArgs = {
  where: Ai_Tools_Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ai_Tools_Services_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Caption_Example_CategoriesArgs = {
  where: Caption_Example_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Caption_Example_Categories_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Caption_Example_SubcategoriesArgs = {
  where: Caption_Example_Subcategories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Caption_Example_Subcategories_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_BridgingsArgs = {
  where: Chat_Bridgings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Bridgings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Stream_Action_Send_MessageArgs = {
  where: Chat_Stream_Action_Send_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Stream_Action_Send_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Stream_Post_WebhooksArgs = {
  where: Chat_Stream_Post_Webhooks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Stream_Post_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Stream_Pre_WebhooksArgs = {
  where: Chat_Stream_Pre_Webhooks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Stream_Pre_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Twilio_Conv_Action_Send_MessageArgs = {
  where: Chat_Twilio_Conv_Action_Send_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Twilio_Conv_Action_Send_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_Twilio_Conv_Post_WebhooksArgs = {
  where: Chat_Twilio_Conv_Post_Webhooks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_Twilio_Conv_Post_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_User_Channel_AliasArgs = {
  where: Chat_User_Channel_Alias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_User_Channel_Alias_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Fb_Request_MetaArgs = {
  where: Client_Fb_Request_Meta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Fb_Request_Meta_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Fb_Resource_StatusArgs = {
  where: Client_Fb_Resource_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Fb_Resource_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Fb_Resource_TypeArgs = {
  where: Client_Fb_Resource_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Fb_Resource_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Fb_ResourcesArgs = {
  where: Client_Fb_Resources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Fb_Resources_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
  resource_type: Client_Fb_Resource_Type_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Client_InvitesArgs = {
  where: Client_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Invites_By_PkArgs = {
  agency_id: Scalars['uuid'];
  client_email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Organization_Caption_ExamplesArgs = {
  where: Client_Organization_Caption_Examples_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Organization_Caption_Examples_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Organization_Fb_ConnectionArgs = {
  where: Client_Organization_Fb_Connection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Organization_Fb_Connection_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Client_OrganizationsArgs = {
  where: Client_Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Organizations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Relevant_LinksArgs = {
  where: Client_Relevant_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Relevant_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Report_DocumentArgs = {
  where: Client_Report_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Report_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Report_SetArgs = {
  where: Client_Report_Set_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Report_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Invites_StatusArgs = {
  where: Invites_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invites_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Member_InvitesArgs = {
  where: Member_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Member_Invites_By_PkArgs = {
  agency_id: Scalars['uuid'];
  member_email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_OffersArgs = {
  where: Offers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Offers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Offers_StatusArgs = {
  where: Offers_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Offers_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Fb_ConnectionArgs = {
  where: Organization_Fb_Connection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Fb_Connection_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_MembersArgs = {
  where: Organization_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Members_StatusArgs = {
  where: Organization_Members_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Members_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Members_TypeArgs = {
  where: Organization_Members_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Members_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationsArgs = {
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organizations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organizations_StatusArgs = {
  where: Organizations_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organizations_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Organizations_TypeArgs = {
  where: Organizations_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organizations_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_UsersArgs = {
  where: Project_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectsArgs = {
  where: Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Projects_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Projects_StatusArgs = {
  where: Projects_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Projects_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Theme_TypeArgs = {
  where: Theme_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Theme_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Users_Freelancer_StatusArgs = {
  where: Users_Freelancer_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_Freelancer_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_White_LabelingArgs = {
  where: White_Labeling_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_White_Labeling_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_White_Labeling_ColorsArgs = {
  where: White_Labeling_Colors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_White_Labeling_Colors_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_White_Labeling_FontsArgs = {
  where: White_Labeling_Fonts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_White_Labeling_Fonts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Document_VersionsArgs = {
  where: Workflow_Document_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Document_Versions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_DocumentsArgs = {
  where: Workflow_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Field_ContentsArgs = {
  where: Workflow_Field_Contents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Field_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Field_Permission_TypesArgs = {
  where: Workflow_Field_Permission_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Field_Permission_Types_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Field_PermissionsArgs = {
  where: Workflow_Field_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Field_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Field_TypesArgs = {
  where: Workflow_Field_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Field_Types_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_FieldsArgs = {
  where: Workflow_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Fields_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_PagesArgs = {
  where: Workflow_Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Pages_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Processmaker_UsersArgs = {
  where: Workflow_Processmaker_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Processmaker_Users_By_PkArgs = {
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Saved_Document_Part_TypesArgs = {
  where: Workflow_Saved_Document_Part_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Saved_Document_Part_Types_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Saved_Document_PartsArgs = {
  where: Workflow_Saved_Document_Parts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Saved_Document_Parts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Section_Comment_StatusArgs = {
  where: Workflow_Section_Comment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Section_Comment_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Section_CommentsArgs = {
  where: Workflow_Section_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Section_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_SectionsArgs = {
  where: Workflow_Sections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Sections_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Task_NotificationsArgs = {
  where: Workflow_Task_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Task_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Task_TypesArgs = {
  where: Workflow_Task_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Task_Types_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_TasksArgs = {
  where: Workflow_Tasks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Tasks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_Creation_StatusArgs = {
  where: Workflow_Workflow_Creation_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_Creation_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_Reactflow_StatusArgs = {
  where: Workflow_Workflow_Reactflow_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_Reactflow_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_StatusArgs = {
  where: Workflow_Workflow_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_TemplatesArgs = {
  where: Workflow_Workflow_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_VersionsArgs = {
  where: Workflow_Workflow_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflow_Versions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_WorkflowsArgs = {
  where: Workflow_Workflows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Workflows_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootGenerate_Upload_UrlArgs = {
  arg1: Generate_Upload_Url_Input;
};


/** mutation root */
export type Mutation_RootGet_Client_ReportArgs = {
  arg1: GetClientReportInput;
};


/** mutation root */
export type Mutation_RootGet_Client_Shared_ReportArgs = {
  arg1: GetClientSharedReportInput;
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_LinksArgs = {
  objects: Array<Address_Links_Insert_Input>;
  on_conflict?: InputMaybe<Address_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_Links_OneArgs = {
  object: Address_Links_Insert_Input;
  on_conflict?: InputMaybe<Address_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Tools_CreditsArgs = {
  objects: Array<Ai_Tools_Credits_Insert_Input>;
  on_conflict?: InputMaybe<Ai_Tools_Credits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Tools_Credits_OneArgs = {
  object: Ai_Tools_Credits_Insert_Input;
  on_conflict?: InputMaybe<Ai_Tools_Credits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Tools_HistoryArgs = {
  objects: Array<Ai_Tools_History_Insert_Input>;
  on_conflict?: InputMaybe<Ai_Tools_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Tools_History_OneArgs = {
  object: Ai_Tools_History_Insert_Input;
  on_conflict?: InputMaybe<Ai_Tools_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Tools_ServicesArgs = {
  objects: Array<Ai_Tools_Services_Insert_Input>;
  on_conflict?: InputMaybe<Ai_Tools_Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Tools_Services_OneArgs = {
  object: Ai_Tools_Services_Insert_Input;
  on_conflict?: InputMaybe<Ai_Tools_Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Caption_Example_CategoriesArgs = {
  objects: Array<Caption_Example_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Caption_Example_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Caption_Example_Categories_OneArgs = {
  object: Caption_Example_Categories_Insert_Input;
  on_conflict?: InputMaybe<Caption_Example_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Caption_Example_SubcategoriesArgs = {
  objects: Array<Caption_Example_Subcategories_Insert_Input>;
  on_conflict?: InputMaybe<Caption_Example_Subcategories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Caption_Example_Subcategories_OneArgs = {
  object: Caption_Example_Subcategories_Insert_Input;
  on_conflict?: InputMaybe<Caption_Example_Subcategories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_BridgingsArgs = {
  objects: Array<Chat_Bridgings_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Bridgings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Bridgings_OneArgs = {
  object: Chat_Bridgings_Insert_Input;
  on_conflict?: InputMaybe<Chat_Bridgings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Stream_Action_Send_MessageArgs = {
  objects: Array<Chat_Stream_Action_Send_Message_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Stream_Action_Send_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Stream_Action_Send_Message_OneArgs = {
  object: Chat_Stream_Action_Send_Message_Insert_Input;
  on_conflict?: InputMaybe<Chat_Stream_Action_Send_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Stream_Post_WebhooksArgs = {
  objects: Array<Chat_Stream_Post_Webhooks_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Stream_Post_Webhooks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Stream_Post_Webhooks_OneArgs = {
  object: Chat_Stream_Post_Webhooks_Insert_Input;
  on_conflict?: InputMaybe<Chat_Stream_Post_Webhooks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Stream_Pre_WebhooksArgs = {
  objects: Array<Chat_Stream_Pre_Webhooks_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Stream_Pre_Webhooks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Stream_Pre_Webhooks_OneArgs = {
  object: Chat_Stream_Pre_Webhooks_Insert_Input;
  on_conflict?: InputMaybe<Chat_Stream_Pre_Webhooks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Twilio_Conv_Action_Send_MessageArgs = {
  objects: Array<Chat_Twilio_Conv_Action_Send_Message_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Twilio_Conv_Action_Send_Message_OneArgs = {
  object: Chat_Twilio_Conv_Action_Send_Message_Insert_Input;
  on_conflict?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Twilio_Conv_Post_WebhooksArgs = {
  objects: Array<Chat_Twilio_Conv_Post_Webhooks_Insert_Input>;
  on_conflict?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_Twilio_Conv_Post_Webhooks_OneArgs = {
  object: Chat_Twilio_Conv_Post_Webhooks_Insert_Input;
  on_conflict?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_User_Channel_AliasArgs = {
  objects: Array<Chat_User_Channel_Alias_Insert_Input>;
  on_conflict?: InputMaybe<Chat_User_Channel_Alias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_User_Channel_Alias_OneArgs = {
  object: Chat_User_Channel_Alias_Insert_Input;
  on_conflict?: InputMaybe<Chat_User_Channel_Alias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Fb_Request_MetaArgs = {
  objects: Array<Client_Fb_Request_Meta_Insert_Input>;
  on_conflict?: InputMaybe<Client_Fb_Request_Meta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Fb_Request_Meta_OneArgs = {
  object: Client_Fb_Request_Meta_Insert_Input;
  on_conflict?: InputMaybe<Client_Fb_Request_Meta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Fb_Resource_StatusArgs = {
  objects: Array<Client_Fb_Resource_Status_Insert_Input>;
  on_conflict?: InputMaybe<Client_Fb_Resource_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Fb_Resource_Status_OneArgs = {
  object: Client_Fb_Resource_Status_Insert_Input;
  on_conflict?: InputMaybe<Client_Fb_Resource_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Fb_Resource_TypeArgs = {
  objects: Array<Client_Fb_Resource_Type_Insert_Input>;
  on_conflict?: InputMaybe<Client_Fb_Resource_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Fb_Resource_Type_OneArgs = {
  object: Client_Fb_Resource_Type_Insert_Input;
  on_conflict?: InputMaybe<Client_Fb_Resource_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Fb_ResourcesArgs = {
  objects: Array<Client_Fb_Resources_Insert_Input>;
  on_conflict?: InputMaybe<Client_Fb_Resources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Fb_Resources_OneArgs = {
  object: Client_Fb_Resources_Insert_Input;
  on_conflict?: InputMaybe<Client_Fb_Resources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_InvitesArgs = {
  objects: Array<Client_Invites_Insert_Input>;
  on_conflict?: InputMaybe<Client_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Invites_OneArgs = {
  object: Client_Invites_Insert_Input;
  on_conflict?: InputMaybe<Client_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Organization_Caption_ExamplesArgs = {
  objects: Array<Client_Organization_Caption_Examples_Insert_Input>;
  on_conflict?: InputMaybe<Client_Organization_Caption_Examples_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Organization_Caption_Examples_OneArgs = {
  object: Client_Organization_Caption_Examples_Insert_Input;
  on_conflict?: InputMaybe<Client_Organization_Caption_Examples_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Organization_Fb_ConnectionArgs = {
  objects: Array<Client_Organization_Fb_Connection_Insert_Input>;
  on_conflict?: InputMaybe<Client_Organization_Fb_Connection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Organization_Fb_Connection_OneArgs = {
  object: Client_Organization_Fb_Connection_Insert_Input;
  on_conflict?: InputMaybe<Client_Organization_Fb_Connection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_OrganizationsArgs = {
  objects: Array<Client_Organizations_Insert_Input>;
  on_conflict?: InputMaybe<Client_Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Organizations_OneArgs = {
  object: Client_Organizations_Insert_Input;
  on_conflict?: InputMaybe<Client_Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Relevant_LinksArgs = {
  objects: Array<Client_Relevant_Links_Insert_Input>;
  on_conflict?: InputMaybe<Client_Relevant_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Relevant_Links_OneArgs = {
  object: Client_Relevant_Links_Insert_Input;
  on_conflict?: InputMaybe<Client_Relevant_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Report_DocumentArgs = {
  objects: Array<Client_Report_Document_Insert_Input>;
  on_conflict?: InputMaybe<Client_Report_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Report_Document_OneArgs = {
  object: Client_Report_Document_Insert_Input;
  on_conflict?: InputMaybe<Client_Report_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Report_SetArgs = {
  objects: Array<Client_Report_Set_Insert_Input>;
  on_conflict?: InputMaybe<Client_Report_Set_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Report_Set_OneArgs = {
  object: Client_Report_Set_Insert_Input;
  on_conflict?: InputMaybe<Client_Report_Set_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invites_StatusArgs = {
  objects: Array<Invites_Status_Insert_Input>;
  on_conflict?: InputMaybe<Invites_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invites_Status_OneArgs = {
  object: Invites_Status_Insert_Input;
  on_conflict?: InputMaybe<Invites_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Member_InvitesArgs = {
  objects: Array<Member_Invites_Insert_Input>;
  on_conflict?: InputMaybe<Member_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Member_Invites_OneArgs = {
  object: Member_Invites_Insert_Input;
  on_conflict?: InputMaybe<Member_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OffersArgs = {
  objects: Array<Offers_Insert_Input>;
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Offers_OneArgs = {
  object: Offers_Insert_Input;
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Offers_StatusArgs = {
  objects: Array<Offers_Status_Insert_Input>;
  on_conflict?: InputMaybe<Offers_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Offers_Status_OneArgs = {
  object: Offers_Status_Insert_Input;
  on_conflict?: InputMaybe<Offers_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Fb_ConnectionArgs = {
  objects: Array<Organization_Fb_Connection_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Fb_Connection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Fb_Connection_OneArgs = {
  object: Organization_Fb_Connection_Insert_Input;
  on_conflict?: InputMaybe<Organization_Fb_Connection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_MembersArgs = {
  objects: Array<Organization_Members_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Members_OneArgs = {
  object: Organization_Members_Insert_Input;
  on_conflict?: InputMaybe<Organization_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Members_StatusArgs = {
  objects: Array<Organization_Members_Status_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Members_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Members_Status_OneArgs = {
  object: Organization_Members_Status_Insert_Input;
  on_conflict?: InputMaybe<Organization_Members_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Members_TypeArgs = {
  objects: Array<Organization_Members_Type_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Members_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Members_Type_OneArgs = {
  object: Organization_Members_Type_Insert_Input;
  on_conflict?: InputMaybe<Organization_Members_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationsArgs = {
  objects: Array<Organizations_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_OneArgs = {
  object: Organizations_Insert_Input;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_StatusArgs = {
  objects: Array<Organizations_Status_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_Status_OneArgs = {
  object: Organizations_Status_Insert_Input;
  on_conflict?: InputMaybe<Organizations_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_TypeArgs = {
  objects: Array<Organizations_Type_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_Type_OneArgs = {
  object: Organizations_Type_Insert_Input;
  on_conflict?: InputMaybe<Organizations_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_UsersArgs = {
  objects: Array<Project_Users_Insert_Input>;
  on_conflict?: InputMaybe<Project_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Users_OneArgs = {
  object: Project_Users_Insert_Input;
  on_conflict?: InputMaybe<Project_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectsArgs = {
  objects: Array<Projects_Insert_Input>;
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_OneArgs = {
  object: Projects_Insert_Input;
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_StatusArgs = {
  objects: Array<Projects_Status_Insert_Input>;
  on_conflict?: InputMaybe<Projects_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_Status_OneArgs = {
  object: Projects_Status_Insert_Input;
  on_conflict?: InputMaybe<Projects_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Theme_TypeArgs = {
  objects: Array<Theme_Type_Insert_Input>;
  on_conflict?: InputMaybe<Theme_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Theme_Type_OneArgs = {
  object: Theme_Type_Insert_Input;
  on_conflict?: InputMaybe<Theme_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Freelancer_StatusArgs = {
  objects: Array<Users_Freelancer_Status_Insert_Input>;
  on_conflict?: InputMaybe<Users_Freelancer_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Freelancer_Status_OneArgs = {
  object: Users_Freelancer_Status_Insert_Input;
  on_conflict?: InputMaybe<Users_Freelancer_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_LabelingArgs = {
  objects: Array<White_Labeling_Insert_Input>;
  on_conflict?: InputMaybe<White_Labeling_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Labeling_ColorsArgs = {
  objects: Array<White_Labeling_Colors_Insert_Input>;
  on_conflict?: InputMaybe<White_Labeling_Colors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Labeling_Colors_OneArgs = {
  object: White_Labeling_Colors_Insert_Input;
  on_conflict?: InputMaybe<White_Labeling_Colors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Labeling_FontsArgs = {
  objects: Array<White_Labeling_Fonts_Insert_Input>;
  on_conflict?: InputMaybe<White_Labeling_Fonts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Labeling_Fonts_OneArgs = {
  object: White_Labeling_Fonts_Insert_Input;
  on_conflict?: InputMaybe<White_Labeling_Fonts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Labeling_OneArgs = {
  object: White_Labeling_Insert_Input;
  on_conflict?: InputMaybe<White_Labeling_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Document_VersionsArgs = {
  objects: Array<Workflow_Document_Versions_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Document_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Document_Versions_OneArgs = {
  object: Workflow_Document_Versions_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Document_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_DocumentsArgs = {
  objects: Array<Workflow_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Documents_OneArgs = {
  object: Workflow_Documents_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Field_ContentsArgs = {
  objects: Array<Workflow_Field_Contents_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Field_Contents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Field_Contents_OneArgs = {
  object: Workflow_Field_Contents_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Field_Contents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Field_Permission_TypesArgs = {
  objects: Array<Workflow_Field_Permission_Types_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Field_Permission_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Field_Permission_Types_OneArgs = {
  object: Workflow_Field_Permission_Types_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Field_Permission_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Field_PermissionsArgs = {
  objects: Array<Workflow_Field_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Field_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Field_Permissions_OneArgs = {
  object: Workflow_Field_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Field_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Field_TypesArgs = {
  objects: Array<Workflow_Field_Types_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Field_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Field_Types_OneArgs = {
  object: Workflow_Field_Types_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Field_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_FieldsArgs = {
  objects: Array<Workflow_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Fields_OneArgs = {
  object: Workflow_Fields_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_PagesArgs = {
  objects: Array<Workflow_Pages_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Pages_OneArgs = {
  object: Workflow_Pages_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Processmaker_UsersArgs = {
  objects: Array<Workflow_Processmaker_Users_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Processmaker_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Processmaker_Users_OneArgs = {
  object: Workflow_Processmaker_Users_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Processmaker_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Saved_Document_Part_TypesArgs = {
  objects: Array<Workflow_Saved_Document_Part_Types_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Saved_Document_Part_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Saved_Document_Part_Types_OneArgs = {
  object: Workflow_Saved_Document_Part_Types_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Saved_Document_Part_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Saved_Document_PartsArgs = {
  objects: Array<Workflow_Saved_Document_Parts_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Saved_Document_Parts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Saved_Document_Parts_OneArgs = {
  object: Workflow_Saved_Document_Parts_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Saved_Document_Parts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Section_Comment_StatusArgs = {
  objects: Array<Workflow_Section_Comment_Status_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Section_Comment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Section_Comment_Status_OneArgs = {
  object: Workflow_Section_Comment_Status_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Section_Comment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Section_CommentsArgs = {
  objects: Array<Workflow_Section_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Section_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Section_Comments_OneArgs = {
  object: Workflow_Section_Comments_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Section_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_SectionsArgs = {
  objects: Array<Workflow_Sections_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Sections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Sections_OneArgs = {
  object: Workflow_Sections_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Sections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Task_NotificationsArgs = {
  objects: Array<Workflow_Task_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Task_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Task_Notifications_OneArgs = {
  object: Workflow_Task_Notifications_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Task_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Task_TypesArgs = {
  objects: Array<Workflow_Task_Types_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Task_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Task_Types_OneArgs = {
  object: Workflow_Task_Types_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Task_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_TasksArgs = {
  objects: Array<Workflow_Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Tasks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Tasks_OneArgs = {
  object: Workflow_Tasks_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Tasks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_Creation_StatusArgs = {
  objects: Array<Workflow_Workflow_Creation_Status_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Workflow_Creation_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_Creation_Status_OneArgs = {
  object: Workflow_Workflow_Creation_Status_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Workflow_Creation_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_Reactflow_StatusArgs = {
  objects: Array<Workflow_Workflow_Reactflow_Status_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Workflow_Reactflow_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_Reactflow_Status_OneArgs = {
  object: Workflow_Workflow_Reactflow_Status_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Workflow_Reactflow_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_StatusArgs = {
  objects: Array<Workflow_Workflow_Status_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Workflow_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_Status_OneArgs = {
  object: Workflow_Workflow_Status_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Workflow_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_TemplatesArgs = {
  objects: Array<Workflow_Workflow_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Workflow_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_Templates_OneArgs = {
  object: Workflow_Workflow_Templates_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Workflow_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_VersionsArgs = {
  objects: Array<Workflow_Workflow_Versions_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Workflow_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflow_Versions_OneArgs = {
  object: Workflow_Workflow_Versions_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Workflow_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_WorkflowsArgs = {
  objects: Array<Workflow_Workflows_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Workflows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Workflows_OneArgs = {
  object: Workflow_Workflows_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Workflows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootOrganization_Invitation_AcceptArgs = {
  arg1: OrganizationInvitationAcceptInput;
};


/** mutation root */
export type Mutation_RootOrganization_Invitation_CancelArgs = {
  arg1: OrganizationInvitationInput;
};


/** mutation root */
export type Mutation_RootOrganization_Invitation_CreateArgs = {
  arg1: OrganizationInvitationInput;
};


/** mutation root */
export type Mutation_RootOrganization_Member_AddArgs = {
  arg1: OrganizationMemberInput;
};


/** mutation root */
export type Mutation_RootOrganization_Member_RemoveArgs = {
  arg1: OrganizationMemberRemoveInput;
};


/** mutation root */
export type Mutation_RootReset_Client_Facebook_ConnectionArgs = {
  arg1: UrlMetadataInput;
};


/** mutation root */
export type Mutation_RootSet_Url_MetadataArgs = {
  arg1: SetUrlMetadataInput;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_LinksArgs = {
  _set?: InputMaybe<Address_Links_Set_Input>;
  where: Address_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Links_By_PkArgs = {
  _set?: InputMaybe<Address_Links_Set_Input>;
  pk_columns: Address_Links_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Tools_CreditsArgs = {
  _inc?: InputMaybe<Ai_Tools_Credits_Inc_Input>;
  _set?: InputMaybe<Ai_Tools_Credits_Set_Input>;
  where: Ai_Tools_Credits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Tools_Credits_By_PkArgs = {
  _inc?: InputMaybe<Ai_Tools_Credits_Inc_Input>;
  _set?: InputMaybe<Ai_Tools_Credits_Set_Input>;
  pk_columns: Ai_Tools_Credits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Tools_HistoryArgs = {
  _append?: InputMaybe<Ai_Tools_History_Append_Input>;
  _delete_at_path?: InputMaybe<Ai_Tools_History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ai_Tools_History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ai_Tools_History_Delete_Key_Input>;
  _prepend?: InputMaybe<Ai_Tools_History_Prepend_Input>;
  _set?: InputMaybe<Ai_Tools_History_Set_Input>;
  where: Ai_Tools_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Tools_History_By_PkArgs = {
  _append?: InputMaybe<Ai_Tools_History_Append_Input>;
  _delete_at_path?: InputMaybe<Ai_Tools_History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ai_Tools_History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ai_Tools_History_Delete_Key_Input>;
  _prepend?: InputMaybe<Ai_Tools_History_Prepend_Input>;
  _set?: InputMaybe<Ai_Tools_History_Set_Input>;
  pk_columns: Ai_Tools_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Tools_ServicesArgs = {
  _set?: InputMaybe<Ai_Tools_Services_Set_Input>;
  where: Ai_Tools_Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Tools_Services_By_PkArgs = {
  _set?: InputMaybe<Ai_Tools_Services_Set_Input>;
  pk_columns: Ai_Tools_Services_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Caption_Example_CategoriesArgs = {
  _set?: InputMaybe<Caption_Example_Categories_Set_Input>;
  where: Caption_Example_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Caption_Example_Categories_By_PkArgs = {
  _set?: InputMaybe<Caption_Example_Categories_Set_Input>;
  pk_columns: Caption_Example_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Caption_Example_SubcategoriesArgs = {
  _set?: InputMaybe<Caption_Example_Subcategories_Set_Input>;
  where: Caption_Example_Subcategories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Caption_Example_Subcategories_By_PkArgs = {
  _set?: InputMaybe<Caption_Example_Subcategories_Set_Input>;
  pk_columns: Caption_Example_Subcategories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_BridgingsArgs = {
  _set?: InputMaybe<Chat_Bridgings_Set_Input>;
  where: Chat_Bridgings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Bridgings_By_PkArgs = {
  _set?: InputMaybe<Chat_Bridgings_Set_Input>;
  pk_columns: Chat_Bridgings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Stream_Action_Send_MessageArgs = {
  _append?: InputMaybe<Chat_Stream_Action_Send_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Stream_Action_Send_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Stream_Action_Send_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Stream_Action_Send_Message_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Stream_Action_Send_Message_Prepend_Input>;
  _set?: InputMaybe<Chat_Stream_Action_Send_Message_Set_Input>;
  where: Chat_Stream_Action_Send_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Stream_Action_Send_Message_By_PkArgs = {
  _append?: InputMaybe<Chat_Stream_Action_Send_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Stream_Action_Send_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Stream_Action_Send_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Stream_Action_Send_Message_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Stream_Action_Send_Message_Prepend_Input>;
  _set?: InputMaybe<Chat_Stream_Action_Send_Message_Set_Input>;
  pk_columns: Chat_Stream_Action_Send_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Stream_Post_WebhooksArgs = {
  _append?: InputMaybe<Chat_Stream_Post_Webhooks_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Stream_Post_Webhooks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Stream_Post_Webhooks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Stream_Post_Webhooks_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Stream_Post_Webhooks_Prepend_Input>;
  _set?: InputMaybe<Chat_Stream_Post_Webhooks_Set_Input>;
  where: Chat_Stream_Post_Webhooks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Stream_Post_Webhooks_By_PkArgs = {
  _append?: InputMaybe<Chat_Stream_Post_Webhooks_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Stream_Post_Webhooks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Stream_Post_Webhooks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Stream_Post_Webhooks_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Stream_Post_Webhooks_Prepend_Input>;
  _set?: InputMaybe<Chat_Stream_Post_Webhooks_Set_Input>;
  pk_columns: Chat_Stream_Post_Webhooks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Stream_Pre_WebhooksArgs = {
  _append?: InputMaybe<Chat_Stream_Pre_Webhooks_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Stream_Pre_Webhooks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Stream_Pre_Webhooks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Stream_Pre_Webhooks_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Stream_Pre_Webhooks_Prepend_Input>;
  _set?: InputMaybe<Chat_Stream_Pre_Webhooks_Set_Input>;
  where: Chat_Stream_Pre_Webhooks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Stream_Pre_Webhooks_By_PkArgs = {
  _append?: InputMaybe<Chat_Stream_Pre_Webhooks_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Stream_Pre_Webhooks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Stream_Pre_Webhooks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Stream_Pre_Webhooks_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Stream_Pre_Webhooks_Prepend_Input>;
  _set?: InputMaybe<Chat_Stream_Pre_Webhooks_Set_Input>;
  pk_columns: Chat_Stream_Pre_Webhooks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Twilio_Conv_Action_Send_MessageArgs = {
  _set?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_Set_Input>;
  where: Chat_Twilio_Conv_Action_Send_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Twilio_Conv_Action_Send_Message_By_PkArgs = {
  _set?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_Set_Input>;
  pk_columns: Chat_Twilio_Conv_Action_Send_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Twilio_Conv_Post_WebhooksArgs = {
  _append?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Prepend_Input>;
  _set?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Set_Input>;
  where: Chat_Twilio_Conv_Post_Webhooks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_Twilio_Conv_Post_Webhooks_By_PkArgs = {
  _append?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Append_Input>;
  _delete_at_path?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Delete_Key_Input>;
  _prepend?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Prepend_Input>;
  _set?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Set_Input>;
  pk_columns: Chat_Twilio_Conv_Post_Webhooks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_User_Channel_AliasArgs = {
  _set?: InputMaybe<Chat_User_Channel_Alias_Set_Input>;
  where: Chat_User_Channel_Alias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_User_Channel_Alias_By_PkArgs = {
  _set?: InputMaybe<Chat_User_Channel_Alias_Set_Input>;
  pk_columns: Chat_User_Channel_Alias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Fb_Request_MetaArgs = {
  _append?: InputMaybe<Client_Fb_Request_Meta_Append_Input>;
  _delete_at_path?: InputMaybe<Client_Fb_Request_Meta_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Client_Fb_Request_Meta_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Client_Fb_Request_Meta_Delete_Key_Input>;
  _prepend?: InputMaybe<Client_Fb_Request_Meta_Prepend_Input>;
  _set?: InputMaybe<Client_Fb_Request_Meta_Set_Input>;
  where: Client_Fb_Request_Meta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Fb_Request_Meta_By_PkArgs = {
  _append?: InputMaybe<Client_Fb_Request_Meta_Append_Input>;
  _delete_at_path?: InputMaybe<Client_Fb_Request_Meta_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Client_Fb_Request_Meta_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Client_Fb_Request_Meta_Delete_Key_Input>;
  _prepend?: InputMaybe<Client_Fb_Request_Meta_Prepend_Input>;
  _set?: InputMaybe<Client_Fb_Request_Meta_Set_Input>;
  pk_columns: Client_Fb_Request_Meta_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Fb_Resource_StatusArgs = {
  _set?: InputMaybe<Client_Fb_Resource_Status_Set_Input>;
  where: Client_Fb_Resource_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Fb_Resource_Status_By_PkArgs = {
  _set?: InputMaybe<Client_Fb_Resource_Status_Set_Input>;
  pk_columns: Client_Fb_Resource_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Fb_Resource_TypeArgs = {
  _set?: InputMaybe<Client_Fb_Resource_Type_Set_Input>;
  where: Client_Fb_Resource_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Fb_Resource_Type_By_PkArgs = {
  _set?: InputMaybe<Client_Fb_Resource_Type_Set_Input>;
  pk_columns: Client_Fb_Resource_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Fb_ResourcesArgs = {
  _set?: InputMaybe<Client_Fb_Resources_Set_Input>;
  where: Client_Fb_Resources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Fb_Resources_By_PkArgs = {
  _set?: InputMaybe<Client_Fb_Resources_Set_Input>;
  pk_columns: Client_Fb_Resources_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_InvitesArgs = {
  _set?: InputMaybe<Client_Invites_Set_Input>;
  where: Client_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Invites_By_PkArgs = {
  _set?: InputMaybe<Client_Invites_Set_Input>;
  pk_columns: Client_Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Organization_Caption_ExamplesArgs = {
  _set?: InputMaybe<Client_Organization_Caption_Examples_Set_Input>;
  where: Client_Organization_Caption_Examples_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Organization_Caption_Examples_By_PkArgs = {
  _set?: InputMaybe<Client_Organization_Caption_Examples_Set_Input>;
  pk_columns: Client_Organization_Caption_Examples_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Organization_Fb_ConnectionArgs = {
  _set?: InputMaybe<Client_Organization_Fb_Connection_Set_Input>;
  where: Client_Organization_Fb_Connection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Organization_Fb_Connection_By_PkArgs = {
  _set?: InputMaybe<Client_Organization_Fb_Connection_Set_Input>;
  pk_columns: Client_Organization_Fb_Connection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_OrganizationsArgs = {
  _set?: InputMaybe<Client_Organizations_Set_Input>;
  where: Client_Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Organizations_By_PkArgs = {
  _set?: InputMaybe<Client_Organizations_Set_Input>;
  pk_columns: Client_Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Relevant_LinksArgs = {
  _set?: InputMaybe<Client_Relevant_Links_Set_Input>;
  where: Client_Relevant_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Relevant_Links_By_PkArgs = {
  _set?: InputMaybe<Client_Relevant_Links_Set_Input>;
  pk_columns: Client_Relevant_Links_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Report_DocumentArgs = {
  _append?: InputMaybe<Client_Report_Document_Append_Input>;
  _delete_at_path?: InputMaybe<Client_Report_Document_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Client_Report_Document_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Client_Report_Document_Delete_Key_Input>;
  _prepend?: InputMaybe<Client_Report_Document_Prepend_Input>;
  _set?: InputMaybe<Client_Report_Document_Set_Input>;
  where: Client_Report_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Report_Document_By_PkArgs = {
  _append?: InputMaybe<Client_Report_Document_Append_Input>;
  _delete_at_path?: InputMaybe<Client_Report_Document_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Client_Report_Document_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Client_Report_Document_Delete_Key_Input>;
  _prepend?: InputMaybe<Client_Report_Document_Prepend_Input>;
  _set?: InputMaybe<Client_Report_Document_Set_Input>;
  pk_columns: Client_Report_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Report_SetArgs = {
  _append?: InputMaybe<Client_Report_Set_Append_Input>;
  _delete_at_path?: InputMaybe<Client_Report_Set_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Client_Report_Set_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Client_Report_Set_Delete_Key_Input>;
  _prepend?: InputMaybe<Client_Report_Set_Prepend_Input>;
  _set?: InputMaybe<Client_Report_Set_Set_Input>;
  where: Client_Report_Set_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Report_Set_By_PkArgs = {
  _append?: InputMaybe<Client_Report_Set_Append_Input>;
  _delete_at_path?: InputMaybe<Client_Report_Set_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Client_Report_Set_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Client_Report_Set_Delete_Key_Input>;
  _prepend?: InputMaybe<Client_Report_Set_Prepend_Input>;
  _set?: InputMaybe<Client_Report_Set_Set_Input>;
  pk_columns: Client_Report_Set_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invites_StatusArgs = {
  _set?: InputMaybe<Invites_Status_Set_Input>;
  where: Invites_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invites_Status_By_PkArgs = {
  _set?: InputMaybe<Invites_Status_Set_Input>;
  pk_columns: Invites_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Member_InvitesArgs = {
  _set?: InputMaybe<Member_Invites_Set_Input>;
  where: Member_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Member_Invites_By_PkArgs = {
  _set?: InputMaybe<Member_Invites_Set_Input>;
  pk_columns: Member_Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_OffersArgs = {
  _set?: InputMaybe<Offers_Set_Input>;
  where: Offers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_By_PkArgs = {
  _set?: InputMaybe<Offers_Set_Input>;
  pk_columns: Offers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_StatusArgs = {
  _set?: InputMaybe<Offers_Status_Set_Input>;
  where: Offers_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_Status_By_PkArgs = {
  _set?: InputMaybe<Offers_Status_Set_Input>;
  pk_columns: Offers_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Fb_ConnectionArgs = {
  _set?: InputMaybe<Organization_Fb_Connection_Set_Input>;
  where: Organization_Fb_Connection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Fb_Connection_By_PkArgs = {
  _set?: InputMaybe<Organization_Fb_Connection_Set_Input>;
  pk_columns: Organization_Fb_Connection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_MembersArgs = {
  _set?: InputMaybe<Organization_Members_Set_Input>;
  where: Organization_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Members_By_PkArgs = {
  _set?: InputMaybe<Organization_Members_Set_Input>;
  pk_columns: Organization_Members_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Members_StatusArgs = {
  _set?: InputMaybe<Organization_Members_Status_Set_Input>;
  where: Organization_Members_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Members_Status_By_PkArgs = {
  _set?: InputMaybe<Organization_Members_Status_Set_Input>;
  pk_columns: Organization_Members_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Members_TypeArgs = {
  _set?: InputMaybe<Organization_Members_Type_Set_Input>;
  where: Organization_Members_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Members_Type_By_PkArgs = {
  _set?: InputMaybe<Organization_Members_Type_Set_Input>;
  pk_columns: Organization_Members_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationsArgs = {
  _set?: InputMaybe<Organizations_Set_Input>;
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_By_PkArgs = {
  _set?: InputMaybe<Organizations_Set_Input>;
  pk_columns: Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_StatusArgs = {
  _set?: InputMaybe<Organizations_Status_Set_Input>;
  where: Organizations_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_Status_By_PkArgs = {
  _set?: InputMaybe<Organizations_Status_Set_Input>;
  pk_columns: Organizations_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_TypeArgs = {
  _set?: InputMaybe<Organizations_Type_Set_Input>;
  where: Organizations_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_Type_By_PkArgs = {
  _set?: InputMaybe<Organizations_Type_Set_Input>;
  pk_columns: Organizations_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_UsersArgs = {
  _set?: InputMaybe<Project_Users_Set_Input>;
  where: Project_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Users_By_PkArgs = {
  _set?: InputMaybe<Project_Users_Set_Input>;
  pk_columns: Project_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectsArgs = {
  _set?: InputMaybe<Projects_Set_Input>;
  where: Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_By_PkArgs = {
  _set?: InputMaybe<Projects_Set_Input>;
  pk_columns: Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_StatusArgs = {
  _set?: InputMaybe<Projects_Status_Set_Input>;
  where: Projects_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_Status_By_PkArgs = {
  _set?: InputMaybe<Projects_Status_Set_Input>;
  pk_columns: Projects_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Theme_TypeArgs = {
  _set?: InputMaybe<Theme_Type_Set_Input>;
  where: Theme_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Theme_Type_By_PkArgs = {
  _set?: InputMaybe<Theme_Type_Set_Input>;
  pk_columns: Theme_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Freelancer_StatusArgs = {
  _set?: InputMaybe<Users_Freelancer_Status_Set_Input>;
  where: Users_Freelancer_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Freelancer_Status_By_PkArgs = {
  _set?: InputMaybe<Users_Freelancer_Status_Set_Input>;
  pk_columns: Users_Freelancer_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_White_LabelingArgs = {
  _set?: InputMaybe<White_Labeling_Set_Input>;
  where: White_Labeling_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_White_Labeling_By_PkArgs = {
  _set?: InputMaybe<White_Labeling_Set_Input>;
  pk_columns: White_Labeling_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_White_Labeling_ColorsArgs = {
  _set?: InputMaybe<White_Labeling_Colors_Set_Input>;
  where: White_Labeling_Colors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_White_Labeling_Colors_By_PkArgs = {
  _set?: InputMaybe<White_Labeling_Colors_Set_Input>;
  pk_columns: White_Labeling_Colors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_White_Labeling_FontsArgs = {
  _set?: InputMaybe<White_Labeling_Fonts_Set_Input>;
  where: White_Labeling_Fonts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_White_Labeling_Fonts_By_PkArgs = {
  _set?: InputMaybe<White_Labeling_Fonts_Set_Input>;
  pk_columns: White_Labeling_Fonts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Document_VersionsArgs = {
  _append?: InputMaybe<Workflow_Document_Versions_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Document_Versions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Document_Versions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Document_Versions_Delete_Key_Input>;
  _prepend?: InputMaybe<Workflow_Document_Versions_Prepend_Input>;
  _set?: InputMaybe<Workflow_Document_Versions_Set_Input>;
  where: Workflow_Document_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Document_Versions_By_PkArgs = {
  _append?: InputMaybe<Workflow_Document_Versions_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Document_Versions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Document_Versions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Document_Versions_Delete_Key_Input>;
  _prepend?: InputMaybe<Workflow_Document_Versions_Prepend_Input>;
  _set?: InputMaybe<Workflow_Document_Versions_Set_Input>;
  pk_columns: Workflow_Document_Versions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_DocumentsArgs = {
  _set?: InputMaybe<Workflow_Documents_Set_Input>;
  where: Workflow_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Documents_By_PkArgs = {
  _set?: InputMaybe<Workflow_Documents_Set_Input>;
  pk_columns: Workflow_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Field_ContentsArgs = {
  _append?: InputMaybe<Workflow_Field_Contents_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Field_Contents_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Field_Contents_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Field_Contents_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Field_Contents_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Field_Contents_Prepend_Input>;
  _set?: InputMaybe<Workflow_Field_Contents_Set_Input>;
  where: Workflow_Field_Contents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Field_Contents_By_PkArgs = {
  _append?: InputMaybe<Workflow_Field_Contents_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Field_Contents_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Field_Contents_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Field_Contents_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Field_Contents_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Field_Contents_Prepend_Input>;
  _set?: InputMaybe<Workflow_Field_Contents_Set_Input>;
  pk_columns: Workflow_Field_Contents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Field_Permission_TypesArgs = {
  _set?: InputMaybe<Workflow_Field_Permission_Types_Set_Input>;
  where: Workflow_Field_Permission_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Field_Permission_Types_By_PkArgs = {
  _set?: InputMaybe<Workflow_Field_Permission_Types_Set_Input>;
  pk_columns: Workflow_Field_Permission_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Field_PermissionsArgs = {
  _set?: InputMaybe<Workflow_Field_Permissions_Set_Input>;
  where: Workflow_Field_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Field_Permissions_By_PkArgs = {
  _set?: InputMaybe<Workflow_Field_Permissions_Set_Input>;
  pk_columns: Workflow_Field_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Field_TypesArgs = {
  _set?: InputMaybe<Workflow_Field_Types_Set_Input>;
  where: Workflow_Field_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Field_Types_By_PkArgs = {
  _set?: InputMaybe<Workflow_Field_Types_Set_Input>;
  pk_columns: Workflow_Field_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_FieldsArgs = {
  _append?: InputMaybe<Workflow_Fields_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Fields_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Fields_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Fields_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Fields_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Fields_Prepend_Input>;
  _set?: InputMaybe<Workflow_Fields_Set_Input>;
  where: Workflow_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Fields_By_PkArgs = {
  _append?: InputMaybe<Workflow_Fields_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Fields_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Fields_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Fields_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Fields_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Fields_Prepend_Input>;
  _set?: InputMaybe<Workflow_Fields_Set_Input>;
  pk_columns: Workflow_Fields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_PagesArgs = {
  _inc?: InputMaybe<Workflow_Pages_Inc_Input>;
  _set?: InputMaybe<Workflow_Pages_Set_Input>;
  where: Workflow_Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Pages_By_PkArgs = {
  _inc?: InputMaybe<Workflow_Pages_Inc_Input>;
  _set?: InputMaybe<Workflow_Pages_Set_Input>;
  pk_columns: Workflow_Pages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Processmaker_UsersArgs = {
  _inc?: InputMaybe<Workflow_Processmaker_Users_Inc_Input>;
  _set?: InputMaybe<Workflow_Processmaker_Users_Set_Input>;
  where: Workflow_Processmaker_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Processmaker_Users_By_PkArgs = {
  _inc?: InputMaybe<Workflow_Processmaker_Users_Inc_Input>;
  _set?: InputMaybe<Workflow_Processmaker_Users_Set_Input>;
  pk_columns: Workflow_Processmaker_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Saved_Document_Part_TypesArgs = {
  _set?: InputMaybe<Workflow_Saved_Document_Part_Types_Set_Input>;
  where: Workflow_Saved_Document_Part_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Saved_Document_Part_Types_By_PkArgs = {
  _set?: InputMaybe<Workflow_Saved_Document_Part_Types_Set_Input>;
  pk_columns: Workflow_Saved_Document_Part_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Saved_Document_PartsArgs = {
  _append?: InputMaybe<Workflow_Saved_Document_Parts_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Saved_Document_Parts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Saved_Document_Parts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Saved_Document_Parts_Delete_Key_Input>;
  _prepend?: InputMaybe<Workflow_Saved_Document_Parts_Prepend_Input>;
  _set?: InputMaybe<Workflow_Saved_Document_Parts_Set_Input>;
  where: Workflow_Saved_Document_Parts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Saved_Document_Parts_By_PkArgs = {
  _append?: InputMaybe<Workflow_Saved_Document_Parts_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Saved_Document_Parts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Saved_Document_Parts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Saved_Document_Parts_Delete_Key_Input>;
  _prepend?: InputMaybe<Workflow_Saved_Document_Parts_Prepend_Input>;
  _set?: InputMaybe<Workflow_Saved_Document_Parts_Set_Input>;
  pk_columns: Workflow_Saved_Document_Parts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Section_Comment_StatusArgs = {
  _set?: InputMaybe<Workflow_Section_Comment_Status_Set_Input>;
  where: Workflow_Section_Comment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Section_Comment_Status_By_PkArgs = {
  _set?: InputMaybe<Workflow_Section_Comment_Status_Set_Input>;
  pk_columns: Workflow_Section_Comment_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Section_CommentsArgs = {
  _inc?: InputMaybe<Workflow_Section_Comments_Inc_Input>;
  _set?: InputMaybe<Workflow_Section_Comments_Set_Input>;
  where: Workflow_Section_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Section_Comments_By_PkArgs = {
  _inc?: InputMaybe<Workflow_Section_Comments_Inc_Input>;
  _set?: InputMaybe<Workflow_Section_Comments_Set_Input>;
  pk_columns: Workflow_Section_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_SectionsArgs = {
  _inc?: InputMaybe<Workflow_Sections_Inc_Input>;
  _set?: InputMaybe<Workflow_Sections_Set_Input>;
  where: Workflow_Sections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Sections_By_PkArgs = {
  _inc?: InputMaybe<Workflow_Sections_Inc_Input>;
  _set?: InputMaybe<Workflow_Sections_Set_Input>;
  pk_columns: Workflow_Sections_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Task_NotificationsArgs = {
  _inc?: InputMaybe<Workflow_Task_Notifications_Inc_Input>;
  _set?: InputMaybe<Workflow_Task_Notifications_Set_Input>;
  where: Workflow_Task_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Task_Notifications_By_PkArgs = {
  _inc?: InputMaybe<Workflow_Task_Notifications_Inc_Input>;
  _set?: InputMaybe<Workflow_Task_Notifications_Set_Input>;
  pk_columns: Workflow_Task_Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Task_TypesArgs = {
  _set?: InputMaybe<Workflow_Task_Types_Set_Input>;
  where: Workflow_Task_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Task_Types_By_PkArgs = {
  _set?: InputMaybe<Workflow_Task_Types_Set_Input>;
  pk_columns: Workflow_Task_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_TasksArgs = {
  _append?: InputMaybe<Workflow_Tasks_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Tasks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Tasks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Tasks_Delete_Key_Input>;
  _prepend?: InputMaybe<Workflow_Tasks_Prepend_Input>;
  _set?: InputMaybe<Workflow_Tasks_Set_Input>;
  where: Workflow_Tasks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Tasks_By_PkArgs = {
  _append?: InputMaybe<Workflow_Tasks_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Tasks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Tasks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Tasks_Delete_Key_Input>;
  _prepend?: InputMaybe<Workflow_Tasks_Prepend_Input>;
  _set?: InputMaybe<Workflow_Tasks_Set_Input>;
  pk_columns: Workflow_Tasks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_Creation_StatusArgs = {
  _set?: InputMaybe<Workflow_Workflow_Creation_Status_Set_Input>;
  where: Workflow_Workflow_Creation_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_Creation_Status_By_PkArgs = {
  _set?: InputMaybe<Workflow_Workflow_Creation_Status_Set_Input>;
  pk_columns: Workflow_Workflow_Creation_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_Reactflow_StatusArgs = {
  _set?: InputMaybe<Workflow_Workflow_Reactflow_Status_Set_Input>;
  where: Workflow_Workflow_Reactflow_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_Reactflow_Status_By_PkArgs = {
  _set?: InputMaybe<Workflow_Workflow_Reactflow_Status_Set_Input>;
  pk_columns: Workflow_Workflow_Reactflow_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_StatusArgs = {
  _set?: InputMaybe<Workflow_Workflow_Status_Set_Input>;
  where: Workflow_Workflow_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_Status_By_PkArgs = {
  _set?: InputMaybe<Workflow_Workflow_Status_Set_Input>;
  pk_columns: Workflow_Workflow_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_TemplatesArgs = {
  _append?: InputMaybe<Workflow_Workflow_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Workflow_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Workflow_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Workflow_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Workflow_Workflow_Templates_Prepend_Input>;
  _set?: InputMaybe<Workflow_Workflow_Templates_Set_Input>;
  where: Workflow_Workflow_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_Templates_By_PkArgs = {
  _append?: InputMaybe<Workflow_Workflow_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Workflow_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Workflow_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Workflow_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Workflow_Workflow_Templates_Prepend_Input>;
  _set?: InputMaybe<Workflow_Workflow_Templates_Set_Input>;
  pk_columns: Workflow_Workflow_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_VersionsArgs = {
  _append?: InputMaybe<Workflow_Workflow_Versions_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Workflow_Versions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Workflow_Versions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Workflow_Versions_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Workflow_Versions_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Workflow_Versions_Prepend_Input>;
  _set?: InputMaybe<Workflow_Workflow_Versions_Set_Input>;
  where: Workflow_Workflow_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflow_Versions_By_PkArgs = {
  _append?: InputMaybe<Workflow_Workflow_Versions_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Workflow_Versions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Workflow_Versions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Workflow_Versions_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Workflow_Versions_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Workflow_Versions_Prepend_Input>;
  _set?: InputMaybe<Workflow_Workflow_Versions_Set_Input>;
  pk_columns: Workflow_Workflow_Versions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_WorkflowsArgs = {
  _inc?: InputMaybe<Workflow_Workflows_Inc_Input>;
  _set?: InputMaybe<Workflow_Workflows_Set_Input>;
  where: Workflow_Workflows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Workflows_By_PkArgs = {
  _inc?: InputMaybe<Workflow_Workflows_Inc_Input>;
  _set?: InputMaybe<Workflow_Workflows_Set_Input>;
  pk_columns: Workflow_Workflows_Pk_Columns_Input;
};

/** columns and relationships of "offers" */
export type Offers = {
  __typename?: 'offers';
  /** An object relationship */
  agency?: Maybe<Organizations>;
  agency_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamp']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  status: Offers_Status_Enum;
  /** An object relationship */
  status_id?: Maybe<Offers_Status>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamp']>;
};


/** columns and relationships of "offers" */
export type OffersProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};

/** aggregated selection of "offers" */
export type Offers_Aggregate = {
  __typename?: 'offers_aggregate';
  aggregate?: Maybe<Offers_Aggregate_Fields>;
  nodes: Array<Offers>;
};

/** aggregate fields of "offers" */
export type Offers_Aggregate_Fields = {
  __typename?: 'offers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Offers_Max_Fields>;
  min?: Maybe<Offers_Min_Fields>;
};


/** aggregate fields of "offers" */
export type Offers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "offers" */
export type Offers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offers_Max_Order_By>;
  min?: InputMaybe<Offers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "offers" */
export type Offers_Arr_Rel_Insert_Input = {
  data: Array<Offers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "offers". All fields are combined with a logical 'AND'. */
export type Offers_Bool_Exp = {
  _and?: InputMaybe<Array<Offers_Bool_Exp>>;
  _not?: InputMaybe<Offers_Bool_Exp>;
  _or?: InputMaybe<Array<Offers_Bool_Exp>>;
  agency?: InputMaybe<Organizations_Bool_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  projects?: InputMaybe<Projects_Bool_Exp>;
  status?: InputMaybe<Offers_Status_Enum_Comparison_Exp>;
  status_id?: InputMaybe<Offers_Status_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "offers" */
export enum Offers_Constraint {
  /** unique or primary key constraint on columns "id" */
  OffersPkey = 'offers_pkey'
}

/** input type for inserting data into table "offers" */
export type Offers_Insert_Input = {
  agency?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  agency_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Projects_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Offers_Status_Enum>;
  status_id?: InputMaybe<Offers_Status_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Offers_Max_Fields = {
  __typename?: 'offers_max_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "offers" */
export type Offers_Max_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offers_Min_Fields = {
  __typename?: 'offers_min_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "offers" */
export type Offers_Min_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "offers" */
export type Offers_Mutation_Response = {
  __typename?: 'offers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Offers>;
};

/** input type for inserting object relation for remote table "offers" */
export type Offers_Obj_Rel_Insert_Input = {
  data: Offers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};

/** on_conflict condition type for table "offers" */
export type Offers_On_Conflict = {
  constraint: Offers_Constraint;
  update_columns?: Array<Offers_Update_Column>;
  where?: InputMaybe<Offers_Bool_Exp>;
};

/** Ordering options when selecting data from "offers". */
export type Offers_Order_By = {
  agency?: InputMaybe<Organizations_Order_By>;
  agency_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Projects_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Offers_Status_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: offers */
export type Offers_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "offers" */
export enum Offers_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "offers" */
export type Offers_Set_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Offers_Status_Enum>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** columns and relationships of "offers_status" */
export type Offers_Status = {
  __typename?: 'offers_status';
  name: Scalars['String'];
  status: Scalars['String'];
};

/** aggregated selection of "offers_status" */
export type Offers_Status_Aggregate = {
  __typename?: 'offers_status_aggregate';
  aggregate?: Maybe<Offers_Status_Aggregate_Fields>;
  nodes: Array<Offers_Status>;
};

/** aggregate fields of "offers_status" */
export type Offers_Status_Aggregate_Fields = {
  __typename?: 'offers_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Offers_Status_Max_Fields>;
  min?: Maybe<Offers_Status_Min_Fields>;
};


/** aggregate fields of "offers_status" */
export type Offers_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offers_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "offers_status". All fields are combined with a logical 'AND'. */
export type Offers_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Offers_Status_Bool_Exp>>;
  _not?: InputMaybe<Offers_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Offers_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "offers_status" */
export enum Offers_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  OffersStatusNameKey = 'offers_status_name_key',
  /** unique or primary key constraint on columns "status" */
  OffersStatusPkey = 'offers_status_pkey'
}

export enum Offers_Status_Enum {
  /** Active */
  Active = 'ACTIVE',
  /** Archived */
  Archived = 'ARCHIVED'
}

/** Boolean expression to compare columns of type "offers_status_enum". All fields are combined with logical 'AND'. */
export type Offers_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Offers_Status_Enum>;
  _in?: InputMaybe<Array<Offers_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Offers_Status_Enum>;
  _nin?: InputMaybe<Array<Offers_Status_Enum>>;
};

/** input type for inserting data into table "offers_status" */
export type Offers_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Offers_Status_Max_Fields = {
  __typename?: 'offers_status_max_fields';
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Offers_Status_Min_Fields = {
  __typename?: 'offers_status_min_fields';
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "offers_status" */
export type Offers_Status_Mutation_Response = {
  __typename?: 'offers_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Offers_Status>;
};

/** input type for inserting object relation for remote table "offers_status" */
export type Offers_Status_Obj_Rel_Insert_Input = {
  data: Offers_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Offers_Status_On_Conflict>;
};

/** on_conflict condition type for table "offers_status" */
export type Offers_Status_On_Conflict = {
  constraint: Offers_Status_Constraint;
  update_columns?: Array<Offers_Status_Update_Column>;
  where?: InputMaybe<Offers_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "offers_status". */
export type Offers_Status_Order_By = {
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: offers_status */
export type Offers_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "offers_status" */
export enum Offers_Status_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "offers_status" */
export type Offers_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "offers_status" */
export enum Offers_Status_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status'
}

/** update columns of table "offers" */
export enum Offers_Update_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organization_fb_connection" */
export type Organization_Fb_Connection = {
  __typename?: 'organization_fb_connection';
  access_token: Scalars['String'];
  access_token_expiration: Scalars['timestamp'];
  business_id: Scalars['String'];
  business_manager_id: Scalars['String'];
  fb_user_id: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
};

/** aggregated selection of "organization_fb_connection" */
export type Organization_Fb_Connection_Aggregate = {
  __typename?: 'organization_fb_connection_aggregate';
  aggregate?: Maybe<Organization_Fb_Connection_Aggregate_Fields>;
  nodes: Array<Organization_Fb_Connection>;
};

/** aggregate fields of "organization_fb_connection" */
export type Organization_Fb_Connection_Aggregate_Fields = {
  __typename?: 'organization_fb_connection_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Fb_Connection_Max_Fields>;
  min?: Maybe<Organization_Fb_Connection_Min_Fields>;
};


/** aggregate fields of "organization_fb_connection" */
export type Organization_Fb_Connection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Fb_Connection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organization_fb_connection". All fields are combined with a logical 'AND'. */
export type Organization_Fb_Connection_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Fb_Connection_Bool_Exp>>;
  _not?: InputMaybe<Organization_Fb_Connection_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Fb_Connection_Bool_Exp>>;
  access_token?: InputMaybe<String_Comparison_Exp>;
  access_token_expiration?: InputMaybe<Timestamp_Comparison_Exp>;
  business_id?: InputMaybe<String_Comparison_Exp>;
  business_manager_id?: InputMaybe<String_Comparison_Exp>;
  fb_user_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_fb_connection" */
export enum Organization_Fb_Connection_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  OrganizationFbConnectionOrganizationIdKey = 'organization_fb_connection_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationFbConnectionPkey = 'organization_fb_connection_pkey'
}

/** input type for inserting data into table "organization_fb_connection" */
export type Organization_Fb_Connection_Insert_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  access_token_expiration?: InputMaybe<Scalars['timestamp']>;
  business_id?: InputMaybe<Scalars['String']>;
  business_manager_id?: InputMaybe<Scalars['String']>;
  fb_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Organization_Fb_Connection_Max_Fields = {
  __typename?: 'organization_fb_connection_max_fields';
  access_token?: Maybe<Scalars['String']>;
  access_token_expiration?: Maybe<Scalars['timestamp']>;
  business_id?: Maybe<Scalars['String']>;
  business_manager_id?: Maybe<Scalars['String']>;
  fb_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Organization_Fb_Connection_Min_Fields = {
  __typename?: 'organization_fb_connection_min_fields';
  access_token?: Maybe<Scalars['String']>;
  access_token_expiration?: Maybe<Scalars['timestamp']>;
  business_id?: Maybe<Scalars['String']>;
  business_manager_id?: Maybe<Scalars['String']>;
  fb_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "organization_fb_connection" */
export type Organization_Fb_Connection_Mutation_Response = {
  __typename?: 'organization_fb_connection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Fb_Connection>;
};

/** on_conflict condition type for table "organization_fb_connection" */
export type Organization_Fb_Connection_On_Conflict = {
  constraint: Organization_Fb_Connection_Constraint;
  update_columns?: Array<Organization_Fb_Connection_Update_Column>;
  where?: InputMaybe<Organization_Fb_Connection_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_fb_connection". */
export type Organization_Fb_Connection_Order_By = {
  access_token?: InputMaybe<Order_By>;
  access_token_expiration?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  business_manager_id?: InputMaybe<Order_By>;
  fb_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_fb_connection */
export type Organization_Fb_Connection_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organization_fb_connection" */
export enum Organization_Fb_Connection_Select_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  AccessTokenExpiration = 'access_token_expiration',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  BusinessManagerId = 'business_manager_id',
  /** column name */
  FbUserId = 'fb_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id'
}

/** input type for updating data in table "organization_fb_connection" */
export type Organization_Fb_Connection_Set_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  access_token_expiration?: InputMaybe<Scalars['timestamp']>;
  business_id?: InputMaybe<Scalars['String']>;
  business_manager_id?: InputMaybe<Scalars['String']>;
  fb_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "organization_fb_connection" */
export enum Organization_Fb_Connection_Update_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  AccessTokenExpiration = 'access_token_expiration',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  BusinessManagerId = 'business_manager_id',
  /** column name */
  FbUserId = 'fb_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id'
}

/** columns and relationships of "organization_members" */
export type Organization_Members = {
  __typename?: 'organization_members';
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  organization_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  role: Roles;
  role_id: Roles_Enum;
  status?: Maybe<Organization_Members_Status_Enum>;
  title: Scalars['String'];
  type?: Maybe<Organization_Members_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "organization_members" */
export type Organization_Members_Aggregate = {
  __typename?: 'organization_members_aggregate';
  aggregate?: Maybe<Organization_Members_Aggregate_Fields>;
  nodes: Array<Organization_Members>;
};

/** aggregate fields of "organization_members" */
export type Organization_Members_Aggregate_Fields = {
  __typename?: 'organization_members_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Members_Max_Fields>;
  min?: Maybe<Organization_Members_Min_Fields>;
};


/** aggregate fields of "organization_members" */
export type Organization_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization_members" */
export type Organization_Members_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Members_Max_Order_By>;
  min?: InputMaybe<Organization_Members_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_members" */
export type Organization_Members_Arr_Rel_Insert_Input = {
  data: Array<Organization_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Members_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_members". All fields are combined with a logical 'AND'. */
export type Organization_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Members_Bool_Exp>>;
  _not?: InputMaybe<Organization_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Members_Bool_Exp>>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Roles_Enum_Comparison_Exp>;
  status?: InputMaybe<Organization_Members_Status_Enum_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Organization_Members_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_members" */
export enum Organization_Members_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationMembersPkey = 'organization_members_pkey'
}

/** input type for inserting data into table "organization_members" */
export type Organization_Members_Insert_Input = {
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Roles_Enum>;
  status?: InputMaybe<Organization_Members_Status_Enum>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Organization_Members_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Organization_Members_Max_Fields = {
  __typename?: 'organization_members_max_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "organization_members" */
export type Organization_Members_Max_Order_By = {
  client_organization_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Members_Min_Fields = {
  __typename?: 'organization_members_min_fields';
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "organization_members" */
export type Organization_Members_Min_Order_By = {
  client_organization_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_members" */
export type Organization_Members_Mutation_Response = {
  __typename?: 'organization_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Members>;
};

/** input type for inserting object relation for remote table "organization_members" */
export type Organization_Members_Obj_Rel_Insert_Input = {
  data: Organization_Members_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Members_On_Conflict>;
};

/** on_conflict condition type for table "organization_members" */
export type Organization_Members_On_Conflict = {
  constraint: Organization_Members_Constraint;
  update_columns?: Array<Organization_Members_Update_Column>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_members". */
export type Organization_Members_Order_By = {
  client_organization_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_members */
export type Organization_Members_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organization_members" */
export enum Organization_Members_Select_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "organization_members" */
export type Organization_Members_Set_Input = {
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Roles_Enum>;
  status?: InputMaybe<Organization_Members_Status_Enum>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Organization_Members_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "organization_members_status" */
export type Organization_Members_Status = {
  __typename?: 'organization_members_status';
  /** vals: active, inactive */
  status: Scalars['String'];
};

/** aggregated selection of "organization_members_status" */
export type Organization_Members_Status_Aggregate = {
  __typename?: 'organization_members_status_aggregate';
  aggregate?: Maybe<Organization_Members_Status_Aggregate_Fields>;
  nodes: Array<Organization_Members_Status>;
};

/** aggregate fields of "organization_members_status" */
export type Organization_Members_Status_Aggregate_Fields = {
  __typename?: 'organization_members_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Members_Status_Max_Fields>;
  min?: Maybe<Organization_Members_Status_Min_Fields>;
};


/** aggregate fields of "organization_members_status" */
export type Organization_Members_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Members_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organization_members_status". All fields are combined with a logical 'AND'. */
export type Organization_Members_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Members_Status_Bool_Exp>>;
  _not?: InputMaybe<Organization_Members_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Members_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_members_status" */
export enum Organization_Members_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  OrganizationMembersStatusPkey = 'organization_members_status_pkey'
}

export enum Organization_Members_Status_Enum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "organization_members_status_enum". All fields are combined with logical 'AND'. */
export type Organization_Members_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organization_Members_Status_Enum>;
  _in?: InputMaybe<Array<Organization_Members_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Organization_Members_Status_Enum>;
  _nin?: InputMaybe<Array<Organization_Members_Status_Enum>>;
};

/** input type for inserting data into table "organization_members_status" */
export type Organization_Members_Status_Insert_Input = {
  /** vals: active, inactive */
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organization_Members_Status_Max_Fields = {
  __typename?: 'organization_members_status_max_fields';
  /** vals: active, inactive */
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organization_Members_Status_Min_Fields = {
  __typename?: 'organization_members_status_min_fields';
  /** vals: active, inactive */
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organization_members_status" */
export type Organization_Members_Status_Mutation_Response = {
  __typename?: 'organization_members_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Members_Status>;
};

/** on_conflict condition type for table "organization_members_status" */
export type Organization_Members_Status_On_Conflict = {
  constraint: Organization_Members_Status_Constraint;
  update_columns?: Array<Organization_Members_Status_Update_Column>;
  where?: InputMaybe<Organization_Members_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_members_status". */
export type Organization_Members_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_members_status */
export type Organization_Members_Status_Pk_Columns_Input = {
  /** vals: active, inactive */
  status: Scalars['String'];
};

/** select columns of table "organization_members_status" */
export enum Organization_Members_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "organization_members_status" */
export type Organization_Members_Status_Set_Input = {
  /** vals: active, inactive */
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organization_members_status" */
export enum Organization_Members_Status_Update_Column {
  /** column name */
  Status = 'status'
}

/** columns and relationships of "organization_members_type" */
export type Organization_Members_Type = {
  __typename?: 'organization_members_type';
  /** vals: member, freelancer */
  type: Scalars['String'];
};

/** aggregated selection of "organization_members_type" */
export type Organization_Members_Type_Aggregate = {
  __typename?: 'organization_members_type_aggregate';
  aggregate?: Maybe<Organization_Members_Type_Aggregate_Fields>;
  nodes: Array<Organization_Members_Type>;
};

/** aggregate fields of "organization_members_type" */
export type Organization_Members_Type_Aggregate_Fields = {
  __typename?: 'organization_members_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Members_Type_Max_Fields>;
  min?: Maybe<Organization_Members_Type_Min_Fields>;
};


/** aggregate fields of "organization_members_type" */
export type Organization_Members_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Members_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organization_members_type". All fields are combined with a logical 'AND'. */
export type Organization_Members_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Members_Type_Bool_Exp>>;
  _not?: InputMaybe<Organization_Members_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Members_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_members_type" */
export enum Organization_Members_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  OrganizationMembersTypePkey = 'organization_members_type_pkey'
}

export enum Organization_Members_Type_Enum {
  Client = 'CLIENT',
  Freelancer = 'FREELANCER',
  Member = 'MEMBER',
  Robot = 'ROBOT'
}

/** Boolean expression to compare columns of type "organization_members_type_enum". All fields are combined with logical 'AND'. */
export type Organization_Members_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organization_Members_Type_Enum>;
  _in?: InputMaybe<Array<Organization_Members_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Organization_Members_Type_Enum>;
  _nin?: InputMaybe<Array<Organization_Members_Type_Enum>>;
};

/** input type for inserting data into table "organization_members_type" */
export type Organization_Members_Type_Insert_Input = {
  /** vals: member, freelancer */
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organization_Members_Type_Max_Fields = {
  __typename?: 'organization_members_type_max_fields';
  /** vals: member, freelancer */
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organization_Members_Type_Min_Fields = {
  __typename?: 'organization_members_type_min_fields';
  /** vals: member, freelancer */
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organization_members_type" */
export type Organization_Members_Type_Mutation_Response = {
  __typename?: 'organization_members_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Members_Type>;
};

/** on_conflict condition type for table "organization_members_type" */
export type Organization_Members_Type_On_Conflict = {
  constraint: Organization_Members_Type_Constraint;
  update_columns?: Array<Organization_Members_Type_Update_Column>;
  where?: InputMaybe<Organization_Members_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_members_type". */
export type Organization_Members_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_members_type */
export type Organization_Members_Type_Pk_Columns_Input = {
  /** vals: member, freelancer */
  type: Scalars['String'];
};

/** select columns of table "organization_members_type" */
export enum Organization_Members_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "organization_members_type" */
export type Organization_Members_Type_Set_Input = {
  /** vals: member, freelancer */
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organization_members_type" */
export enum Organization_Members_Type_Update_Column {
  /** column name */
  Type = 'type'
}

/** update columns of table "organization_members" */
export enum Organization_Members_Update_Column {
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  address_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  address_links: Array<Address_Links>;
  /** An aggregate relationship */
  address_links_aggregate: Address_Links_Aggregate;
  /** An array relationship */
  client_organizations: Array<Client_Organizations>;
  /** An aggregate relationship */
  client_organizations_aggregate: Client_Organizations_Aggregate;
  created_at?: Maybe<Scalars['timestamp']>;
  custom_domain?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  logo_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  member_invites: Array<Member_Invites>;
  /** An aggregate relationship */
  member_invites_aggregate: Member_Invites_Aggregate;
  /** An array relationship */
  members: Array<Organization_Members>;
  /** An aggregate relationship */
  members_aggregate: Organization_Members_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  status: Organizations_Status_Enum;
  stripe_customer_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  type: Organizations_Type_Enum;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsAddress_LinksArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsAddress_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsClient_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Client_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organizations_Order_By>>;
  where?: InputMaybe<Client_Organizations_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsClient_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organizations_Order_By>>;
  where?: InputMaybe<Client_Organizations_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsMember_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Member_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Invites_Order_By>>;
  where?: InputMaybe<Member_Invites_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsMember_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Invites_Order_By>>;
  where?: InputMaybe<Member_Invites_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsMembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};

/** aggregated selection of "organizations" */
export type Organizations_Aggregate = {
  __typename?: 'organizations_aggregate';
  aggregate?: Maybe<Organizations_Aggregate_Fields>;
  nodes: Array<Organizations>;
};

/** aggregate fields of "organizations" */
export type Organizations_Aggregate_Fields = {
  __typename?: 'organizations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organizations_Max_Fields>;
  min?: Maybe<Organizations_Min_Fields>;
};


/** aggregate fields of "organizations" */
export type Organizations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Bool_Exp>>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  address_links?: InputMaybe<Address_Links_Bool_Exp>;
  client_organizations?: InputMaybe<Client_Organizations_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  custom_domain?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logo_url?: InputMaybe<String_Comparison_Exp>;
  member_invites?: InputMaybe<Member_Invites_Bool_Exp>;
  members?: InputMaybe<Organization_Members_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  offers?: InputMaybe<Offers_Bool_Exp>;
  projects?: InputMaybe<Projects_Bool_Exp>;
  status?: InputMaybe<Organizations_Status_Enum_Comparison_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Organizations_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organizations" */
export enum Organizations_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationsPkey = 'organizations_pkey',
  /** unique or primary key constraint on columns "stripe_customer_id" */
  OrganizationsStripeCustomerIdKey = 'organizations_stripe_customer_id_key'
}

/** input type for inserting data into table "organizations" */
export type Organizations_Insert_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  address_links?: InputMaybe<Address_Links_Arr_Rel_Insert_Input>;
  client_organizations?: InputMaybe<Client_Organizations_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  custom_domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  logo_url?: InputMaybe<Scalars['String']>;
  member_invites?: InputMaybe<Member_Invites_Arr_Rel_Insert_Input>;
  members?: InputMaybe<Organization_Members_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Offers_Arr_Rel_Insert_Input>;
  projects?: InputMaybe<Projects_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Organizations_Status_Enum>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Organizations_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Organizations_Max_Fields = {
  __typename?: 'organizations_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  custom_domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logo_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Organizations_Min_Fields = {
  __typename?: 'organizations_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  custom_domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logo_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "organizations" */
export type Organizations_Mutation_Response = {
  __typename?: 'organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** input type for inserting object relation for remote table "organizations" */
export type Organizations_Obj_Rel_Insert_Input = {
  data: Organizations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};

/** on_conflict condition type for table "organizations" */
export type Organizations_On_Conflict = {
  constraint: Organizations_Constraint;
  update_columns?: Array<Organizations_Update_Column>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations". */
export type Organizations_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_links_aggregate?: InputMaybe<Address_Links_Aggregate_Order_By>;
  client_organizations_aggregate?: InputMaybe<Client_Organizations_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_domain?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  member_invites_aggregate?: InputMaybe<Member_Invites_Aggregate_Order_By>;
  members_aggregate?: InputMaybe<Organization_Members_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  offers_aggregate?: InputMaybe<Offers_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Projects_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organizations */
export type Organizations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organizations" */
export enum Organizations_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomDomain = 'custom_domain',
  /** column name */
  Id = 'id',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organizations" */
export type Organizations_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  custom_domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  logo_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Organizations_Status_Enum>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Organizations_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "organizations_status" */
export type Organizations_Status = {
  __typename?: 'organizations_status';
  /** types active, inactive, deleted */
  status: Scalars['String'];
};

/** aggregated selection of "organizations_status" */
export type Organizations_Status_Aggregate = {
  __typename?: 'organizations_status_aggregate';
  aggregate?: Maybe<Organizations_Status_Aggregate_Fields>;
  nodes: Array<Organizations_Status>;
};

/** aggregate fields of "organizations_status" */
export type Organizations_Status_Aggregate_Fields = {
  __typename?: 'organizations_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organizations_Status_Max_Fields>;
  min?: Maybe<Organizations_Status_Min_Fields>;
};


/** aggregate fields of "organizations_status" */
export type Organizations_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organizations_status". All fields are combined with a logical 'AND'. */
export type Organizations_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Status_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organizations_status" */
export enum Organizations_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  OrganizationsStatusPkey = 'organizations_status_pkey'
}

export enum Organizations_Status_Enum {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "organizations_status_enum". All fields are combined with logical 'AND'. */
export type Organizations_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organizations_Status_Enum>;
  _in?: InputMaybe<Array<Organizations_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Organizations_Status_Enum>;
  _nin?: InputMaybe<Array<Organizations_Status_Enum>>;
};

/** input type for inserting data into table "organizations_status" */
export type Organizations_Status_Insert_Input = {
  /** types active, inactive, deleted */
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organizations_Status_Max_Fields = {
  __typename?: 'organizations_status_max_fields';
  /** types active, inactive, deleted */
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organizations_Status_Min_Fields = {
  __typename?: 'organizations_status_min_fields';
  /** types active, inactive, deleted */
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organizations_status" */
export type Organizations_Status_Mutation_Response = {
  __typename?: 'organizations_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations_Status>;
};

/** on_conflict condition type for table "organizations_status" */
export type Organizations_Status_On_Conflict = {
  constraint: Organizations_Status_Constraint;
  update_columns?: Array<Organizations_Status_Update_Column>;
  where?: InputMaybe<Organizations_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations_status". */
export type Organizations_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organizations_status */
export type Organizations_Status_Pk_Columns_Input = {
  /** types active, inactive, deleted */
  status: Scalars['String'];
};

/** select columns of table "organizations_status" */
export enum Organizations_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "organizations_status" */
export type Organizations_Status_Set_Input = {
  /** types active, inactive, deleted */
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organizations_status" */
export enum Organizations_Status_Update_Column {
  /** column name */
  Status = 'status'
}

/** columns and relationships of "organizations_type" */
export type Organizations_Type = {
  __typename?: 'organizations_type';
  /** values: agency, business */
  type: Scalars['String'];
};

/** aggregated selection of "organizations_type" */
export type Organizations_Type_Aggregate = {
  __typename?: 'organizations_type_aggregate';
  aggregate?: Maybe<Organizations_Type_Aggregate_Fields>;
  nodes: Array<Organizations_Type>;
};

/** aggregate fields of "organizations_type" */
export type Organizations_Type_Aggregate_Fields = {
  __typename?: 'organizations_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organizations_Type_Max_Fields>;
  min?: Maybe<Organizations_Type_Min_Fields>;
};


/** aggregate fields of "organizations_type" */
export type Organizations_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organizations_type". All fields are combined with a logical 'AND'. */
export type Organizations_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Type_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organizations_type" */
export enum Organizations_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  OrganizationsTypePkey = 'organizations_type_pkey'
}

export enum Organizations_Type_Enum {
  Agency = 'AGENCY',
  Business = 'BUSINESS'
}

/** Boolean expression to compare columns of type "organizations_type_enum". All fields are combined with logical 'AND'. */
export type Organizations_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organizations_Type_Enum>;
  _in?: InputMaybe<Array<Organizations_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Organizations_Type_Enum>;
  _nin?: InputMaybe<Array<Organizations_Type_Enum>>;
};

/** input type for inserting data into table "organizations_type" */
export type Organizations_Type_Insert_Input = {
  /** values: agency, business */
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organizations_Type_Max_Fields = {
  __typename?: 'organizations_type_max_fields';
  /** values: agency, business */
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organizations_Type_Min_Fields = {
  __typename?: 'organizations_type_min_fields';
  /** values: agency, business */
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organizations_type" */
export type Organizations_Type_Mutation_Response = {
  __typename?: 'organizations_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations_Type>;
};

/** on_conflict condition type for table "organizations_type" */
export type Organizations_Type_On_Conflict = {
  constraint: Organizations_Type_Constraint;
  update_columns?: Array<Organizations_Type_Update_Column>;
  where?: InputMaybe<Organizations_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations_type". */
export type Organizations_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organizations_type */
export type Organizations_Type_Pk_Columns_Input = {
  /** values: agency, business */
  type: Scalars['String'];
};

/** select columns of table "organizations_type" */
export enum Organizations_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "organizations_type" */
export type Organizations_Type_Set_Input = {
  /** values: agency, business */
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organizations_type" */
export enum Organizations_Type_Update_Column {
  /** column name */
  Type = 'type'
}

/** update columns of table "organizations" */
export enum Organizations_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomDomain = 'custom_domain',
  /** column name */
  Id = 'id',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** The team members added specifically to this project */
export type Project_Users = {
  __typename?: 'project_users';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  organization_member: Organization_Members;
  organization_members_id: Scalars['uuid'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "project_users" */
export type Project_Users_Aggregate = {
  __typename?: 'project_users_aggregate';
  aggregate?: Maybe<Project_Users_Aggregate_Fields>;
  nodes: Array<Project_Users>;
};

/** aggregate fields of "project_users" */
export type Project_Users_Aggregate_Fields = {
  __typename?: 'project_users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Users_Max_Fields>;
  min?: Maybe<Project_Users_Min_Fields>;
};


/** aggregate fields of "project_users" */
export type Project_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_users" */
export type Project_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Users_Max_Order_By>;
  min?: InputMaybe<Project_Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_users" */
export type Project_Users_Arr_Rel_Insert_Input = {
  data: Array<Project_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_users". All fields are combined with a logical 'AND'. */
export type Project_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Users_Bool_Exp>>;
  _not?: InputMaybe<Project_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_member?: InputMaybe<Organization_Members_Bool_Exp>;
  organization_members_id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_users" */
export enum Project_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectUsersPkey = 'project_users_pkey'
}

/** input type for inserting data into table "project_users" */
export type Project_Users_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_member?: InputMaybe<Organization_Members_Obj_Rel_Insert_Input>;
  organization_members_id?: InputMaybe<Scalars['uuid']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Project_Users_Max_Fields = {
  __typename?: 'project_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organization_members_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "project_users" */
export type Project_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_members_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Users_Min_Fields = {
  __typename?: 'project_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organization_members_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "project_users" */
export type Project_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_members_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_users" */
export type Project_Users_Mutation_Response = {
  __typename?: 'project_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Users>;
};

/** on_conflict condition type for table "project_users" */
export type Project_Users_On_Conflict = {
  constraint: Project_Users_Constraint;
  update_columns?: Array<Project_Users_Update_Column>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "project_users". */
export type Project_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_member?: InputMaybe<Organization_Members_Order_By>;
  organization_members_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_users */
export type Project_Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_users" */
export enum Project_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationMembersId = 'organization_members_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_users" */
export type Project_Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_members_id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "project_users" */
export enum Project_Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationMembersId = 'organization_members_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "projects" */
export type Projects = {
  __typename?: 'projects';
  /** An object relationship */
  agency?: Maybe<Organizations>;
  agency_id?: Maybe<Scalars['uuid']>;
  business_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  client_organization?: Maybe<Client_Organizations>;
  created_at?: Maybe<Scalars['timestamp']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  offer?: Maybe<Offers>;
  offer_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  project_users: Array<Project_Users>;
  /** An aggregate relationship */
  project_users_aggregate: Project_Users_Aggregate;
  status?: Maybe<Projects_Status_Enum>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_UsersArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};

/** aggregated selection of "projects" */
export type Projects_Aggregate = {
  __typename?: 'projects_aggregate';
  aggregate?: Maybe<Projects_Aggregate_Fields>;
  nodes: Array<Projects>;
};

/** aggregate fields of "projects" */
export type Projects_Aggregate_Fields = {
  __typename?: 'projects_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Projects_Max_Fields>;
  min?: Maybe<Projects_Min_Fields>;
};


/** aggregate fields of "projects" */
export type Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "projects" */
export type Projects_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projects_Max_Order_By>;
  min?: InputMaybe<Projects_Min_Order_By>;
};

/** input type for inserting array relation for remote table "projects" */
export type Projects_Arr_Rel_Insert_Input = {
  data: Array<Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};

/** Boolean expression to filter rows from the table "projects". All fields are combined with a logical 'AND'. */
export type Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Bool_Exp>>;
  _not?: InputMaybe<Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Bool_Exp>>;
  agency?: InputMaybe<Organizations_Bool_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  business_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_organization?: InputMaybe<Client_Organizations_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  details?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  offer?: InputMaybe<Offers_Bool_Exp>;
  offer_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_users?: InputMaybe<Project_Users_Bool_Exp>;
  status?: InputMaybe<Projects_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "projects" */
export enum Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectsPkey = 'projects_pkey'
}

/** input type for inserting data into table "projects" */
export type Projects_Insert_Input = {
  agency?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  agency_id?: InputMaybe<Scalars['uuid']>;
  business_id?: InputMaybe<Scalars['uuid']>;
  client_organization?: InputMaybe<Client_Organizations_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  offer?: InputMaybe<Offers_Obj_Rel_Insert_Input>;
  offer_id?: InputMaybe<Scalars['uuid']>;
  project_users?: InputMaybe<Project_Users_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Projects_Status_Enum>;
};

/** aggregate max on columns */
export type Projects_Max_Fields = {
  __typename?: 'projects_max_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  business_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  offer_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "projects" */
export type Projects_Max_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Projects_Min_Fields = {
  __typename?: 'projects_min_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  business_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  offer_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "projects" */
export type Projects_Min_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "projects" */
export type Projects_Mutation_Response = {
  __typename?: 'projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects>;
};

/** input type for inserting object relation for remote table "projects" */
export type Projects_Obj_Rel_Insert_Input = {
  data: Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};

/** on_conflict condition type for table "projects" */
export type Projects_On_Conflict = {
  constraint: Projects_Constraint;
  update_columns?: Array<Projects_Update_Column>;
  where?: InputMaybe<Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "projects". */
export type Projects_Order_By = {
  agency?: InputMaybe<Organizations_Order_By>;
  agency_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  client_organization?: InputMaybe<Client_Organizations_Order_By>;
  created_at?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offer?: InputMaybe<Offers_Order_By>;
  offer_id?: InputMaybe<Order_By>;
  project_users_aggregate?: InputMaybe<Project_Users_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: projects */
export type Projects_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "projects" */
export enum Projects_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "projects" */
export type Projects_Set_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  business_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  offer_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Projects_Status_Enum>;
};

/** columns and relationships of "projects_status" */
export type Projects_Status = {
  __typename?: 'projects_status';
  /** vals: active, inactive, canceled */
  status: Scalars['String'];
};

/** aggregated selection of "projects_status" */
export type Projects_Status_Aggregate = {
  __typename?: 'projects_status_aggregate';
  aggregate?: Maybe<Projects_Status_Aggregate_Fields>;
  nodes: Array<Projects_Status>;
};

/** aggregate fields of "projects_status" */
export type Projects_Status_Aggregate_Fields = {
  __typename?: 'projects_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Projects_Status_Max_Fields>;
  min?: Maybe<Projects_Status_Min_Fields>;
};


/** aggregate fields of "projects_status" */
export type Projects_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "projects_status". All fields are combined with a logical 'AND'. */
export type Projects_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Status_Bool_Exp>>;
  _not?: InputMaybe<Projects_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "projects_status" */
export enum Projects_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  ProjectsStatusPkey = 'projects_status_pkey'
}

export enum Projects_Status_Enum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "projects_status_enum". All fields are combined with logical 'AND'. */
export type Projects_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Projects_Status_Enum>;
  _in?: InputMaybe<Array<Projects_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Projects_Status_Enum>;
  _nin?: InputMaybe<Array<Projects_Status_Enum>>;
};

/** input type for inserting data into table "projects_status" */
export type Projects_Status_Insert_Input = {
  /** vals: active, inactive, canceled */
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Projects_Status_Max_Fields = {
  __typename?: 'projects_status_max_fields';
  /** vals: active, inactive, canceled */
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Projects_Status_Min_Fields = {
  __typename?: 'projects_status_min_fields';
  /** vals: active, inactive, canceled */
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "projects_status" */
export type Projects_Status_Mutation_Response = {
  __typename?: 'projects_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects_Status>;
};

/** on_conflict condition type for table "projects_status" */
export type Projects_Status_On_Conflict = {
  constraint: Projects_Status_Constraint;
  update_columns?: Array<Projects_Status_Update_Column>;
  where?: InputMaybe<Projects_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "projects_status". */
export type Projects_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: projects_status */
export type Projects_Status_Pk_Columns_Input = {
  /** vals: active, inactive, canceled */
  status: Scalars['String'];
};

/** select columns of table "projects_status" */
export enum Projects_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "projects_status" */
export type Projects_Status_Set_Input = {
  /** vals: active, inactive, canceled */
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "projects_status" */
export enum Projects_Status_Update_Column {
  /** column name */
  Status = 'status'
}

/** update columns of table "projects" */
export enum Projects_Update_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  Status = 'status'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** An array relationship */
  address_links: Array<Address_Links>;
  /** An aggregate relationship */
  address_links_aggregate: Address_Links_Aggregate;
  /** fetch data from the table: "address_links" using primary key columns */
  address_links_by_pk?: Maybe<Address_Links>;
  /** fetch data from the table: "ai_tools_credits" */
  ai_tools_credits: Array<Ai_Tools_Credits>;
  /** fetch aggregated fields from the table: "ai_tools_credits" */
  ai_tools_credits_aggregate: Ai_Tools_Credits_Aggregate;
  /** fetch data from the table: "ai_tools_credits" using primary key columns */
  ai_tools_credits_by_pk?: Maybe<Ai_Tools_Credits>;
  ai_tools_get_usage?: Maybe<ServiceUsage>;
  /** fetch data from the table: "ai_tools_history" */
  ai_tools_history: Array<Ai_Tools_History>;
  /** fetch aggregated fields from the table: "ai_tools_history" */
  ai_tools_history_aggregate: Ai_Tools_History_Aggregate;
  /** fetch data from the table: "ai_tools_history" using primary key columns */
  ai_tools_history_by_pk?: Maybe<Ai_Tools_History>;
  /** fetch data from the table: "ai_tools_services" */
  ai_tools_services: Array<Ai_Tools_Services>;
  /** fetch aggregated fields from the table: "ai_tools_services" */
  ai_tools_services_aggregate: Ai_Tools_Services_Aggregate;
  /** fetch data from the table: "ai_tools_services" using primary key columns */
  ai_tools_services_by_pk?: Maybe<Ai_Tools_Services>;
  /** fetch data from the table: "caption_example_categories" */
  caption_example_categories: Array<Caption_Example_Categories>;
  /** fetch aggregated fields from the table: "caption_example_categories" */
  caption_example_categories_aggregate: Caption_Example_Categories_Aggregate;
  /** fetch data from the table: "caption_example_categories" using primary key columns */
  caption_example_categories_by_pk?: Maybe<Caption_Example_Categories>;
  /** fetch data from the table: "caption_example_subcategories" */
  caption_example_subcategories: Array<Caption_Example_Subcategories>;
  /** fetch aggregated fields from the table: "caption_example_subcategories" */
  caption_example_subcategories_aggregate: Caption_Example_Subcategories_Aggregate;
  /** fetch data from the table: "caption_example_subcategories" using primary key columns */
  caption_example_subcategories_by_pk?: Maybe<Caption_Example_Subcategories>;
  /** fetch data from the table: "chat_bridgings" */
  chat_bridgings: Array<Chat_Bridgings>;
  /** fetch aggregated fields from the table: "chat_bridgings" */
  chat_bridgings_aggregate: Chat_Bridgings_Aggregate;
  /** fetch data from the table: "chat_bridgings" using primary key columns */
  chat_bridgings_by_pk?: Maybe<Chat_Bridgings>;
  /** fetch data from the table: "chat_stream_action_send_message" */
  chat_stream_action_send_message: Array<Chat_Stream_Action_Send_Message>;
  /** fetch aggregated fields from the table: "chat_stream_action_send_message" */
  chat_stream_action_send_message_aggregate: Chat_Stream_Action_Send_Message_Aggregate;
  /** fetch data from the table: "chat_stream_action_send_message" using primary key columns */
  chat_stream_action_send_message_by_pk?: Maybe<Chat_Stream_Action_Send_Message>;
  /** fetch data from the table: "chat_stream_post_webhooks" */
  chat_stream_post_webhooks: Array<Chat_Stream_Post_Webhooks>;
  /** fetch aggregated fields from the table: "chat_stream_post_webhooks" */
  chat_stream_post_webhooks_aggregate: Chat_Stream_Post_Webhooks_Aggregate;
  /** fetch data from the table: "chat_stream_post_webhooks" using primary key columns */
  chat_stream_post_webhooks_by_pk?: Maybe<Chat_Stream_Post_Webhooks>;
  /** fetch data from the table: "chat_stream_pre_webhooks" */
  chat_stream_pre_webhooks: Array<Chat_Stream_Pre_Webhooks>;
  /** fetch aggregated fields from the table: "chat_stream_pre_webhooks" */
  chat_stream_pre_webhooks_aggregate: Chat_Stream_Pre_Webhooks_Aggregate;
  /** fetch data from the table: "chat_stream_pre_webhooks" using primary key columns */
  chat_stream_pre_webhooks_by_pk?: Maybe<Chat_Stream_Pre_Webhooks>;
  /** fetch data from the table: "chat_twilio_conv_action_send_message" */
  chat_twilio_conv_action_send_message: Array<Chat_Twilio_Conv_Action_Send_Message>;
  /** fetch aggregated fields from the table: "chat_twilio_conv_action_send_message" */
  chat_twilio_conv_action_send_message_aggregate: Chat_Twilio_Conv_Action_Send_Message_Aggregate;
  /** fetch data from the table: "chat_twilio_conv_action_send_message" using primary key columns */
  chat_twilio_conv_action_send_message_by_pk?: Maybe<Chat_Twilio_Conv_Action_Send_Message>;
  /** fetch data from the table: "chat_twilio_conv_post_webhooks" */
  chat_twilio_conv_post_webhooks: Array<Chat_Twilio_Conv_Post_Webhooks>;
  /** fetch aggregated fields from the table: "chat_twilio_conv_post_webhooks" */
  chat_twilio_conv_post_webhooks_aggregate: Chat_Twilio_Conv_Post_Webhooks_Aggregate;
  /** fetch data from the table: "chat_twilio_conv_post_webhooks" using primary key columns */
  chat_twilio_conv_post_webhooks_by_pk?: Maybe<Chat_Twilio_Conv_Post_Webhooks>;
  /** fetch data from the table: "chat_user_channel_alias" */
  chat_user_channel_alias: Array<Chat_User_Channel_Alias>;
  /** fetch aggregated fields from the table: "chat_user_channel_alias" */
  chat_user_channel_alias_aggregate: Chat_User_Channel_Alias_Aggregate;
  /** fetch data from the table: "chat_user_channel_alias" using primary key columns */
  chat_user_channel_alias_by_pk?: Maybe<Chat_User_Channel_Alias>;
  client_facebook_client_code?: Maybe<FacebookClientCode>;
  /** fetch data from the table: "client_fb_request_meta" */
  client_fb_request_meta: Array<Client_Fb_Request_Meta>;
  /** fetch aggregated fields from the table: "client_fb_request_meta" */
  client_fb_request_meta_aggregate: Client_Fb_Request_Meta_Aggregate;
  /** fetch data from the table: "client_fb_request_meta" using primary key columns */
  client_fb_request_meta_by_pk?: Maybe<Client_Fb_Request_Meta>;
  /** fetch data from the table: "client_fb_resource_status" */
  client_fb_resource_status: Array<Client_Fb_Resource_Status>;
  /** fetch aggregated fields from the table: "client_fb_resource_status" */
  client_fb_resource_status_aggregate: Client_Fb_Resource_Status_Aggregate;
  /** fetch data from the table: "client_fb_resource_status" using primary key columns */
  client_fb_resource_status_by_pk?: Maybe<Client_Fb_Resource_Status>;
  /** fetch data from the table: "client_fb_resource_type" */
  client_fb_resource_type: Array<Client_Fb_Resource_Type>;
  /** fetch aggregated fields from the table: "client_fb_resource_type" */
  client_fb_resource_type_aggregate: Client_Fb_Resource_Type_Aggregate;
  /** fetch data from the table: "client_fb_resource_type" using primary key columns */
  client_fb_resource_type_by_pk?: Maybe<Client_Fb_Resource_Type>;
  /** fetch data from the table: "client_fb_resources" */
  client_fb_resources: Array<Client_Fb_Resources>;
  /** fetch aggregated fields from the table: "client_fb_resources" */
  client_fb_resources_aggregate: Client_Fb_Resources_Aggregate;
  /** fetch data from the table: "client_fb_resources" using primary key columns */
  client_fb_resources_by_pk?: Maybe<Client_Fb_Resources>;
  /** fetch data from the table: "client_invites" */
  client_invites: Array<Client_Invites>;
  /** fetch aggregated fields from the table: "client_invites" */
  client_invites_aggregate: Client_Invites_Aggregate;
  /** fetch data from the table: "client_invites" using primary key columns */
  client_invites_by_pk?: Maybe<Client_Invites>;
  /** fetch data from the table: "client_organization_caption_examples" */
  client_organization_caption_examples: Array<Client_Organization_Caption_Examples>;
  /** fetch aggregated fields from the table: "client_organization_caption_examples" */
  client_organization_caption_examples_aggregate: Client_Organization_Caption_Examples_Aggregate;
  /** fetch data from the table: "client_organization_caption_examples" using primary key columns */
  client_organization_caption_examples_by_pk?: Maybe<Client_Organization_Caption_Examples>;
  /** fetch data from the table: "client_organization_fb_connection" */
  client_organization_fb_connection: Array<Client_Organization_Fb_Connection>;
  /** fetch aggregated fields from the table: "client_organization_fb_connection" */
  client_organization_fb_connection_aggregate: Client_Organization_Fb_Connection_Aggregate;
  /** fetch data from the table: "client_organization_fb_connection" using primary key columns */
  client_organization_fb_connection_by_pk?: Maybe<Client_Organization_Fb_Connection>;
  /** An array relationship */
  client_organizations: Array<Client_Organizations>;
  /** An aggregate relationship */
  client_organizations_aggregate: Client_Organizations_Aggregate;
  /** fetch data from the table: "client_organizations" using primary key columns */
  client_organizations_by_pk?: Maybe<Client_Organizations>;
  /** An array relationship */
  client_relevant_links: Array<Client_Relevant_Links>;
  /** An aggregate relationship */
  client_relevant_links_aggregate: Client_Relevant_Links_Aggregate;
  /** fetch data from the table: "client_relevant_links" using primary key columns */
  client_relevant_links_by_pk?: Maybe<Client_Relevant_Links>;
  /** fetch data from the table: "client_report_document" */
  client_report_document: Array<Client_Report_Document>;
  /** fetch aggregated fields from the table: "client_report_document" */
  client_report_document_aggregate: Client_Report_Document_Aggregate;
  /** fetch data from the table: "client_report_document" using primary key columns */
  client_report_document_by_pk?: Maybe<Client_Report_Document>;
  /** fetch data from the table: "client_report_set" */
  client_report_set: Array<Client_Report_Set>;
  /** fetch aggregated fields from the table: "client_report_set" */
  client_report_set_aggregate: Client_Report_Set_Aggregate;
  /** fetch data from the table: "client_report_set" using primary key columns */
  client_report_set_by_pk?: Maybe<Client_Report_Set>;
  facebook_client_code?: Maybe<FacebookClientCode>;
  get_url_metadata?: Maybe<UrlMetadataOutput>;
  /** fetch data from the table: "invites_status" */
  invites_status: Array<Invites_Status>;
  /** fetch aggregated fields from the table: "invites_status" */
  invites_status_aggregate: Invites_Status_Aggregate;
  /** fetch data from the table: "invites_status" using primary key columns */
  invites_status_by_pk?: Maybe<Invites_Status>;
  /** An array relationship */
  member_invites: Array<Member_Invites>;
  /** An aggregate relationship */
  member_invites_aggregate: Member_Invites_Aggregate;
  /** fetch data from the table: "member_invites" using primary key columns */
  member_invites_by_pk?: Maybe<Member_Invites>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  /** fetch data from the table: "offers" using primary key columns */
  offers_by_pk?: Maybe<Offers>;
  /** fetch data from the table: "offers_status" */
  offers_status: Array<Offers_Status>;
  /** fetch aggregated fields from the table: "offers_status" */
  offers_status_aggregate: Offers_Status_Aggregate;
  /** fetch data from the table: "offers_status" using primary key columns */
  offers_status_by_pk?: Maybe<Offers_Status>;
  /** fetch data from the table: "organization_fb_connection" */
  organization_fb_connection: Array<Organization_Fb_Connection>;
  /** fetch aggregated fields from the table: "organization_fb_connection" */
  organization_fb_connection_aggregate: Organization_Fb_Connection_Aggregate;
  /** fetch data from the table: "organization_fb_connection" using primary key columns */
  organization_fb_connection_by_pk?: Maybe<Organization_Fb_Connection>;
  /** An array relationship */
  organization_members: Array<Organization_Members>;
  /** An aggregate relationship */
  organization_members_aggregate: Organization_Members_Aggregate;
  /** fetch data from the table: "organization_members" using primary key columns */
  organization_members_by_pk?: Maybe<Organization_Members>;
  /** fetch data from the table: "organization_members_status" */
  organization_members_status: Array<Organization_Members_Status>;
  /** fetch aggregated fields from the table: "organization_members_status" */
  organization_members_status_aggregate: Organization_Members_Status_Aggregate;
  /** fetch data from the table: "organization_members_status" using primary key columns */
  organization_members_status_by_pk?: Maybe<Organization_Members_Status>;
  /** fetch data from the table: "organization_members_type" */
  organization_members_type: Array<Organization_Members_Type>;
  /** fetch aggregated fields from the table: "organization_members_type" */
  organization_members_type_aggregate: Organization_Members_Type_Aggregate;
  /** fetch data from the table: "organization_members_type" using primary key columns */
  organization_members_type_by_pk?: Maybe<Organization_Members_Type>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "organizations_status" */
  organizations_status: Array<Organizations_Status>;
  /** fetch aggregated fields from the table: "organizations_status" */
  organizations_status_aggregate: Organizations_Status_Aggregate;
  /** fetch data from the table: "organizations_status" using primary key columns */
  organizations_status_by_pk?: Maybe<Organizations_Status>;
  /** fetch data from the table: "organizations_type" */
  organizations_type: Array<Organizations_Type>;
  /** fetch aggregated fields from the table: "organizations_type" */
  organizations_type_aggregate: Organizations_Type_Aggregate;
  /** fetch data from the table: "organizations_type" using primary key columns */
  organizations_type_by_pk?: Maybe<Organizations_Type>;
  /** An array relationship */
  project_users: Array<Project_Users>;
  /** An aggregate relationship */
  project_users_aggregate: Project_Users_Aggregate;
  /** fetch data from the table: "project_users" using primary key columns */
  project_users_by_pk?: Maybe<Project_Users>;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table: "projects_status" */
  projects_status: Array<Projects_Status>;
  /** fetch aggregated fields from the table: "projects_status" */
  projects_status_aggregate: Projects_Status_Aggregate;
  /** fetch data from the table: "projects_status" using primary key columns */
  projects_status_by_pk?: Maybe<Projects_Status>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "theme_type" */
  theme_type: Array<Theme_Type>;
  /** fetch aggregated fields from the table: "theme_type" */
  theme_type_aggregate: Theme_Type_Aggregate;
  /** fetch data from the table: "theme_type" using primary key columns */
  theme_type_by_pk?: Maybe<Theme_Type>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "users_freelancer_status" */
  users_freelancer_status: Array<Users_Freelancer_Status>;
  /** fetch aggregated fields from the table: "users_freelancer_status" */
  users_freelancer_status_aggregate: Users_Freelancer_Status_Aggregate;
  /** fetch data from the table: "users_freelancer_status" using primary key columns */
  users_freelancer_status_by_pk?: Maybe<Users_Freelancer_Status>;
  verify_facebook_resources?: Maybe<Array<Maybe<ClientFacebookResources>>>;
  /** fetch data from the table: "white_labeling" */
  white_labeling: Array<White_Labeling>;
  /** fetch aggregated fields from the table: "white_labeling" */
  white_labeling_aggregate: White_Labeling_Aggregate;
  /** fetch data from the table: "white_labeling" using primary key columns */
  white_labeling_by_pk?: Maybe<White_Labeling>;
  /** fetch data from the table: "white_labeling_colors" */
  white_labeling_colors: Array<White_Labeling_Colors>;
  /** fetch aggregated fields from the table: "white_labeling_colors" */
  white_labeling_colors_aggregate: White_Labeling_Colors_Aggregate;
  /** fetch data from the table: "white_labeling_colors" using primary key columns */
  white_labeling_colors_by_pk?: Maybe<White_Labeling_Colors>;
  /** fetch data from the table: "white_labeling_fonts" */
  white_labeling_fonts: Array<White_Labeling_Fonts>;
  /** fetch aggregated fields from the table: "white_labeling_fonts" */
  white_labeling_fonts_aggregate: White_Labeling_Fonts_Aggregate;
  /** fetch data from the table: "white_labeling_fonts" using primary key columns */
  white_labeling_fonts_by_pk?: Maybe<White_Labeling_Fonts>;
  /** fetch data from the table: "workflow.document_versions" */
  workflow_document_versions: Array<Workflow_Document_Versions>;
  /** fetch aggregated fields from the table: "workflow.document_versions" */
  workflow_document_versions_aggregate: Workflow_Document_Versions_Aggregate;
  /** fetch data from the table: "workflow.document_versions" using primary key columns */
  workflow_document_versions_by_pk?: Maybe<Workflow_Document_Versions>;
  /** fetch data from the table: "workflow.documents" */
  workflow_documents: Array<Workflow_Documents>;
  /** fetch aggregated fields from the table: "workflow.documents" */
  workflow_documents_aggregate: Workflow_Documents_Aggregate;
  /** fetch data from the table: "workflow.documents" using primary key columns */
  workflow_documents_by_pk?: Maybe<Workflow_Documents>;
  /** fetch data from the table: "workflow.field_contents" */
  workflow_field_contents: Array<Workflow_Field_Contents>;
  /** fetch aggregated fields from the table: "workflow.field_contents" */
  workflow_field_contents_aggregate: Workflow_Field_Contents_Aggregate;
  /** fetch data from the table: "workflow.field_contents" using primary key columns */
  workflow_field_contents_by_pk?: Maybe<Workflow_Field_Contents>;
  /** fetch data from the table: "workflow.field_permission_types" */
  workflow_field_permission_types: Array<Workflow_Field_Permission_Types>;
  /** fetch aggregated fields from the table: "workflow.field_permission_types" */
  workflow_field_permission_types_aggregate: Workflow_Field_Permission_Types_Aggregate;
  /** fetch data from the table: "workflow.field_permission_types" using primary key columns */
  workflow_field_permission_types_by_pk?: Maybe<Workflow_Field_Permission_Types>;
  /** fetch data from the table: "workflow.field_permissions" */
  workflow_field_permissions: Array<Workflow_Field_Permissions>;
  /** fetch aggregated fields from the table: "workflow.field_permissions" */
  workflow_field_permissions_aggregate: Workflow_Field_Permissions_Aggregate;
  /** fetch data from the table: "workflow.field_permissions" using primary key columns */
  workflow_field_permissions_by_pk?: Maybe<Workflow_Field_Permissions>;
  /** fetch data from the table: "workflow.field_types" */
  workflow_field_types: Array<Workflow_Field_Types>;
  /** fetch aggregated fields from the table: "workflow.field_types" */
  workflow_field_types_aggregate: Workflow_Field_Types_Aggregate;
  /** fetch data from the table: "workflow.field_types" using primary key columns */
  workflow_field_types_by_pk?: Maybe<Workflow_Field_Types>;
  /** fetch data from the table: "workflow.fields" */
  workflow_fields: Array<Workflow_Fields>;
  /** fetch aggregated fields from the table: "workflow.fields" */
  workflow_fields_aggregate: Workflow_Fields_Aggregate;
  /** fetch data from the table: "workflow.fields" using primary key columns */
  workflow_fields_by_pk?: Maybe<Workflow_Fields>;
  /** fetch data from the table: "workflow.pages" */
  workflow_pages: Array<Workflow_Pages>;
  /** fetch aggregated fields from the table: "workflow.pages" */
  workflow_pages_aggregate: Workflow_Pages_Aggregate;
  /** fetch data from the table: "workflow.pages" using primary key columns */
  workflow_pages_by_pk?: Maybe<Workflow_Pages>;
  /** fetch data from the table: "workflow.processmaker_users" */
  workflow_processmaker_users: Array<Workflow_Processmaker_Users>;
  /** fetch aggregated fields from the table: "workflow.processmaker_users" */
  workflow_processmaker_users_aggregate: Workflow_Processmaker_Users_Aggregate;
  /** fetch data from the table: "workflow.processmaker_users" using primary key columns */
  workflow_processmaker_users_by_pk?: Maybe<Workflow_Processmaker_Users>;
  /** fetch data from the table: "workflow.saved_document_part_types" */
  workflow_saved_document_part_types: Array<Workflow_Saved_Document_Part_Types>;
  /** fetch aggregated fields from the table: "workflow.saved_document_part_types" */
  workflow_saved_document_part_types_aggregate: Workflow_Saved_Document_Part_Types_Aggregate;
  /** fetch data from the table: "workflow.saved_document_part_types" using primary key columns */
  workflow_saved_document_part_types_by_pk?: Maybe<Workflow_Saved_Document_Part_Types>;
  /** fetch data from the table: "workflow.saved_document_parts" */
  workflow_saved_document_parts: Array<Workflow_Saved_Document_Parts>;
  /** fetch aggregated fields from the table: "workflow.saved_document_parts" */
  workflow_saved_document_parts_aggregate: Workflow_Saved_Document_Parts_Aggregate;
  /** fetch data from the table: "workflow.saved_document_parts" using primary key columns */
  workflow_saved_document_parts_by_pk?: Maybe<Workflow_Saved_Document_Parts>;
  /** fetch data from the table: "workflow.section_comment_status" */
  workflow_section_comment_status: Array<Workflow_Section_Comment_Status>;
  /** fetch aggregated fields from the table: "workflow.section_comment_status" */
  workflow_section_comment_status_aggregate: Workflow_Section_Comment_Status_Aggregate;
  /** fetch data from the table: "workflow.section_comment_status" using primary key columns */
  workflow_section_comment_status_by_pk?: Maybe<Workflow_Section_Comment_Status>;
  /** fetch data from the table: "workflow.section_comments" */
  workflow_section_comments: Array<Workflow_Section_Comments>;
  /** fetch aggregated fields from the table: "workflow.section_comments" */
  workflow_section_comments_aggregate: Workflow_Section_Comments_Aggregate;
  /** fetch data from the table: "workflow.section_comments" using primary key columns */
  workflow_section_comments_by_pk?: Maybe<Workflow_Section_Comments>;
  /** fetch data from the table: "workflow.sections" */
  workflow_sections: Array<Workflow_Sections>;
  /** fetch aggregated fields from the table: "workflow.sections" */
  workflow_sections_aggregate: Workflow_Sections_Aggregate;
  /** fetch data from the table: "workflow.sections" using primary key columns */
  workflow_sections_by_pk?: Maybe<Workflow_Sections>;
  /** fetch data from the table: "workflow.task_notifications" */
  workflow_task_notifications: Array<Workflow_Task_Notifications>;
  /** fetch aggregated fields from the table: "workflow.task_notifications" */
  workflow_task_notifications_aggregate: Workflow_Task_Notifications_Aggregate;
  /** fetch data from the table: "workflow.task_notifications" using primary key columns */
  workflow_task_notifications_by_pk?: Maybe<Workflow_Task_Notifications>;
  /** fetch data from the table: "workflow.task_types" */
  workflow_task_types: Array<Workflow_Task_Types>;
  /** fetch aggregated fields from the table: "workflow.task_types" */
  workflow_task_types_aggregate: Workflow_Task_Types_Aggregate;
  /** fetch data from the table: "workflow.task_types" using primary key columns */
  workflow_task_types_by_pk?: Maybe<Workflow_Task_Types>;
  /** fetch data from the table: "workflow.tasks" */
  workflow_tasks: Array<Workflow_Tasks>;
  /** fetch aggregated fields from the table: "workflow.tasks" */
  workflow_tasks_aggregate: Workflow_Tasks_Aggregate;
  /** fetch data from the table: "workflow.tasks" using primary key columns */
  workflow_tasks_by_pk?: Maybe<Workflow_Tasks>;
  /** fetch data from the table: "workflow.workflow_creation_status" */
  workflow_workflow_creation_status: Array<Workflow_Workflow_Creation_Status>;
  /** fetch aggregated fields from the table: "workflow.workflow_creation_status" */
  workflow_workflow_creation_status_aggregate: Workflow_Workflow_Creation_Status_Aggregate;
  /** fetch data from the table: "workflow.workflow_creation_status" using primary key columns */
  workflow_workflow_creation_status_by_pk?: Maybe<Workflow_Workflow_Creation_Status>;
  /** fetch data from the table: "workflow.workflow_reactflow_status" */
  workflow_workflow_reactflow_status: Array<Workflow_Workflow_Reactflow_Status>;
  /** fetch aggregated fields from the table: "workflow.workflow_reactflow_status" */
  workflow_workflow_reactflow_status_aggregate: Workflow_Workflow_Reactflow_Status_Aggregate;
  /** fetch data from the table: "workflow.workflow_reactflow_status" using primary key columns */
  workflow_workflow_reactflow_status_by_pk?: Maybe<Workflow_Workflow_Reactflow_Status>;
  /** fetch data from the table: "workflow.workflow_status" */
  workflow_workflow_status: Array<Workflow_Workflow_Status>;
  /** fetch aggregated fields from the table: "workflow.workflow_status" */
  workflow_workflow_status_aggregate: Workflow_Workflow_Status_Aggregate;
  /** fetch data from the table: "workflow.workflow_status" using primary key columns */
  workflow_workflow_status_by_pk?: Maybe<Workflow_Workflow_Status>;
  /** fetch data from the table: "workflow.workflow_templates" */
  workflow_workflow_templates: Array<Workflow_Workflow_Templates>;
  /** fetch aggregated fields from the table: "workflow.workflow_templates" */
  workflow_workflow_templates_aggregate: Workflow_Workflow_Templates_Aggregate;
  /** fetch data from the table: "workflow.workflow_templates" using primary key columns */
  workflow_workflow_templates_by_pk?: Maybe<Workflow_Workflow_Templates>;
  /** fetch data from the table: "workflow.workflow_versions" */
  workflow_workflow_versions: Array<Workflow_Workflow_Versions>;
  /** fetch aggregated fields from the table: "workflow.workflow_versions" */
  workflow_workflow_versions_aggregate: Workflow_Workflow_Versions_Aggregate;
  /** fetch data from the table: "workflow.workflow_versions" using primary key columns */
  workflow_workflow_versions_by_pk?: Maybe<Workflow_Workflow_Versions>;
  /** fetch data from the table: "workflow.workflows" */
  workflow_workflows: Array<Workflow_Workflows>;
  /** fetch aggregated fields from the table: "workflow.workflows" */
  workflow_workflows_aggregate: Workflow_Workflows_Aggregate;
  /** fetch data from the table: "workflow.workflows" using primary key columns */
  workflow_workflows_by_pk?: Maybe<Workflow_Workflows>;
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAddress_LinksArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


export type Query_RootAddress_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


export type Query_RootAddress_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAi_Tools_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_Credits_Order_By>>;
  where?: InputMaybe<Ai_Tools_Credits_Bool_Exp>;
};


export type Query_RootAi_Tools_Credits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_Credits_Order_By>>;
  where?: InputMaybe<Ai_Tools_Credits_Bool_Exp>;
};


export type Query_RootAi_Tools_Credits_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAi_Tools_Get_UsageArgs = {
  arg1: AiToolsGetUsageInput;
};


export type Query_RootAi_Tools_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_History_Order_By>>;
  where?: InputMaybe<Ai_Tools_History_Bool_Exp>;
};


export type Query_RootAi_Tools_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_History_Order_By>>;
  where?: InputMaybe<Ai_Tools_History_Bool_Exp>;
};


export type Query_RootAi_Tools_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAi_Tools_ServicesArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_Services_Order_By>>;
  where?: InputMaybe<Ai_Tools_Services_Bool_Exp>;
};


export type Query_RootAi_Tools_Services_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_Services_Order_By>>;
  where?: InputMaybe<Ai_Tools_Services_Bool_Exp>;
};


export type Query_RootAi_Tools_Services_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCaption_Example_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Caption_Example_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caption_Example_Categories_Order_By>>;
  where?: InputMaybe<Caption_Example_Categories_Bool_Exp>;
};


export type Query_RootCaption_Example_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Caption_Example_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caption_Example_Categories_Order_By>>;
  where?: InputMaybe<Caption_Example_Categories_Bool_Exp>;
};


export type Query_RootCaption_Example_Categories_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCaption_Example_SubcategoriesArgs = {
  distinct_on?: InputMaybe<Array<Caption_Example_Subcategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caption_Example_Subcategories_Order_By>>;
  where?: InputMaybe<Caption_Example_Subcategories_Bool_Exp>;
};


export type Query_RootCaption_Example_Subcategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Caption_Example_Subcategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caption_Example_Subcategories_Order_By>>;
  where?: InputMaybe<Caption_Example_Subcategories_Bool_Exp>;
};


export type Query_RootCaption_Example_Subcategories_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootChat_BridgingsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bridgings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Bridgings_Order_By>>;
  where?: InputMaybe<Chat_Bridgings_Bool_Exp>;
};


export type Query_RootChat_Bridgings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bridgings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Bridgings_Order_By>>;
  where?: InputMaybe<Chat_Bridgings_Bool_Exp>;
};


export type Query_RootChat_Bridgings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChat_Stream_Action_Send_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Order_By>>;
  where?: InputMaybe<Chat_Stream_Action_Send_Message_Bool_Exp>;
};


export type Query_RootChat_Stream_Action_Send_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Order_By>>;
  where?: InputMaybe<Chat_Stream_Action_Send_Message_Bool_Exp>;
};


export type Query_RootChat_Stream_Action_Send_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChat_Stream_Post_WebhooksArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Stream_Post_Webhooks_Bool_Exp>;
};


export type Query_RootChat_Stream_Post_Webhooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Stream_Post_Webhooks_Bool_Exp>;
};


export type Query_RootChat_Stream_Post_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChat_Stream_Pre_WebhooksArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Stream_Pre_Webhooks_Bool_Exp>;
};


export type Query_RootChat_Stream_Pre_Webhooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Stream_Pre_Webhooks_Bool_Exp>;
};


export type Query_RootChat_Stream_Pre_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChat_Twilio_Conv_Action_Send_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Order_By>>;
  where?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_Bool_Exp>;
};


export type Query_RootChat_Twilio_Conv_Action_Send_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Order_By>>;
  where?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_Bool_Exp>;
};


export type Query_RootChat_Twilio_Conv_Action_Send_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChat_Twilio_Conv_Post_WebhooksArgs = {
  distinct_on?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Bool_Exp>;
};


export type Query_RootChat_Twilio_Conv_Post_Webhooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Bool_Exp>;
};


export type Query_RootChat_Twilio_Conv_Post_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChat_User_Channel_AliasArgs = {
  distinct_on?: InputMaybe<Array<Chat_User_Channel_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_User_Channel_Alias_Order_By>>;
  where?: InputMaybe<Chat_User_Channel_Alias_Bool_Exp>;
};


export type Query_RootChat_User_Channel_Alias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_User_Channel_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_User_Channel_Alias_Order_By>>;
  where?: InputMaybe<Chat_User_Channel_Alias_Bool_Exp>;
};


export type Query_RootChat_User_Channel_Alias_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClient_Fb_Request_MetaArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Request_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Request_Meta_Order_By>>;
  where?: InputMaybe<Client_Fb_Request_Meta_Bool_Exp>;
};


export type Query_RootClient_Fb_Request_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Request_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Request_Meta_Order_By>>;
  where?: InputMaybe<Client_Fb_Request_Meta_Bool_Exp>;
};


export type Query_RootClient_Fb_Request_Meta_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
};


export type Query_RootClient_Fb_Resource_StatusArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resource_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resource_Status_Order_By>>;
  where?: InputMaybe<Client_Fb_Resource_Status_Bool_Exp>;
};


export type Query_RootClient_Fb_Resource_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resource_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resource_Status_Order_By>>;
  where?: InputMaybe<Client_Fb_Resource_Status_Bool_Exp>;
};


export type Query_RootClient_Fb_Resource_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootClient_Fb_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resource_Type_Order_By>>;
  where?: InputMaybe<Client_Fb_Resource_Type_Bool_Exp>;
};


export type Query_RootClient_Fb_Resource_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resource_Type_Order_By>>;
  where?: InputMaybe<Client_Fb_Resource_Type_Bool_Exp>;
};


export type Query_RootClient_Fb_Resource_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootClient_Fb_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resources_Order_By>>;
  where?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
};


export type Query_RootClient_Fb_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resources_Order_By>>;
  where?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
};


export type Query_RootClient_Fb_Resources_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
  resource_type: Client_Fb_Resource_Type_Enum;
};


export type Query_RootClient_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Client_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Invites_Order_By>>;
  where?: InputMaybe<Client_Invites_Bool_Exp>;
};


export type Query_RootClient_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Invites_Order_By>>;
  where?: InputMaybe<Client_Invites_Bool_Exp>;
};


export type Query_RootClient_Invites_By_PkArgs = {
  agency_id: Scalars['uuid'];
  client_email: Scalars['String'];
};


export type Query_RootClient_Organization_Caption_ExamplesArgs = {
  distinct_on?: InputMaybe<Array<Client_Organization_Caption_Examples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organization_Caption_Examples_Order_By>>;
  where?: InputMaybe<Client_Organization_Caption_Examples_Bool_Exp>;
};


export type Query_RootClient_Organization_Caption_Examples_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Organization_Caption_Examples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organization_Caption_Examples_Order_By>>;
  where?: InputMaybe<Client_Organization_Caption_Examples_Bool_Exp>;
};


export type Query_RootClient_Organization_Caption_Examples_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClient_Organization_Fb_ConnectionArgs = {
  distinct_on?: InputMaybe<Array<Client_Organization_Fb_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organization_Fb_Connection_Order_By>>;
  where?: InputMaybe<Client_Organization_Fb_Connection_Bool_Exp>;
};


export type Query_RootClient_Organization_Fb_Connection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Organization_Fb_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organization_Fb_Connection_Order_By>>;
  where?: InputMaybe<Client_Organization_Fb_Connection_Bool_Exp>;
};


export type Query_RootClient_Organization_Fb_Connection_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
};


export type Query_RootClient_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Client_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organizations_Order_By>>;
  where?: InputMaybe<Client_Organizations_Bool_Exp>;
};


export type Query_RootClient_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organizations_Order_By>>;
  where?: InputMaybe<Client_Organizations_Bool_Exp>;
};


export type Query_RootClient_Organizations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClient_Relevant_LinksArgs = {
  distinct_on?: InputMaybe<Array<Client_Relevant_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Relevant_Links_Order_By>>;
  where?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
};


export type Query_RootClient_Relevant_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Relevant_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Relevant_Links_Order_By>>;
  where?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
};


export type Query_RootClient_Relevant_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClient_Report_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Document_Order_By>>;
  where?: InputMaybe<Client_Report_Document_Bool_Exp>;
};


export type Query_RootClient_Report_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Document_Order_By>>;
  where?: InputMaybe<Client_Report_Document_Bool_Exp>;
};


export type Query_RootClient_Report_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClient_Report_SetArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Set_Order_By>>;
  where?: InputMaybe<Client_Report_Set_Bool_Exp>;
};


export type Query_RootClient_Report_Set_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Set_Order_By>>;
  where?: InputMaybe<Client_Report_Set_Bool_Exp>;
};


export type Query_RootClient_Report_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGet_Url_MetadataArgs = {
  arg1: UrlMetadataInput;
};


export type Query_RootInvites_StatusArgs = {
  distinct_on?: InputMaybe<Array<Invites_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Status_Order_By>>;
  where?: InputMaybe<Invites_Status_Bool_Exp>;
};


export type Query_RootInvites_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invites_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Status_Order_By>>;
  where?: InputMaybe<Invites_Status_Bool_Exp>;
};


export type Query_RootInvites_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootMember_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Member_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Invites_Order_By>>;
  where?: InputMaybe<Member_Invites_Bool_Exp>;
};


export type Query_RootMember_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Invites_Order_By>>;
  where?: InputMaybe<Member_Invites_Bool_Exp>;
};


export type Query_RootMember_Invites_By_PkArgs = {
  agency_id: Scalars['uuid'];
  member_email: Scalars['String'];
};


export type Query_RootOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Query_RootOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Query_RootOffers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOffers_StatusArgs = {
  distinct_on?: InputMaybe<Array<Offers_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Status_Order_By>>;
  where?: InputMaybe<Offers_Status_Bool_Exp>;
};


export type Query_RootOffers_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Status_Order_By>>;
  where?: InputMaybe<Offers_Status_Bool_Exp>;
};


export type Query_RootOffers_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootOrganization_Fb_ConnectionArgs = {
  distinct_on?: InputMaybe<Array<Organization_Fb_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Fb_Connection_Order_By>>;
  where?: InputMaybe<Organization_Fb_Connection_Bool_Exp>;
};


export type Query_RootOrganization_Fb_Connection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Fb_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Fb_Connection_Order_By>>;
  where?: InputMaybe<Organization_Fb_Connection_Bool_Exp>;
};


export type Query_RootOrganization_Fb_Connection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganization_MembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Query_RootOrganization_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Query_RootOrganization_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganization_Members_StatusArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Status_Order_By>>;
  where?: InputMaybe<Organization_Members_Status_Bool_Exp>;
};


export type Query_RootOrganization_Members_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Status_Order_By>>;
  where?: InputMaybe<Organization_Members_Status_Bool_Exp>;
};


export type Query_RootOrganization_Members_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootOrganization_Members_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Type_Order_By>>;
  where?: InputMaybe<Organization_Members_Type_Bool_Exp>;
};


export type Query_RootOrganization_Members_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Type_Order_By>>;
  where?: InputMaybe<Organization_Members_Type_Bool_Exp>;
};


export type Query_RootOrganization_Members_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootOrganizations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganizations_StatusArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Status_Order_By>>;
  where?: InputMaybe<Organizations_Status_Bool_Exp>;
};


export type Query_RootOrganizations_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Status_Order_By>>;
  where?: InputMaybe<Organizations_Status_Bool_Exp>;
};


export type Query_RootOrganizations_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootOrganizations_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Type_Order_By>>;
  where?: InputMaybe<Organizations_Type_Bool_Exp>;
};


export type Query_RootOrganizations_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Type_Order_By>>;
  where?: InputMaybe<Organizations_Type_Bool_Exp>;
};


export type Query_RootOrganizations_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootProject_UsersArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Query_RootProject_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Query_RootProject_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProjects_StatusArgs = {
  distinct_on?: InputMaybe<Array<Projects_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Status_Order_By>>;
  where?: InputMaybe<Projects_Status_Bool_Exp>;
};


export type Query_RootProjects_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Status_Order_By>>;
  where?: InputMaybe<Projects_Status_Bool_Exp>;
};


export type Query_RootProjects_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootTheme_TypeArgs = {
  distinct_on?: InputMaybe<Array<Theme_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Theme_Type_Order_By>>;
  where?: InputMaybe<Theme_Type_Bool_Exp>;
};


export type Query_RootTheme_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Theme_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Theme_Type_Order_By>>;
  where?: InputMaybe<Theme_Type_Bool_Exp>;
};


export type Query_RootTheme_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsers_Freelancer_StatusArgs = {
  distinct_on?: InputMaybe<Array<Users_Freelancer_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Freelancer_Status_Order_By>>;
  where?: InputMaybe<Users_Freelancer_Status_Bool_Exp>;
};


export type Query_RootUsers_Freelancer_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Freelancer_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Freelancer_Status_Order_By>>;
  where?: InputMaybe<Users_Freelancer_Status_Bool_Exp>;
};


export type Query_RootUsers_Freelancer_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootVerify_Facebook_ResourcesArgs = {
  arg1?: InputMaybe<VerifyFacebookResourceInput>;
};


export type Query_RootWhite_LabelingArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Order_By>>;
  where?: InputMaybe<White_Labeling_Bool_Exp>;
};


export type Query_RootWhite_Labeling_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Order_By>>;
  where?: InputMaybe<White_Labeling_Bool_Exp>;
};


export type Query_RootWhite_Labeling_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWhite_Labeling_ColorsArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Colors_Order_By>>;
  where?: InputMaybe<White_Labeling_Colors_Bool_Exp>;
};


export type Query_RootWhite_Labeling_Colors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Colors_Order_By>>;
  where?: InputMaybe<White_Labeling_Colors_Bool_Exp>;
};


export type Query_RootWhite_Labeling_Colors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWhite_Labeling_FontsArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Fonts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Fonts_Order_By>>;
  where?: InputMaybe<White_Labeling_Fonts_Bool_Exp>;
};


export type Query_RootWhite_Labeling_Fonts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Fonts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Fonts_Order_By>>;
  where?: InputMaybe<White_Labeling_Fonts_Bool_Exp>;
};


export type Query_RootWhite_Labeling_Fonts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Document_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Document_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Document_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
};


export type Query_RootWorkflow_Document_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Document_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Document_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
};


export type Query_RootWorkflow_Document_Versions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Documents_Order_By>>;
  where?: InputMaybe<Workflow_Documents_Bool_Exp>;
};


export type Query_RootWorkflow_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Documents_Order_By>>;
  where?: InputMaybe<Workflow_Documents_Bool_Exp>;
};


export type Query_RootWorkflow_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Field_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Contents_Order_By>>;
  where?: InputMaybe<Workflow_Field_Contents_Bool_Exp>;
};


export type Query_RootWorkflow_Field_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Contents_Order_By>>;
  where?: InputMaybe<Workflow_Field_Contents_Bool_Exp>;
};


export type Query_RootWorkflow_Field_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Field_Permission_TypesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permission_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permission_Types_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permission_Types_Bool_Exp>;
};


export type Query_RootWorkflow_Field_Permission_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permission_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permission_Types_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permission_Types_Bool_Exp>;
};


export type Query_RootWorkflow_Field_Permission_Types_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootWorkflow_Field_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permissions_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
};


export type Query_RootWorkflow_Field_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permissions_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
};


export type Query_RootWorkflow_Field_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Field_TypesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Types_Order_By>>;
  where?: InputMaybe<Workflow_Field_Types_Bool_Exp>;
};


export type Query_RootWorkflow_Field_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Types_Order_By>>;
  where?: InputMaybe<Workflow_Field_Types_Bool_Exp>;
};


export type Query_RootWorkflow_Field_Types_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootWorkflow_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Fields_Order_By>>;
  where?: InputMaybe<Workflow_Fields_Bool_Exp>;
};


export type Query_RootWorkflow_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Fields_Order_By>>;
  where?: InputMaybe<Workflow_Fields_Bool_Exp>;
};


export type Query_RootWorkflow_Fields_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_PagesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Pages_Order_By>>;
  where?: InputMaybe<Workflow_Pages_Bool_Exp>;
};


export type Query_RootWorkflow_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Pages_Order_By>>;
  where?: InputMaybe<Workflow_Pages_Bool_Exp>;
};


export type Query_RootWorkflow_Pages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Processmaker_UsersArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Processmaker_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Processmaker_Users_Order_By>>;
  where?: InputMaybe<Workflow_Processmaker_Users_Bool_Exp>;
};


export type Query_RootWorkflow_Processmaker_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Processmaker_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Processmaker_Users_Order_By>>;
  where?: InputMaybe<Workflow_Processmaker_Users_Bool_Exp>;
};


export type Query_RootWorkflow_Processmaker_Users_By_PkArgs = {
  user_id: Scalars['uuid'];
};


export type Query_RootWorkflow_Saved_Document_Part_TypesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Order_By>>;
  where?: InputMaybe<Workflow_Saved_Document_Part_Types_Bool_Exp>;
};


export type Query_RootWorkflow_Saved_Document_Part_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Order_By>>;
  where?: InputMaybe<Workflow_Saved_Document_Part_Types_Bool_Exp>;
};


export type Query_RootWorkflow_Saved_Document_Part_Types_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootWorkflow_Saved_Document_PartsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Saved_Document_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Saved_Document_Parts_Order_By>>;
  where?: InputMaybe<Workflow_Saved_Document_Parts_Bool_Exp>;
};


export type Query_RootWorkflow_Saved_Document_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Saved_Document_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Saved_Document_Parts_Order_By>>;
  where?: InputMaybe<Workflow_Saved_Document_Parts_Bool_Exp>;
};


export type Query_RootWorkflow_Saved_Document_Parts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Section_Comment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Section_Comment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Section_Comment_Status_Order_By>>;
  where?: InputMaybe<Workflow_Section_Comment_Status_Bool_Exp>;
};


export type Query_RootWorkflow_Section_Comment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Section_Comment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Section_Comment_Status_Order_By>>;
  where?: InputMaybe<Workflow_Section_Comment_Status_Bool_Exp>;
};


export type Query_RootWorkflow_Section_Comment_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootWorkflow_Section_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Section_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Section_Comments_Order_By>>;
  where?: InputMaybe<Workflow_Section_Comments_Bool_Exp>;
};


export type Query_RootWorkflow_Section_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Section_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Section_Comments_Order_By>>;
  where?: InputMaybe<Workflow_Section_Comments_Bool_Exp>;
};


export type Query_RootWorkflow_Section_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Sections_Order_By>>;
  where?: InputMaybe<Workflow_Sections_Bool_Exp>;
};


export type Query_RootWorkflow_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Sections_Order_By>>;
  where?: InputMaybe<Workflow_Sections_Bool_Exp>;
};


export type Query_RootWorkflow_Sections_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Task_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Task_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Task_Notifications_Order_By>>;
  where?: InputMaybe<Workflow_Task_Notifications_Bool_Exp>;
};


export type Query_RootWorkflow_Task_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Task_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Task_Notifications_Order_By>>;
  where?: InputMaybe<Workflow_Task_Notifications_Bool_Exp>;
};


export type Query_RootWorkflow_Task_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Task_TypesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Task_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Task_Types_Order_By>>;
  where?: InputMaybe<Workflow_Task_Types_Bool_Exp>;
};


export type Query_RootWorkflow_Task_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Task_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Task_Types_Order_By>>;
  where?: InputMaybe<Workflow_Task_Types_Bool_Exp>;
};


export type Query_RootWorkflow_Task_Types_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootWorkflow_TasksArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Tasks_Order_By>>;
  where?: InputMaybe<Workflow_Tasks_Bool_Exp>;
};


export type Query_RootWorkflow_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Tasks_Order_By>>;
  where?: InputMaybe<Workflow_Tasks_Bool_Exp>;
};


export type Query_RootWorkflow_Tasks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Workflow_Creation_StatusArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Creation_Status_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Creation_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Creation_Status_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Creation_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootWorkflow_Workflow_Reactflow_StatusArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Reactflow_Status_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Reactflow_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Reactflow_Status_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Reactflow_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootWorkflow_Workflow_StatusArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Status_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Status_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootWorkflow_Workflow_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Templates_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Templates_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Templates_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Templates_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_Workflow_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
};


export type Query_RootWorkflow_Workflow_Versions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWorkflow_WorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflows_Order_By>>;
  where?: InputMaybe<Workflow_Workflows_Bool_Exp>;
};


export type Query_RootWorkflow_Workflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflows_Order_By>>;
  where?: InputMaybe<Workflow_Workflows_Bool_Exp>;
};


export type Query_RootWorkflow_Workflows_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  /** vals admin, manager, co_manager, member */
  id: Scalars['String'];
  /** Client facing name */
  name: Scalars['String'];
  /** An array relationship */
  organization_members: Array<Organization_Members>;
  /** An aggregate relationship */
  organization_members_aggregate: Organization_Members_Aggregate;
};


/** columns and relationships of "roles" */
export type RolesOrganization_MembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesOrganization_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_members?: InputMaybe<Organization_Members_Bool_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolesPkey = 'roles_pkey'
}

export enum Roles_Enum {
  /** Admin */
  Admin = 'ADMIN',
  /** Co-Manager */
  ClientCoManager = 'CLIENT_CO_MANAGER',
  /** Manager */
  ClientManager = 'CLIENT_MANAGER',
  /** Member */
  ClientMember = 'CLIENT_MEMBER',
  /** Co-Manager */
  CoManager = 'CO_MANAGER',
  /** Manager */
  Manager = 'MANAGER',
  /** Member */
  Member = 'MEMBER'
}

/** Boolean expression to compare columns of type "roles_enum". All fields are combined with logical 'AND'. */
export type Roles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Roles_Enum>;
  _in?: InputMaybe<Array<Roles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Roles_Enum>;
  _nin?: InputMaybe<Array<Roles_Enum>>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  /** vals admin, manager, co_manager, member */
  id?: InputMaybe<Scalars['String']>;
  /** Client facing name */
  name?: InputMaybe<Scalars['String']>;
  organization_members?: InputMaybe<Organization_Members_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  /** vals admin, manager, co_manager, member */
  id?: Maybe<Scalars['String']>;
  /** Client facing name */
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  /** vals admin, manager, co_manager, member */
  id?: Maybe<Scalars['String']>;
  /** Client facing name */
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_members_aggregate?: InputMaybe<Organization_Members_Aggregate_Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  /** vals admin, manager, co_manager, member */
  id: Scalars['String'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  /** vals admin, manager, co_manager, member */
  id?: InputMaybe<Scalars['String']>;
  /** Client facing name */
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** An array relationship */
  address_links: Array<Address_Links>;
  /** An aggregate relationship */
  address_links_aggregate: Address_Links_Aggregate;
  /** fetch data from the table: "address_links" using primary key columns */
  address_links_by_pk?: Maybe<Address_Links>;
  /** fetch data from the table: "ai_tools_credits" */
  ai_tools_credits: Array<Ai_Tools_Credits>;
  /** fetch aggregated fields from the table: "ai_tools_credits" */
  ai_tools_credits_aggregate: Ai_Tools_Credits_Aggregate;
  /** fetch data from the table: "ai_tools_credits" using primary key columns */
  ai_tools_credits_by_pk?: Maybe<Ai_Tools_Credits>;
  /** fetch data from the table: "ai_tools_history" */
  ai_tools_history: Array<Ai_Tools_History>;
  /** fetch aggregated fields from the table: "ai_tools_history" */
  ai_tools_history_aggregate: Ai_Tools_History_Aggregate;
  /** fetch data from the table: "ai_tools_history" using primary key columns */
  ai_tools_history_by_pk?: Maybe<Ai_Tools_History>;
  /** fetch data from the table: "ai_tools_services" */
  ai_tools_services: Array<Ai_Tools_Services>;
  /** fetch aggregated fields from the table: "ai_tools_services" */
  ai_tools_services_aggregate: Ai_Tools_Services_Aggregate;
  /** fetch data from the table: "ai_tools_services" using primary key columns */
  ai_tools_services_by_pk?: Maybe<Ai_Tools_Services>;
  /** fetch data from the table: "caption_example_categories" */
  caption_example_categories: Array<Caption_Example_Categories>;
  /** fetch aggregated fields from the table: "caption_example_categories" */
  caption_example_categories_aggregate: Caption_Example_Categories_Aggregate;
  /** fetch data from the table: "caption_example_categories" using primary key columns */
  caption_example_categories_by_pk?: Maybe<Caption_Example_Categories>;
  /** fetch data from the table: "caption_example_subcategories" */
  caption_example_subcategories: Array<Caption_Example_Subcategories>;
  /** fetch aggregated fields from the table: "caption_example_subcategories" */
  caption_example_subcategories_aggregate: Caption_Example_Subcategories_Aggregate;
  /** fetch data from the table: "caption_example_subcategories" using primary key columns */
  caption_example_subcategories_by_pk?: Maybe<Caption_Example_Subcategories>;
  /** fetch data from the table: "chat_bridgings" */
  chat_bridgings: Array<Chat_Bridgings>;
  /** fetch aggregated fields from the table: "chat_bridgings" */
  chat_bridgings_aggregate: Chat_Bridgings_Aggregate;
  /** fetch data from the table: "chat_bridgings" using primary key columns */
  chat_bridgings_by_pk?: Maybe<Chat_Bridgings>;
  /** fetch data from the table: "chat_stream_action_send_message" */
  chat_stream_action_send_message: Array<Chat_Stream_Action_Send_Message>;
  /** fetch aggregated fields from the table: "chat_stream_action_send_message" */
  chat_stream_action_send_message_aggregate: Chat_Stream_Action_Send_Message_Aggregate;
  /** fetch data from the table: "chat_stream_action_send_message" using primary key columns */
  chat_stream_action_send_message_by_pk?: Maybe<Chat_Stream_Action_Send_Message>;
  /** fetch data from the table: "chat_stream_post_webhooks" */
  chat_stream_post_webhooks: Array<Chat_Stream_Post_Webhooks>;
  /** fetch aggregated fields from the table: "chat_stream_post_webhooks" */
  chat_stream_post_webhooks_aggregate: Chat_Stream_Post_Webhooks_Aggregate;
  /** fetch data from the table: "chat_stream_post_webhooks" using primary key columns */
  chat_stream_post_webhooks_by_pk?: Maybe<Chat_Stream_Post_Webhooks>;
  /** fetch data from the table: "chat_stream_pre_webhooks" */
  chat_stream_pre_webhooks: Array<Chat_Stream_Pre_Webhooks>;
  /** fetch aggregated fields from the table: "chat_stream_pre_webhooks" */
  chat_stream_pre_webhooks_aggregate: Chat_Stream_Pre_Webhooks_Aggregate;
  /** fetch data from the table: "chat_stream_pre_webhooks" using primary key columns */
  chat_stream_pre_webhooks_by_pk?: Maybe<Chat_Stream_Pre_Webhooks>;
  /** fetch data from the table: "chat_twilio_conv_action_send_message" */
  chat_twilio_conv_action_send_message: Array<Chat_Twilio_Conv_Action_Send_Message>;
  /** fetch aggregated fields from the table: "chat_twilio_conv_action_send_message" */
  chat_twilio_conv_action_send_message_aggregate: Chat_Twilio_Conv_Action_Send_Message_Aggregate;
  /** fetch data from the table: "chat_twilio_conv_action_send_message" using primary key columns */
  chat_twilio_conv_action_send_message_by_pk?: Maybe<Chat_Twilio_Conv_Action_Send_Message>;
  /** fetch data from the table: "chat_twilio_conv_post_webhooks" */
  chat_twilio_conv_post_webhooks: Array<Chat_Twilio_Conv_Post_Webhooks>;
  /** fetch aggregated fields from the table: "chat_twilio_conv_post_webhooks" */
  chat_twilio_conv_post_webhooks_aggregate: Chat_Twilio_Conv_Post_Webhooks_Aggregate;
  /** fetch data from the table: "chat_twilio_conv_post_webhooks" using primary key columns */
  chat_twilio_conv_post_webhooks_by_pk?: Maybe<Chat_Twilio_Conv_Post_Webhooks>;
  /** fetch data from the table: "chat_user_channel_alias" */
  chat_user_channel_alias: Array<Chat_User_Channel_Alias>;
  /** fetch aggregated fields from the table: "chat_user_channel_alias" */
  chat_user_channel_alias_aggregate: Chat_User_Channel_Alias_Aggregate;
  /** fetch data from the table: "chat_user_channel_alias" using primary key columns */
  chat_user_channel_alias_by_pk?: Maybe<Chat_User_Channel_Alias>;
  /** fetch data from the table: "client_fb_request_meta" */
  client_fb_request_meta: Array<Client_Fb_Request_Meta>;
  /** fetch aggregated fields from the table: "client_fb_request_meta" */
  client_fb_request_meta_aggregate: Client_Fb_Request_Meta_Aggregate;
  /** fetch data from the table: "client_fb_request_meta" using primary key columns */
  client_fb_request_meta_by_pk?: Maybe<Client_Fb_Request_Meta>;
  /** fetch data from the table: "client_fb_resource_status" */
  client_fb_resource_status: Array<Client_Fb_Resource_Status>;
  /** fetch aggregated fields from the table: "client_fb_resource_status" */
  client_fb_resource_status_aggregate: Client_Fb_Resource_Status_Aggregate;
  /** fetch data from the table: "client_fb_resource_status" using primary key columns */
  client_fb_resource_status_by_pk?: Maybe<Client_Fb_Resource_Status>;
  /** fetch data from the table: "client_fb_resource_type" */
  client_fb_resource_type: Array<Client_Fb_Resource_Type>;
  /** fetch aggregated fields from the table: "client_fb_resource_type" */
  client_fb_resource_type_aggregate: Client_Fb_Resource_Type_Aggregate;
  /** fetch data from the table: "client_fb_resource_type" using primary key columns */
  client_fb_resource_type_by_pk?: Maybe<Client_Fb_Resource_Type>;
  /** fetch data from the table: "client_fb_resources" */
  client_fb_resources: Array<Client_Fb_Resources>;
  /** fetch aggregated fields from the table: "client_fb_resources" */
  client_fb_resources_aggregate: Client_Fb_Resources_Aggregate;
  /** fetch data from the table: "client_fb_resources" using primary key columns */
  client_fb_resources_by_pk?: Maybe<Client_Fb_Resources>;
  /** fetch data from the table: "client_invites" */
  client_invites: Array<Client_Invites>;
  /** fetch aggregated fields from the table: "client_invites" */
  client_invites_aggregate: Client_Invites_Aggregate;
  /** fetch data from the table: "client_invites" using primary key columns */
  client_invites_by_pk?: Maybe<Client_Invites>;
  /** fetch data from the table: "client_organization_caption_examples" */
  client_organization_caption_examples: Array<Client_Organization_Caption_Examples>;
  /** fetch aggregated fields from the table: "client_organization_caption_examples" */
  client_organization_caption_examples_aggregate: Client_Organization_Caption_Examples_Aggregate;
  /** fetch data from the table: "client_organization_caption_examples" using primary key columns */
  client_organization_caption_examples_by_pk?: Maybe<Client_Organization_Caption_Examples>;
  /** fetch data from the table: "client_organization_fb_connection" */
  client_organization_fb_connection: Array<Client_Organization_Fb_Connection>;
  /** fetch aggregated fields from the table: "client_organization_fb_connection" */
  client_organization_fb_connection_aggregate: Client_Organization_Fb_Connection_Aggregate;
  /** fetch data from the table: "client_organization_fb_connection" using primary key columns */
  client_organization_fb_connection_by_pk?: Maybe<Client_Organization_Fb_Connection>;
  /** An array relationship */
  client_organizations: Array<Client_Organizations>;
  /** An aggregate relationship */
  client_organizations_aggregate: Client_Organizations_Aggregate;
  /** fetch data from the table: "client_organizations" using primary key columns */
  client_organizations_by_pk?: Maybe<Client_Organizations>;
  /** An array relationship */
  client_relevant_links: Array<Client_Relevant_Links>;
  /** An aggregate relationship */
  client_relevant_links_aggregate: Client_Relevant_Links_Aggregate;
  /** fetch data from the table: "client_relevant_links" using primary key columns */
  client_relevant_links_by_pk?: Maybe<Client_Relevant_Links>;
  /** fetch data from the table: "client_report_document" */
  client_report_document: Array<Client_Report_Document>;
  /** fetch aggregated fields from the table: "client_report_document" */
  client_report_document_aggregate: Client_Report_Document_Aggregate;
  /** fetch data from the table: "client_report_document" using primary key columns */
  client_report_document_by_pk?: Maybe<Client_Report_Document>;
  /** fetch data from the table: "client_report_set" */
  client_report_set: Array<Client_Report_Set>;
  /** fetch aggregated fields from the table: "client_report_set" */
  client_report_set_aggregate: Client_Report_Set_Aggregate;
  /** fetch data from the table: "client_report_set" using primary key columns */
  client_report_set_by_pk?: Maybe<Client_Report_Set>;
  /** fetch data from the table: "invites_status" */
  invites_status: Array<Invites_Status>;
  /** fetch aggregated fields from the table: "invites_status" */
  invites_status_aggregate: Invites_Status_Aggregate;
  /** fetch data from the table: "invites_status" using primary key columns */
  invites_status_by_pk?: Maybe<Invites_Status>;
  /** An array relationship */
  member_invites: Array<Member_Invites>;
  /** An aggregate relationship */
  member_invites_aggregate: Member_Invites_Aggregate;
  /** fetch data from the table: "member_invites" using primary key columns */
  member_invites_by_pk?: Maybe<Member_Invites>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  /** fetch data from the table: "offers" using primary key columns */
  offers_by_pk?: Maybe<Offers>;
  /** fetch data from the table: "offers_status" */
  offers_status: Array<Offers_Status>;
  /** fetch aggregated fields from the table: "offers_status" */
  offers_status_aggregate: Offers_Status_Aggregate;
  /** fetch data from the table: "offers_status" using primary key columns */
  offers_status_by_pk?: Maybe<Offers_Status>;
  /** fetch data from the table: "organization_fb_connection" */
  organization_fb_connection: Array<Organization_Fb_Connection>;
  /** fetch aggregated fields from the table: "organization_fb_connection" */
  organization_fb_connection_aggregate: Organization_Fb_Connection_Aggregate;
  /** fetch data from the table: "organization_fb_connection" using primary key columns */
  organization_fb_connection_by_pk?: Maybe<Organization_Fb_Connection>;
  /** An array relationship */
  organization_members: Array<Organization_Members>;
  /** An aggregate relationship */
  organization_members_aggregate: Organization_Members_Aggregate;
  /** fetch data from the table: "organization_members" using primary key columns */
  organization_members_by_pk?: Maybe<Organization_Members>;
  /** fetch data from the table: "organization_members_status" */
  organization_members_status: Array<Organization_Members_Status>;
  /** fetch aggregated fields from the table: "organization_members_status" */
  organization_members_status_aggregate: Organization_Members_Status_Aggregate;
  /** fetch data from the table: "organization_members_status" using primary key columns */
  organization_members_status_by_pk?: Maybe<Organization_Members_Status>;
  /** fetch data from the table: "organization_members_type" */
  organization_members_type: Array<Organization_Members_Type>;
  /** fetch aggregated fields from the table: "organization_members_type" */
  organization_members_type_aggregate: Organization_Members_Type_Aggregate;
  /** fetch data from the table: "organization_members_type" using primary key columns */
  organization_members_type_by_pk?: Maybe<Organization_Members_Type>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "organizations_status" */
  organizations_status: Array<Organizations_Status>;
  /** fetch aggregated fields from the table: "organizations_status" */
  organizations_status_aggregate: Organizations_Status_Aggregate;
  /** fetch data from the table: "organizations_status" using primary key columns */
  organizations_status_by_pk?: Maybe<Organizations_Status>;
  /** fetch data from the table: "organizations_type" */
  organizations_type: Array<Organizations_Type>;
  /** fetch aggregated fields from the table: "organizations_type" */
  organizations_type_aggregate: Organizations_Type_Aggregate;
  /** fetch data from the table: "organizations_type" using primary key columns */
  organizations_type_by_pk?: Maybe<Organizations_Type>;
  /** An array relationship */
  project_users: Array<Project_Users>;
  /** An aggregate relationship */
  project_users_aggregate: Project_Users_Aggregate;
  /** fetch data from the table: "project_users" using primary key columns */
  project_users_by_pk?: Maybe<Project_Users>;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table: "projects_status" */
  projects_status: Array<Projects_Status>;
  /** fetch aggregated fields from the table: "projects_status" */
  projects_status_aggregate: Projects_Status_Aggregate;
  /** fetch data from the table: "projects_status" using primary key columns */
  projects_status_by_pk?: Maybe<Projects_Status>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "theme_type" */
  theme_type: Array<Theme_Type>;
  /** fetch aggregated fields from the table: "theme_type" */
  theme_type_aggregate: Theme_Type_Aggregate;
  /** fetch data from the table: "theme_type" using primary key columns */
  theme_type_by_pk?: Maybe<Theme_Type>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "users_freelancer_status" */
  users_freelancer_status: Array<Users_Freelancer_Status>;
  /** fetch aggregated fields from the table: "users_freelancer_status" */
  users_freelancer_status_aggregate: Users_Freelancer_Status_Aggregate;
  /** fetch data from the table: "users_freelancer_status" using primary key columns */
  users_freelancer_status_by_pk?: Maybe<Users_Freelancer_Status>;
  /** fetch data from the table: "white_labeling" */
  white_labeling: Array<White_Labeling>;
  /** fetch aggregated fields from the table: "white_labeling" */
  white_labeling_aggregate: White_Labeling_Aggregate;
  /** fetch data from the table: "white_labeling" using primary key columns */
  white_labeling_by_pk?: Maybe<White_Labeling>;
  /** fetch data from the table: "white_labeling_colors" */
  white_labeling_colors: Array<White_Labeling_Colors>;
  /** fetch aggregated fields from the table: "white_labeling_colors" */
  white_labeling_colors_aggregate: White_Labeling_Colors_Aggregate;
  /** fetch data from the table: "white_labeling_colors" using primary key columns */
  white_labeling_colors_by_pk?: Maybe<White_Labeling_Colors>;
  /** fetch data from the table: "white_labeling_fonts" */
  white_labeling_fonts: Array<White_Labeling_Fonts>;
  /** fetch aggregated fields from the table: "white_labeling_fonts" */
  white_labeling_fonts_aggregate: White_Labeling_Fonts_Aggregate;
  /** fetch data from the table: "white_labeling_fonts" using primary key columns */
  white_labeling_fonts_by_pk?: Maybe<White_Labeling_Fonts>;
  /** fetch data from the table: "workflow.document_versions" */
  workflow_document_versions: Array<Workflow_Document_Versions>;
  /** fetch aggregated fields from the table: "workflow.document_versions" */
  workflow_document_versions_aggregate: Workflow_Document_Versions_Aggregate;
  /** fetch data from the table: "workflow.document_versions" using primary key columns */
  workflow_document_versions_by_pk?: Maybe<Workflow_Document_Versions>;
  /** fetch data from the table: "workflow.documents" */
  workflow_documents: Array<Workflow_Documents>;
  /** fetch aggregated fields from the table: "workflow.documents" */
  workflow_documents_aggregate: Workflow_Documents_Aggregate;
  /** fetch data from the table: "workflow.documents" using primary key columns */
  workflow_documents_by_pk?: Maybe<Workflow_Documents>;
  /** fetch data from the table: "workflow.field_contents" */
  workflow_field_contents: Array<Workflow_Field_Contents>;
  /** fetch aggregated fields from the table: "workflow.field_contents" */
  workflow_field_contents_aggregate: Workflow_Field_Contents_Aggregate;
  /** fetch data from the table: "workflow.field_contents" using primary key columns */
  workflow_field_contents_by_pk?: Maybe<Workflow_Field_Contents>;
  /** fetch data from the table: "workflow.field_permission_types" */
  workflow_field_permission_types: Array<Workflow_Field_Permission_Types>;
  /** fetch aggregated fields from the table: "workflow.field_permission_types" */
  workflow_field_permission_types_aggregate: Workflow_Field_Permission_Types_Aggregate;
  /** fetch data from the table: "workflow.field_permission_types" using primary key columns */
  workflow_field_permission_types_by_pk?: Maybe<Workflow_Field_Permission_Types>;
  /** fetch data from the table: "workflow.field_permissions" */
  workflow_field_permissions: Array<Workflow_Field_Permissions>;
  /** fetch aggregated fields from the table: "workflow.field_permissions" */
  workflow_field_permissions_aggregate: Workflow_Field_Permissions_Aggregate;
  /** fetch data from the table: "workflow.field_permissions" using primary key columns */
  workflow_field_permissions_by_pk?: Maybe<Workflow_Field_Permissions>;
  /** fetch data from the table: "workflow.field_types" */
  workflow_field_types: Array<Workflow_Field_Types>;
  /** fetch aggregated fields from the table: "workflow.field_types" */
  workflow_field_types_aggregate: Workflow_Field_Types_Aggregate;
  /** fetch data from the table: "workflow.field_types" using primary key columns */
  workflow_field_types_by_pk?: Maybe<Workflow_Field_Types>;
  /** fetch data from the table: "workflow.fields" */
  workflow_fields: Array<Workflow_Fields>;
  /** fetch aggregated fields from the table: "workflow.fields" */
  workflow_fields_aggregate: Workflow_Fields_Aggregate;
  /** fetch data from the table: "workflow.fields" using primary key columns */
  workflow_fields_by_pk?: Maybe<Workflow_Fields>;
  /** fetch data from the table: "workflow.pages" */
  workflow_pages: Array<Workflow_Pages>;
  /** fetch aggregated fields from the table: "workflow.pages" */
  workflow_pages_aggregate: Workflow_Pages_Aggregate;
  /** fetch data from the table: "workflow.pages" using primary key columns */
  workflow_pages_by_pk?: Maybe<Workflow_Pages>;
  /** fetch data from the table: "workflow.processmaker_users" */
  workflow_processmaker_users: Array<Workflow_Processmaker_Users>;
  /** fetch aggregated fields from the table: "workflow.processmaker_users" */
  workflow_processmaker_users_aggregate: Workflow_Processmaker_Users_Aggregate;
  /** fetch data from the table: "workflow.processmaker_users" using primary key columns */
  workflow_processmaker_users_by_pk?: Maybe<Workflow_Processmaker_Users>;
  /** fetch data from the table: "workflow.saved_document_part_types" */
  workflow_saved_document_part_types: Array<Workflow_Saved_Document_Part_Types>;
  /** fetch aggregated fields from the table: "workflow.saved_document_part_types" */
  workflow_saved_document_part_types_aggregate: Workflow_Saved_Document_Part_Types_Aggregate;
  /** fetch data from the table: "workflow.saved_document_part_types" using primary key columns */
  workflow_saved_document_part_types_by_pk?: Maybe<Workflow_Saved_Document_Part_Types>;
  /** fetch data from the table: "workflow.saved_document_parts" */
  workflow_saved_document_parts: Array<Workflow_Saved_Document_Parts>;
  /** fetch aggregated fields from the table: "workflow.saved_document_parts" */
  workflow_saved_document_parts_aggregate: Workflow_Saved_Document_Parts_Aggregate;
  /** fetch data from the table: "workflow.saved_document_parts" using primary key columns */
  workflow_saved_document_parts_by_pk?: Maybe<Workflow_Saved_Document_Parts>;
  /** fetch data from the table: "workflow.section_comment_status" */
  workflow_section_comment_status: Array<Workflow_Section_Comment_Status>;
  /** fetch aggregated fields from the table: "workflow.section_comment_status" */
  workflow_section_comment_status_aggregate: Workflow_Section_Comment_Status_Aggregate;
  /** fetch data from the table: "workflow.section_comment_status" using primary key columns */
  workflow_section_comment_status_by_pk?: Maybe<Workflow_Section_Comment_Status>;
  /** fetch data from the table: "workflow.section_comments" */
  workflow_section_comments: Array<Workflow_Section_Comments>;
  /** fetch aggregated fields from the table: "workflow.section_comments" */
  workflow_section_comments_aggregate: Workflow_Section_Comments_Aggregate;
  /** fetch data from the table: "workflow.section_comments" using primary key columns */
  workflow_section_comments_by_pk?: Maybe<Workflow_Section_Comments>;
  /** fetch data from the table: "workflow.sections" */
  workflow_sections: Array<Workflow_Sections>;
  /** fetch aggregated fields from the table: "workflow.sections" */
  workflow_sections_aggregate: Workflow_Sections_Aggregate;
  /** fetch data from the table: "workflow.sections" using primary key columns */
  workflow_sections_by_pk?: Maybe<Workflow_Sections>;
  /** fetch data from the table: "workflow.task_notifications" */
  workflow_task_notifications: Array<Workflow_Task_Notifications>;
  /** fetch aggregated fields from the table: "workflow.task_notifications" */
  workflow_task_notifications_aggregate: Workflow_Task_Notifications_Aggregate;
  /** fetch data from the table: "workflow.task_notifications" using primary key columns */
  workflow_task_notifications_by_pk?: Maybe<Workflow_Task_Notifications>;
  /** fetch data from the table: "workflow.task_types" */
  workflow_task_types: Array<Workflow_Task_Types>;
  /** fetch aggregated fields from the table: "workflow.task_types" */
  workflow_task_types_aggregate: Workflow_Task_Types_Aggregate;
  /** fetch data from the table: "workflow.task_types" using primary key columns */
  workflow_task_types_by_pk?: Maybe<Workflow_Task_Types>;
  /** fetch data from the table: "workflow.tasks" */
  workflow_tasks: Array<Workflow_Tasks>;
  /** fetch aggregated fields from the table: "workflow.tasks" */
  workflow_tasks_aggregate: Workflow_Tasks_Aggregate;
  /** fetch data from the table: "workflow.tasks" using primary key columns */
  workflow_tasks_by_pk?: Maybe<Workflow_Tasks>;
  /** fetch data from the table: "workflow.workflow_creation_status" */
  workflow_workflow_creation_status: Array<Workflow_Workflow_Creation_Status>;
  /** fetch aggregated fields from the table: "workflow.workflow_creation_status" */
  workflow_workflow_creation_status_aggregate: Workflow_Workflow_Creation_Status_Aggregate;
  /** fetch data from the table: "workflow.workflow_creation_status" using primary key columns */
  workflow_workflow_creation_status_by_pk?: Maybe<Workflow_Workflow_Creation_Status>;
  /** fetch data from the table: "workflow.workflow_reactflow_status" */
  workflow_workflow_reactflow_status: Array<Workflow_Workflow_Reactflow_Status>;
  /** fetch aggregated fields from the table: "workflow.workflow_reactflow_status" */
  workflow_workflow_reactflow_status_aggregate: Workflow_Workflow_Reactflow_Status_Aggregate;
  /** fetch data from the table: "workflow.workflow_reactflow_status" using primary key columns */
  workflow_workflow_reactflow_status_by_pk?: Maybe<Workflow_Workflow_Reactflow_Status>;
  /** fetch data from the table: "workflow.workflow_status" */
  workflow_workflow_status: Array<Workflow_Workflow_Status>;
  /** fetch aggregated fields from the table: "workflow.workflow_status" */
  workflow_workflow_status_aggregate: Workflow_Workflow_Status_Aggregate;
  /** fetch data from the table: "workflow.workflow_status" using primary key columns */
  workflow_workflow_status_by_pk?: Maybe<Workflow_Workflow_Status>;
  /** fetch data from the table: "workflow.workflow_templates" */
  workflow_workflow_templates: Array<Workflow_Workflow_Templates>;
  /** fetch aggregated fields from the table: "workflow.workflow_templates" */
  workflow_workflow_templates_aggregate: Workflow_Workflow_Templates_Aggregate;
  /** fetch data from the table: "workflow.workflow_templates" using primary key columns */
  workflow_workflow_templates_by_pk?: Maybe<Workflow_Workflow_Templates>;
  /** fetch data from the table: "workflow.workflow_versions" */
  workflow_workflow_versions: Array<Workflow_Workflow_Versions>;
  /** fetch aggregated fields from the table: "workflow.workflow_versions" */
  workflow_workflow_versions_aggregate: Workflow_Workflow_Versions_Aggregate;
  /** fetch data from the table: "workflow.workflow_versions" using primary key columns */
  workflow_workflow_versions_by_pk?: Maybe<Workflow_Workflow_Versions>;
  /** fetch data from the table: "workflow.workflows" */
  workflow_workflows: Array<Workflow_Workflows>;
  /** fetch aggregated fields from the table: "workflow.workflows" */
  workflow_workflows_aggregate: Workflow_Workflows_Aggregate;
  /** fetch data from the table: "workflow.workflows" using primary key columns */
  workflow_workflows_by_pk?: Maybe<Workflow_Workflows>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAddress_LinksArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


export type Subscription_RootAddress_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


export type Subscription_RootAddress_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAi_Tools_CreditsArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_Credits_Order_By>>;
  where?: InputMaybe<Ai_Tools_Credits_Bool_Exp>;
};


export type Subscription_RootAi_Tools_Credits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_Credits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_Credits_Order_By>>;
  where?: InputMaybe<Ai_Tools_Credits_Bool_Exp>;
};


export type Subscription_RootAi_Tools_Credits_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAi_Tools_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_History_Order_By>>;
  where?: InputMaybe<Ai_Tools_History_Bool_Exp>;
};


export type Subscription_RootAi_Tools_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_History_Order_By>>;
  where?: InputMaybe<Ai_Tools_History_Bool_Exp>;
};


export type Subscription_RootAi_Tools_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAi_Tools_ServicesArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_Services_Order_By>>;
  where?: InputMaybe<Ai_Tools_Services_Bool_Exp>;
};


export type Subscription_RootAi_Tools_Services_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Tools_Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Tools_Services_Order_By>>;
  where?: InputMaybe<Ai_Tools_Services_Bool_Exp>;
};


export type Subscription_RootAi_Tools_Services_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCaption_Example_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Caption_Example_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caption_Example_Categories_Order_By>>;
  where?: InputMaybe<Caption_Example_Categories_Bool_Exp>;
};


export type Subscription_RootCaption_Example_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Caption_Example_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caption_Example_Categories_Order_By>>;
  where?: InputMaybe<Caption_Example_Categories_Bool_Exp>;
};


export type Subscription_RootCaption_Example_Categories_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCaption_Example_SubcategoriesArgs = {
  distinct_on?: InputMaybe<Array<Caption_Example_Subcategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caption_Example_Subcategories_Order_By>>;
  where?: InputMaybe<Caption_Example_Subcategories_Bool_Exp>;
};


export type Subscription_RootCaption_Example_Subcategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Caption_Example_Subcategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Caption_Example_Subcategories_Order_By>>;
  where?: InputMaybe<Caption_Example_Subcategories_Bool_Exp>;
};


export type Subscription_RootCaption_Example_Subcategories_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootChat_BridgingsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bridgings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Bridgings_Order_By>>;
  where?: InputMaybe<Chat_Bridgings_Bool_Exp>;
};


export type Subscription_RootChat_Bridgings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Bridgings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Bridgings_Order_By>>;
  where?: InputMaybe<Chat_Bridgings_Bool_Exp>;
};


export type Subscription_RootChat_Bridgings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChat_Stream_Action_Send_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Order_By>>;
  where?: InputMaybe<Chat_Stream_Action_Send_Message_Bool_Exp>;
};


export type Subscription_RootChat_Stream_Action_Send_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Action_Send_Message_Order_By>>;
  where?: InputMaybe<Chat_Stream_Action_Send_Message_Bool_Exp>;
};


export type Subscription_RootChat_Stream_Action_Send_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChat_Stream_Post_WebhooksArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Stream_Post_Webhooks_Bool_Exp>;
};


export type Subscription_RootChat_Stream_Post_Webhooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Post_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Stream_Post_Webhooks_Bool_Exp>;
};


export type Subscription_RootChat_Stream_Post_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChat_Stream_Pre_WebhooksArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Stream_Pre_Webhooks_Bool_Exp>;
};


export type Subscription_RootChat_Stream_Pre_Webhooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Stream_Pre_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Stream_Pre_Webhooks_Bool_Exp>;
};


export type Subscription_RootChat_Stream_Pre_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChat_Twilio_Conv_Action_Send_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Order_By>>;
  where?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_Bool_Exp>;
};


export type Subscription_RootChat_Twilio_Conv_Action_Send_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Twilio_Conv_Action_Send_Message_Order_By>>;
  where?: InputMaybe<Chat_Twilio_Conv_Action_Send_Message_Bool_Exp>;
};


export type Subscription_RootChat_Twilio_Conv_Action_Send_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChat_Twilio_Conv_Post_WebhooksArgs = {
  distinct_on?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Bool_Exp>;
};


export type Subscription_RootChat_Twilio_Conv_Post_Webhooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Twilio_Conv_Post_Webhooks_Order_By>>;
  where?: InputMaybe<Chat_Twilio_Conv_Post_Webhooks_Bool_Exp>;
};


export type Subscription_RootChat_Twilio_Conv_Post_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChat_User_Channel_AliasArgs = {
  distinct_on?: InputMaybe<Array<Chat_User_Channel_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_User_Channel_Alias_Order_By>>;
  where?: InputMaybe<Chat_User_Channel_Alias_Bool_Exp>;
};


export type Subscription_RootChat_User_Channel_Alias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_User_Channel_Alias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_User_Channel_Alias_Order_By>>;
  where?: InputMaybe<Chat_User_Channel_Alias_Bool_Exp>;
};


export type Subscription_RootChat_User_Channel_Alias_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClient_Fb_Request_MetaArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Request_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Request_Meta_Order_By>>;
  where?: InputMaybe<Client_Fb_Request_Meta_Bool_Exp>;
};


export type Subscription_RootClient_Fb_Request_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Request_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Request_Meta_Order_By>>;
  where?: InputMaybe<Client_Fb_Request_Meta_Bool_Exp>;
};


export type Subscription_RootClient_Fb_Request_Meta_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
};


export type Subscription_RootClient_Fb_Resource_StatusArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resource_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resource_Status_Order_By>>;
  where?: InputMaybe<Client_Fb_Resource_Status_Bool_Exp>;
};


export type Subscription_RootClient_Fb_Resource_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resource_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resource_Status_Order_By>>;
  where?: InputMaybe<Client_Fb_Resource_Status_Bool_Exp>;
};


export type Subscription_RootClient_Fb_Resource_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootClient_Fb_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resource_Type_Order_By>>;
  where?: InputMaybe<Client_Fb_Resource_Type_Bool_Exp>;
};


export type Subscription_RootClient_Fb_Resource_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resource_Type_Order_By>>;
  where?: InputMaybe<Client_Fb_Resource_Type_Bool_Exp>;
};


export type Subscription_RootClient_Fb_Resource_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootClient_Fb_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resources_Order_By>>;
  where?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
};


export type Subscription_RootClient_Fb_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Fb_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Fb_Resources_Order_By>>;
  where?: InputMaybe<Client_Fb_Resources_Bool_Exp>;
};


export type Subscription_RootClient_Fb_Resources_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
  resource_type: Client_Fb_Resource_Type_Enum;
};


export type Subscription_RootClient_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Client_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Invites_Order_By>>;
  where?: InputMaybe<Client_Invites_Bool_Exp>;
};


export type Subscription_RootClient_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Invites_Order_By>>;
  where?: InputMaybe<Client_Invites_Bool_Exp>;
};


export type Subscription_RootClient_Invites_By_PkArgs = {
  agency_id: Scalars['uuid'];
  client_email: Scalars['String'];
};


export type Subscription_RootClient_Organization_Caption_ExamplesArgs = {
  distinct_on?: InputMaybe<Array<Client_Organization_Caption_Examples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organization_Caption_Examples_Order_By>>;
  where?: InputMaybe<Client_Organization_Caption_Examples_Bool_Exp>;
};


export type Subscription_RootClient_Organization_Caption_Examples_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Organization_Caption_Examples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organization_Caption_Examples_Order_By>>;
  where?: InputMaybe<Client_Organization_Caption_Examples_Bool_Exp>;
};


export type Subscription_RootClient_Organization_Caption_Examples_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClient_Organization_Fb_ConnectionArgs = {
  distinct_on?: InputMaybe<Array<Client_Organization_Fb_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organization_Fb_Connection_Order_By>>;
  where?: InputMaybe<Client_Organization_Fb_Connection_Bool_Exp>;
};


export type Subscription_RootClient_Organization_Fb_Connection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Organization_Fb_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organization_Fb_Connection_Order_By>>;
  where?: InputMaybe<Client_Organization_Fb_Connection_Bool_Exp>;
};


export type Subscription_RootClient_Organization_Fb_Connection_By_PkArgs = {
  client_organization_id: Scalars['uuid'];
};


export type Subscription_RootClient_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Client_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organizations_Order_By>>;
  where?: InputMaybe<Client_Organizations_Bool_Exp>;
};


export type Subscription_RootClient_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Organizations_Order_By>>;
  where?: InputMaybe<Client_Organizations_Bool_Exp>;
};


export type Subscription_RootClient_Organizations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClient_Relevant_LinksArgs = {
  distinct_on?: InputMaybe<Array<Client_Relevant_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Relevant_Links_Order_By>>;
  where?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
};


export type Subscription_RootClient_Relevant_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Relevant_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Relevant_Links_Order_By>>;
  where?: InputMaybe<Client_Relevant_Links_Bool_Exp>;
};


export type Subscription_RootClient_Relevant_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClient_Report_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Document_Order_By>>;
  where?: InputMaybe<Client_Report_Document_Bool_Exp>;
};


export type Subscription_RootClient_Report_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Document_Order_By>>;
  where?: InputMaybe<Client_Report_Document_Bool_Exp>;
};


export type Subscription_RootClient_Report_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClient_Report_SetArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Set_Order_By>>;
  where?: InputMaybe<Client_Report_Set_Bool_Exp>;
};


export type Subscription_RootClient_Report_Set_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Report_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Report_Set_Order_By>>;
  where?: InputMaybe<Client_Report_Set_Bool_Exp>;
};


export type Subscription_RootClient_Report_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvites_StatusArgs = {
  distinct_on?: InputMaybe<Array<Invites_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Status_Order_By>>;
  where?: InputMaybe<Invites_Status_Bool_Exp>;
};


export type Subscription_RootInvites_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invites_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Status_Order_By>>;
  where?: InputMaybe<Invites_Status_Bool_Exp>;
};


export type Subscription_RootInvites_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootMember_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Member_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Invites_Order_By>>;
  where?: InputMaybe<Member_Invites_Bool_Exp>;
};


export type Subscription_RootMember_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Invites_Order_By>>;
  where?: InputMaybe<Member_Invites_Bool_Exp>;
};


export type Subscription_RootMember_Invites_By_PkArgs = {
  agency_id: Scalars['uuid'];
  member_email: Scalars['String'];
};


export type Subscription_RootOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOffers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOffers_StatusArgs = {
  distinct_on?: InputMaybe<Array<Offers_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Status_Order_By>>;
  where?: InputMaybe<Offers_Status_Bool_Exp>;
};


export type Subscription_RootOffers_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Status_Order_By>>;
  where?: InputMaybe<Offers_Status_Bool_Exp>;
};


export type Subscription_RootOffers_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootOrganization_Fb_ConnectionArgs = {
  distinct_on?: InputMaybe<Array<Organization_Fb_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Fb_Connection_Order_By>>;
  where?: InputMaybe<Organization_Fb_Connection_Bool_Exp>;
};


export type Subscription_RootOrganization_Fb_Connection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Fb_Connection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Fb_Connection_Order_By>>;
  where?: InputMaybe<Organization_Fb_Connection_Bool_Exp>;
};


export type Subscription_RootOrganization_Fb_Connection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_MembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Subscription_RootOrganization_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Subscription_RootOrganization_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_Members_StatusArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Status_Order_By>>;
  where?: InputMaybe<Organization_Members_Status_Bool_Exp>;
};


export type Subscription_RootOrganization_Members_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Status_Order_By>>;
  where?: InputMaybe<Organization_Members_Status_Bool_Exp>;
};


export type Subscription_RootOrganization_Members_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootOrganization_Members_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Type_Order_By>>;
  where?: InputMaybe<Organization_Members_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Members_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Type_Order_By>>;
  where?: InputMaybe<Organization_Members_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Members_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganizations_StatusArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Status_Order_By>>;
  where?: InputMaybe<Organizations_Status_Bool_Exp>;
};


export type Subscription_RootOrganizations_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Status_Order_By>>;
  where?: InputMaybe<Organizations_Status_Bool_Exp>;
};


export type Subscription_RootOrganizations_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootOrganizations_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Type_Order_By>>;
  where?: InputMaybe<Organizations_Type_Bool_Exp>;
};


export type Subscription_RootOrganizations_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Type_Order_By>>;
  where?: InputMaybe<Organizations_Type_Bool_Exp>;
};


export type Subscription_RootOrganizations_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootProject_UsersArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Subscription_RootProject_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Subscription_RootProject_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProjects_StatusArgs = {
  distinct_on?: InputMaybe<Array<Projects_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Status_Order_By>>;
  where?: InputMaybe<Projects_Status_Bool_Exp>;
};


export type Subscription_RootProjects_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Status_Order_By>>;
  where?: InputMaybe<Projects_Status_Bool_Exp>;
};


export type Subscription_RootProjects_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTheme_TypeArgs = {
  distinct_on?: InputMaybe<Array<Theme_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Theme_Type_Order_By>>;
  where?: InputMaybe<Theme_Type_Bool_Exp>;
};


export type Subscription_RootTheme_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Theme_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Theme_Type_Order_By>>;
  where?: InputMaybe<Theme_Type_Bool_Exp>;
};


export type Subscription_RootTheme_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_Freelancer_StatusArgs = {
  distinct_on?: InputMaybe<Array<Users_Freelancer_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Freelancer_Status_Order_By>>;
  where?: InputMaybe<Users_Freelancer_Status_Bool_Exp>;
};


export type Subscription_RootUsers_Freelancer_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Freelancer_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Freelancer_Status_Order_By>>;
  where?: InputMaybe<Users_Freelancer_Status_Bool_Exp>;
};


export type Subscription_RootUsers_Freelancer_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootWhite_LabelingArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Order_By>>;
  where?: InputMaybe<White_Labeling_Bool_Exp>;
};


export type Subscription_RootWhite_Labeling_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Order_By>>;
  where?: InputMaybe<White_Labeling_Bool_Exp>;
};


export type Subscription_RootWhite_Labeling_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWhite_Labeling_ColorsArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Colors_Order_By>>;
  where?: InputMaybe<White_Labeling_Colors_Bool_Exp>;
};


export type Subscription_RootWhite_Labeling_Colors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Colors_Order_By>>;
  where?: InputMaybe<White_Labeling_Colors_Bool_Exp>;
};


export type Subscription_RootWhite_Labeling_Colors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWhite_Labeling_FontsArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Fonts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Fonts_Order_By>>;
  where?: InputMaybe<White_Labeling_Fonts_Bool_Exp>;
};


export type Subscription_RootWhite_Labeling_Fonts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Labeling_Fonts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<White_Labeling_Fonts_Order_By>>;
  where?: InputMaybe<White_Labeling_Fonts_Bool_Exp>;
};


export type Subscription_RootWhite_Labeling_Fonts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Document_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Document_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Document_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
};


export type Subscription_RootWorkflow_Document_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Document_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Document_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
};


export type Subscription_RootWorkflow_Document_Versions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Documents_Order_By>>;
  where?: InputMaybe<Workflow_Documents_Bool_Exp>;
};


export type Subscription_RootWorkflow_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Documents_Order_By>>;
  where?: InputMaybe<Workflow_Documents_Bool_Exp>;
};


export type Subscription_RootWorkflow_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Field_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Contents_Order_By>>;
  where?: InputMaybe<Workflow_Field_Contents_Bool_Exp>;
};


export type Subscription_RootWorkflow_Field_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Contents_Order_By>>;
  where?: InputMaybe<Workflow_Field_Contents_Bool_Exp>;
};


export type Subscription_RootWorkflow_Field_Contents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Field_Permission_TypesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permission_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permission_Types_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permission_Types_Bool_Exp>;
};


export type Subscription_RootWorkflow_Field_Permission_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permission_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permission_Types_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permission_Types_Bool_Exp>;
};


export type Subscription_RootWorkflow_Field_Permission_Types_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootWorkflow_Field_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permissions_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
};


export type Subscription_RootWorkflow_Field_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permissions_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
};


export type Subscription_RootWorkflow_Field_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Field_TypesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Types_Order_By>>;
  where?: InputMaybe<Workflow_Field_Types_Bool_Exp>;
};


export type Subscription_RootWorkflow_Field_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Types_Order_By>>;
  where?: InputMaybe<Workflow_Field_Types_Bool_Exp>;
};


export type Subscription_RootWorkflow_Field_Types_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootWorkflow_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Fields_Order_By>>;
  where?: InputMaybe<Workflow_Fields_Bool_Exp>;
};


export type Subscription_RootWorkflow_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Fields_Order_By>>;
  where?: InputMaybe<Workflow_Fields_Bool_Exp>;
};


export type Subscription_RootWorkflow_Fields_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_PagesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Pages_Order_By>>;
  where?: InputMaybe<Workflow_Pages_Bool_Exp>;
};


export type Subscription_RootWorkflow_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Pages_Order_By>>;
  where?: InputMaybe<Workflow_Pages_Bool_Exp>;
};


export type Subscription_RootWorkflow_Pages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Processmaker_UsersArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Processmaker_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Processmaker_Users_Order_By>>;
  where?: InputMaybe<Workflow_Processmaker_Users_Bool_Exp>;
};


export type Subscription_RootWorkflow_Processmaker_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Processmaker_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Processmaker_Users_Order_By>>;
  where?: InputMaybe<Workflow_Processmaker_Users_Bool_Exp>;
};


export type Subscription_RootWorkflow_Processmaker_Users_By_PkArgs = {
  user_id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Saved_Document_Part_TypesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Order_By>>;
  where?: InputMaybe<Workflow_Saved_Document_Part_Types_Bool_Exp>;
};


export type Subscription_RootWorkflow_Saved_Document_Part_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Order_By>>;
  where?: InputMaybe<Workflow_Saved_Document_Part_Types_Bool_Exp>;
};


export type Subscription_RootWorkflow_Saved_Document_Part_Types_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootWorkflow_Saved_Document_PartsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Saved_Document_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Saved_Document_Parts_Order_By>>;
  where?: InputMaybe<Workflow_Saved_Document_Parts_Bool_Exp>;
};


export type Subscription_RootWorkflow_Saved_Document_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Saved_Document_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Saved_Document_Parts_Order_By>>;
  where?: InputMaybe<Workflow_Saved_Document_Parts_Bool_Exp>;
};


export type Subscription_RootWorkflow_Saved_Document_Parts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Section_Comment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Section_Comment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Section_Comment_Status_Order_By>>;
  where?: InputMaybe<Workflow_Section_Comment_Status_Bool_Exp>;
};


export type Subscription_RootWorkflow_Section_Comment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Section_Comment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Section_Comment_Status_Order_By>>;
  where?: InputMaybe<Workflow_Section_Comment_Status_Bool_Exp>;
};


export type Subscription_RootWorkflow_Section_Comment_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootWorkflow_Section_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Section_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Section_Comments_Order_By>>;
  where?: InputMaybe<Workflow_Section_Comments_Bool_Exp>;
};


export type Subscription_RootWorkflow_Section_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Section_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Section_Comments_Order_By>>;
  where?: InputMaybe<Workflow_Section_Comments_Bool_Exp>;
};


export type Subscription_RootWorkflow_Section_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Sections_Order_By>>;
  where?: InputMaybe<Workflow_Sections_Bool_Exp>;
};


export type Subscription_RootWorkflow_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Sections_Order_By>>;
  where?: InputMaybe<Workflow_Sections_Bool_Exp>;
};


export type Subscription_RootWorkflow_Sections_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Task_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Task_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Task_Notifications_Order_By>>;
  where?: InputMaybe<Workflow_Task_Notifications_Bool_Exp>;
};


export type Subscription_RootWorkflow_Task_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Task_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Task_Notifications_Order_By>>;
  where?: InputMaybe<Workflow_Task_Notifications_Bool_Exp>;
};


export type Subscription_RootWorkflow_Task_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Task_TypesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Task_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Task_Types_Order_By>>;
  where?: InputMaybe<Workflow_Task_Types_Bool_Exp>;
};


export type Subscription_RootWorkflow_Task_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Task_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Task_Types_Order_By>>;
  where?: InputMaybe<Workflow_Task_Types_Bool_Exp>;
};


export type Subscription_RootWorkflow_Task_Types_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootWorkflow_TasksArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Tasks_Order_By>>;
  where?: InputMaybe<Workflow_Tasks_Bool_Exp>;
};


export type Subscription_RootWorkflow_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Tasks_Order_By>>;
  where?: InputMaybe<Workflow_Tasks_Bool_Exp>;
};


export type Subscription_RootWorkflow_Tasks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Workflow_Creation_StatusArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Creation_Status_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Creation_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Creation_Status_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Creation_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootWorkflow_Workflow_Reactflow_StatusArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Reactflow_Status_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Reactflow_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Reactflow_Status_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Reactflow_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootWorkflow_Workflow_StatusArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Status_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Status_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Status_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootWorkflow_Workflow_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Templates_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Templates_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Templates_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Templates_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_Workflow_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflow_Versions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWorkflow_WorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflows_Order_By>>;
  where?: InputMaybe<Workflow_Workflows_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflows_Order_By>>;
  where?: InputMaybe<Workflow_Workflows_Bool_Exp>;
};


export type Subscription_RootWorkflow_Workflows_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "theme_type" */
export type Theme_Type = {
  __typename?: 'theme_type';
  description?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** aggregated selection of "theme_type" */
export type Theme_Type_Aggregate = {
  __typename?: 'theme_type_aggregate';
  aggregate?: Maybe<Theme_Type_Aggregate_Fields>;
  nodes: Array<Theme_Type>;
};

/** aggregate fields of "theme_type" */
export type Theme_Type_Aggregate_Fields = {
  __typename?: 'theme_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Theme_Type_Max_Fields>;
  min?: Maybe<Theme_Type_Min_Fields>;
};


/** aggregate fields of "theme_type" */
export type Theme_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Theme_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "theme_type". All fields are combined with a logical 'AND'. */
export type Theme_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Theme_Type_Bool_Exp>>;
  _not?: InputMaybe<Theme_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Theme_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "theme_type" */
export enum Theme_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  ThemeTypePkey = 'theme_type_pkey'
}

/** input type for inserting data into table "theme_type" */
export type Theme_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Theme_Type_Max_Fields = {
  __typename?: 'theme_type_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Theme_Type_Min_Fields = {
  __typename?: 'theme_type_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "theme_type" */
export type Theme_Type_Mutation_Response = {
  __typename?: 'theme_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Theme_Type>;
};

/** on_conflict condition type for table "theme_type" */
export type Theme_Type_On_Conflict = {
  constraint: Theme_Type_Constraint;
  update_columns?: Array<Theme_Type_Update_Column>;
  where?: InputMaybe<Theme_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "theme_type". */
export type Theme_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: theme_type */
export type Theme_Type_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "theme_type" */
export enum Theme_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "theme_type" */
export type Theme_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "theme_type" */
export enum Theme_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type Timestamp_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _cast?: InputMaybe<Timestamp_Cast_Exp>;
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

export type Timestamptz_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _cast?: InputMaybe<Timestamptz_Cast_Exp>;
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  address_links: Array<Address_Links>;
  /** An aggregate relationship */
  address_links_aggregate: Address_Links_Aggregate;
  agency_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  freelancer_status?: Maybe<Users_Freelancer_Status_Enum>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  organization_members: Array<Organization_Members>;
  /** An aggregate relationship */
  organization_members_aggregate: Organization_Members_Aggregate;
  phone?: Maybe<Scalars['String']>;
  /** An object relationship */
  processmaker_user?: Maybe<Workflow_Processmaker_Users>;
  stream_token?: Maybe<Scalars['String']>;
  /** An object relationship */
  users_freelancer_status?: Maybe<Users_Freelancer_Status>;
};


/** columns and relationships of "users" */
export type UsersAddress_LinksArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAddress_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Links_Order_By>>;
  where?: InputMaybe<Address_Links_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganization_MembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganization_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  address_links?: InputMaybe<Address_Links_Bool_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  freelancer_status?: InputMaybe<Users_Freelancer_Status_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  organization_members?: InputMaybe<Organization_Members_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  processmaker_user?: InputMaybe<Workflow_Processmaker_Users_Bool_Exp>;
  stream_token?: InputMaybe<String_Comparison_Exp>;
  users_freelancer_status?: InputMaybe<Users_Freelancer_Status_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email", "agency_id" */
  UsersEmailAgencyIdKey = 'users_email_agency_id_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** columns and relationships of "users_freelancer_status" */
export type Users_Freelancer_Status = {
  __typename?: 'users_freelancer_status';
  /** vals: active, inactive */
  status: Scalars['String'];
};

/** aggregated selection of "users_freelancer_status" */
export type Users_Freelancer_Status_Aggregate = {
  __typename?: 'users_freelancer_status_aggregate';
  aggregate?: Maybe<Users_Freelancer_Status_Aggregate_Fields>;
  nodes: Array<Users_Freelancer_Status>;
};

/** aggregate fields of "users_freelancer_status" */
export type Users_Freelancer_Status_Aggregate_Fields = {
  __typename?: 'users_freelancer_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Freelancer_Status_Max_Fields>;
  min?: Maybe<Users_Freelancer_Status_Min_Fields>;
};


/** aggregate fields of "users_freelancer_status" */
export type Users_Freelancer_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Freelancer_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "users_freelancer_status". All fields are combined with a logical 'AND'. */
export type Users_Freelancer_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Freelancer_Status_Bool_Exp>>;
  _not?: InputMaybe<Users_Freelancer_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Freelancer_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_freelancer_status" */
export enum Users_Freelancer_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  UsersFreelancerStatusPkey = 'users_freelancer_status_pkey'
}

export enum Users_Freelancer_Status_Enum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Boolean expression to compare columns of type "users_freelancer_status_enum". All fields are combined with logical 'AND'. */
export type Users_Freelancer_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Users_Freelancer_Status_Enum>;
  _in?: InputMaybe<Array<Users_Freelancer_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Users_Freelancer_Status_Enum>;
  _nin?: InputMaybe<Array<Users_Freelancer_Status_Enum>>;
};

/** input type for inserting data into table "users_freelancer_status" */
export type Users_Freelancer_Status_Insert_Input = {
  /** vals: active, inactive */
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Freelancer_Status_Max_Fields = {
  __typename?: 'users_freelancer_status_max_fields';
  /** vals: active, inactive */
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Freelancer_Status_Min_Fields = {
  __typename?: 'users_freelancer_status_min_fields';
  /** vals: active, inactive */
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users_freelancer_status" */
export type Users_Freelancer_Status_Mutation_Response = {
  __typename?: 'users_freelancer_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Freelancer_Status>;
};

/** input type for inserting object relation for remote table "users_freelancer_status" */
export type Users_Freelancer_Status_Obj_Rel_Insert_Input = {
  data: Users_Freelancer_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_Freelancer_Status_On_Conflict>;
};

/** on_conflict condition type for table "users_freelancer_status" */
export type Users_Freelancer_Status_On_Conflict = {
  constraint: Users_Freelancer_Status_Constraint;
  update_columns?: Array<Users_Freelancer_Status_Update_Column>;
  where?: InputMaybe<Users_Freelancer_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "users_freelancer_status". */
export type Users_Freelancer_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_freelancer_status */
export type Users_Freelancer_Status_Pk_Columns_Input = {
  /** vals: active, inactive */
  status: Scalars['String'];
};

/** select columns of table "users_freelancer_status" */
export enum Users_Freelancer_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "users_freelancer_status" */
export type Users_Freelancer_Status_Set_Input = {
  /** vals: active, inactive */
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "users_freelancer_status" */
export enum Users_Freelancer_Status_Update_Column {
  /** column name */
  Status = 'status'
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  address_links?: InputMaybe<Address_Links_Arr_Rel_Insert_Input>;
  agency_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  freelancer_status?: InputMaybe<Users_Freelancer_Status_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  organization_members?: InputMaybe<Organization_Members_Arr_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']>;
  processmaker_user?: InputMaybe<Workflow_Processmaker_Users_Obj_Rel_Insert_Input>;
  stream_token?: InputMaybe<Scalars['String']>;
  users_freelancer_status?: InputMaybe<Users_Freelancer_Status_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  agency_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  stream_token?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  agency_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  stream_token?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  address_links_aggregate?: InputMaybe<Address_Links_Aggregate_Order_By>;
  agency_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  freelancer_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization_members_aggregate?: InputMaybe<Organization_Members_Aggregate_Order_By>;
  phone?: InputMaybe<Order_By>;
  processmaker_user?: InputMaybe<Workflow_Processmaker_Users_Order_By>;
  stream_token?: InputMaybe<Order_By>;
  users_freelancer_status?: InputMaybe<Users_Freelancer_Status_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FreelancerStatus = 'freelancer_status',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone',
  /** column name */
  StreamToken = 'stream_token'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  agency_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  freelancer_status?: InputMaybe<Users_Freelancer_Status_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  stream_token?: InputMaybe<Scalars['String']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FreelancerStatus = 'freelancer_status',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phone = 'phone',
  /** column name */
  StreamToken = 'stream_token'
}

export type Uuid_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _cast?: InputMaybe<Uuid_Cast_Exp>;
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "white_labeling" */
export type White_Labeling = {
  __typename?: 'white_labeling';
  agency_id?: Maybe<Scalars['uuid']>;
  font?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_active?: Maybe<Scalars['Boolean']>;
  primary_color?: Maybe<Scalars['uuid']>;
  secondary_color?: Maybe<Scalars['uuid']>;
  theme_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "white_labeling" */
export type White_Labeling_Aggregate = {
  __typename?: 'white_labeling_aggregate';
  aggregate?: Maybe<White_Labeling_Aggregate_Fields>;
  nodes: Array<White_Labeling>;
};

/** aggregate fields of "white_labeling" */
export type White_Labeling_Aggregate_Fields = {
  __typename?: 'white_labeling_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<White_Labeling_Max_Fields>;
  min?: Maybe<White_Labeling_Min_Fields>;
};


/** aggregate fields of "white_labeling" */
export type White_Labeling_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<White_Labeling_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "white_labeling". All fields are combined with a logical 'AND'. */
export type White_Labeling_Bool_Exp = {
  _and?: InputMaybe<Array<White_Labeling_Bool_Exp>>;
  _not?: InputMaybe<White_Labeling_Bool_Exp>;
  _or?: InputMaybe<Array<White_Labeling_Bool_Exp>>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  font?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  primary_color?: InputMaybe<Uuid_Comparison_Exp>;
  secondary_color?: InputMaybe<Uuid_Comparison_Exp>;
  theme_type?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "white_labeling_colors" */
export type White_Labeling_Colors = {
  __typename?: 'white_labeling_colors';
  hex_code?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  theme_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "white_labeling_colors" */
export type White_Labeling_Colors_Aggregate = {
  __typename?: 'white_labeling_colors_aggregate';
  aggregate?: Maybe<White_Labeling_Colors_Aggregate_Fields>;
  nodes: Array<White_Labeling_Colors>;
};

/** aggregate fields of "white_labeling_colors" */
export type White_Labeling_Colors_Aggregate_Fields = {
  __typename?: 'white_labeling_colors_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<White_Labeling_Colors_Max_Fields>;
  min?: Maybe<White_Labeling_Colors_Min_Fields>;
};


/** aggregate fields of "white_labeling_colors" */
export type White_Labeling_Colors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<White_Labeling_Colors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "white_labeling_colors". All fields are combined with a logical 'AND'. */
export type White_Labeling_Colors_Bool_Exp = {
  _and?: InputMaybe<Array<White_Labeling_Colors_Bool_Exp>>;
  _not?: InputMaybe<White_Labeling_Colors_Bool_Exp>;
  _or?: InputMaybe<Array<White_Labeling_Colors_Bool_Exp>>;
  hex_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  theme_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "white_labeling_colors" */
export enum White_Labeling_Colors_Constraint {
  /** unique or primary key constraint on columns "id" */
  WhiteLabelingColorsPkey = 'white_labeling_colors_pkey'
}

/** input type for inserting data into table "white_labeling_colors" */
export type White_Labeling_Colors_Insert_Input = {
  hex_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  theme_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type White_Labeling_Colors_Max_Fields = {
  __typename?: 'white_labeling_colors_max_fields';
  hex_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  theme_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type White_Labeling_Colors_Min_Fields = {
  __typename?: 'white_labeling_colors_min_fields';
  hex_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  theme_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "white_labeling_colors" */
export type White_Labeling_Colors_Mutation_Response = {
  __typename?: 'white_labeling_colors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<White_Labeling_Colors>;
};

/** on_conflict condition type for table "white_labeling_colors" */
export type White_Labeling_Colors_On_Conflict = {
  constraint: White_Labeling_Colors_Constraint;
  update_columns?: Array<White_Labeling_Colors_Update_Column>;
  where?: InputMaybe<White_Labeling_Colors_Bool_Exp>;
};

/** Ordering options when selecting data from "white_labeling_colors". */
export type White_Labeling_Colors_Order_By = {
  hex_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  theme_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: white_labeling_colors */
export type White_Labeling_Colors_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "white_labeling_colors" */
export enum White_Labeling_Colors_Select_Column {
  /** column name */
  HexCode = 'hex_code',
  /** column name */
  Id = 'id',
  /** column name */
  ThemeType = 'theme_type'
}

/** input type for updating data in table "white_labeling_colors" */
export type White_Labeling_Colors_Set_Input = {
  hex_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  theme_type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "white_labeling_colors" */
export enum White_Labeling_Colors_Update_Column {
  /** column name */
  HexCode = 'hex_code',
  /** column name */
  Id = 'id',
  /** column name */
  ThemeType = 'theme_type'
}

/** unique or primary key constraints on table "white_labeling" */
export enum White_Labeling_Constraint {
  /** unique or primary key constraint on columns "id" */
  WhiteLabelingPkey = 'white_labeling_pkey'
}

/** columns and relationships of "white_labeling_fonts" */
export type White_Labeling_Fonts = {
  __typename?: 'white_labeling_fonts';
  font?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
};

/** aggregated selection of "white_labeling_fonts" */
export type White_Labeling_Fonts_Aggregate = {
  __typename?: 'white_labeling_fonts_aggregate';
  aggregate?: Maybe<White_Labeling_Fonts_Aggregate_Fields>;
  nodes: Array<White_Labeling_Fonts>;
};

/** aggregate fields of "white_labeling_fonts" */
export type White_Labeling_Fonts_Aggregate_Fields = {
  __typename?: 'white_labeling_fonts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<White_Labeling_Fonts_Max_Fields>;
  min?: Maybe<White_Labeling_Fonts_Min_Fields>;
};


/** aggregate fields of "white_labeling_fonts" */
export type White_Labeling_Fonts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<White_Labeling_Fonts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "white_labeling_fonts". All fields are combined with a logical 'AND'. */
export type White_Labeling_Fonts_Bool_Exp = {
  _and?: InputMaybe<Array<White_Labeling_Fonts_Bool_Exp>>;
  _not?: InputMaybe<White_Labeling_Fonts_Bool_Exp>;
  _or?: InputMaybe<Array<White_Labeling_Fonts_Bool_Exp>>;
  font?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "white_labeling_fonts" */
export enum White_Labeling_Fonts_Constraint {
  /** unique or primary key constraint on columns "id" */
  WhiteLabelingFontsPkey = 'white_labeling_fonts_pkey'
}

/** input type for inserting data into table "white_labeling_fonts" */
export type White_Labeling_Fonts_Insert_Input = {
  font?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type White_Labeling_Fonts_Max_Fields = {
  __typename?: 'white_labeling_fonts_max_fields';
  font?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type White_Labeling_Fonts_Min_Fields = {
  __typename?: 'white_labeling_fonts_min_fields';
  font?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "white_labeling_fonts" */
export type White_Labeling_Fonts_Mutation_Response = {
  __typename?: 'white_labeling_fonts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<White_Labeling_Fonts>;
};

/** on_conflict condition type for table "white_labeling_fonts" */
export type White_Labeling_Fonts_On_Conflict = {
  constraint: White_Labeling_Fonts_Constraint;
  update_columns?: Array<White_Labeling_Fonts_Update_Column>;
  where?: InputMaybe<White_Labeling_Fonts_Bool_Exp>;
};

/** Ordering options when selecting data from "white_labeling_fonts". */
export type White_Labeling_Fonts_Order_By = {
  font?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: white_labeling_fonts */
export type White_Labeling_Fonts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "white_labeling_fonts" */
export enum White_Labeling_Fonts_Select_Column {
  /** column name */
  Font = 'font',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "white_labeling_fonts" */
export type White_Labeling_Fonts_Set_Input = {
  font?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "white_labeling_fonts" */
export enum White_Labeling_Fonts_Update_Column {
  /** column name */
  Font = 'font',
  /** column name */
  Id = 'id'
}

/** input type for inserting data into table "white_labeling" */
export type White_Labeling_Insert_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  font?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  primary_color?: InputMaybe<Scalars['uuid']>;
  secondary_color?: InputMaybe<Scalars['uuid']>;
  theme_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type White_Labeling_Max_Fields = {
  __typename?: 'white_labeling_max_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  font?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  primary_color?: Maybe<Scalars['uuid']>;
  secondary_color?: Maybe<Scalars['uuid']>;
  theme_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type White_Labeling_Min_Fields = {
  __typename?: 'white_labeling_min_fields';
  agency_id?: Maybe<Scalars['uuid']>;
  font?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  primary_color?: Maybe<Scalars['uuid']>;
  secondary_color?: Maybe<Scalars['uuid']>;
  theme_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "white_labeling" */
export type White_Labeling_Mutation_Response = {
  __typename?: 'white_labeling_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<White_Labeling>;
};

/** on_conflict condition type for table "white_labeling" */
export type White_Labeling_On_Conflict = {
  constraint: White_Labeling_Constraint;
  update_columns?: Array<White_Labeling_Update_Column>;
  where?: InputMaybe<White_Labeling_Bool_Exp>;
};

/** Ordering options when selecting data from "white_labeling". */
export type White_Labeling_Order_By = {
  agency_id?: InputMaybe<Order_By>;
  font?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  primary_color?: InputMaybe<Order_By>;
  secondary_color?: InputMaybe<Order_By>;
  theme_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: white_labeling */
export type White_Labeling_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "white_labeling" */
export enum White_Labeling_Select_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  Font = 'font',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PrimaryColor = 'primary_color',
  /** column name */
  SecondaryColor = 'secondary_color',
  /** column name */
  ThemeType = 'theme_type'
}

/** input type for updating data in table "white_labeling" */
export type White_Labeling_Set_Input = {
  agency_id?: InputMaybe<Scalars['uuid']>;
  font?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  primary_color?: InputMaybe<Scalars['uuid']>;
  secondary_color?: InputMaybe<Scalars['uuid']>;
  theme_type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "white_labeling" */
export enum White_Labeling_Update_Column {
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  Font = 'font',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PrimaryColor = 'primary_color',
  /** column name */
  SecondaryColor = 'secondary_color',
  /** column name */
  ThemeType = 'theme_type'
}

/** columns and relationships of "workflow.document_versions" */
export type Workflow_Document_Versions = {
  __typename?: 'workflow_document_versions';
  content?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  document: Workflow_Documents;
  document_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  pages: Array<Workflow_Pages>;
  /** An aggregate relationship */
  pages_aggregate: Workflow_Pages_Aggregate;
};


/** columns and relationships of "workflow.document_versions" */
export type Workflow_Document_VersionsContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workflow.document_versions" */
export type Workflow_Document_VersionsPagesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Pages_Order_By>>;
  where?: InputMaybe<Workflow_Pages_Bool_Exp>;
};


/** columns and relationships of "workflow.document_versions" */
export type Workflow_Document_VersionsPages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Pages_Order_By>>;
  where?: InputMaybe<Workflow_Pages_Bool_Exp>;
};

/** aggregated selection of "workflow.document_versions" */
export type Workflow_Document_Versions_Aggregate = {
  __typename?: 'workflow_document_versions_aggregate';
  aggregate?: Maybe<Workflow_Document_Versions_Aggregate_Fields>;
  nodes: Array<Workflow_Document_Versions>;
};

/** aggregate fields of "workflow.document_versions" */
export type Workflow_Document_Versions_Aggregate_Fields = {
  __typename?: 'workflow_document_versions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Document_Versions_Max_Fields>;
  min?: Maybe<Workflow_Document_Versions_Min_Fields>;
};


/** aggregate fields of "workflow.document_versions" */
export type Workflow_Document_Versions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Document_Versions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow.document_versions" */
export type Workflow_Document_Versions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Document_Versions_Max_Order_By>;
  min?: InputMaybe<Workflow_Document_Versions_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Document_Versions_Append_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "workflow.document_versions" */
export type Workflow_Document_Versions_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Document_Versions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Document_Versions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "workflow.document_versions". All fields are combined with a logical 'AND'. */
export type Workflow_Document_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Document_Versions_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Document_Versions_Bool_Exp>>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Workflow_Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pages?: InputMaybe<Workflow_Pages_Bool_Exp>;
};

/** unique or primary key constraints on table "workflow.document_versions" */
export enum Workflow_Document_Versions_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentVersionsPkey = 'document_versions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Document_Versions_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Document_Versions_Delete_Elem_Input = {
  content?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Document_Versions_Delete_Key_Input = {
  content?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "workflow.document_versions" */
export type Workflow_Document_Versions_Insert_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Workflow_Documents_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  pages?: InputMaybe<Workflow_Pages_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Workflow_Document_Versions_Max_Fields = {
  __typename?: 'workflow_document_versions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "workflow.document_versions" */
export type Workflow_Document_Versions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Document_Versions_Min_Fields = {
  __typename?: 'workflow_document_versions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "workflow.document_versions" */
export type Workflow_Document_Versions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow.document_versions" */
export type Workflow_Document_Versions_Mutation_Response = {
  __typename?: 'workflow_document_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Document_Versions>;
};

/** input type for inserting object relation for remote table "workflow.document_versions" */
export type Workflow_Document_Versions_Obj_Rel_Insert_Input = {
  data: Workflow_Document_Versions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Document_Versions_On_Conflict>;
};

/** on_conflict condition type for table "workflow.document_versions" */
export type Workflow_Document_Versions_On_Conflict = {
  constraint: Workflow_Document_Versions_Constraint;
  update_columns?: Array<Workflow_Document_Versions_Update_Column>;
  where?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.document_versions". */
export type Workflow_Document_Versions_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Workflow_Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pages_aggregate?: InputMaybe<Workflow_Pages_Aggregate_Order_By>;
};

/** primary key columns input for table: workflow_document_versions */
export type Workflow_Document_Versions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Document_Versions_Prepend_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow.document_versions" */
export enum Workflow_Document_Versions_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "workflow.document_versions" */
export type Workflow_Document_Versions_Set_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "workflow.document_versions" */
export enum Workflow_Document_Versions_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id'
}

/** columns and relationships of "workflow.documents" */
export type Workflow_Documents = {
  __typename?: 'workflow_documents';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  document_versions: Array<Workflow_Document_Versions>;
  /** An aggregate relationship */
  document_versions_aggregate: Workflow_Document_Versions_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "workflow.documents" */
export type Workflow_DocumentsDocument_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Document_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Document_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
};


/** columns and relationships of "workflow.documents" */
export type Workflow_DocumentsDocument_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Document_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Document_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
};

/** aggregated selection of "workflow.documents" */
export type Workflow_Documents_Aggregate = {
  __typename?: 'workflow_documents_aggregate';
  aggregate?: Maybe<Workflow_Documents_Aggregate_Fields>;
  nodes: Array<Workflow_Documents>;
};

/** aggregate fields of "workflow.documents" */
export type Workflow_Documents_Aggregate_Fields = {
  __typename?: 'workflow_documents_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Documents_Max_Fields>;
  min?: Maybe<Workflow_Documents_Min_Fields>;
};


/** aggregate fields of "workflow.documents" */
export type Workflow_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.documents". All fields are combined with a logical 'AND'. */
export type Workflow_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Documents_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_versions?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.documents" */
export enum Workflow_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentsPkey = 'documents_pkey'
}

/** input type for inserting data into table "workflow.documents" */
export type Workflow_Documents_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_versions?: InputMaybe<Workflow_Document_Versions_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Workflow_Documents_Max_Fields = {
  __typename?: 'workflow_documents_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Workflow_Documents_Min_Fields = {
  __typename?: 'workflow_documents_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "workflow.documents" */
export type Workflow_Documents_Mutation_Response = {
  __typename?: 'workflow_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Documents>;
};

/** input type for inserting object relation for remote table "workflow.documents" */
export type Workflow_Documents_Obj_Rel_Insert_Input = {
  data: Workflow_Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Documents_On_Conflict>;
};

/** on_conflict condition type for table "workflow.documents" */
export type Workflow_Documents_On_Conflict = {
  constraint: Workflow_Documents_Constraint;
  update_columns?: Array<Workflow_Documents_Update_Column>;
  where?: InputMaybe<Workflow_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.documents". */
export type Workflow_Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_versions_aggregate?: InputMaybe<Workflow_Document_Versions_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_documents */
export type Workflow_Documents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "workflow.documents" */
export enum Workflow_Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "workflow.documents" */
export type Workflow_Documents_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "workflow.documents" */
export enum Workflow_Documents_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "workflow.field_contents" */
export type Workflow_Field_Contents = {
  __typename?: 'workflow_field_contents';
  body?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  field_id: Scalars['uuid'];
  id: Scalars['uuid'];
  page_index: Scalars['Int'];
  processmaker_process_request_id: Scalars['Int'];
  section_index: Scalars['Int'];
};


/** columns and relationships of "workflow.field_contents" */
export type Workflow_Field_ContentsBodyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "workflow.field_contents" */
export type Workflow_Field_Contents_Aggregate = {
  __typename?: 'workflow_field_contents_aggregate';
  aggregate?: Maybe<Workflow_Field_Contents_Aggregate_Fields>;
  nodes: Array<Workflow_Field_Contents>;
};

/** aggregate fields of "workflow.field_contents" */
export type Workflow_Field_Contents_Aggregate_Fields = {
  __typename?: 'workflow_field_contents_aggregate_fields';
  avg?: Maybe<Workflow_Field_Contents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Field_Contents_Max_Fields>;
  min?: Maybe<Workflow_Field_Contents_Min_Fields>;
  stddev?: Maybe<Workflow_Field_Contents_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Field_Contents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Field_Contents_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Field_Contents_Sum_Fields>;
  var_pop?: Maybe<Workflow_Field_Contents_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Field_Contents_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Field_Contents_Variance_Fields>;
};


/** aggregate fields of "workflow.field_contents" */
export type Workflow_Field_Contents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Field_Contents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Field_Contents_Append_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Workflow_Field_Contents_Avg_Fields = {
  __typename?: 'workflow_field_contents_avg_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "workflow.field_contents". All fields are combined with a logical 'AND'. */
export type Workflow_Field_Contents_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Field_Contents_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Field_Contents_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Field_Contents_Bool_Exp>>;
  body?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  field_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  page_index?: InputMaybe<Int_Comparison_Exp>;
  processmaker_process_request_id?: InputMaybe<Int_Comparison_Exp>;
  section_index?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.field_contents" */
export enum Workflow_Field_Contents_Constraint {
  /** unique or primary key constraint on columns "page_index", "field_id", "section_index", "processmaker_process_request_id" */
  FieldContentsFieldIdPageIndexProcessmakerProcessRequest = 'field_contents_field_id_page_index_processmaker_process_request',
  /** unique or primary key constraint on columns "id" */
  FieldContentsPkey = 'field_contents_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Field_Contents_Delete_At_Path_Input = {
  body?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Field_Contents_Delete_Elem_Input = {
  body?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Field_Contents_Delete_Key_Input = {
  body?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "workflow.field_contents" */
export type Workflow_Field_Contents_Inc_Input = {
  page_index?: InputMaybe<Scalars['Int']>;
  processmaker_process_request_id?: InputMaybe<Scalars['Int']>;
  section_index?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow.field_contents" */
export type Workflow_Field_Contents_Insert_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  field_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  page_index?: InputMaybe<Scalars['Int']>;
  processmaker_process_request_id?: InputMaybe<Scalars['Int']>;
  section_index?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Workflow_Field_Contents_Max_Fields = {
  __typename?: 'workflow_field_contents_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  field_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  page_index?: Maybe<Scalars['Int']>;
  processmaker_process_request_id?: Maybe<Scalars['Int']>;
  section_index?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Workflow_Field_Contents_Min_Fields = {
  __typename?: 'workflow_field_contents_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  field_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  page_index?: Maybe<Scalars['Int']>;
  processmaker_process_request_id?: Maybe<Scalars['Int']>;
  section_index?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "workflow.field_contents" */
export type Workflow_Field_Contents_Mutation_Response = {
  __typename?: 'workflow_field_contents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Field_Contents>;
};

/** on_conflict condition type for table "workflow.field_contents" */
export type Workflow_Field_Contents_On_Conflict = {
  constraint: Workflow_Field_Contents_Constraint;
  update_columns?: Array<Workflow_Field_Contents_Update_Column>;
  where?: InputMaybe<Workflow_Field_Contents_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.field_contents". */
export type Workflow_Field_Contents_Order_By = {
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  page_index?: InputMaybe<Order_By>;
  processmaker_process_request_id?: InputMaybe<Order_By>;
  section_index?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_field_contents */
export type Workflow_Field_Contents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Field_Contents_Prepend_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow.field_contents" */
export enum Workflow_Field_Contents_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  PageIndex = 'page_index',
  /** column name */
  ProcessmakerProcessRequestId = 'processmaker_process_request_id',
  /** column name */
  SectionIndex = 'section_index'
}

/** input type for updating data in table "workflow.field_contents" */
export type Workflow_Field_Contents_Set_Input = {
  body?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  field_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  page_index?: InputMaybe<Scalars['Int']>;
  processmaker_process_request_id?: InputMaybe<Scalars['Int']>;
  section_index?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Workflow_Field_Contents_Stddev_Fields = {
  __typename?: 'workflow_field_contents_stddev_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Field_Contents_Stddev_Pop_Fields = {
  __typename?: 'workflow_field_contents_stddev_pop_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Field_Contents_Stddev_Samp_Fields = {
  __typename?: 'workflow_field_contents_stddev_samp_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Workflow_Field_Contents_Sum_Fields = {
  __typename?: 'workflow_field_contents_sum_fields';
  page_index?: Maybe<Scalars['Int']>;
  processmaker_process_request_id?: Maybe<Scalars['Int']>;
  section_index?: Maybe<Scalars['Int']>;
};

/** update columns of table "workflow.field_contents" */
export enum Workflow_Field_Contents_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  PageIndex = 'page_index',
  /** column name */
  ProcessmakerProcessRequestId = 'processmaker_process_request_id',
  /** column name */
  SectionIndex = 'section_index'
}

/** aggregate var_pop on columns */
export type Workflow_Field_Contents_Var_Pop_Fields = {
  __typename?: 'workflow_field_contents_var_pop_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Workflow_Field_Contents_Var_Samp_Fields = {
  __typename?: 'workflow_field_contents_var_samp_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Workflow_Field_Contents_Variance_Fields = {
  __typename?: 'workflow_field_contents_variance_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "workflow.field_permission_types" */
export type Workflow_Field_Permission_Types = {
  __typename?: 'workflow_field_permission_types';
  name: Scalars['String'];
};

/** aggregated selection of "workflow.field_permission_types" */
export type Workflow_Field_Permission_Types_Aggregate = {
  __typename?: 'workflow_field_permission_types_aggregate';
  aggregate?: Maybe<Workflow_Field_Permission_Types_Aggregate_Fields>;
  nodes: Array<Workflow_Field_Permission_Types>;
};

/** aggregate fields of "workflow.field_permission_types" */
export type Workflow_Field_Permission_Types_Aggregate_Fields = {
  __typename?: 'workflow_field_permission_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Field_Permission_Types_Max_Fields>;
  min?: Maybe<Workflow_Field_Permission_Types_Min_Fields>;
};


/** aggregate fields of "workflow.field_permission_types" */
export type Workflow_Field_Permission_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Field_Permission_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.field_permission_types". All fields are combined with a logical 'AND'. */
export type Workflow_Field_Permission_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Field_Permission_Types_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Field_Permission_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Field_Permission_Types_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.field_permission_types" */
export enum Workflow_Field_Permission_Types_Constraint {
  /** unique or primary key constraint on columns "name" */
  FieldPermissionTypesPkey = 'field_permission_types_pkey'
}

export enum Workflow_Field_Permission_Types_Enum {
  Read = 'READ',
  Write = 'WRITE'
}

/** Boolean expression to compare columns of type "workflow_field_permission_types_enum". All fields are combined with logical 'AND'. */
export type Workflow_Field_Permission_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Workflow_Field_Permission_Types_Enum>;
  _in?: InputMaybe<Array<Workflow_Field_Permission_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Workflow_Field_Permission_Types_Enum>;
  _nin?: InputMaybe<Array<Workflow_Field_Permission_Types_Enum>>;
};

/** input type for inserting data into table "workflow.field_permission_types" */
export type Workflow_Field_Permission_Types_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Field_Permission_Types_Max_Fields = {
  __typename?: 'workflow_field_permission_types_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Field_Permission_Types_Min_Fields = {
  __typename?: 'workflow_field_permission_types_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.field_permission_types" */
export type Workflow_Field_Permission_Types_Mutation_Response = {
  __typename?: 'workflow_field_permission_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Field_Permission_Types>;
};

/** on_conflict condition type for table "workflow.field_permission_types" */
export type Workflow_Field_Permission_Types_On_Conflict = {
  constraint: Workflow_Field_Permission_Types_Constraint;
  update_columns?: Array<Workflow_Field_Permission_Types_Update_Column>;
  where?: InputMaybe<Workflow_Field_Permission_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.field_permission_types". */
export type Workflow_Field_Permission_Types_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_field_permission_types */
export type Workflow_Field_Permission_Types_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "workflow.field_permission_types" */
export enum Workflow_Field_Permission_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflow.field_permission_types" */
export type Workflow_Field_Permission_Types_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.field_permission_types" */
export enum Workflow_Field_Permission_Types_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "workflow.field_permissions" */
export type Workflow_Field_Permissions = {
  __typename?: 'workflow_field_permissions';
  created_at?: Maybe<Scalars['timestamptz']>;
  field_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_required: Scalars['Boolean'];
  task_id: Scalars['uuid'];
  type: Workflow_Field_Permission_Types_Enum;
};

/** aggregated selection of "workflow.field_permissions" */
export type Workflow_Field_Permissions_Aggregate = {
  __typename?: 'workflow_field_permissions_aggregate';
  aggregate?: Maybe<Workflow_Field_Permissions_Aggregate_Fields>;
  nodes: Array<Workflow_Field_Permissions>;
};

/** aggregate fields of "workflow.field_permissions" */
export type Workflow_Field_Permissions_Aggregate_Fields = {
  __typename?: 'workflow_field_permissions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Field_Permissions_Max_Fields>;
  min?: Maybe<Workflow_Field_Permissions_Min_Fields>;
};


/** aggregate fields of "workflow.field_permissions" */
export type Workflow_Field_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Field_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow.field_permissions" */
export type Workflow_Field_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Field_Permissions_Max_Order_By>;
  min?: InputMaybe<Workflow_Field_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "workflow.field_permissions" */
export type Workflow_Field_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Field_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Field_Permissions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "workflow.field_permissions". All fields are combined with a logical 'AND'. */
export type Workflow_Field_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Field_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Field_Permissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  field_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_required?: InputMaybe<Boolean_Comparison_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Workflow_Field_Permission_Types_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.field_permissions" */
export enum Workflow_Field_Permissions_Constraint {
  /** unique or primary key constraint on columns "task_id", "field_id" */
  FieldPermissionsFieldIdTaskIdKey = 'field_permissions_field_id_task_id_key',
  /** unique or primary key constraint on columns "id" */
  FieldPermissionsPkey = 'field_permissions_pkey'
}

/** input type for inserting data into table "workflow.field_permissions" */
export type Workflow_Field_Permissions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  field_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  task_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Workflow_Field_Permission_Types_Enum>;
};

/** aggregate max on columns */
export type Workflow_Field_Permissions_Max_Fields = {
  __typename?: 'workflow_field_permissions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  field_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  task_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "workflow.field_permissions" */
export type Workflow_Field_Permissions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Field_Permissions_Min_Fields = {
  __typename?: 'workflow_field_permissions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  field_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  task_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "workflow.field_permissions" */
export type Workflow_Field_Permissions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow.field_permissions" */
export type Workflow_Field_Permissions_Mutation_Response = {
  __typename?: 'workflow_field_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Field_Permissions>;
};

/** on_conflict condition type for table "workflow.field_permissions" */
export type Workflow_Field_Permissions_On_Conflict = {
  constraint: Workflow_Field_Permissions_Constraint;
  update_columns?: Array<Workflow_Field_Permissions_Update_Column>;
  where?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.field_permissions". */
export type Workflow_Field_Permissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_required?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_field_permissions */
export type Workflow_Field_Permissions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "workflow.field_permissions" */
export enum Workflow_Field_Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsRequired = 'is_required',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "workflow.field_permissions" */
export type Workflow_Field_Permissions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  field_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  task_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Workflow_Field_Permission_Types_Enum>;
};

/** update columns of table "workflow.field_permissions" */
export enum Workflow_Field_Permissions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsRequired = 'is_required',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Type = 'type'
}

/** columns and relationships of "workflow.field_types" */
export type Workflow_Field_Types = {
  __typename?: 'workflow_field_types';
  name: Scalars['String'];
};

/** aggregated selection of "workflow.field_types" */
export type Workflow_Field_Types_Aggregate = {
  __typename?: 'workflow_field_types_aggregate';
  aggregate?: Maybe<Workflow_Field_Types_Aggregate_Fields>;
  nodes: Array<Workflow_Field_Types>;
};

/** aggregate fields of "workflow.field_types" */
export type Workflow_Field_Types_Aggregate_Fields = {
  __typename?: 'workflow_field_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Field_Types_Max_Fields>;
  min?: Maybe<Workflow_Field_Types_Min_Fields>;
};


/** aggregate fields of "workflow.field_types" */
export type Workflow_Field_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Field_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.field_types". All fields are combined with a logical 'AND'. */
export type Workflow_Field_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Field_Types_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Field_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Field_Types_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.field_types" */
export enum Workflow_Field_Types_Constraint {
  /** unique or primary key constraint on columns "name" */
  FieldTypesPkey = 'field_types_pkey'
}

export enum Workflow_Field_Types_Enum {
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  FileUploader = 'FILE_UPLOADER',
  List = 'LIST',
  Location = 'LOCATION',
  Table = 'TABLE',
  Text = 'TEXT',
  TextArea = 'TEXT_AREA',
  Tickbox = 'TICKBOX'
}

/** Boolean expression to compare columns of type "workflow_field_types_enum". All fields are combined with logical 'AND'. */
export type Workflow_Field_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Workflow_Field_Types_Enum>;
  _in?: InputMaybe<Array<Workflow_Field_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Workflow_Field_Types_Enum>;
  _nin?: InputMaybe<Array<Workflow_Field_Types_Enum>>;
};

/** input type for inserting data into table "workflow.field_types" */
export type Workflow_Field_Types_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Field_Types_Max_Fields = {
  __typename?: 'workflow_field_types_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Field_Types_Min_Fields = {
  __typename?: 'workflow_field_types_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.field_types" */
export type Workflow_Field_Types_Mutation_Response = {
  __typename?: 'workflow_field_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Field_Types>;
};

/** input type for inserting object relation for remote table "workflow.field_types" */
export type Workflow_Field_Types_Obj_Rel_Insert_Input = {
  data: Workflow_Field_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Field_Types_On_Conflict>;
};

/** on_conflict condition type for table "workflow.field_types" */
export type Workflow_Field_Types_On_Conflict = {
  constraint: Workflow_Field_Types_Constraint;
  update_columns?: Array<Workflow_Field_Types_Update_Column>;
  where?: InputMaybe<Workflow_Field_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.field_types". */
export type Workflow_Field_Types_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_field_types */
export type Workflow_Field_Types_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "workflow.field_types" */
export enum Workflow_Field_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflow.field_types" */
export type Workflow_Field_Types_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.field_types" */
export enum Workflow_Field_Types_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "workflow.fields" */
export type Workflow_Fields = {
  __typename?: 'workflow_fields';
  column_index?: Maybe<Scalars['Int']>;
  configuration?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  field_type?: Maybe<Workflow_Field_Types>;
  id: Scalars['uuid'];
  row_index?: Maybe<Scalars['Int']>;
  /** An object relationship */
  section?: Maybe<Workflow_Sections>;
  section_id?: Maybe<Scalars['uuid']>;
  title: Scalars['String'];
  type?: Maybe<Workflow_Field_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "workflow.fields" */
export type Workflow_FieldsConfigurationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "workflow.fields" */
export type Workflow_Fields_Aggregate = {
  __typename?: 'workflow_fields_aggregate';
  aggregate?: Maybe<Workflow_Fields_Aggregate_Fields>;
  nodes: Array<Workflow_Fields>;
};

/** aggregate fields of "workflow.fields" */
export type Workflow_Fields_Aggregate_Fields = {
  __typename?: 'workflow_fields_aggregate_fields';
  avg?: Maybe<Workflow_Fields_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Fields_Max_Fields>;
  min?: Maybe<Workflow_Fields_Min_Fields>;
  stddev?: Maybe<Workflow_Fields_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Fields_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Fields_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Fields_Sum_Fields>;
  var_pop?: Maybe<Workflow_Fields_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Fields_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Fields_Variance_Fields>;
};


/** aggregate fields of "workflow.fields" */
export type Workflow_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow.fields" */
export type Workflow_Fields_Aggregate_Order_By = {
  avg?: InputMaybe<Workflow_Fields_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Fields_Max_Order_By>;
  min?: InputMaybe<Workflow_Fields_Min_Order_By>;
  stddev?: InputMaybe<Workflow_Fields_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Workflow_Fields_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Workflow_Fields_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Workflow_Fields_Sum_Order_By>;
  var_pop?: InputMaybe<Workflow_Fields_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Workflow_Fields_Var_Samp_Order_By>;
  variance?: InputMaybe<Workflow_Fields_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Fields_Append_Input = {
  configuration?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "workflow.fields" */
export type Workflow_Fields_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Fields_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Fields_On_Conflict>;
};

/** aggregate avg on columns */
export type Workflow_Fields_Avg_Fields = {
  __typename?: 'workflow_fields_avg_fields';
  column_index?: Maybe<Scalars['Float']>;
  row_index?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workflow.fields" */
export type Workflow_Fields_Avg_Order_By = {
  column_index?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "workflow.fields". All fields are combined with a logical 'AND'. */
export type Workflow_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Fields_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Fields_Bool_Exp>>;
  column_index?: InputMaybe<Int_Comparison_Exp>;
  configuration?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  field_type?: InputMaybe<Workflow_Field_Types_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  row_index?: InputMaybe<Int_Comparison_Exp>;
  section?: InputMaybe<Workflow_Sections_Bool_Exp>;
  section_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Workflow_Field_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.fields" */
export enum Workflow_Fields_Constraint {
  /** unique or primary key constraint on columns "id" */
  FieldsPkey = 'fields_pkey',
  /** unique or primary key constraint on columns "column_index", "section_id", "row_index" */
  FieldsSectionIdRowIndexColumnIndexKey = 'fields_section_id_row_index_column_index_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Fields_Delete_At_Path_Input = {
  configuration?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Fields_Delete_Elem_Input = {
  configuration?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Fields_Delete_Key_Input = {
  configuration?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "workflow.fields" */
export type Workflow_Fields_Inc_Input = {
  column_index?: InputMaybe<Scalars['Int']>;
  row_index?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow.fields" */
export type Workflow_Fields_Insert_Input = {
  column_index?: InputMaybe<Scalars['Int']>;
  configuration?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  field_type?: InputMaybe<Workflow_Field_Types_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  row_index?: InputMaybe<Scalars['Int']>;
  section?: InputMaybe<Workflow_Sections_Obj_Rel_Insert_Input>;
  section_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Workflow_Field_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Workflow_Fields_Max_Fields = {
  __typename?: 'workflow_fields_max_fields';
  column_index?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  row_index?: Maybe<Scalars['Int']>;
  section_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "workflow.fields" */
export type Workflow_Fields_Max_Order_By = {
  column_index?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Fields_Min_Fields = {
  __typename?: 'workflow_fields_min_fields';
  column_index?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  row_index?: Maybe<Scalars['Int']>;
  section_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "workflow.fields" */
export type Workflow_Fields_Min_Order_By = {
  column_index?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow.fields" */
export type Workflow_Fields_Mutation_Response = {
  __typename?: 'workflow_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Fields>;
};

/** on_conflict condition type for table "workflow.fields" */
export type Workflow_Fields_On_Conflict = {
  constraint: Workflow_Fields_Constraint;
  update_columns?: Array<Workflow_Fields_Update_Column>;
  where?: InputMaybe<Workflow_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.fields". */
export type Workflow_Fields_Order_By = {
  column_index?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Workflow_Field_Types_Order_By>;
  id?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
  section?: InputMaybe<Workflow_Sections_Order_By>;
  section_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_fields */
export type Workflow_Fields_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Fields_Prepend_Input = {
  configuration?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow.fields" */
export enum Workflow_Fields_Select_Column {
  /** column name */
  ColumnIndex = 'column_index',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RowIndex = 'row_index',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "workflow.fields" */
export type Workflow_Fields_Set_Input = {
  column_index?: InputMaybe<Scalars['Int']>;
  configuration?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  row_index?: InputMaybe<Scalars['Int']>;
  section_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Workflow_Field_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Workflow_Fields_Stddev_Fields = {
  __typename?: 'workflow_fields_stddev_fields';
  column_index?: Maybe<Scalars['Float']>;
  row_index?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workflow.fields" */
export type Workflow_Fields_Stddev_Order_By = {
  column_index?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Fields_Stddev_Pop_Fields = {
  __typename?: 'workflow_fields_stddev_pop_fields';
  column_index?: Maybe<Scalars['Float']>;
  row_index?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workflow.fields" */
export type Workflow_Fields_Stddev_Pop_Order_By = {
  column_index?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Fields_Stddev_Samp_Fields = {
  __typename?: 'workflow_fields_stddev_samp_fields';
  column_index?: Maybe<Scalars['Float']>;
  row_index?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workflow.fields" */
export type Workflow_Fields_Stddev_Samp_Order_By = {
  column_index?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Workflow_Fields_Sum_Fields = {
  __typename?: 'workflow_fields_sum_fields';
  column_index?: Maybe<Scalars['Int']>;
  row_index?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workflow.fields" */
export type Workflow_Fields_Sum_Order_By = {
  column_index?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
};

/** update columns of table "workflow.fields" */
export enum Workflow_Fields_Update_Column {
  /** column name */
  ColumnIndex = 'column_index',
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RowIndex = 'row_index',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Workflow_Fields_Var_Pop_Fields = {
  __typename?: 'workflow_fields_var_pop_fields';
  column_index?: Maybe<Scalars['Float']>;
  row_index?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workflow.fields" */
export type Workflow_Fields_Var_Pop_Order_By = {
  column_index?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Workflow_Fields_Var_Samp_Fields = {
  __typename?: 'workflow_fields_var_samp_fields';
  column_index?: Maybe<Scalars['Float']>;
  row_index?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workflow.fields" */
export type Workflow_Fields_Var_Samp_Order_By = {
  column_index?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Workflow_Fields_Variance_Fields = {
  __typename?: 'workflow_fields_variance_fields';
  column_index?: Maybe<Scalars['Float']>;
  row_index?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workflow.fields" */
export type Workflow_Fields_Variance_Order_By = {
  column_index?: InputMaybe<Order_By>;
  row_index?: InputMaybe<Order_By>;
};

/** columns and relationships of "workflow.pages" */
export type Workflow_Pages = {
  __typename?: 'workflow_pages';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_version_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  index?: Maybe<Scalars['Int']>;
  is_saved?: Maybe<Scalars['Boolean']>;
  is_variable?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
  organization_id: Scalars['uuid'];
  /** An array relationship */
  sections: Array<Workflow_Sections>;
  /** An aggregate relationship */
  sections_aggregate: Workflow_Sections_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "workflow.pages" */
export type Workflow_PagesSectionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Sections_Order_By>>;
  where?: InputMaybe<Workflow_Sections_Bool_Exp>;
};


/** columns and relationships of "workflow.pages" */
export type Workflow_PagesSections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Sections_Order_By>>;
  where?: InputMaybe<Workflow_Sections_Bool_Exp>;
};

/** aggregated selection of "workflow.pages" */
export type Workflow_Pages_Aggregate = {
  __typename?: 'workflow_pages_aggregate';
  aggregate?: Maybe<Workflow_Pages_Aggregate_Fields>;
  nodes: Array<Workflow_Pages>;
};

/** aggregate fields of "workflow.pages" */
export type Workflow_Pages_Aggregate_Fields = {
  __typename?: 'workflow_pages_aggregate_fields';
  avg?: Maybe<Workflow_Pages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Pages_Max_Fields>;
  min?: Maybe<Workflow_Pages_Min_Fields>;
  stddev?: Maybe<Workflow_Pages_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Pages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Pages_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Pages_Sum_Fields>;
  var_pop?: Maybe<Workflow_Pages_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Pages_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Pages_Variance_Fields>;
};


/** aggregate fields of "workflow.pages" */
export type Workflow_Pages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Pages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow.pages" */
export type Workflow_Pages_Aggregate_Order_By = {
  avg?: InputMaybe<Workflow_Pages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Pages_Max_Order_By>;
  min?: InputMaybe<Workflow_Pages_Min_Order_By>;
  stddev?: InputMaybe<Workflow_Pages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Workflow_Pages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Workflow_Pages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Workflow_Pages_Sum_Order_By>;
  var_pop?: InputMaybe<Workflow_Pages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Workflow_Pages_Var_Samp_Order_By>;
  variance?: InputMaybe<Workflow_Pages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workflow.pages" */
export type Workflow_Pages_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Pages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Pages_On_Conflict>;
};

/** aggregate avg on columns */
export type Workflow_Pages_Avg_Fields = {
  __typename?: 'workflow_pages_avg_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workflow.pages" */
export type Workflow_Pages_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "workflow.pages". All fields are combined with a logical 'AND'. */
export type Workflow_Pages_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Pages_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Pages_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Pages_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  is_saved?: InputMaybe<Boolean_Comparison_Exp>;
  is_variable?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  sections?: InputMaybe<Workflow_Sections_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.pages" */
export enum Workflow_Pages_Constraint {
  /** unique or primary key constraint on columns "document_version_id", "index" */
  PagesDocumentIdIndexKey = 'pages_document_id_index_key',
  /** unique or primary key constraint on columns "id" */
  PagesPkey = 'pages_pkey'
}

/** input type for incrementing numeric columns in table "workflow.pages" */
export type Workflow_Pages_Inc_Input = {
  index?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow.pages" */
export type Workflow_Pages_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_version_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  index?: InputMaybe<Scalars['Int']>;
  is_saved?: InputMaybe<Scalars['Boolean']>;
  is_variable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  sections?: InputMaybe<Workflow_Sections_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Workflow_Pages_Max_Fields = {
  __typename?: 'workflow_pages_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_version_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "workflow.pages" */
export type Workflow_Pages_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Pages_Min_Fields = {
  __typename?: 'workflow_pages_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_version_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "workflow.pages" */
export type Workflow_Pages_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow.pages" */
export type Workflow_Pages_Mutation_Response = {
  __typename?: 'workflow_pages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Pages>;
};

/** on_conflict condition type for table "workflow.pages" */
export type Workflow_Pages_On_Conflict = {
  constraint: Workflow_Pages_Constraint;
  update_columns?: Array<Workflow_Pages_Update_Column>;
  where?: InputMaybe<Workflow_Pages_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.pages". */
export type Workflow_Pages_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  is_saved?: InputMaybe<Order_By>;
  is_variable?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  sections_aggregate?: InputMaybe<Workflow_Sections_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_pages */
export type Workflow_Pages_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "workflow.pages" */
export enum Workflow_Pages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentVersionId = 'document_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  IsSaved = 'is_saved',
  /** column name */
  IsVariable = 'is_variable',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "workflow.pages" */
export type Workflow_Pages_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_version_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  index?: InputMaybe<Scalars['Int']>;
  is_saved?: InputMaybe<Scalars['Boolean']>;
  is_variable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Workflow_Pages_Stddev_Fields = {
  __typename?: 'workflow_pages_stddev_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workflow.pages" */
export type Workflow_Pages_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Pages_Stddev_Pop_Fields = {
  __typename?: 'workflow_pages_stddev_pop_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workflow.pages" */
export type Workflow_Pages_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Pages_Stddev_Samp_Fields = {
  __typename?: 'workflow_pages_stddev_samp_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workflow.pages" */
export type Workflow_Pages_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Workflow_Pages_Sum_Fields = {
  __typename?: 'workflow_pages_sum_fields';
  index?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workflow.pages" */
export type Workflow_Pages_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** update columns of table "workflow.pages" */
export enum Workflow_Pages_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentVersionId = 'document_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  IsSaved = 'is_saved',
  /** column name */
  IsVariable = 'is_variable',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Workflow_Pages_Var_Pop_Fields = {
  __typename?: 'workflow_pages_var_pop_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workflow.pages" */
export type Workflow_Pages_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Workflow_Pages_Var_Samp_Fields = {
  __typename?: 'workflow_pages_var_samp_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workflow.pages" */
export type Workflow_Pages_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Workflow_Pages_Variance_Fields = {
  __typename?: 'workflow_pages_variance_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workflow.pages" */
export type Workflow_Pages_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** columns and relationships of "workflow.processmaker_users" */
export type Workflow_Processmaker_Users = {
  __typename?: 'workflow_processmaker_users';
  processmaker_user_id: Scalars['Int'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_Aggregate = {
  __typename?: 'workflow_processmaker_users_aggregate';
  aggregate?: Maybe<Workflow_Processmaker_Users_Aggregate_Fields>;
  nodes: Array<Workflow_Processmaker_Users>;
};

/** aggregate fields of "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_Aggregate_Fields = {
  __typename?: 'workflow_processmaker_users_aggregate_fields';
  avg?: Maybe<Workflow_Processmaker_Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Processmaker_Users_Max_Fields>;
  min?: Maybe<Workflow_Processmaker_Users_Min_Fields>;
  stddev?: Maybe<Workflow_Processmaker_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Processmaker_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Processmaker_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Processmaker_Users_Sum_Fields>;
  var_pop?: Maybe<Workflow_Processmaker_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Processmaker_Users_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Processmaker_Users_Variance_Fields>;
};


/** aggregate fields of "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Processmaker_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Workflow_Processmaker_Users_Avg_Fields = {
  __typename?: 'workflow_processmaker_users_avg_fields';
  processmaker_user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "workflow.processmaker_users". All fields are combined with a logical 'AND'. */
export type Workflow_Processmaker_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Processmaker_Users_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Processmaker_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Processmaker_Users_Bool_Exp>>;
  processmaker_user_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.processmaker_users" */
export enum Workflow_Processmaker_Users_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  ProcessmakerUsersPkey = 'processmaker_users_pkey',
  /** unique or primary key constraint on columns "processmaker_user_id" */
  ProcessmakerUsersProcessmakerUserId = 'processmaker_users_processmaker_user_id'
}

/** input type for incrementing numeric columns in table "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_Inc_Input = {
  processmaker_user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_Insert_Input = {
  processmaker_user_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Workflow_Processmaker_Users_Max_Fields = {
  __typename?: 'workflow_processmaker_users_max_fields';
  processmaker_user_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Workflow_Processmaker_Users_Min_Fields = {
  __typename?: 'workflow_processmaker_users_min_fields';
  processmaker_user_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_Mutation_Response = {
  __typename?: 'workflow_processmaker_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Processmaker_Users>;
};

/** input type for inserting object relation for remote table "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_Obj_Rel_Insert_Input = {
  data: Workflow_Processmaker_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Processmaker_Users_On_Conflict>;
};

/** on_conflict condition type for table "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_On_Conflict = {
  constraint: Workflow_Processmaker_Users_Constraint;
  update_columns?: Array<Workflow_Processmaker_Users_Update_Column>;
  where?: InputMaybe<Workflow_Processmaker_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.processmaker_users". */
export type Workflow_Processmaker_Users_Order_By = {
  processmaker_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_processmaker_users */
export type Workflow_Processmaker_Users_Pk_Columns_Input = {
  user_id: Scalars['uuid'];
};

/** select columns of table "workflow.processmaker_users" */
export enum Workflow_Processmaker_Users_Select_Column {
  /** column name */
  ProcessmakerUserId = 'processmaker_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "workflow.processmaker_users" */
export type Workflow_Processmaker_Users_Set_Input = {
  processmaker_user_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Workflow_Processmaker_Users_Stddev_Fields = {
  __typename?: 'workflow_processmaker_users_stddev_fields';
  processmaker_user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Processmaker_Users_Stddev_Pop_Fields = {
  __typename?: 'workflow_processmaker_users_stddev_pop_fields';
  processmaker_user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Processmaker_Users_Stddev_Samp_Fields = {
  __typename?: 'workflow_processmaker_users_stddev_samp_fields';
  processmaker_user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Workflow_Processmaker_Users_Sum_Fields = {
  __typename?: 'workflow_processmaker_users_sum_fields';
  processmaker_user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "workflow.processmaker_users" */
export enum Workflow_Processmaker_Users_Update_Column {
  /** column name */
  ProcessmakerUserId = 'processmaker_user_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Workflow_Processmaker_Users_Var_Pop_Fields = {
  __typename?: 'workflow_processmaker_users_var_pop_fields';
  processmaker_user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Workflow_Processmaker_Users_Var_Samp_Fields = {
  __typename?: 'workflow_processmaker_users_var_samp_fields';
  processmaker_user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Workflow_Processmaker_Users_Variance_Fields = {
  __typename?: 'workflow_processmaker_users_variance_fields';
  processmaker_user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "workflow.saved_document_part_types" */
export type Workflow_Saved_Document_Part_Types = {
  __typename?: 'workflow_saved_document_part_types';
  name: Scalars['String'];
};

/** aggregated selection of "workflow.saved_document_part_types" */
export type Workflow_Saved_Document_Part_Types_Aggregate = {
  __typename?: 'workflow_saved_document_part_types_aggregate';
  aggregate?: Maybe<Workflow_Saved_Document_Part_Types_Aggregate_Fields>;
  nodes: Array<Workflow_Saved_Document_Part_Types>;
};

/** aggregate fields of "workflow.saved_document_part_types" */
export type Workflow_Saved_Document_Part_Types_Aggregate_Fields = {
  __typename?: 'workflow_saved_document_part_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Saved_Document_Part_Types_Max_Fields>;
  min?: Maybe<Workflow_Saved_Document_Part_Types_Min_Fields>;
};


/** aggregate fields of "workflow.saved_document_part_types" */
export type Workflow_Saved_Document_Part_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.saved_document_part_types". All fields are combined with a logical 'AND'. */
export type Workflow_Saved_Document_Part_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Saved_Document_Part_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Saved_Document_Part_Types_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.saved_document_part_types" */
export enum Workflow_Saved_Document_Part_Types_Constraint {
  /** unique or primary key constraint on columns "name" */
  SavedDocumentPartTypesPkey = 'saved_document_part_types_pkey'
}

/** input type for inserting data into table "workflow.saved_document_part_types" */
export type Workflow_Saved_Document_Part_Types_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Saved_Document_Part_Types_Max_Fields = {
  __typename?: 'workflow_saved_document_part_types_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Saved_Document_Part_Types_Min_Fields = {
  __typename?: 'workflow_saved_document_part_types_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.saved_document_part_types" */
export type Workflow_Saved_Document_Part_Types_Mutation_Response = {
  __typename?: 'workflow_saved_document_part_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Saved_Document_Part_Types>;
};

/** on_conflict condition type for table "workflow.saved_document_part_types" */
export type Workflow_Saved_Document_Part_Types_On_Conflict = {
  constraint: Workflow_Saved_Document_Part_Types_Constraint;
  update_columns?: Array<Workflow_Saved_Document_Part_Types_Update_Column>;
  where?: InputMaybe<Workflow_Saved_Document_Part_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.saved_document_part_types". */
export type Workflow_Saved_Document_Part_Types_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_saved_document_part_types */
export type Workflow_Saved_Document_Part_Types_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "workflow.saved_document_part_types" */
export enum Workflow_Saved_Document_Part_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflow.saved_document_part_types" */
export type Workflow_Saved_Document_Part_Types_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.saved_document_part_types" */
export enum Workflow_Saved_Document_Part_Types_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "workflow.saved_document_parts" */
export type Workflow_Saved_Document_Parts = {
  __typename?: 'workflow_saved_document_parts';
  content: Scalars['jsonb'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  organization_id: Scalars['uuid'];
  type: Scalars['String'];
};


/** columns and relationships of "workflow.saved_document_parts" */
export type Workflow_Saved_Document_PartsContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "workflow.saved_document_parts" */
export type Workflow_Saved_Document_Parts_Aggregate = {
  __typename?: 'workflow_saved_document_parts_aggregate';
  aggregate?: Maybe<Workflow_Saved_Document_Parts_Aggregate_Fields>;
  nodes: Array<Workflow_Saved_Document_Parts>;
};

/** aggregate fields of "workflow.saved_document_parts" */
export type Workflow_Saved_Document_Parts_Aggregate_Fields = {
  __typename?: 'workflow_saved_document_parts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Saved_Document_Parts_Max_Fields>;
  min?: Maybe<Workflow_Saved_Document_Parts_Min_Fields>;
};


/** aggregate fields of "workflow.saved_document_parts" */
export type Workflow_Saved_Document_Parts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Saved_Document_Parts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Saved_Document_Parts_Append_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "workflow.saved_document_parts". All fields are combined with a logical 'AND'. */
export type Workflow_Saved_Document_Parts_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Saved_Document_Parts_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Saved_Document_Parts_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Saved_Document_Parts_Bool_Exp>>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.saved_document_parts" */
export enum Workflow_Saved_Document_Parts_Constraint {
  /** unique or primary key constraint on columns "id" */
  SavedDocumentPartsPkey = 'saved_document_parts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Saved_Document_Parts_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Saved_Document_Parts_Delete_Elem_Input = {
  content?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Saved_Document_Parts_Delete_Key_Input = {
  content?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "workflow.saved_document_parts" */
export type Workflow_Saved_Document_Parts_Insert_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Saved_Document_Parts_Max_Fields = {
  __typename?: 'workflow_saved_document_parts_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Saved_Document_Parts_Min_Fields = {
  __typename?: 'workflow_saved_document_parts_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.saved_document_parts" */
export type Workflow_Saved_Document_Parts_Mutation_Response = {
  __typename?: 'workflow_saved_document_parts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Saved_Document_Parts>;
};

/** on_conflict condition type for table "workflow.saved_document_parts" */
export type Workflow_Saved_Document_Parts_On_Conflict = {
  constraint: Workflow_Saved_Document_Parts_Constraint;
  update_columns?: Array<Workflow_Saved_Document_Parts_Update_Column>;
  where?: InputMaybe<Workflow_Saved_Document_Parts_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.saved_document_parts". */
export type Workflow_Saved_Document_Parts_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_saved_document_parts */
export type Workflow_Saved_Document_Parts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Saved_Document_Parts_Prepend_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow.saved_document_parts" */
export enum Workflow_Saved_Document_Parts_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "workflow.saved_document_parts" */
export type Workflow_Saved_Document_Parts_Set_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.saved_document_parts" */
export enum Workflow_Saved_Document_Parts_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Type = 'type'
}

/** columns and relationships of "workflow.section_comment_status" */
export type Workflow_Section_Comment_Status = {
  __typename?: 'workflow_section_comment_status';
  name: Scalars['String'];
};

/** aggregated selection of "workflow.section_comment_status" */
export type Workflow_Section_Comment_Status_Aggregate = {
  __typename?: 'workflow_section_comment_status_aggregate';
  aggregate?: Maybe<Workflow_Section_Comment_Status_Aggregate_Fields>;
  nodes: Array<Workflow_Section_Comment_Status>;
};

/** aggregate fields of "workflow.section_comment_status" */
export type Workflow_Section_Comment_Status_Aggregate_Fields = {
  __typename?: 'workflow_section_comment_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Section_Comment_Status_Max_Fields>;
  min?: Maybe<Workflow_Section_Comment_Status_Min_Fields>;
};


/** aggregate fields of "workflow.section_comment_status" */
export type Workflow_Section_Comment_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Section_Comment_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.section_comment_status". All fields are combined with a logical 'AND'. */
export type Workflow_Section_Comment_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Section_Comment_Status_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Section_Comment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Section_Comment_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.section_comment_status" */
export enum Workflow_Section_Comment_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  WorkflowRunDeliverableCommentStatusPkey = 'workflow_run_deliverable_comment_status_pkey'
}

export enum Workflow_Section_Comment_Status_Enum {
  Archived = 'ARCHIVED',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

/** Boolean expression to compare columns of type "workflow_section_comment_status_enum". All fields are combined with logical 'AND'. */
export type Workflow_Section_Comment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Workflow_Section_Comment_Status_Enum>;
  _in?: InputMaybe<Array<Workflow_Section_Comment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Workflow_Section_Comment_Status_Enum>;
  _nin?: InputMaybe<Array<Workflow_Section_Comment_Status_Enum>>;
};

/** input type for inserting data into table "workflow.section_comment_status" */
export type Workflow_Section_Comment_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Section_Comment_Status_Max_Fields = {
  __typename?: 'workflow_section_comment_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Section_Comment_Status_Min_Fields = {
  __typename?: 'workflow_section_comment_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.section_comment_status" */
export type Workflow_Section_Comment_Status_Mutation_Response = {
  __typename?: 'workflow_section_comment_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Section_Comment_Status>;
};

/** on_conflict condition type for table "workflow.section_comment_status" */
export type Workflow_Section_Comment_Status_On_Conflict = {
  constraint: Workflow_Section_Comment_Status_Constraint;
  update_columns?: Array<Workflow_Section_Comment_Status_Update_Column>;
  where?: InputMaybe<Workflow_Section_Comment_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.section_comment_status". */
export type Workflow_Section_Comment_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_section_comment_status */
export type Workflow_Section_Comment_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "workflow.section_comment_status" */
export enum Workflow_Section_Comment_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflow.section_comment_status" */
export type Workflow_Section_Comment_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.section_comment_status" */
export enum Workflow_Section_Comment_Status_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "workflow.section_comments" */
export type Workflow_Section_Comments = {
  __typename?: 'workflow_section_comments';
  /** An object relationship */
  author?: Maybe<Users>;
  client_organization_author?: Maybe<Scalars['uuid']>;
  client_organization_resolver?: Maybe<Scalars['uuid']>;
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  page_id?: Maybe<Scalars['uuid']>;
  page_index: Scalars['Int'];
  page_name?: Maybe<Scalars['String']>;
  processmaker_process_request_id: Scalars['Int'];
  resolved_at?: Maybe<Scalars['timestamp']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  resolver?: Maybe<Users>;
  section_id: Scalars['uuid'];
  section_index: Scalars['Int'];
  section_name?: Maybe<Scalars['String']>;
  status: Workflow_Section_Comment_Status_Enum;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "workflow.section_comments" */
export type Workflow_Section_Comments_Aggregate = {
  __typename?: 'workflow_section_comments_aggregate';
  aggregate?: Maybe<Workflow_Section_Comments_Aggregate_Fields>;
  nodes: Array<Workflow_Section_Comments>;
};

/** aggregate fields of "workflow.section_comments" */
export type Workflow_Section_Comments_Aggregate_Fields = {
  __typename?: 'workflow_section_comments_aggregate_fields';
  avg?: Maybe<Workflow_Section_Comments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Section_Comments_Max_Fields>;
  min?: Maybe<Workflow_Section_Comments_Min_Fields>;
  stddev?: Maybe<Workflow_Section_Comments_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Section_Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Section_Comments_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Section_Comments_Sum_Fields>;
  var_pop?: Maybe<Workflow_Section_Comments_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Section_Comments_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Section_Comments_Variance_Fields>;
};


/** aggregate fields of "workflow.section_comments" */
export type Workflow_Section_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Section_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Workflow_Section_Comments_Avg_Fields = {
  __typename?: 'workflow_section_comments_avg_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "workflow.section_comments". All fields are combined with a logical 'AND'. */
export type Workflow_Section_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Section_Comments_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Section_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Section_Comments_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  client_organization_author?: InputMaybe<Uuid_Comparison_Exp>;
  client_organization_resolver?: InputMaybe<Uuid_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  page_index?: InputMaybe<Int_Comparison_Exp>;
  page_name?: InputMaybe<String_Comparison_Exp>;
  processmaker_process_request_id?: InputMaybe<Int_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamp_Comparison_Exp>;
  resolved_by?: InputMaybe<Uuid_Comparison_Exp>;
  resolver?: InputMaybe<Users_Bool_Exp>;
  section_id?: InputMaybe<Uuid_Comparison_Exp>;
  section_index?: InputMaybe<Int_Comparison_Exp>;
  section_name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Workflow_Section_Comment_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.section_comments" */
export enum Workflow_Section_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkflowRunDeliverableCommentsPkey = 'workflow_run_deliverable_comments_pkey'
}

/** input type for incrementing numeric columns in table "workflow.section_comments" */
export type Workflow_Section_Comments_Inc_Input = {
  page_index?: InputMaybe<Scalars['Int']>;
  processmaker_process_request_id?: InputMaybe<Scalars['Int']>;
  section_index?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow.section_comments" */
export type Workflow_Section_Comments_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  client_organization_author?: InputMaybe<Scalars['uuid']>;
  client_organization_resolver?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  page_index?: InputMaybe<Scalars['Int']>;
  page_name?: InputMaybe<Scalars['String']>;
  processmaker_process_request_id?: InputMaybe<Scalars['Int']>;
  resolved_at?: InputMaybe<Scalars['timestamp']>;
  resolved_by?: InputMaybe<Scalars['uuid']>;
  resolver?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  section_id?: InputMaybe<Scalars['uuid']>;
  section_index?: InputMaybe<Scalars['Int']>;
  section_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Workflow_Section_Comment_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Workflow_Section_Comments_Max_Fields = {
  __typename?: 'workflow_section_comments_max_fields';
  client_organization_author?: Maybe<Scalars['uuid']>;
  client_organization_resolver?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  page_id?: Maybe<Scalars['uuid']>;
  page_index?: Maybe<Scalars['Int']>;
  page_name?: Maybe<Scalars['String']>;
  processmaker_process_request_id?: Maybe<Scalars['Int']>;
  resolved_at?: Maybe<Scalars['timestamp']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  section_id?: Maybe<Scalars['uuid']>;
  section_index?: Maybe<Scalars['Int']>;
  section_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Workflow_Section_Comments_Min_Fields = {
  __typename?: 'workflow_section_comments_min_fields';
  client_organization_author?: Maybe<Scalars['uuid']>;
  client_organization_resolver?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  page_id?: Maybe<Scalars['uuid']>;
  page_index?: Maybe<Scalars['Int']>;
  page_name?: Maybe<Scalars['String']>;
  processmaker_process_request_id?: Maybe<Scalars['Int']>;
  resolved_at?: Maybe<Scalars['timestamp']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  section_id?: Maybe<Scalars['uuid']>;
  section_index?: Maybe<Scalars['Int']>;
  section_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "workflow.section_comments" */
export type Workflow_Section_Comments_Mutation_Response = {
  __typename?: 'workflow_section_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Section_Comments>;
};

/** on_conflict condition type for table "workflow.section_comments" */
export type Workflow_Section_Comments_On_Conflict = {
  constraint: Workflow_Section_Comments_Constraint;
  update_columns?: Array<Workflow_Section_Comments_Update_Column>;
  where?: InputMaybe<Workflow_Section_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.section_comments". */
export type Workflow_Section_Comments_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  client_organization_author?: InputMaybe<Order_By>;
  client_organization_resolver?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  page_index?: InputMaybe<Order_By>;
  page_name?: InputMaybe<Order_By>;
  processmaker_process_request_id?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by?: InputMaybe<Order_By>;
  resolver?: InputMaybe<Users_Order_By>;
  section_id?: InputMaybe<Order_By>;
  section_index?: InputMaybe<Order_By>;
  section_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_section_comments */
export type Workflow_Section_Comments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "workflow.section_comments" */
export enum Workflow_Section_Comments_Select_Column {
  /** column name */
  ClientOrganizationAuthor = 'client_organization_author',
  /** column name */
  ClientOrganizationResolver = 'client_organization_resolver',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  PageIndex = 'page_index',
  /** column name */
  PageName = 'page_name',
  /** column name */
  ProcessmakerProcessRequestId = 'processmaker_process_request_id',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedBy = 'resolved_by',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  SectionIndex = 'section_index',
  /** column name */
  SectionName = 'section_name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "workflow.section_comments" */
export type Workflow_Section_Comments_Set_Input = {
  client_organization_author?: InputMaybe<Scalars['uuid']>;
  client_organization_resolver?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  page_index?: InputMaybe<Scalars['Int']>;
  page_name?: InputMaybe<Scalars['String']>;
  processmaker_process_request_id?: InputMaybe<Scalars['Int']>;
  resolved_at?: InputMaybe<Scalars['timestamp']>;
  resolved_by?: InputMaybe<Scalars['uuid']>;
  section_id?: InputMaybe<Scalars['uuid']>;
  section_index?: InputMaybe<Scalars['Int']>;
  section_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Workflow_Section_Comment_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Workflow_Section_Comments_Stddev_Fields = {
  __typename?: 'workflow_section_comments_stddev_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Section_Comments_Stddev_Pop_Fields = {
  __typename?: 'workflow_section_comments_stddev_pop_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Section_Comments_Stddev_Samp_Fields = {
  __typename?: 'workflow_section_comments_stddev_samp_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Workflow_Section_Comments_Sum_Fields = {
  __typename?: 'workflow_section_comments_sum_fields';
  page_index?: Maybe<Scalars['Int']>;
  processmaker_process_request_id?: Maybe<Scalars['Int']>;
  section_index?: Maybe<Scalars['Int']>;
};

/** update columns of table "workflow.section_comments" */
export enum Workflow_Section_Comments_Update_Column {
  /** column name */
  ClientOrganizationAuthor = 'client_organization_author',
  /** column name */
  ClientOrganizationResolver = 'client_organization_resolver',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  PageIndex = 'page_index',
  /** column name */
  PageName = 'page_name',
  /** column name */
  ProcessmakerProcessRequestId = 'processmaker_process_request_id',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedBy = 'resolved_by',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  SectionIndex = 'section_index',
  /** column name */
  SectionName = 'section_name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Workflow_Section_Comments_Var_Pop_Fields = {
  __typename?: 'workflow_section_comments_var_pop_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Workflow_Section_Comments_Var_Samp_Fields = {
  __typename?: 'workflow_section_comments_var_samp_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Workflow_Section_Comments_Variance_Fields = {
  __typename?: 'workflow_section_comments_variance_fields';
  page_index?: Maybe<Scalars['Float']>;
  processmaker_process_request_id?: Maybe<Scalars['Float']>;
  section_index?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "workflow.sections" */
export type Workflow_Sections = {
  __typename?: 'workflow_sections';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  fields: Array<Workflow_Fields>;
  /** An aggregate relationship */
  fields_aggregate: Workflow_Fields_Aggregate;
  id: Scalars['uuid'];
  index?: Maybe<Scalars['Int']>;
  is_saved?: Maybe<Scalars['Boolean']>;
  is_variable?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
  organization_id: Scalars['uuid'];
  page_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "workflow.sections" */
export type Workflow_SectionsFieldsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Fields_Order_By>>;
  where?: InputMaybe<Workflow_Fields_Bool_Exp>;
};


/** columns and relationships of "workflow.sections" */
export type Workflow_SectionsFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Fields_Order_By>>;
  where?: InputMaybe<Workflow_Fields_Bool_Exp>;
};

/** aggregated selection of "workflow.sections" */
export type Workflow_Sections_Aggregate = {
  __typename?: 'workflow_sections_aggregate';
  aggregate?: Maybe<Workflow_Sections_Aggregate_Fields>;
  nodes: Array<Workflow_Sections>;
};

/** aggregate fields of "workflow.sections" */
export type Workflow_Sections_Aggregate_Fields = {
  __typename?: 'workflow_sections_aggregate_fields';
  avg?: Maybe<Workflow_Sections_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Sections_Max_Fields>;
  min?: Maybe<Workflow_Sections_Min_Fields>;
  stddev?: Maybe<Workflow_Sections_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Sections_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Sections_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Sections_Sum_Fields>;
  var_pop?: Maybe<Workflow_Sections_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Sections_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Sections_Variance_Fields>;
};


/** aggregate fields of "workflow.sections" */
export type Workflow_Sections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Sections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow.sections" */
export type Workflow_Sections_Aggregate_Order_By = {
  avg?: InputMaybe<Workflow_Sections_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Sections_Max_Order_By>;
  min?: InputMaybe<Workflow_Sections_Min_Order_By>;
  stddev?: InputMaybe<Workflow_Sections_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Workflow_Sections_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Workflow_Sections_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Workflow_Sections_Sum_Order_By>;
  var_pop?: InputMaybe<Workflow_Sections_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Workflow_Sections_Var_Samp_Order_By>;
  variance?: InputMaybe<Workflow_Sections_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workflow.sections" */
export type Workflow_Sections_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Sections_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Sections_On_Conflict>;
};

/** aggregate avg on columns */
export type Workflow_Sections_Avg_Fields = {
  __typename?: 'workflow_sections_avg_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workflow.sections" */
export type Workflow_Sections_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "workflow.sections". All fields are combined with a logical 'AND'. */
export type Workflow_Sections_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Sections_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Sections_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Sections_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fields?: InputMaybe<Workflow_Fields_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  is_saved?: InputMaybe<Boolean_Comparison_Exp>;
  is_variable?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.sections" */
export enum Workflow_Sections_Constraint {
  /** unique or primary key constraint on columns "index", "page_id" */
  SectionsPageIdIndexKey = 'sections_page_id_index_key',
  /** unique or primary key constraint on columns "id" */
  SectionsPkey = 'sections_pkey'
}

/** input type for incrementing numeric columns in table "workflow.sections" */
export type Workflow_Sections_Inc_Input = {
  index?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow.sections" */
export type Workflow_Sections_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fields?: InputMaybe<Workflow_Fields_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  index?: InputMaybe<Scalars['Int']>;
  is_saved?: InputMaybe<Scalars['Boolean']>;
  is_variable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Workflow_Sections_Max_Fields = {
  __typename?: 'workflow_sections_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['uuid']>;
  page_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "workflow.sections" */
export type Workflow_Sections_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Sections_Min_Fields = {
  __typename?: 'workflow_sections_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['uuid']>;
  page_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "workflow.sections" */
export type Workflow_Sections_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow.sections" */
export type Workflow_Sections_Mutation_Response = {
  __typename?: 'workflow_sections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Sections>;
};

/** input type for inserting object relation for remote table "workflow.sections" */
export type Workflow_Sections_Obj_Rel_Insert_Input = {
  data: Workflow_Sections_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Sections_On_Conflict>;
};

/** on_conflict condition type for table "workflow.sections" */
export type Workflow_Sections_On_Conflict = {
  constraint: Workflow_Sections_Constraint;
  update_columns?: Array<Workflow_Sections_Update_Column>;
  where?: InputMaybe<Workflow_Sections_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.sections". */
export type Workflow_Sections_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fields_aggregate?: InputMaybe<Workflow_Fields_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  is_saved?: InputMaybe<Order_By>;
  is_variable?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_sections */
export type Workflow_Sections_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "workflow.sections" */
export enum Workflow_Sections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  IsSaved = 'is_saved',
  /** column name */
  IsVariable = 'is_variable',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "workflow.sections" */
export type Workflow_Sections_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  index?: InputMaybe<Scalars['Int']>;
  is_saved?: InputMaybe<Scalars['Boolean']>;
  is_variable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Workflow_Sections_Stddev_Fields = {
  __typename?: 'workflow_sections_stddev_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workflow.sections" */
export type Workflow_Sections_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Sections_Stddev_Pop_Fields = {
  __typename?: 'workflow_sections_stddev_pop_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workflow.sections" */
export type Workflow_Sections_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Sections_Stddev_Samp_Fields = {
  __typename?: 'workflow_sections_stddev_samp_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workflow.sections" */
export type Workflow_Sections_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Workflow_Sections_Sum_Fields = {
  __typename?: 'workflow_sections_sum_fields';
  index?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workflow.sections" */
export type Workflow_Sections_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** update columns of table "workflow.sections" */
export enum Workflow_Sections_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  IsSaved = 'is_saved',
  /** column name */
  IsVariable = 'is_variable',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Workflow_Sections_Var_Pop_Fields = {
  __typename?: 'workflow_sections_var_pop_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workflow.sections" */
export type Workflow_Sections_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Workflow_Sections_Var_Samp_Fields = {
  __typename?: 'workflow_sections_var_samp_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workflow.sections" */
export type Workflow_Sections_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Workflow_Sections_Variance_Fields = {
  __typename?: 'workflow_sections_variance_fields';
  index?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workflow.sections" */
export type Workflow_Sections_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** columns and relationships of "workflow.task_notifications" */
export type Workflow_Task_Notifications = {
  __typename?: 'workflow_task_notifications';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  task_id: Scalars['bigint'];
  type: Scalars['String'];
};

/** aggregated selection of "workflow.task_notifications" */
export type Workflow_Task_Notifications_Aggregate = {
  __typename?: 'workflow_task_notifications_aggregate';
  aggregate?: Maybe<Workflow_Task_Notifications_Aggregate_Fields>;
  nodes: Array<Workflow_Task_Notifications>;
};

/** aggregate fields of "workflow.task_notifications" */
export type Workflow_Task_Notifications_Aggregate_Fields = {
  __typename?: 'workflow_task_notifications_aggregate_fields';
  avg?: Maybe<Workflow_Task_Notifications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Task_Notifications_Max_Fields>;
  min?: Maybe<Workflow_Task_Notifications_Min_Fields>;
  stddev?: Maybe<Workflow_Task_Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Task_Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Task_Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Task_Notifications_Sum_Fields>;
  var_pop?: Maybe<Workflow_Task_Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Task_Notifications_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Task_Notifications_Variance_Fields>;
};


/** aggregate fields of "workflow.task_notifications" */
export type Workflow_Task_Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Task_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Workflow_Task_Notifications_Avg_Fields = {
  __typename?: 'workflow_task_notifications_avg_fields';
  task_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "workflow.task_notifications". All fields are combined with a logical 'AND'. */
export type Workflow_Task_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Task_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Task_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Task_Notifications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task_id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.task_notifications" */
export enum Workflow_Task_Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskNotificationsPkey = 'task_notifications_pkey'
}

/** input type for incrementing numeric columns in table "workflow.task_notifications" */
export type Workflow_Task_Notifications_Inc_Input = {
  task_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "workflow.task_notifications" */
export type Workflow_Task_Notifications_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  task_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Task_Notifications_Max_Fields = {
  __typename?: 'workflow_task_notifications_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  task_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Task_Notifications_Min_Fields = {
  __typename?: 'workflow_task_notifications_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  task_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.task_notifications" */
export type Workflow_Task_Notifications_Mutation_Response = {
  __typename?: 'workflow_task_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Task_Notifications>;
};

/** on_conflict condition type for table "workflow.task_notifications" */
export type Workflow_Task_Notifications_On_Conflict = {
  constraint: Workflow_Task_Notifications_Constraint;
  update_columns?: Array<Workflow_Task_Notifications_Update_Column>;
  where?: InputMaybe<Workflow_Task_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.task_notifications". */
export type Workflow_Task_Notifications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_task_notifications */
export type Workflow_Task_Notifications_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "workflow.task_notifications" */
export enum Workflow_Task_Notifications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "workflow.task_notifications" */
export type Workflow_Task_Notifications_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  task_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Workflow_Task_Notifications_Stddev_Fields = {
  __typename?: 'workflow_task_notifications_stddev_fields';
  task_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Task_Notifications_Stddev_Pop_Fields = {
  __typename?: 'workflow_task_notifications_stddev_pop_fields';
  task_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Task_Notifications_Stddev_Samp_Fields = {
  __typename?: 'workflow_task_notifications_stddev_samp_fields';
  task_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Workflow_Task_Notifications_Sum_Fields = {
  __typename?: 'workflow_task_notifications_sum_fields';
  task_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "workflow.task_notifications" */
export enum Workflow_Task_Notifications_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Type = 'type'
}

/** aggregate var_pop on columns */
export type Workflow_Task_Notifications_Var_Pop_Fields = {
  __typename?: 'workflow_task_notifications_var_pop_fields';
  task_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Workflow_Task_Notifications_Var_Samp_Fields = {
  __typename?: 'workflow_task_notifications_var_samp_fields';
  task_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Workflow_Task_Notifications_Variance_Fields = {
  __typename?: 'workflow_task_notifications_variance_fields';
  task_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "workflow.task_types" */
export type Workflow_Task_Types = {
  __typename?: 'workflow_task_types';
  name: Scalars['String'];
};

/** aggregated selection of "workflow.task_types" */
export type Workflow_Task_Types_Aggregate = {
  __typename?: 'workflow_task_types_aggregate';
  aggregate?: Maybe<Workflow_Task_Types_Aggregate_Fields>;
  nodes: Array<Workflow_Task_Types>;
};

/** aggregate fields of "workflow.task_types" */
export type Workflow_Task_Types_Aggregate_Fields = {
  __typename?: 'workflow_task_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Task_Types_Max_Fields>;
  min?: Maybe<Workflow_Task_Types_Min_Fields>;
};


/** aggregate fields of "workflow.task_types" */
export type Workflow_Task_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Task_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.task_types". All fields are combined with a logical 'AND'. */
export type Workflow_Task_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Task_Types_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Task_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Task_Types_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.task_types" */
export enum Workflow_Task_Types_Constraint {
  /** unique or primary key constraint on columns "name" */
  TaskTypesPkey = 'task_types_pkey'
}

export enum Workflow_Task_Types_Enum {
  ApprovalTask = 'APPROVAL_TASK',
  AutomationTask = 'AUTOMATION_TASK',
  FormTask = 'FORM_TASK',
  Task = 'TASK'
}

/** Boolean expression to compare columns of type "workflow_task_types_enum". All fields are combined with logical 'AND'. */
export type Workflow_Task_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Workflow_Task_Types_Enum>;
  _in?: InputMaybe<Array<Workflow_Task_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Workflow_Task_Types_Enum>;
  _nin?: InputMaybe<Array<Workflow_Task_Types_Enum>>;
};

/** input type for inserting data into table "workflow.task_types" */
export type Workflow_Task_Types_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Task_Types_Max_Fields = {
  __typename?: 'workflow_task_types_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Task_Types_Min_Fields = {
  __typename?: 'workflow_task_types_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.task_types" */
export type Workflow_Task_Types_Mutation_Response = {
  __typename?: 'workflow_task_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Task_Types>;
};

/** on_conflict condition type for table "workflow.task_types" */
export type Workflow_Task_Types_On_Conflict = {
  constraint: Workflow_Task_Types_Constraint;
  update_columns?: Array<Workflow_Task_Types_Update_Column>;
  where?: InputMaybe<Workflow_Task_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.task_types". */
export type Workflow_Task_Types_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_task_types */
export type Workflow_Task_Types_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "workflow.task_types" */
export enum Workflow_Task_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflow.task_types" */
export type Workflow_Task_Types_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.task_types" */
export enum Workflow_Task_Types_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "workflow.tasks" */
export type Workflow_Tasks = {
  __typename?: 'workflow_tasks';
  approval_conditions?: Maybe<Scalars['jsonb']>;
  automation_configuration?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  field_permissions: Array<Workflow_Field_Permissions>;
  /** An aggregate relationship */
  field_permissions_aggregate: Workflow_Field_Permissions_Aggregate;
  id: Scalars['uuid'];
  processmaker_node_id: Scalars['String'];
  type?: Maybe<Workflow_Task_Types_Enum>;
  workflow_version_id: Scalars['uuid'];
};


/** columns and relationships of "workflow.tasks" */
export type Workflow_TasksApproval_ConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workflow.tasks" */
export type Workflow_TasksAutomation_ConfigurationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workflow.tasks" */
export type Workflow_TasksField_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permissions_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
};


/** columns and relationships of "workflow.tasks" */
export type Workflow_TasksField_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Field_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Field_Permissions_Order_By>>;
  where?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
};

/** aggregated selection of "workflow.tasks" */
export type Workflow_Tasks_Aggregate = {
  __typename?: 'workflow_tasks_aggregate';
  aggregate?: Maybe<Workflow_Tasks_Aggregate_Fields>;
  nodes: Array<Workflow_Tasks>;
};

/** aggregate fields of "workflow.tasks" */
export type Workflow_Tasks_Aggregate_Fields = {
  __typename?: 'workflow_tasks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Tasks_Max_Fields>;
  min?: Maybe<Workflow_Tasks_Min_Fields>;
};


/** aggregate fields of "workflow.tasks" */
export type Workflow_Tasks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Tasks_Append_Input = {
  approval_conditions?: InputMaybe<Scalars['jsonb']>;
  automation_configuration?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "workflow.tasks". All fields are combined with a logical 'AND'. */
export type Workflow_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Tasks_Bool_Exp>>;
  approval_conditions?: InputMaybe<Jsonb_Comparison_Exp>;
  automation_configuration?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  field_permissions?: InputMaybe<Workflow_Field_Permissions_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  processmaker_node_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Workflow_Task_Types_Enum_Comparison_Exp>;
  workflow_version_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.tasks" */
export enum Workflow_Tasks_Constraint {
  /** unique or primary key constraint on columns "id" */
  TasksPkey = 'tasks_pkey',
  /** unique or primary key constraint on columns "workflow_version_id", "processmaker_node_id" */
  TasksProcessmakerNodeIdWorkflowVersionIdKey = 'tasks_processmaker_node_id_workflow_version_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Tasks_Delete_At_Path_Input = {
  approval_conditions?: InputMaybe<Array<Scalars['String']>>;
  automation_configuration?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Tasks_Delete_Elem_Input = {
  approval_conditions?: InputMaybe<Scalars['Int']>;
  automation_configuration?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Tasks_Delete_Key_Input = {
  approval_conditions?: InputMaybe<Scalars['String']>;
  automation_configuration?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "workflow.tasks" */
export type Workflow_Tasks_Insert_Input = {
  approval_conditions?: InputMaybe<Scalars['jsonb']>;
  automation_configuration?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  field_permissions?: InputMaybe<Workflow_Field_Permissions_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  processmaker_node_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Workflow_Task_Types_Enum>;
  workflow_version_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Workflow_Tasks_Max_Fields = {
  __typename?: 'workflow_tasks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  processmaker_node_id?: Maybe<Scalars['String']>;
  workflow_version_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Workflow_Tasks_Min_Fields = {
  __typename?: 'workflow_tasks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  processmaker_node_id?: Maybe<Scalars['String']>;
  workflow_version_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "workflow.tasks" */
export type Workflow_Tasks_Mutation_Response = {
  __typename?: 'workflow_tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Tasks>;
};

/** on_conflict condition type for table "workflow.tasks" */
export type Workflow_Tasks_On_Conflict = {
  constraint: Workflow_Tasks_Constraint;
  update_columns?: Array<Workflow_Tasks_Update_Column>;
  where?: InputMaybe<Workflow_Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.tasks". */
export type Workflow_Tasks_Order_By = {
  approval_conditions?: InputMaybe<Order_By>;
  automation_configuration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  field_permissions_aggregate?: InputMaybe<Workflow_Field_Permissions_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  processmaker_node_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  workflow_version_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_tasks */
export type Workflow_Tasks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Tasks_Prepend_Input = {
  approval_conditions?: InputMaybe<Scalars['jsonb']>;
  automation_configuration?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow.tasks" */
export enum Workflow_Tasks_Select_Column {
  /** column name */
  ApprovalConditions = 'approval_conditions',
  /** column name */
  AutomationConfiguration = 'automation_configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ProcessmakerNodeId = 'processmaker_node_id',
  /** column name */
  Type = 'type',
  /** column name */
  WorkflowVersionId = 'workflow_version_id'
}

/** input type for updating data in table "workflow.tasks" */
export type Workflow_Tasks_Set_Input = {
  approval_conditions?: InputMaybe<Scalars['jsonb']>;
  automation_configuration?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  processmaker_node_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Workflow_Task_Types_Enum>;
  workflow_version_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "workflow.tasks" */
export enum Workflow_Tasks_Update_Column {
  /** column name */
  ApprovalConditions = 'approval_conditions',
  /** column name */
  AutomationConfiguration = 'automation_configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ProcessmakerNodeId = 'processmaker_node_id',
  /** column name */
  Type = 'type',
  /** column name */
  WorkflowVersionId = 'workflow_version_id'
}

/** columns and relationships of "workflow.workflow_creation_status" */
export type Workflow_Workflow_Creation_Status = {
  __typename?: 'workflow_workflow_creation_status';
  name: Scalars['String'];
};

/** aggregated selection of "workflow.workflow_creation_status" */
export type Workflow_Workflow_Creation_Status_Aggregate = {
  __typename?: 'workflow_workflow_creation_status_aggregate';
  aggregate?: Maybe<Workflow_Workflow_Creation_Status_Aggregate_Fields>;
  nodes: Array<Workflow_Workflow_Creation_Status>;
};

/** aggregate fields of "workflow.workflow_creation_status" */
export type Workflow_Workflow_Creation_Status_Aggregate_Fields = {
  __typename?: 'workflow_workflow_creation_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Workflow_Creation_Status_Max_Fields>;
  min?: Maybe<Workflow_Workflow_Creation_Status_Min_Fields>;
};


/** aggregate fields of "workflow.workflow_creation_status" */
export type Workflow_Workflow_Creation_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.workflow_creation_status". All fields are combined with a logical 'AND'. */
export type Workflow_Workflow_Creation_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Workflow_Creation_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Workflow_Creation_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.workflow_creation_status" */
export enum Workflow_Workflow_Creation_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  WorkflowCreationStatusPkey = 'workflow_creation_status_pkey'
}

/** input type for inserting data into table "workflow.workflow_creation_status" */
export type Workflow_Workflow_Creation_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Workflow_Creation_Status_Max_Fields = {
  __typename?: 'workflow_workflow_creation_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Workflow_Creation_Status_Min_Fields = {
  __typename?: 'workflow_workflow_creation_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.workflow_creation_status" */
export type Workflow_Workflow_Creation_Status_Mutation_Response = {
  __typename?: 'workflow_workflow_creation_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Workflow_Creation_Status>;
};

/** on_conflict condition type for table "workflow.workflow_creation_status" */
export type Workflow_Workflow_Creation_Status_On_Conflict = {
  constraint: Workflow_Workflow_Creation_Status_Constraint;
  update_columns?: Array<Workflow_Workflow_Creation_Status_Update_Column>;
  where?: InputMaybe<Workflow_Workflow_Creation_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.workflow_creation_status". */
export type Workflow_Workflow_Creation_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_workflow_creation_status */
export type Workflow_Workflow_Creation_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "workflow.workflow_creation_status" */
export enum Workflow_Workflow_Creation_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflow.workflow_creation_status" */
export type Workflow_Workflow_Creation_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.workflow_creation_status" */
export enum Workflow_Workflow_Creation_Status_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "workflow.workflow_reactflow_status" */
export type Workflow_Workflow_Reactflow_Status = {
  __typename?: 'workflow_workflow_reactflow_status';
  name: Scalars['String'];
};

/** aggregated selection of "workflow.workflow_reactflow_status" */
export type Workflow_Workflow_Reactflow_Status_Aggregate = {
  __typename?: 'workflow_workflow_reactflow_status_aggregate';
  aggregate?: Maybe<Workflow_Workflow_Reactflow_Status_Aggregate_Fields>;
  nodes: Array<Workflow_Workflow_Reactflow_Status>;
};

/** aggregate fields of "workflow.workflow_reactflow_status" */
export type Workflow_Workflow_Reactflow_Status_Aggregate_Fields = {
  __typename?: 'workflow_workflow_reactflow_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Workflow_Reactflow_Status_Max_Fields>;
  min?: Maybe<Workflow_Workflow_Reactflow_Status_Min_Fields>;
};


/** aggregate fields of "workflow.workflow_reactflow_status" */
export type Workflow_Workflow_Reactflow_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.workflow_reactflow_status". All fields are combined with a logical 'AND'. */
export type Workflow_Workflow_Reactflow_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Workflow_Reactflow_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.workflow_reactflow_status" */
export enum Workflow_Workflow_Reactflow_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  WorkflowReactflowStatusPkey = 'workflow_reactflow_status_pkey'
}

export enum Workflow_Workflow_Reactflow_Status_Enum {
  AnalysisInProgress = 'ANALYSIS_IN_PROGRESS',
  InvalidJson = 'INVALID_JSON',
  InvalidXml = 'INVALID_XML',
  Valid = 'VALID'
}

/** Boolean expression to compare columns of type "workflow_workflow_reactflow_status_enum". All fields are combined with logical 'AND'. */
export type Workflow_Workflow_Reactflow_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Workflow_Workflow_Reactflow_Status_Enum>;
  _in?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Workflow_Workflow_Reactflow_Status_Enum>;
  _nin?: InputMaybe<Array<Workflow_Workflow_Reactflow_Status_Enum>>;
};

/** input type for inserting data into table "workflow.workflow_reactflow_status" */
export type Workflow_Workflow_Reactflow_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Workflow_Reactflow_Status_Max_Fields = {
  __typename?: 'workflow_workflow_reactflow_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Workflow_Reactflow_Status_Min_Fields = {
  __typename?: 'workflow_workflow_reactflow_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.workflow_reactflow_status" */
export type Workflow_Workflow_Reactflow_Status_Mutation_Response = {
  __typename?: 'workflow_workflow_reactflow_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Workflow_Reactflow_Status>;
};

/** on_conflict condition type for table "workflow.workflow_reactflow_status" */
export type Workflow_Workflow_Reactflow_Status_On_Conflict = {
  constraint: Workflow_Workflow_Reactflow_Status_Constraint;
  update_columns?: Array<Workflow_Workflow_Reactflow_Status_Update_Column>;
  where?: InputMaybe<Workflow_Workflow_Reactflow_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.workflow_reactflow_status". */
export type Workflow_Workflow_Reactflow_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_workflow_reactflow_status */
export type Workflow_Workflow_Reactflow_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "workflow.workflow_reactflow_status" */
export enum Workflow_Workflow_Reactflow_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflow.workflow_reactflow_status" */
export type Workflow_Workflow_Reactflow_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.workflow_reactflow_status" */
export enum Workflow_Workflow_Reactflow_Status_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "workflow.workflow_status" */
export type Workflow_Workflow_Status = {
  __typename?: 'workflow_workflow_status';
  name: Scalars['String'];
};

/** aggregated selection of "workflow.workflow_status" */
export type Workflow_Workflow_Status_Aggregate = {
  __typename?: 'workflow_workflow_status_aggregate';
  aggregate?: Maybe<Workflow_Workflow_Status_Aggregate_Fields>;
  nodes: Array<Workflow_Workflow_Status>;
};

/** aggregate fields of "workflow.workflow_status" */
export type Workflow_Workflow_Status_Aggregate_Fields = {
  __typename?: 'workflow_workflow_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Workflow_Status_Max_Fields>;
  min?: Maybe<Workflow_Workflow_Status_Min_Fields>;
};


/** aggregate fields of "workflow.workflow_status" */
export type Workflow_Workflow_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Workflow_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "workflow.workflow_status". All fields are combined with a logical 'AND'. */
export type Workflow_Workflow_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Workflow_Status_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Workflow_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Workflow_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.workflow_status" */
export enum Workflow_Workflow_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  WorkflowStatusPkey = 'workflow_status_pkey'
}

export enum Workflow_Workflow_Status_Enum {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Stopped = 'STOPPED'
}

/** Boolean expression to compare columns of type "workflow_workflow_status_enum". All fields are combined with logical 'AND'. */
export type Workflow_Workflow_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Workflow_Workflow_Status_Enum>;
  _in?: InputMaybe<Array<Workflow_Workflow_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Workflow_Workflow_Status_Enum>;
  _nin?: InputMaybe<Array<Workflow_Workflow_Status_Enum>>;
};

/** input type for inserting data into table "workflow.workflow_status" */
export type Workflow_Workflow_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Workflow_Status_Max_Fields = {
  __typename?: 'workflow_workflow_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflow_Workflow_Status_Min_Fields = {
  __typename?: 'workflow_workflow_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflow.workflow_status" */
export type Workflow_Workflow_Status_Mutation_Response = {
  __typename?: 'workflow_workflow_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Workflow_Status>;
};

/** on_conflict condition type for table "workflow.workflow_status" */
export type Workflow_Workflow_Status_On_Conflict = {
  constraint: Workflow_Workflow_Status_Constraint;
  update_columns?: Array<Workflow_Workflow_Status_Update_Column>;
  where?: InputMaybe<Workflow_Workflow_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.workflow_status". */
export type Workflow_Workflow_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_workflow_status */
export type Workflow_Workflow_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "workflow.workflow_status" */
export enum Workflow_Workflow_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflow.workflow_status" */
export type Workflow_Workflow_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workflow.workflow_status" */
export enum Workflow_Workflow_Status_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "workflow.workflow_templates" */
export type Workflow_Workflow_Templates = {
  __typename?: 'workflow_workflow_templates';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  organization_id?: Maybe<Scalars['uuid']>;
  reactflow_json?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "workflow.workflow_templates" */
export type Workflow_Workflow_TemplatesReactflow_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "workflow.workflow_templates" */
export type Workflow_Workflow_Templates_Aggregate = {
  __typename?: 'workflow_workflow_templates_aggregate';
  aggregate?: Maybe<Workflow_Workflow_Templates_Aggregate_Fields>;
  nodes: Array<Workflow_Workflow_Templates>;
};

/** aggregate fields of "workflow.workflow_templates" */
export type Workflow_Workflow_Templates_Aggregate_Fields = {
  __typename?: 'workflow_workflow_templates_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Workflow_Workflow_Templates_Max_Fields>;
  min?: Maybe<Workflow_Workflow_Templates_Min_Fields>;
};


/** aggregate fields of "workflow.workflow_templates" */
export type Workflow_Workflow_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Workflow_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Workflow_Templates_Append_Input = {
  reactflow_json?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "workflow.workflow_templates". All fields are combined with a logical 'AND'. */
export type Workflow_Workflow_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Workflow_Templates_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Workflow_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Workflow_Templates_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  reactflow_json?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.workflow_templates" */
export enum Workflow_Workflow_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkflowTemplatesPkey = 'workflow_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Workflow_Templates_Delete_At_Path_Input = {
  reactflow_json?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Workflow_Templates_Delete_Elem_Input = {
  reactflow_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Workflow_Templates_Delete_Key_Input = {
  reactflow_json?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "workflow.workflow_templates" */
export type Workflow_Workflow_Templates_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  document_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  reactflow_json?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Workflow_Workflow_Templates_Max_Fields = {
  __typename?: 'workflow_workflow_templates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Workflow_Workflow_Templates_Min_Fields = {
  __typename?: 'workflow_workflow_templates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "workflow.workflow_templates" */
export type Workflow_Workflow_Templates_Mutation_Response = {
  __typename?: 'workflow_workflow_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Workflow_Templates>;
};

/** on_conflict condition type for table "workflow.workflow_templates" */
export type Workflow_Workflow_Templates_On_Conflict = {
  constraint: Workflow_Workflow_Templates_Constraint;
  update_columns?: Array<Workflow_Workflow_Templates_Update_Column>;
  where?: InputMaybe<Workflow_Workflow_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.workflow_templates". */
export type Workflow_Workflow_Templates_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  reactflow_json?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_workflow_templates */
export type Workflow_Workflow_Templates_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Workflow_Templates_Prepend_Input = {
  reactflow_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow.workflow_templates" */
export enum Workflow_Workflow_Templates_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ReactflowJson = 'reactflow_json',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "workflow.workflow_templates" */
export type Workflow_Workflow_Templates_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  document_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  reactflow_json?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "workflow.workflow_templates" */
export enum Workflow_Workflow_Templates_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ReactflowJson = 'reactflow_json',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "workflow.workflow_versions" */
export type Workflow_Workflow_Versions = {
  __typename?: 'workflow_workflow_versions';
  created_at?: Maybe<Scalars['timestamptz']>;
  creation_status?: Maybe<Scalars['String']>;
  /** An object relationship */
  document_version?: Maybe<Workflow_Document_Versions>;
  document_version_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['Int']>;
  enriched_reactflow_json?: Maybe<Scalars['jsonb']>;
  first_due_date?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  processmaker_moddle_warnings?: Maybe<Scalars['jsonb']>;
  processmaker_process_version_id?: Maybe<Scalars['Int']>;
  processmaker_xml?: Maybe<Scalars['xml']>;
  processmaker_xml_warnings?: Maybe<Scalars['jsonb']>;
  reactflow_json?: Maybe<Scalars['jsonb']>;
  reactflow_status: Workflow_Workflow_Reactflow_Status_Enum;
  /** An object relationship */
  workflow: Workflow_Workflows;
  workflow_id: Scalars['uuid'];
};


/** columns and relationships of "workflow.workflow_versions" */
export type Workflow_Workflow_VersionsEnriched_Reactflow_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workflow.workflow_versions" */
export type Workflow_Workflow_VersionsProcessmaker_Moddle_WarningsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workflow.workflow_versions" */
export type Workflow_Workflow_VersionsProcessmaker_Xml_WarningsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workflow.workflow_versions" */
export type Workflow_Workflow_VersionsReactflow_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Aggregate = {
  __typename?: 'workflow_workflow_versions_aggregate';
  aggregate?: Maybe<Workflow_Workflow_Versions_Aggregate_Fields>;
  nodes: Array<Workflow_Workflow_Versions>;
};

/** aggregate fields of "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Aggregate_Fields = {
  __typename?: 'workflow_workflow_versions_aggregate_fields';
  avg?: Maybe<Workflow_Workflow_Versions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Workflow_Versions_Max_Fields>;
  min?: Maybe<Workflow_Workflow_Versions_Min_Fields>;
  stddev?: Maybe<Workflow_Workflow_Versions_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Workflow_Versions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Workflow_Versions_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Workflow_Versions_Sum_Fields>;
  var_pop?: Maybe<Workflow_Workflow_Versions_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Workflow_Versions_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Workflow_Versions_Variance_Fields>;
};


/** aggregate fields of "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Workflow_Versions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Aggregate_Order_By = {
  avg?: InputMaybe<Workflow_Workflow_Versions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Workflow_Versions_Max_Order_By>;
  min?: InputMaybe<Workflow_Workflow_Versions_Min_Order_By>;
  stddev?: InputMaybe<Workflow_Workflow_Versions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Workflow_Workflow_Versions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Workflow_Workflow_Versions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Workflow_Workflow_Versions_Sum_Order_By>;
  var_pop?: InputMaybe<Workflow_Workflow_Versions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Workflow_Workflow_Versions_Var_Samp_Order_By>;
  variance?: InputMaybe<Workflow_Workflow_Versions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Workflow_Versions_Append_Input = {
  enriched_reactflow_json?: InputMaybe<Scalars['jsonb']>;
  processmaker_moddle_warnings?: InputMaybe<Scalars['jsonb']>;
  processmaker_xml_warnings?: InputMaybe<Scalars['jsonb']>;
  reactflow_json?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Workflow_Versions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Workflow_Versions_On_Conflict>;
};

/** aggregate avg on columns */
export type Workflow_Workflow_Versions_Avg_Fields = {
  __typename?: 'workflow_workflow_versions_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  processmaker_process_version_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Avg_Order_By = {
  duration?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "workflow.workflow_versions". All fields are combined with a logical 'AND'. */
export type Workflow_Workflow_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Workflow_Versions_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Workflow_Versions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_status?: InputMaybe<String_Comparison_Exp>;
  document_version?: InputMaybe<Workflow_Document_Versions_Bool_Exp>;
  document_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  enriched_reactflow_json?: InputMaybe<Jsonb_Comparison_Exp>;
  first_due_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  processmaker_moddle_warnings?: InputMaybe<Jsonb_Comparison_Exp>;
  processmaker_process_version_id?: InputMaybe<Int_Comparison_Exp>;
  processmaker_xml?: InputMaybe<Xml_Comparison_Exp>;
  processmaker_xml_warnings?: InputMaybe<Jsonb_Comparison_Exp>;
  reactflow_json?: InputMaybe<Jsonb_Comparison_Exp>;
  reactflow_status?: InputMaybe<Workflow_Workflow_Reactflow_Status_Enum_Comparison_Exp>;
  workflow?: InputMaybe<Workflow_Workflows_Bool_Exp>;
  workflow_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow.workflow_versions" */
export enum Workflow_Workflow_Versions_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkflowVersionsPkey = 'workflow_versions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Workflow_Versions_Delete_At_Path_Input = {
  enriched_reactflow_json?: InputMaybe<Array<Scalars['String']>>;
  processmaker_moddle_warnings?: InputMaybe<Array<Scalars['String']>>;
  processmaker_xml_warnings?: InputMaybe<Array<Scalars['String']>>;
  reactflow_json?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Workflow_Versions_Delete_Elem_Input = {
  enriched_reactflow_json?: InputMaybe<Scalars['Int']>;
  processmaker_moddle_warnings?: InputMaybe<Scalars['Int']>;
  processmaker_xml_warnings?: InputMaybe<Scalars['Int']>;
  reactflow_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Workflow_Versions_Delete_Key_Input = {
  enriched_reactflow_json?: InputMaybe<Scalars['String']>;
  processmaker_moddle_warnings?: InputMaybe<Scalars['String']>;
  processmaker_xml_warnings?: InputMaybe<Scalars['String']>;
  reactflow_json?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  processmaker_process_version_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  creation_status?: InputMaybe<Scalars['String']>;
  document_version?: InputMaybe<Workflow_Document_Versions_Obj_Rel_Insert_Input>;
  document_version_id?: InputMaybe<Scalars['uuid']>;
  duration?: InputMaybe<Scalars['Int']>;
  enriched_reactflow_json?: InputMaybe<Scalars['jsonb']>;
  first_due_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  processmaker_moddle_warnings?: InputMaybe<Scalars['jsonb']>;
  processmaker_process_version_id?: InputMaybe<Scalars['Int']>;
  processmaker_xml?: InputMaybe<Scalars['xml']>;
  processmaker_xml_warnings?: InputMaybe<Scalars['jsonb']>;
  reactflow_json?: InputMaybe<Scalars['jsonb']>;
  reactflow_status?: InputMaybe<Workflow_Workflow_Reactflow_Status_Enum>;
  workflow?: InputMaybe<Workflow_Workflows_Obj_Rel_Insert_Input>;
  workflow_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Workflow_Workflow_Versions_Max_Fields = {
  __typename?: 'workflow_workflow_versions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  creation_status?: Maybe<Scalars['String']>;
  document_version_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['Int']>;
  first_due_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  processmaker_process_version_id?: Maybe<Scalars['Int']>;
  workflow_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creation_status?: InputMaybe<Order_By>;
  document_version_id?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  first_due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Workflow_Versions_Min_Fields = {
  __typename?: 'workflow_workflow_versions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  creation_status?: Maybe<Scalars['String']>;
  document_version_id?: Maybe<Scalars['uuid']>;
  duration?: Maybe<Scalars['Int']>;
  first_due_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  processmaker_process_version_id?: Maybe<Scalars['Int']>;
  workflow_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creation_status?: InputMaybe<Order_By>;
  document_version_id?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  first_due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Mutation_Response = {
  __typename?: 'workflow_workflow_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Workflow_Versions>;
};

/** input type for inserting object relation for remote table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Obj_Rel_Insert_Input = {
  data: Workflow_Workflow_Versions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Workflow_Versions_On_Conflict>;
};

/** on_conflict condition type for table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_On_Conflict = {
  constraint: Workflow_Workflow_Versions_Constraint;
  update_columns?: Array<Workflow_Workflow_Versions_Update_Column>;
  where?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.workflow_versions". */
export type Workflow_Workflow_Versions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creation_status?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Workflow_Document_Versions_Order_By>;
  document_version_id?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  enriched_reactflow_json?: InputMaybe<Order_By>;
  first_due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processmaker_moddle_warnings?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
  processmaker_xml?: InputMaybe<Order_By>;
  processmaker_xml_warnings?: InputMaybe<Order_By>;
  reactflow_json?: InputMaybe<Order_By>;
  reactflow_status?: InputMaybe<Order_By>;
  workflow?: InputMaybe<Workflow_Workflows_Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_workflow_versions */
export type Workflow_Workflow_Versions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Workflow_Versions_Prepend_Input = {
  enriched_reactflow_json?: InputMaybe<Scalars['jsonb']>;
  processmaker_moddle_warnings?: InputMaybe<Scalars['jsonb']>;
  processmaker_xml_warnings?: InputMaybe<Scalars['jsonb']>;
  reactflow_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow.workflow_versions" */
export enum Workflow_Workflow_Versions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreationStatus = 'creation_status',
  /** column name */
  DocumentVersionId = 'document_version_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  EnrichedReactflowJson = 'enriched_reactflow_json',
  /** column name */
  FirstDueDate = 'first_due_date',
  /** column name */
  Id = 'id',
  /** column name */
  ProcessmakerModdleWarnings = 'processmaker_moddle_warnings',
  /** column name */
  ProcessmakerProcessVersionId = 'processmaker_process_version_id',
  /** column name */
  ProcessmakerXml = 'processmaker_xml',
  /** column name */
  ProcessmakerXmlWarnings = 'processmaker_xml_warnings',
  /** column name */
  ReactflowJson = 'reactflow_json',
  /** column name */
  ReactflowStatus = 'reactflow_status',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** input type for updating data in table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  creation_status?: InputMaybe<Scalars['String']>;
  document_version_id?: InputMaybe<Scalars['uuid']>;
  duration?: InputMaybe<Scalars['Int']>;
  enriched_reactflow_json?: InputMaybe<Scalars['jsonb']>;
  first_due_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  processmaker_moddle_warnings?: InputMaybe<Scalars['jsonb']>;
  processmaker_process_version_id?: InputMaybe<Scalars['Int']>;
  processmaker_xml?: InputMaybe<Scalars['xml']>;
  processmaker_xml_warnings?: InputMaybe<Scalars['jsonb']>;
  reactflow_json?: InputMaybe<Scalars['jsonb']>;
  reactflow_status?: InputMaybe<Workflow_Workflow_Reactflow_Status_Enum>;
  workflow_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Workflow_Workflow_Versions_Stddev_Fields = {
  __typename?: 'workflow_workflow_versions_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  processmaker_process_version_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Workflow_Versions_Stddev_Pop_Fields = {
  __typename?: 'workflow_workflow_versions_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  processmaker_process_version_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Workflow_Versions_Stddev_Samp_Fields = {
  __typename?: 'workflow_workflow_versions_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  processmaker_process_version_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Workflow_Workflow_Versions_Sum_Fields = {
  __typename?: 'workflow_workflow_versions_sum_fields';
  duration?: Maybe<Scalars['Int']>;
  processmaker_process_version_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Sum_Order_By = {
  duration?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
};

/** update columns of table "workflow.workflow_versions" */
export enum Workflow_Workflow_Versions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreationStatus = 'creation_status',
  /** column name */
  DocumentVersionId = 'document_version_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  EnrichedReactflowJson = 'enriched_reactflow_json',
  /** column name */
  FirstDueDate = 'first_due_date',
  /** column name */
  Id = 'id',
  /** column name */
  ProcessmakerModdleWarnings = 'processmaker_moddle_warnings',
  /** column name */
  ProcessmakerProcessVersionId = 'processmaker_process_version_id',
  /** column name */
  ProcessmakerXml = 'processmaker_xml',
  /** column name */
  ProcessmakerXmlWarnings = 'processmaker_xml_warnings',
  /** column name */
  ReactflowJson = 'reactflow_json',
  /** column name */
  ReactflowStatus = 'reactflow_status',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** aggregate var_pop on columns */
export type Workflow_Workflow_Versions_Var_Pop_Fields = {
  __typename?: 'workflow_workflow_versions_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  processmaker_process_version_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Workflow_Workflow_Versions_Var_Samp_Fields = {
  __typename?: 'workflow_workflow_versions_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  processmaker_process_version_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Workflow_Workflow_Versions_Variance_Fields = {
  __typename?: 'workflow_workflow_versions_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  processmaker_process_version_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workflow.workflow_versions" */
export type Workflow_Workflow_Versions_Variance_Order_By = {
  duration?: InputMaybe<Order_By>;
  processmaker_process_version_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "workflow.workflows" */
export type Workflow_Workflows = {
  __typename?: 'workflow_workflows';
  /** An object relationship */
  active_version?: Maybe<Workflow_Workflow_Versions>;
  active_version_id?: Maybe<Scalars['uuid']>;
  client_organization_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  document?: Maybe<Workflow_Documents>;
  document_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  organization_id: Scalars['uuid'];
  processmaker_process_id?: Maybe<Scalars['Int']>;
  processmaker_screen_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  project?: Maybe<Projects>;
  project_id?: Maybe<Scalars['uuid']>;
  status: Workflow_Workflow_Status_Enum;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  workflow_versions: Array<Workflow_Workflow_Versions>;
  /** An aggregate relationship */
  workflow_versions_aggregate: Workflow_Workflow_Versions_Aggregate;
};


/** columns and relationships of "workflow.workflows" */
export type Workflow_WorkflowsWorkflow_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
};


/** columns and relationships of "workflow.workflows" */
export type Workflow_WorkflowsWorkflow_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Workflow_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Workflow_Versions_Order_By>>;
  where?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
};

/** aggregated selection of "workflow.workflows" */
export type Workflow_Workflows_Aggregate = {
  __typename?: 'workflow_workflows_aggregate';
  aggregate?: Maybe<Workflow_Workflows_Aggregate_Fields>;
  nodes: Array<Workflow_Workflows>;
};

/** aggregate fields of "workflow.workflows" */
export type Workflow_Workflows_Aggregate_Fields = {
  __typename?: 'workflow_workflows_aggregate_fields';
  avg?: Maybe<Workflow_Workflows_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Workflows_Max_Fields>;
  min?: Maybe<Workflow_Workflows_Min_Fields>;
  stddev?: Maybe<Workflow_Workflows_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Workflows_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Workflows_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Workflows_Sum_Fields>;
  var_pop?: Maybe<Workflow_Workflows_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Workflows_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Workflows_Variance_Fields>;
};


/** aggregate fields of "workflow.workflows" */
export type Workflow_Workflows_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Workflows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Workflow_Workflows_Avg_Fields = {
  __typename?: 'workflow_workflows_avg_fields';
  processmaker_process_id?: Maybe<Scalars['Float']>;
  processmaker_screen_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "workflow.workflows". All fields are combined with a logical 'AND'. */
export type Workflow_Workflows_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Workflows_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Workflows_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Workflows_Bool_Exp>>;
  active_version?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
  active_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Workflow_Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  processmaker_process_id?: InputMaybe<Int_Comparison_Exp>;
  processmaker_screen_id?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Workflow_Workflow_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workflow_versions?: InputMaybe<Workflow_Workflow_Versions_Bool_Exp>;
};

/** unique or primary key constraints on table "workflow.workflows" */
export enum Workflow_Workflows_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkflowsPkey = 'workflows_pkey'
}

/** input type for incrementing numeric columns in table "workflow.workflows" */
export type Workflow_Workflows_Inc_Input = {
  processmaker_process_id?: InputMaybe<Scalars['Int']>;
  processmaker_screen_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow.workflows" */
export type Workflow_Workflows_Insert_Input = {
  active_version?: InputMaybe<Workflow_Workflow_Versions_Obj_Rel_Insert_Input>;
  active_version_id?: InputMaybe<Scalars['uuid']>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Workflow_Documents_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  processmaker_process_id?: InputMaybe<Scalars['Int']>;
  processmaker_screen_id?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Workflow_Workflow_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_versions?: InputMaybe<Workflow_Workflow_Versions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Workflow_Workflows_Max_Fields = {
  __typename?: 'workflow_workflows_max_fields';
  active_version_id?: Maybe<Scalars['uuid']>;
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  processmaker_process_id?: Maybe<Scalars['Int']>;
  processmaker_screen_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Workflow_Workflows_Min_Fields = {
  __typename?: 'workflow_workflows_min_fields';
  active_version_id?: Maybe<Scalars['uuid']>;
  client_organization_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  processmaker_process_id?: Maybe<Scalars['Int']>;
  processmaker_screen_id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "workflow.workflows" */
export type Workflow_Workflows_Mutation_Response = {
  __typename?: 'workflow_workflows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Workflows>;
};

/** input type for inserting object relation for remote table "workflow.workflows" */
export type Workflow_Workflows_Obj_Rel_Insert_Input = {
  data: Workflow_Workflows_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Workflows_On_Conflict>;
};

/** on_conflict condition type for table "workflow.workflows" */
export type Workflow_Workflows_On_Conflict = {
  constraint: Workflow_Workflows_Constraint;
  update_columns?: Array<Workflow_Workflows_Update_Column>;
  where?: InputMaybe<Workflow_Workflows_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow.workflows". */
export type Workflow_Workflows_Order_By = {
  active_version?: InputMaybe<Workflow_Workflow_Versions_Order_By>;
  active_version_id?: InputMaybe<Order_By>;
  client_organization_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Workflow_Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  processmaker_process_id?: InputMaybe<Order_By>;
  processmaker_screen_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow_versions_aggregate?: InputMaybe<Workflow_Workflow_Versions_Aggregate_Order_By>;
};

/** primary key columns input for table: workflow_workflows */
export type Workflow_Workflows_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "workflow.workflows" */
export enum Workflow_Workflows_Select_Column {
  /** column name */
  ActiveVersionId = 'active_version_id',
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProcessmakerProcessId = 'processmaker_process_id',
  /** column name */
  ProcessmakerScreenId = 'processmaker_screen_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "workflow.workflows" */
export type Workflow_Workflows_Set_Input = {
  active_version_id?: InputMaybe<Scalars['uuid']>;
  client_organization_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  processmaker_process_id?: InputMaybe<Scalars['Int']>;
  processmaker_screen_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Workflow_Workflow_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Workflow_Workflows_Stddev_Fields = {
  __typename?: 'workflow_workflows_stddev_fields';
  processmaker_process_id?: Maybe<Scalars['Float']>;
  processmaker_screen_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Workflows_Stddev_Pop_Fields = {
  __typename?: 'workflow_workflows_stddev_pop_fields';
  processmaker_process_id?: Maybe<Scalars['Float']>;
  processmaker_screen_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Workflows_Stddev_Samp_Fields = {
  __typename?: 'workflow_workflows_stddev_samp_fields';
  processmaker_process_id?: Maybe<Scalars['Float']>;
  processmaker_screen_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Workflow_Workflows_Sum_Fields = {
  __typename?: 'workflow_workflows_sum_fields';
  processmaker_process_id?: Maybe<Scalars['Int']>;
  processmaker_screen_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "workflow.workflows" */
export enum Workflow_Workflows_Update_Column {
  /** column name */
  ActiveVersionId = 'active_version_id',
  /** column name */
  ClientOrganizationId = 'client_organization_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProcessmakerProcessId = 'processmaker_process_id',
  /** column name */
  ProcessmakerScreenId = 'processmaker_screen_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Workflow_Workflows_Var_Pop_Fields = {
  __typename?: 'workflow_workflows_var_pop_fields';
  processmaker_process_id?: Maybe<Scalars['Float']>;
  processmaker_screen_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Workflow_Workflows_Var_Samp_Fields = {
  __typename?: 'workflow_workflows_var_samp_fields';
  processmaker_process_id?: Maybe<Scalars['Float']>;
  processmaker_screen_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Workflow_Workflows_Variance_Fields = {
  __typename?: 'workflow_workflows_variance_fields';
  processmaker_process_id?: Maybe<Scalars['Float']>;
  processmaker_screen_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "xml". All fields are combined with logical 'AND'. */
export type Xml_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['xml']>;
  _gt?: InputMaybe<Scalars['xml']>;
  _gte?: InputMaybe<Scalars['xml']>;
  _in?: InputMaybe<Array<Scalars['xml']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['xml']>;
  _lte?: InputMaybe<Scalars['xml']>;
  _neq?: InputMaybe<Scalars['xml']>;
  _nin?: InputMaybe<Array<Scalars['xml']>>;
};

export type Create_Section_CommentMutationVariables = Exact<{
  content?: InputMaybe<Scalars['String']>;
  page_index?: InputMaybe<Scalars['Int']>;
  processmaker_process_request_id?: InputMaybe<Scalars['Int']>;
  section_id?: InputMaybe<Scalars['uuid']>;
  section_index?: InputMaybe<Scalars['Int']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  page_name?: InputMaybe<Scalars['String']>;
  section_name?: InputMaybe<Scalars['String']>;
}>;


export type Create_Section_CommentMutation = { __typename?: 'mutation_root', insert_workflow_section_comments_one?: { __typename?: 'workflow_section_comments', client_organization_author?: any | null, client_organization_resolver?: any | null, content: string, created_at: any, created_by?: any | null, id: any, page_index: number, processmaker_process_request_id: number, resolved_at?: any | null, resolved_by?: any | null, section_id: any, section_index: number, status: Workflow_Section_Comment_Status_Enum, updated_at?: any | null, page_name?: string | null, page_id?: any | null, section_name?: string | null } | null };

export type Update_Section_Comment_StatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  status?: InputMaybe<Workflow_Section_Comment_Status_Enum>;
  content?: InputMaybe<Scalars['String']>;
}>;


export type Update_Section_Comment_StatusMutation = { __typename?: 'mutation_root', update_workflow_section_comments_by_pk?: { __typename?: 'workflow_section_comments', id: any, status: Workflow_Section_Comment_Status_Enum, content: string } | null };

export type Get_All_Section_CommentsQueryVariables = Exact<{
  processmaker_process_request_id: Scalars['Int'];
  status?: InputMaybe<Array<Workflow_Section_Comment_Status_Enum> | Workflow_Section_Comment_Status_Enum>;
}>;


export type Get_All_Section_CommentsQuery = { __typename?: 'query_root', workflow_section_comments: Array<{ __typename?: 'workflow_section_comments', id: any, page_id?: any | null, page_index: number, page_name?: string | null, section_id: any, section_index: number, section_name?: string | null, processmaker_process_request_id: number, resolved_at?: any | null, resolved_by?: any | null, created_by?: any | null, created_at: any, content: string, client_organization_resolver?: any | null, client_organization_author?: any | null, author?: { __typename?: 'users', id: any, image_url?: string | null, last_name?: string | null, first_name?: string | null, organization_members: Array<{ __typename?: 'organization_members', title: string }> } | null }> };


export const Create_Section_CommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_SECTION_COMMENT"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page_index"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processmaker_process_request_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section_index"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_workflow_section_comments_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page_index"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page_index"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processmaker_process_request_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processmaker_process_request_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"section_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"section_index"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section_index"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"section_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section_name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_organization_author"}},{"kind":"Field","name":{"kind":"Name","value":"client_organization_resolver"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page_index"}},{"kind":"Field","name":{"kind":"Name","value":"processmaker_process_request_id"}},{"kind":"Field","name":{"kind":"Name","value":"resolved_at"}},{"kind":"Field","name":{"kind":"Name","value":"resolved_by"}},{"kind":"Field","name":{"kind":"Name","value":"section_id"}},{"kind":"Field","name":{"kind":"Name","value":"section_index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"page_name"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"section_name"}}]}}]}}]} as unknown as DocumentNode<Create_Section_CommentMutation, Create_Section_CommentMutationVariables>;
export const Update_Section_Comment_StatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_SECTION_COMMENT_STATUS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"workflow_section_comment_status_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_workflow_section_comments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<Update_Section_Comment_StatusMutation, Update_Section_Comment_StatusMutationVariables>;
export const Get_All_Section_CommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_ALL_SECTION_COMMENTS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processmaker_process_request_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"workflow_section_comment_status_enum"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflow_section_comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"processmaker_process_request_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processmaker_process_request_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"page_id"}},{"kind":"Field","name":{"kind":"Name","value":"page_index"}},{"kind":"Field","name":{"kind":"Name","value":"page_name"}},{"kind":"Field","name":{"kind":"Name","value":"section_id"}},{"kind":"Field","name":{"kind":"Name","value":"section_index"}},{"kind":"Field","name":{"kind":"Name","value":"section_name"}},{"kind":"Field","name":{"kind":"Name","value":"processmaker_process_request_id"}},{"kind":"Field","name":{"kind":"Name","value":"resolved_at"}},{"kind":"Field","name":{"kind":"Name","value":"resolved_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"client_organization_resolver"}},{"kind":"Field","name":{"kind":"Name","value":"client_organization_author"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_url"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"organization_members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Get_All_Section_CommentsQuery, Get_All_Section_CommentsQueryVariables>;